(function (App) {
	// if(sessionStorage.getItem("samsung")){
	// 	App.config = {
	// 		api: {
	// 			domain: 'https://api.ismash.com',
	// 			filemaker: 'https://ismashdev.myclientarea.co.uk/app'
	// 		},
	// 		apiDev: {
	// 			domain: 'https://ismash.atom42.co.uk',
	// 			filemaker: 'https://api.ismash.com/app'
	// 		}
	// 	};
	// 	//console.log("Samsung Journey FM");
	// } else {
	// 	App.config = {
	// 		api: {
	// 			domain: 'https://api.ismash.com',
	// 			filemaker: 'https://api.ismash.com/app'
	// 		},
	// 		apiDev: {
	// 			domain: 'https://ismash.atom42.co.uk',
	// 			filemaker: 'https://api.ismash.com/app'
	// 		}
	// 	};
	// 	//console.log("Normal Journey FM");
	// }

	App.config = {
		api: {
			domain: 'https://api.ismash.com',
			filemaker: 'https://api.ismash.com/app'
		},
		apiDev: {
			domain: 'https://ismash.atom42.co.uk',
			filemaker: 'https://api.ismash.com/app'
		}
	};
 
	// filemaker: 'http://ismash.myclientarea.co.uk/app' - repaireQ
	// filemaker: 'https://ismashdev.myclientarea.co.uk/app'
	// filemaker: 'https://api.ismash.com/app'
	// filemaker: 'https://ismash-dev.atom42.co.uk/fm/app'

	$.urlParam = function(name){
	var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
	if (results==null) {
	return null;
	}
	return decodeURI(results[1]) || 0;
	}

	function getFirstSelectedEntry(selectionMap) {
		var values = Object.values(selectionMap || {});
		return values.length > 0 ? values[0] : null;
	}

	function getRearRepairType(selectedrear) {
		var rearSelection = getFirstSelectedEntry(selectedrear);
		var rearProduct = rearSelection && rearSelection.product ? rearSelection.product : null;
		var rearTags = rearProduct && Array.isArray(rearProduct.tags) ? rearProduct.tags : [];
		return rearTags.indexOf('backglass') > -1 ? 'backglass' : 'housing';
	}

	function buildStoreStockUrl(selected, selectedrear) {
		if (!App || !App.config || !App.config.api || !App.config.api.filemaker) {
			return null;
		}

		var primarySelection = getFirstSelectedEntry(selected);
		var rearSelection = getFirstSelectedEntry(selectedrear);
		var activeSelection = primarySelection || rearSelection;
		if (!activeSelection || !activeSelection.variant) {
			return null;
		}

		var prodSKU = activeSelection.variant.sku || 'SKUNOTFOUND';
		var prodCode = activeSelection.variant.option3 || '0';
		var reartype = getRearRepairType(selectedrear);
		var secondarySelection = primarySelection && rearSelection ? rearSelection : null;
		var secondarySKU = secondarySelection && secondarySelection.variant && secondarySelection.variant.sku ? secondarySelection.variant.sku : '';

		if (secondarySKU && secondarySKU.length > 1) {
			return App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + secondarySKU + '/' + prodCode + '/' + reartype;
		}

		return App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode + '/' + reartype;
	}

	function normalizeStoreListResponse(responseBody) {
		if (Array.isArray(responseBody)) {
			return responseBody;
		}
		if (responseBody && Array.isArray(responseBody.data)) {
			return responseBody.data;
		}
		return [];
	}

	function wrapSelectedStorePayload(store) {
		if (store && typeof store === 'object' && Object.prototype.hasOwnProperty.call(store, 'store')) {
			return store;
		}
		return {
			store: store || null
		};
	}

	function createEmptySelectedProduct() {
		return {
			id: null,
			title: '',
			insurance_customer: 'No',
			featured_image: '',
			featuredimage: '',
			tags: []
		};
	}

	function safeArray(value) {
		return Array.isArray(value) ? value : [];
	}

	function productHasTag(product, tag) {
		return safeArray(product && product.tags).indexOf(tag) > -1;
	}

	function findFeaturedByTag(products, tag) {
		return safeArray(products).find(function (prod) {
			return productHasTag(prod, tag);
		}) || false;
	}

	function findFeaturedByAppleType(products, appleType) {
		return safeArray(products).find(function (prod) {
			return prod && prod.AppleType === appleType;
		}) || false;
	}

	function normalizeRepairCollectionTitle(value) {
		return (value || '')
			.replace('Screen Replacement', '')
			.replace('&', '')
			.replace('Other', '')
			.replace('Repairs', '')
			.replace('Test', '')
			.replace('- Composite Test', '')
			.trim()
			.toLowerCase();
	}

	function loadPremiumServiceProduct(comp, prodHandle) {
		if (!comp || !prodHandle) {
			return;
		}

		var currentTemplateSuffix = '';
		if (currentTemplateSuffix === 'device-no-apple-genuine') {
			comp.premium_service_product = {};
			if (comp.$root) {
				comp.$root.premium_service_product = {};
			}
			return;
		}

		fetch('/products/' + prodHandle + '.js')
			.then(function (response) {
				if (!response || !response.ok) {
					return null;
				}
				return response.json();
			})
			.then(function (data) {
				if (!data || !Array.isArray(data.variants)) {
					return;
				}

				var title = normalizeRepairCollectionTitle(window.collection && window.collection.title);
				var matchedVariant = data.variants.find(function (variant) {
					var option = '';
					if (variant && variant.option1 && variant.option2 === 'Premium') {
						option = String(variant.option1).trim().toLowerCase();
					} else {
						option = normalizeRepairCollectionTitle(variant && variant.title)
							.replace('/ premium', '')
							.replace('/ Premium', '');
					}

					return title === option;
				}) || null;

				comp.premium_service_product = matchedVariant || {};
				if (comp.$root) {
					comp.$root.premium_service_product = comp.premium_service_product;
				}
			})
			.catch(function () {
				comp.premium_service_product = {};
			});
	}

	function shouldUseFunnelTransitionLoader(url) {
		var destination = typeof url === 'string' ? url : '';
		var currentPath = window.location.pathname || '';
		return currentPath.indexOf('/pages/device-funnel-stage-') === 0 || destination.indexOf('/pages/device-funnel-stage-') === 0 || destination.indexOf('/collections/') === 0;
	}

	function getFunnelStageFromUrl(url) {
		var destination = typeof url === 'string' ? url : '';
		var match = destination.match(/\/pages\/device-funnel-stage-(\d)/);
		if (!match || !match[1]) {
			return null;
		}
		return match[1];
	}

	function getFunnelTransitionMessage(url, isEntry) {
		var stage = getFunnelStageFromUrl(url);
		if (!stage) {
			if ((url || '').indexOf('/collections/') === 0) {
				return 'Loading collection...';
			}
			return 'Loading next step...';
		}

		if (stage === '1') {
			return 'Loading your repair options...';
		}
		if (stage === '2') {
			return 'Loading delivery and store options...';
		}
		if (stage === '3') {
			return 'Loading available dates and times...';
		}
		if (stage === '4') {
			return 'Loading available add-ons...';
		}
		if (stage === '5') {
			return 'Loading your details and confirmation...';
		}

		return 'Loading next step...';
	}

	function scrollBookingToTop() {
		var targetSelector = null;
		var preferredTargets = ['.store-select', '#stores_anchor', '.repair--store-list'];
		for (var i = 0; i < preferredTargets.length; i++) {
			if ($(preferredTargets[i]).length) {
				targetSelector = preferredTargets[i];
				break;
			}
		}

		if (targetSelector) {
			scrollTo(targetSelector, 40);
			if ($('.repair--delivery-popup').length && $(targetSelector).length) {
				scrollToMobile(targetSelector, 20, 0);
			}
			return;
		}

		try {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		} catch (e) {}
		$('html, body').stop(true, true).animate({ scrollTop: 0 }, { duration: 450, easing: 'swing' });
		$('.repair--delivery-popup').stop(true, true).animate({ scrollTop: 0 }, { duration: 450, easing: 'swing' });
	}

	function ensureFunnelTransitionLoader() {
		if (document.getElementById('jv-stage-transition-overlay')) {
			return;
		}

		var style = document.createElement('style');
		style.id = 'jv-stage-transition-style';
		style.textContent = '' +
			'.jv-stage-transition-overlay{position:fixed;inset:0;display:none;align-items:center;justify-content:center;background:#fff;z-index:2147483000;opacity:0;transition:opacity .2s ease;}' +
			'.jv-stage-transition-overlay.is-visible{display:flex;opacity:1;}' +
			'.jv-stage-transition-inner{display:flex;flex-direction:column;align-items:center;gap:10px;font-family:inherit;color:#ff148b;}' +
			'.jv-stage-transition-spinner{width:100px;height:100px;display:block;}' +
			'.jv-stage-transition-text{font-size:14px;letter-spacing:.2px;}' +
			'';
		document.head.appendChild(style);

		var overlay = document.createElement('div');
		overlay.id = 'jv-stage-transition-overlay';
		overlay.className = 'jv-stage-transition-overlay';
		overlay.innerHTML = '<div class="jv-stage-transition-inner"><img class="jv-stage-transition-spinner" src="//www.ismash.com/cdn/shop/t/251/assets/ajax-spinner.gif?v=19661169839627851301791377767" alt="Loading" /><span id="jv-stage-transition-text" class="jv-stage-transition-text">Preparing your booking...</span></div>';
		document.body.appendChild(overlay);
	}

	function showFunnelTransitionLoader(message) {
		ensureFunnelTransitionLoader();
		var overlay = document.getElementById('jv-stage-transition-overlay');
		if (!overlay) {
			return;
		}
		var textNode = document.getElementById('jv-stage-transition-text');
		if (textNode && message) {
			textNode.textContent = message;
		}
		overlay.setAttribute('data-visible-since', String(Date.now()));
		overlay.classList.add('is-visible');
	}

	function hideFunnelTransitionLoader(minDurationMs) {
		var overlay = document.getElementById('jv-stage-transition-overlay');
		if (!overlay) {
			return;
		}
		var since = parseInt(overlay.getAttribute('data-visible-since') || '0', 10);
		var minMs = typeof minDurationMs === 'number' ? minDurationMs : 0;
		var elapsed = since > 0 ? Date.now() - since : minMs;
		var wait = elapsed >= minMs ? 0 : (minMs - elapsed);
		setTimeout(function () {
			overlay.classList.remove('is-visible');
		}, wait);
	}

	function navigateWithFunnelLoader(url) {
		if (!url) {
			return;
		}
		if (shouldUseFunnelTransitionLoader(url)) {
			showFunnelTransitionLoader(getFunnelTransitionMessage(url, false));
			setTimeout(function () {
				window.location.assign(url);
			}, 40);
			return;
		}
		window.location.assign(url);
	}

	function smoothScrollToFunnelCollection() {
		var target = document.getElementById('collection');
		if (!target) {
			return;
		}

		setTimeout(function () {
			try {
				target.scrollIntoView({ behavior: 'smooth', block: 'start' });
			} catch (e) {
				var targetTop = target.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0);
				window.scrollTo(0, targetTop);
			}
		}, 120);
	}

	function initFunnelTransitionLoader() {
		var path = window.location.pathname || '';
		if (path.indexOf('/pages/device-funnel-stage-') === 0) {
			showFunnelTransitionLoader(getFunnelTransitionMessage(path, true));
			smoothScrollToFunnelCollection();
			var hideOverlay = function () {
				hideFunnelTransitionLoader(300);
			};
			if (document.readyState === 'complete') {
				setTimeout(hideOverlay, 100);
			} else {
				window.addEventListener('load', function () {
					setTimeout(hideOverlay, 100);
				}, { once: true });
			}
			setTimeout(hideOverlay, 1400);
		}

		document.addEventListener('click', function (event) {
			var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
			if (!link) {
				return;
			}
			var href = link.getAttribute('href') || '';
			if (href.indexOf('/pages/device-funnel-stage-') === 0 || href.indexOf('/collections/') === 0) {
				showFunnelTransitionLoader(getFunnelTransitionMessage(href, false));
			}
		}, true);
	}

	initFunnelTransitionLoader();

	var stage = $.urlParam('stage');
	if(stage){
		if (stage.indexOf('stage')) {
			//console.log("stage  4");
			Vue.prototype.$stage = 4;
			sessionStorage.setItem("stage", 4);
		}
	} else {
		sessionStorage.setItem("stage", 0);
	}

	$.ajax({
		url: "https://www.ismash.com/cdn/shop/t/251/assets/postcodes.json?v=95944372918485390431791378258",
		success: function (validpostcodes) {
			Vue.prototype.$postcodeLookup = validpostcodes;
		}
	});
	let collection = window.collection || undefined;
	if(collection !== undefined){
		$.get("/collections/" + collection.handle + "?view=json", function (data) {
			var hidefields = JSON.parse(data);
			if (hidefields.hideavailability) {
				Vue.prototype.$hideavailability = hidefields.hideavailability;
			}
			if (hidefields.availabilitymessage) {
				Vue.prototype.$availabilitymessage = hidefields.availabilitymessage;
			}
		});
	}

	
	if(sessionStorage.getItem("skyjourney")){
		Vue.prototype.$skyjourney = sessionStorage.getItem("skyjourney");
		Vue.prototype.$insurer = sessionStorage.getItem("insurer");
		sessionStorage.setItem("insurer", sessionStorage.getItem("insurer"));
	} else {
		Vue.prototype.$skyjourney = 'No';
	}
	var isInsuranceMarker = sessionStorage.getItem("isinsurance");
	var isInsuranceJourney = isInsuranceMarker === 'true' || isInsuranceMarker === '1' || isInsuranceMarker === 'Yes';
	if(isInsuranceJourney){
		Vue.prototype.$isinsurance = 'Yes';
		sessionStorage.setItem("isinsurance", 'Yes');
		//console.log("is insurance Yes");
		sessionStorage.setItem("delivery_type", null);
	} else {
		Vue.prototype.$isinsurance = 'No';
		//console.log("is insurance No");
		sessionStorage.setItem("delivery_type", 'store_visit');
	}
	//console.log("is insurance "+this.$isinsurance);
	
	if(sessionStorage.getItem("insuranceref")){
		Vue.prototype.$insuranceref = sessionStorage.getItem("insuranceref");
		sessionStorage.setItem("insuranceref", sessionStorage.getItem("insuranceref"));
		
		Vue.prototype.$insurer = sessionStorage.getItem("insurer");
		sessionStorage.setItem("insurer", sessionStorage.getItem("insurer"));
	}
	////console.log("Part "+sessionStorage.getItem("part"));
	// //console.log("first_name "+sessionStorage.getItem("first_name"));
	// //console.log("last_name "+sessionStorage.getItem("last_name"));
	// //console.log("tel "+sessionStorage.getItem("tel"));
	// //console.log("postcode "+sessionStorage.getItem("postcode"));
	// //console.log("email "+sessionStorage.getItem("email"));
	////console.log("colour "+sessionStorage.getItem("colour"));

	// Insurance bookings
	if(sessionStorage.getItem("part")){
		
		Vue.prototype.$first_name = sessionStorage.getItem("first_name");
		Vue.prototype.$last_name = sessionStorage.getItem("last_name");
		Vue.prototype.$tel = sessionStorage.getItem("tel");
		Vue.prototype.$postcode = sessionStorage.getItem("postcode");
		document.cookie = "useremail="+sessionStorage.getItem("email")+";";
		////console.log("is part runs");	
		//$('#loading').show();
		//console.log(sessionStorage.getItem("part"));
		setTimeout(
			function() 
			{
				// element which needs to be scrolled to
				var element = document.querySelector("#con"+sessionStorage.getItem("part"));
				// scroll to element
				//element.scrollIntoView();
				var thisclosebutton = '';
				var thisoptionid = '';
				var switchbutton = 0;
				var skulookup = sessionStorage.getItem("part");
				$('select').each(function() {
					var optionid = $(this).prop('id');
					var closebutton = $("#"+optionid).closest('.repair--item').find("button").prop('id');
					if(!closebutton){
						closebutton = $("#"+optionid).next("button").prop('id');
					}
					//console.log("select ID "+optionid);
					//console.log("next button id "+closebutton);
					$('option', this).each(function() {
						if ($(this).val().indexOf(sessionStorage.getItem("part")) >= 0){
							$(this).prop('selected', true);
							$(this).attr("selected",true);							
							switchbutton = 1;
							thisclosebutton = closebutton;
							thisoptionid = optionid;
						}
					});
					if(switchbutton==1){
						setTimeout(
						function() 
						{
							//$("#"+thisclosebutton).click();
							//console.log("Button click runs "+thisoptionid);

						}, 2000);						
					}
				});
				if(switchbutton==0){
					if(skulookup=='P101502'){
						//document.querySelector("#"+skulookup).click();
					} else {
						if(skulookup.endsWith('2')){
							var str = sessionStorage.getItem("part");
							str = str.substring(0, str.length - 1);
							skulookup = str+"1";
						}
						var button = document.querySelector("#"+skulookup).closest('button');
							//button.click();
					}
				}

			}, 1000);	

		setTimeout(
			function() 
			{
				$('#loading').hide();

			}, 8000);
		
	}

	// Reschedule Booking
	if(sessionStorage.getItem("repairpart")){

		sessionStorage.setItem("rebook", "yes");
		
		Vue.prototype.$first_name = sessionStorage.getItem("first_name");
		Vue.prototype.$last_name = sessionStorage.getItem("last_name");
		Vue.prototype.$tel = sessionStorage.getItem("tel");
		Vue.prototype.$postcode = sessionStorage.getItem("postcode");
		document.cookie = "useremail="+sessionStorage.getItem("email")+";";
		//console.log("is part runs");	
		$('#loading').show();

		setTimeout(
			function() 
			{
				// element which needs to be scrolled to
				var element = document.querySelector("#con"+sessionStorage.getItem("repairpart"));
				// scroll to element
				//element.scrollIntoView();
				var switchbutton = 0;
				$('select').each(function() {
					$('option', this).each(function(i) {
						////console.log(i+1);
						if ($(this).val().indexOf(sessionStorage.getItem("repairpart")) >= 0){
							$(this).prop('selected', true);
							$(this).attr("selected",true);						
							switchbutton = 1;
						}
					});
					if(switchbutton==1){
						var altbutton = $(this).next('button');
							altbutton.click();
					}
				});
				////console.log("option"+skulookup);
				if(switchbutton==0){
					var skulookup = sessionStorage.getItem("repairpart");
					if(skulookup=='P101502'){
						document.querySelector("#"+skulookup).click();
					} else {
						if(skulookup.endsWith('2')){
							var str = sessionStorage.getItem("repairpart");
							str = str.substring(0, str.length - 1);
							skulookup = str+"1";
						}
						var button = document.querySelector("#"+skulookup).closest('button');
							button.click();
					}
				}

			}, 1000);	

		setTimeout(
			function() 
			{
				$('#loading').hide();

			}, 8000);
		
	} else {
		sessionStorage.setItem("rebook", "no");
	}

	var REGEX_EMAIL = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|( ".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	var REGEX_PHONE = /^(?:00|0|\+)[0-9\s.\/-]{10,15}$/;
	var REGEX_POSTCODE = /^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$/;
	var REGEX_IMEI = /^[3][5][0-9]{13}$/;
	function getCookie(cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for(var i = 0; i <ca.length; i++) {
		  var c = ca[i];
		  while (c.charAt(0) == ' ') {
			c = c.substring(1);
		  }
		  if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		  }
		}
		return "";
	  }

	function scrollTo(selector, offset) {

		if (!offset) {
			offset = 80;
		}
		//check if the selector exists in the DOM
		if(!$(selector).length) return false;

		var scrollVal = $(selector).offset().top - offset;
		//console.log(scrollVal);
		Vue.nextTick(function () {
			$('html, body').animate({
				scrollTop: scrollVal
			}, 1000);
		});
		//console.log(selector);
	}

	function scrollToMobile(selector, offset,delay) {
		if (!offset) {
			offset = 80;
		}
		if (!delay) {
			delay = 10;
		}
		

		Vue.nextTick(function () {
			//we want a small delay here, as the content sometimes is not immidiately visible. and will cause some weird side effects.
			setTimeout(() => {
				var child_top = $(selector).offset().top - $(".repair--delivery-popup").offset().top - offset;
				$(".repair--delivery-popup").animate({ scrollTop: child_top }, { duration: 'medium', easing: 'swing' });
			}, delay);
		});
	}

	function checkStock (stores) {
		StockQty = 0;
		for (var prop in stores) {
			if(stores[prop].in_stock == 'in_store'){
				StockQty = StockQty+1;
			}
			if(stores[prop].in_stock == 'in_warehouse'){
				StockQty = StockQty+2;
			}
			// if ( stores.hasOwnProperty(prop) ) {
			// 	//console.log(stores[prop].in_stock);
			// }
		}
	}

	$.fn.offsetRelative = function (top) {
		var $this = $(this);
		var $parent = $this.offsetParent();
		var offset = $this.position();
		if (!top) return offset; // Didn't pass a 'top' element
		else if ($parent.get(0).tagName == "BODY") return offset; // Reached top of document
		else if ($(top, $parent).length) return offset; // Parent element contains the 'top' element we want the offset to be relative to
		else if ($parent[0] == $(top)[0]) return offset; // Reached the 'top' element we want the offset to be relative to
		else { // Get parent's relative offset
			var parent_offset = $parent.offsetRelative(top);
			offset.top += parent_offset.top;
			offset.left += parent_offset.left;
			return offset;
		}
	};
	$.fn.positionRelative = function (top) {
		return $(this).offsetRelative(top);
	};

	function findObjInArray(array, obj) {
		for (var i = 0; i < array.length; i++) {
			var found = true;
			for (var x = 0; x < Object.keys(obj).length; x++) {
				var attr = Object.keys(obj)[x];
				var value = obj[Object.keys(obj)[x]];
				if (array[i][attr] !== value) {
					found = false;
				}
			}
			if (!found) {
				continue;
			}
			return true;
		}
		return false;
	}

	App.funnelEvent = function (data) {
		var request = new XMLHttpRequest();
		request.open('POST', App.config.api.filemaker + '/funnel', true);
		request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
		request.send(JSON.stringify(data));
	}; 
	
	//New Repair Template with Tabs

  // Only the MacBook repair template opts into this shared funnel hand-off.
  function startMacbookRepairFunnel(context) {
    if (!window.macbookRepairUsesSharedFunnel) return false;
    var collectionHandle = window.collection && window.collection.handle;
    if (!collectionHandle) return false;
    var selected = context.selected || {};
    var selectedRepair = selected[Object.keys(selected)[0]];
    if (!selectedRepair || !selectedRepair.variant) return false;
    var booking = context.booking || {};
    try {
      sessionStorage.setItem('jv_selected', JSON.stringify(selected));
      sessionStorage.setItem('jv_selectedrear', JSON.stringify(context.selectedrear || {}));
      sessionStorage.setItem('jv_stores_list', JSON.stringify(context.stores.list || []));
      sessionStorage.removeItem('jv_selected_store');
      sessionStorage.setItem('jv_booking_snapshot', JSON.stringify({
        email: booking.email || null,
        zip: booking.zip || null,
        delivery_type: '',
        slot: { id: null, store_id: null }
      }));
      sessionStorage.setItem('jv_macbook_repair_duration', JSON.stringify({
        collectionHandle: collectionHandle,
        productId: selectedRepair.product.id,
        duration: booking.appointmentDuration
      }));
      sessionStorage.setItem('jv_source_collection', collectionHandle);
      sessionStorage.setItem('stage', '1');
    } catch (error) {
      window.alert('Please allow browser storage to continue booking your repair.');
      return true;
    }
    navigateWithFunnelLoader('/pages/device-funnel-stage-1?source_collection=' + encodeURIComponent(collectionHandle));
    return true;
  }

	Vue.component('tabs', {
		template: '#tabs',
		props: ['theproducts','loadSelected', 'loadSelectedRear', 'booking', 'stores', 'thepopupproducts'],
		data: function () {
			return {
				selected: {},
				selectedrear: {},
				errors: null,
				products:[]
			};
		},
		mounted: function () {
			
			this.selected = this.loadSelected; 
			this.selectedrear = this.loadSelectedRear; 
		},
		computed:{
			popupmain_product: function () {
				if (this.thepopupproducts && this.thepopupproducts[0]) {
					return this.thepopupproducts[0];
				}
				return {
					id: null,
					title: '',
					price: 0,
					repair_time: '',
					variants: []
				};
			},	
			is_variant_vend_product:function(){
				var selectedValues = Object.values(this.selected || {});
				var selectedRearValues = Object.values(this.selectedrear || {});
				var currentSelection = selectedValues.length > 0 ? selectedValues[0] : (selectedRearValues.length > 0 ? selectedRearValues[0] : null);
				if (!currentSelection || !currentSelection.variant || !currentSelection.variant.title) {
					return false;
				}
				var variantTitle = currentSelection.variant.title;
				return variantTitle.endsWith('BO-W-I') || variantTitle.endsWith('BO-D-I');
			}
		},
		methods: {	
			togglePart: function (product) {
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection(product);
				}

			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			batteryRepairClose: function(){
				var modal = document.getElementById("batteryRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			opendescriptplus: function(thisdescript){
				$('.descript'+thisdescript).toggle('smooth');
				$('.descbutton'+thisdescript).toggleClass('active');
			},
			openrepairplus: function(thisdescript){
				$('.repairtime'+thisdescript).toggle('smooth');
				$('.timebutton'+thisdescript).toggleClass('active');
			},
			openplus: function(thisdescript){
				$('.'+thisdescript+'text').toggle('smooth');
				$('.'+thisdescript).toggleClass('active');
			},
			openadditionalplus: function(thisdescript,button){
				$('.repairtime'+thisdescript).toggle('smooth');
				$('.timebutton'+thisdescript).toggleClass('active');
				$('.importantclick'+button).toggleClass('active');
			},
			selectProduct: function (product) {
				if (product.variants.length < 2) {
					//console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var selectedThis = document.getElementById('optiontab' + product.id).value;
					//console.log(selectedThis);
					if(selectedThis){
						$('.optionselect').addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
					
					//console.log('multi option product ' + selectedThisValue);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById('tab'+product.skuID);
				var otherButtons = $('.part-select-btn');
				otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				this.showBookingSection(product);
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showBookingSection: function (product) {
				////console.log("showBookingSection featured part list run");
				var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
              	var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;
				var vendor = this.selected[Object.keys(this.selected)[0]].product.vendor;
				var insurance = this.selected[Object.keys(this.selected)[0]].product.insurance_customer;
				
				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}

				this.$http.get(App.config.api.filemaker + '/store/withvendor/' + prodSKU + '/' + prodCode + '/' + vendor + '/' + insurance).then(function (data) {
					console.log(App.config.api.filemaker + '/store/withvendor/' + prodSKU + '/' + prodCode + '/' + vendor + '/' + insurance);
					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById('tab'+this.selected[Object.keys(this.selected)[0]].product.skuID);
					button.innerHTML = 'Select'; 

					var otherButtons = $('.part-select-btn');
					otherButtons.removeAttr('disabled');
					var path = window.location.pathname || '';
					var collectionMatch = path.match(/^\/collections\/([^\/\?]+)/);
					if (collectionMatch && collectionMatch[1]) {
						try {
							sessionStorage.setItem('jv_selected', JSON.stringify(this.selected || {}));
							sessionStorage.setItem('jv_selectedrear', JSON.stringify(this.selectedrear || {}));
							sessionStorage.setItem('jv_stores_list', JSON.stringify(this.stores && this.stores.list ? this.stores.list : []));
						} catch (e) {}
						sessionStorage.setItem('jv_source_collection', collectionMatch[1]);
						sessionStorage.setItem('stage', '1');
						navigateWithFunnelLoader('/pages/device-funnel-stage-1?source_collection=' + encodeURIComponent(collectionMatch[1]));
						return;
					}
					document.querySelector('body').classList.add("popup-active");	
					this.booking.stage = 1;
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						////console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			},			
			showPopupProduct: function (product,addrepair) {
				if (product.variants.length < 2) {
					//console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var selectedThis = document.getElementById('optiontab' + product.id).value;
					//console.log(selectedThis);
					if(selectedThis){
						$('.optionselect').addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
					
					//console.log('multi option product ' + selectedThisValue);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById('tab'+product.skuID);
				//var otherButtons = $('.part-select-btn');
				//otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				
				document.querySelector('body').classList.add("popup-active");
				
				var modal = document.getElementById("tabspopupModal");
				modal.style.display = "block";
				//addrepair = true;
				//this.showPopupBookingSection(popupproduct,addrepair);
			},
			selectPopupProduct: function (product) {
				if (product.variants.length < 2) {
					//console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var selectedThis = document.getElementById('popupoption' + product.id).value;
					//console.log(selectedThis);
					if(selectedThis){
						$('.optionselect').addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
					
					//console.log('multi option product ' + selectedThisValue);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selectedrear = Object.keys(this.selectedrear)[0];
				this.$delete(this.selectedrear, selectedrear);

				this.$set(this.selectedrear, product.id, {
					product: product,
					variant: selectedThisValue
				});
				if (window.repairApp) {
					window.repairApp.selectedrear = JSON.parse(JSON.stringify(this.selectedrear || {}));
				}
				try {
					sessionStorage.setItem('jv_selectedrear', JSON.stringify(this.selectedrear || {}));
				} catch (e) {}
				this.$emit('selected-changed', this.selectedrear);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById('popup'+product.id);
				var otherButtons = $('.part-select-btn');
				otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				addrepair = true;
				this.showPopupBookingSection(product,addrepair);
			},
			showPopupBookingSection: function (product,addrepair) {

				var prodSKU = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.sku;
              	var prodCode = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.option3;
				var reartype = 'housing';
				if(Object.keys(this.selected).length === 0){
					var prodSKUOne = ''; 
				} else {
					var prodSKUOne = this.selected[Object.keys(this.selected)[0]].variant.sku;
				}
				
				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}
				if(prodSKUOne.length > 1){
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodSKUOne + '/' + prodCode + '/' + reartype;
				} else {
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode + '/' + reartype;
				}
				////console.log("showRearBookingSection stockurl "+stockurl);
				this.$http.get(stockurl).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selectedrear[Object.keys(this.selectedrear)[0]].product.skuID);
					if( button )
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					//otherButtons.removeAttr('disabled');
					var path = window.location.pathname || '';
					var collectionMatch = path.match(/^\/collections\/([^\/\?]+)/);
					if (collectionMatch && collectionMatch[1]) {
						try {
							sessionStorage.setItem('jv_selected', JSON.stringify(this.selected || {}));
							sessionStorage.setItem('jv_selectedrear', JSON.stringify(this.selectedrear || {}));
							sessionStorage.setItem('jv_stores_list', JSON.stringify(this.stores && this.stores.list ? this.stores.list : []));
						} catch (e) {}
						sessionStorage.setItem('jv_source_collection', collectionMatch[1]);
						sessionStorage.setItem('stage', '1');
						navigateWithFunnelLoader('/pages/device-funnel-stage-1?source_collection=' + encodeURIComponent(collectionMatch[1]));
						return;
					}
					document.querySelector('body').classList.add("popup-active");
					if(addrepair == true){
						this.booking.stage = 1;						
						var modal = document.getElementById("tabspopupModal");
						modal.style.display = "none";
					} else {
						//screenModal();
						var modal = document.getElementById("screenModal");
						modal.style.display = "block";
					}
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});
				var otherButtons = $('.part-select-btn');
				otherButtons.attr('disabled', false);

				//scrollTo('.store-select');
			},
			continueWithout: function(product){
				var button = document.getElementById('without'+product.id);
				var otherButtons = $('.part-select-btn');
				otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				this.showBookingSection(product);
			}
		}
	});	
	
	Vue.component('tabsins', {
		template: '#tabsins',
		props: ['theproducts','loadSelected', 'booking', 'stores'],
		data: function () {
			return {
				selected: {},
				errors: null,
				products:[]
			};
		},
		mounted: function () {
			
			this.selected = this.loadSelected; 
		},
		computed:{
			
			is_variant_vend_product:function(){
				var selectedValues = Object.values(this.selected || {});
				var selectedRearValues = Object.values(this.selectedrear || {});
				var currentSelection = selectedValues.length > 0 ? selectedValues[0] : (selectedRearValues.length > 0 ? selectedRearValues[0] : null);
				if (!currentSelection || !currentSelection.variant || !currentSelection.variant.title) {
					return false;
				}
				var variantTitle = currentSelection.variant.title;
				return variantTitle.endsWith('BO-W-I') || variantTitle.endsWith('BO-D-I');
			}
		},
		methods: {
			togglePart: function (product) {
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection(product);
				}

			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			batteryRepairClose: function(){
				var modal = document.getElementById("batteryRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			opendescriptplus: function(thisdescript){
				$('.descript'+thisdescript).toggle('smooth');
				$('.descbutton'+thisdescript).toggleClass('active');
			},
			openrepairplus: function(thisdescript){
				$('.repairtime'+thisdescript).toggle('smooth');
				$('.timebutton'+thisdescript).toggleClass('active');
			},
			openplus: function(thisdescript){
				$('.'+thisdescript+'text').toggle('smooth');
				$('.'+thisdescript).toggleClass('active');
			},
			openadditionalplus: function(thisdescript,button){
				$('.repairtime'+thisdescript).toggle('smooth');
				$('.timebutton'+thisdescript).toggleClass('active');
				$('.importantclick'+button).toggleClass('active');
			},
			selectProduct: function (product) {
				if (product.variants.length < 2) {
					//console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var selectedThis = document.getElementById('optiontab' + product.id).value;
					//console.log(selectedThis);
					if(selectedThis){
						$('.optionselect').addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
					
					//console.log('multi option product ' + selectedThisValue);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById('tab'+product.skuID);
				var otherButtons = $('.part-select-btn');
				otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				this.showBookingSection(product);
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showBookingSection: function (product) {
				////console.log("showBookingSection featured part list run");
				var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
              	var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;
				var vendor = this.selected[Object.keys(this.selected)[0]].product.vendor;
				var insurance = this.selected[Object.keys(this.selected)[0]].product.insurance_customer;

				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}

				this.$http.get(App.config.api.filemaker + '/store/withvendor/' + prodSKU + '/' + prodCode + '/' + vendor + '/' + insurance).then(function (data) {
					console.log(App.config.api.filemaker + '/store/withvendor/' + prodSKU + '/' + prodCode + '/' + vendor + '/' + insurance);
					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById('tab'+this.selected[Object.keys(this.selected)[0]].product.skuID);
					button.innerHTML = 'Select'; 

					var otherButtons = $('.part-select-btn');
					otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					this.booking.stage = 1;
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						////console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});	

	//Tabs - I dont know option
	Vue.component('dontknow', {
		template: '#dontknow',
		props: ['theproducts','loadSelected', 'booking', 'stores'],
		data: function () {
			return {
				selected: {},
				errors: null,
				products:[]
			};
		},
		mounted: function () {
			
			this.selected = this.loadSelected; 
		},
		computed:{
			
		},
		methods: {
			togglePart: function (product) {
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection(product);
				}

			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			batteryRepairClose: function(){
				var modal = document.getElementById("batteryRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			selectProduct: function (product) {
				var selectedThisValue = product.variants[0]; 
				// if (product.variants.length < 2) {
				// 	//console.log('single product');

				// 	var selectedThisValue = product.variants[0];

				// } else if (product.variants.length > 1) {
				// 	var selectedThis = document.getElementById('option' + product.id).value;
				// 	if(selectedThis){
				// 		$('.optionselect').addClass('optionerror');
				// 	}
				// 	var selectedThisValue = JSON.parse(selectedThis);
					
				// 	//console.log('multi option product ' + selectedThisValue);
				// }
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById(product.skuID);
				var otherButtons = $('.part-select-btn');
				otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				this.showBookingSection(product);
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showBookingSection: function (product) {
				////console.log("showBookingSection featured part list run");
				var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
              	var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;
				var vendor = this.selected[Object.keys(this.selected)[0]].product.vendor;
				var insurance = this.selected[Object.keys(this.selected)[0]].product.insurance_customer;

				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}

				this.$http.get(App.config.api.filemaker + '/store/withvendor/' + prodSKU + '/' + prodCode + '/' + vendor + '/' + insurance).then(function (data) {
					////console.log("storeList "+data.body);
					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selected[Object.keys(this.selected)[0]].product.skuID);
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					otherButtons.removeAttr('disabled');
					var path = window.location.pathname || '';
					var collectionMatch = path.match(/^\/collections\/([^\/\?]+)/);
					if (collectionMatch && collectionMatch[1]) {
						try {
							sessionStorage.setItem('jv_selected', JSON.stringify(this.selected || {}));
							sessionStorage.setItem('jv_selectedrear', JSON.stringify(this.selectedrear || {}));
							sessionStorage.setItem('jv_stores_list', JSON.stringify(this.stores && this.stores.list ? this.stores.list : []));
						} catch (e) {}
						sessionStorage.setItem('jv_source_collection', collectionMatch[1]);
						sessionStorage.setItem('stage', '1');
						navigateWithFunnelLoader('/pages/device-funnel-stage-1?source_collection=' + encodeURIComponent(collectionMatch[1]));
						return;
					}
					document.querySelector('body').classList.add("popup-active");
					this.booking.stage = 1;
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						////console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});

	Vue.component('dontknow-ins', {
		template: '#dontknow-ins',
		props: ['theproducts','loadSelected', 'booking', 'stores'],
		data: function () {
			return {
				selected: {},
				errors: null,
				products:[]
			};
		},
		mounted: function () {
			
			this.selected = this.loadSelected; 
		},
		computed:{
			
		},
		methods: {
			togglePart: function (product) {
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection(product);
				}

			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			batteryRepairClose: function(){
				var modal = document.getElementById("batteryRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			selectProduct: function (product) {
				var selectedThisValue = product.variants[0]; 
				// if (product.variants.length < 2) {
				// 	//console.log('single product');

				// 	var selectedThisValue = product.variants[0];

				// } else if (product.variants.length > 1) {
				// 	var selectedThis = document.getElementById('option' + product.id).value;
				// 	if(selectedThis){
				// 		$('.optionselect').addClass('optionerror');
				// 	}
				// 	var selectedThisValue = JSON.parse(selectedThis);
					
				// 	//console.log('multi option product ' + selectedThisValue);
				// }
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById(product.skuID);
				var otherButtons = $('.part-select-btn');
				otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				this.showBookingSection(product);
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showBookingSection: function (product) {
				////console.log("showBookingSection featured part list run");
				var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
              	var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;
				var vendor = this.selected[Object.keys(this.selected)[0]].product.vendor;
				var insurance = this.selected[Object.keys(this.selected)[0]].product.insurance_customer;

				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}

				this.$http.get(App.config.api.filemaker + '/store/withvendor/' + prodSKU + '/' + prodCode + '/' + vendor + '/' + insurance).then(function (data) {
					////console.log("storeList "+data.body);
					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selected[Object.keys(this.selected)[0]].product.skuID);
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					this.booking.stage = 1;
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						////console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});
  
	//Part List
	Vue.component('part-list', {
		template: '#part-list',
		props: ['loadProducts', 'loadSelected', 'booking', 'stores', 'storesOpen'],
		data: function () {
			return {
				isinsurance: this.$isinsurance,
				selected: {}
			};
		},
		mounted: function () {
			this.selected = this.loadSelected;
		},
		methods: {
			togglePart: function (product) {
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection();
				}

			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes","210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}


			},
			screenRepair: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log(thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			selectProduct: function (product) {

				if (product.variants.length < 2) {
					////console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var selectedThis = document.getElementById('option' + product.id).value;
					var selectedThisValue = JSON.parse(selectedThis);
					////console.log('multi option product ' + selectedThis);

				}
				////console.log(selectedThis);
				if (product.discountamount) {
					this.booking.discountamount = product.discountamount;
				}
				////console.log(this.booking.discountamount);
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById(product.skuID);
				var otherButtons = $('.part-select-btn');
				otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				this.showBookingSection(product);
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showBookingSection: function (product) {
				if(1==1){
					////console.log("showBookingSection part list run"); 
					var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
					var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;
					
					this.setRepairTime(product);
					if (prodSKU == '' || prodSKU == null) {
						prodSKU = 'SKUNOTFOUND';
					}
					//console.log("Product SKU "+prodSKU);
					this.$http.get(App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode).then(function (data) {

						var storeList = data.body;
						this.stores.list = storeList;
						var button = document.getElementById(this.selected[Object.keys(this.selected)[0]].product.skuID);
						button.innerHTML = 'Select';

						var otherButtons = $('.part-select-btn');
						otherButtons.removeAttr('disabled');
						var path = window.location.pathname || '';
						var collectionMatch = path.match(/^\/collections\/([^\/\?]+)/);
						if (collectionMatch && collectionMatch[1]) {
							try {
								sessionStorage.setItem('jv_selected', JSON.stringify(this.selected || {}));
								sessionStorage.setItem('jv_selectedrear', JSON.stringify(this.selectedrear || {}));
								sessionStorage.setItem('jv_stores_list', JSON.stringify(this.stores && this.stores.list ? this.stores.list : []));
							} catch (e) {}
							sessionStorage.setItem('jv_source_collection', collectionMatch[1]);
							sessionStorage.setItem('stage', '1');
							navigateWithFunnelLoader('/pages/device-funnel-stage-1?source_collection=' + encodeURIComponent(collectionMatch[1]));
							return;
						}
						document.querySelector('body').classList.add("popup-active");
						this.booking.stage = 1;
						ga('send', 'pageview', '?select-method');
						button.innerHTML = 'Book Repair';
						////console.log("Store List "+storeList);

						// check if there are at least 5 store with this repair in stock
						checkStock(this.stores.list);
						////console.log(StockQty);

					}, function (data) {
						console.error(data);
					});
				}else{
					var button = document.getElementById(this.selected[Object.keys(this.selected)[0]].product.skuID);
					button.innerHTML = 'Select';
					var otherButtons = $('.part-select-btn');
					otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					this.booking.stage = 1;
					ga('send', 'pageview', '?select-method');
					button.innerHTML = 'Book Repair';
				}	
				


				//scrollTo('.store-select');
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						////console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});

	//Iphone Part List
    Vue.component('iphone-parts-list', {
        template: '#iphone-parts-list',
        props: ['loadProducts', 'loadSelected', 'booking', 'stores'],
        data: function() {
            return {
                selected: {},
				products:[]
            };
        },
        mounted: function() {
			var macbookFirstBattery = window.macbookRepairUsesSharedFunnel ? window.loadProducts.find(function (product) { return product.type === "Battery"; }) : null;
			this.products = window.loadProducts.filter(prod=>{
				//we dont want to include the composit products in the product parts loop
				return !prod.tags.includes('iPhone_Standard') && !prod.tags.includes("iPhone_Premium") && !prod.title.includes('Other Issue Diagnostics') && !prod.title.includes('Other Diagnostics') && (prod.type!=="Battery" || (macbookFirstBattery && prod.id !== macbookFirstBattery.id))
			});
			if(window.bt_prod){
				//this.products = this.products.filter(prod=>prod.)
			}
            this.selected = this.loadSelected;
        },
        methods: {
            togglePart: function(product) {
                var selected = Object.keys(this.selected)[0];
                this.$delete(this.selected, selected);

                this.$set(this.selected, product.id, {
                    product: product,
                    variant: product.variants[0]
                });
                this.$emit('selected-changed', this.selected);
                if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
                    ////console.log($('.totals-contain2').offset().top);
                    var button = document.getElementById(product.skuID);
                    button.innerHTML = 'Loading...';

                    this.showBookingSection();
                }

            },
            getRepairTime: function(product) {
                var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "24 - 48 hours","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
                for (var i = 0; i < product.tags.length; i++) {
                    if (repairTags.indexOf(product.tags[i]) > -1) {
                        return product.tags[i];
                    }
                }
            },
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			batteryRepairClose: function(){
				var modal = document.getElementById("batteryRepairModal");
				modal.style.display = "none";
			},
            selectProduct: function(product) {
				if (product.variants.length < 2) {
					//console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					//console.log('multi option product');
					var selectedThis = document.getElementById('option'+product.id).value;
					var selectedThisValue = JSON.parse(selectedThis);

				}
                //console.log(selectedThis);

                var selected = Object.keys(this.selected)[0];
                this.$delete(this.selected, selected);

                this.$set(this.selected, product.id, {
                    product: product,
                    variant: selectedThisValue
                });
                this.$emit('selected-changed', this.selected);
                ////console.log($('.totals-contain2').offset().top);
                var button = document.getElementById(product.skuID);
                button.innerHTML = 'Loading...';
                this.showBookingSection(product);
            },
            statusSelected (evt) {
                //console.log(JSON.parse(evt.target.value))
            },
            showBookingSection: function(product) {


                var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
				var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;
				this.setRepairTime(product);
                if(prodSKU == ''){
                    prodSKU = 'SKUNOTFOUND';
                }
				////console.log("Testing this");
                this.$http.get(App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode).then(function(data) {

                    var storeList = data.body;
                    this.stores.list = storeList;
                    var button = document.getElementById(this.selected[Object.keys(this.selected)[0]].product.skuID);
                    button.innerHTML = 'Select';

                    if (startMacbookRepairFunnel(this)) return;
                    document.querySelector('body').classList.add("popup-active");
                    this.booking.stage = 1;
                    ga('send', 'pageview', '?select-method');
                    
                }, function(data) {
                    console.error(data);
                });


                scrollTo('.store-select');
            },
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				for (var i = 0; i <= product.tags.length; i++) {
					//console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						//console.log("Tag match "+product.tags[i]);
						//this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						////console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
        }
    });
	
	//Battery Part List
    Vue.component('battery-parts-list', {
        template: '#battery-parts-list',
        props: ['loadProducts', 'loadSelected', 'booking', 'stores'],
        data: function() {
            return {
				skyjourney: this.$skyjourney,
                selected: {},
				products:[]
            };
        },
        mounted: function() {
			this.products = window.loadProducts.filter(prod=>{
				//we dont want to include the composit products in the product parts loop
				return !prod.tags.includes('iPhone_Standard') && !prod.tags.includes("iPhone_Premium") && !prod.title.includes('Other Issue Diagnostics') && !prod.title.includes('Other Diagnostics')
			});
			if(window.bt_prod){
				//this.products = this.products.filter(prod=>prod.)
			}
            this.selected = this.loadSelected;
        },
        methods: {
            togglePart: function(product) {
                var selected = Object.keys(this.selected)[0];
                this.$delete(this.selected, selected);

                this.$set(this.selected, product.id, {
                    product: product,
                    variant: product.variants[0]
                });
                this.$emit('selected-changed', this.selected);
                if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
                    ////console.log($('.totals-contain2').offset().top);
                    var button = document.getElementById(product.skuID);
                    button.innerHTML = 'Loading...';

                    this.showBookingSection();
                }

            },
            getRepairTime: function(product) {
                var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "24 - 48 hours","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
                for (var i = 0; i < product.tags.length; i++) {
                    if (repairTags.indexOf(product.tags[i]) > -1) {
                        return product.tags[i];
                    }
                }
            },
			batteryRepairClose: function(){
				var modal = document.getElementById("batteryRepairModal");
				modal.style.display = "none";
			},
            selectProduct: function(product) {
				if (product.variants.length < 2) {
					//console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					//console.log('multi option product');
					var selectedThis = document.getElementById('option'+product.id).value;
					var selectedThisValue = JSON.parse(selectedThis);

				}
                //console.log(selectedThis);

                var selected = Object.keys(this.selected)[0];
                this.$delete(this.selected, selected);

                this.$set(this.selected, product.id, {
                    product: product,
                    variant: selectedThisValue
                });
                this.$emit('selected-changed', this.selected);
                ////console.log($('.totals-contain2').offset().top);
                var button = document.getElementById(product.skuID);
                button.innerHTML = 'Loading...';
                this.showBookingSection(product);
            },
            statusSelected (evt) {
                //console.log(JSON.parse(evt.target.value))
            },
            showBookingSection: function(product) {

                var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
				var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;
				this.setRepairTime(product);
                if(prodSKU == ''){
                    prodSKU = 'SKUNOTFOUND';
                }
				////console.log("Testing this");
                this.$http.get(App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode).then(function(data) {

                    var storeList = data.body;
                    this.stores.list = storeList;
                    var button = document.getElementById(this.selected[Object.keys(this.selected)[0]].product.skuID);
                    button.innerHTML = 'Select';

                    document.querySelector('body').classList.add("popup-active");
					this.booking.delivery_type = 'store_visit';
                    this.booking.stage = 1;
                    ga('send', 'pageview', '?select-method');
                    
                }, function(data) {
                    console.error(data);
                });


                scrollTo('.store-select');
            },
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				for (var i = 0; i <= product.tags.length; i++) {
					//console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						//console.log("Tag match "+product.tags[i]);
						//this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						////console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
        }
    });

	//Featured Part List
	Vue.component('featured-product', {
		template: '#featured-product',
		props: ['thefeaturedproduct', 'loadSelected', 'booking', 'stores'],
		data: function () {
			return {				
				isinsurance: this.$isinsurance,
				selected: {}
			};
		},
		mounted: function () {
			this.selected = this.loadSelected;
          //console.log(this);
		},
		methods: {
			togglePart: function (product) {
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection();
				}

			},
			getRepairTime: function (product) {
				//console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			selectProduct: function (product) {

				if (product.variants.length < 2) {
					////console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var selectedThis = document.getElementById('option' + product.id).value;
					var selectedThisValue = JSON.parse(selectedThis);
					//console.log('multi option product ' + selectedThisValue);

				}
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById(product.skuID);
				var otherButtons = $('.part-select-btn');
				otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				this.showBookingSection();
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showBookingSection: function (product) {

				//console.log("showBookingSection featured part list run");
				var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
              	var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;

				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}

				this.$http.get(App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selected[Object.keys(this.selected)[0]].product.skuID);
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					this.booking.stage = 1;
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});



				//scrollTo('.store-select');
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						////console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});

	//March Featured Part List
	Vue.component('march-featured', {
		template: '#march-featured',
		props: ['thefeaturedproduct', 'loadSelected', 'booking', 'stores'],
		data: function () {
			return {
				isinsurance: this.$isinsurance,
				selected: {},
				errors: null
			};
		},
		mounted: function () {
			this.selected = this.loadSelected;
		},
		methods: {
			togglePart: function (product) {
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection();
				}

			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			selectProduct: function (product) {

				if (product.variants.length < 2) {
					//console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					//console.log('multi option product ' + selectedThisValue);
					var selectedThis = document.getElementById('option' + product.id).value;
					if(selectedThis){
						$('.optionselect').addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
					
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById(product.skuID);
				var otherButtons = $('.part-select-btn');
				otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				this.showBookingSection(product);
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showBookingSection: function (product) {

				////console.log("showBookingSection featured part list run");
				var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
              var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;

				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}

				this.$http.get(App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selected[Object.keys(this.selected)[0]].product.skuID);
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					this.booking.stage = 1;
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						////console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});

	//Samsung Price Part List
	Vue.component('power-of-one', {
		template: '#power-of-one',
		props: ['thefeaturedproduct', 'loadSelected', 'booking', 'stores'],
		data: function () {
			return {
				isinsurance: this.$isinsurance,
				selected: {},
				errors: null
			};
		},
		mounted: function () {
			this.selected = this.loadSelected;
		},
		methods: {
			togglePart: function (product) {
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection();
				}

			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			selectProduct: function (product) {

				if (product.variants.length < 2) {
					//console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var selectedThis = document.getElementById('option' + product.id).value;
					if(selectedThis){
						$('.optionselect').addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
					
					////console.log('multi option product ' + selectedThisValue);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById(product.skuID);
				var otherButtons = $('.part-select-btn');
				otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				this.showBookingSection(product);
			},
			selectProductM: function (product) {

				if (product.variants.length < 2) {
					//console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var selectedThis = document.getElementById('optionM' + product.id).value;
					if(selectedThis){
						$('.optionselect').addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
					
					////console.log('multi option product ' + selectedThisValue);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById("M"+product.skuID);
				var otherButtons = $('.part-select-btn');
				otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				this.showBookingSection(product);
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showBookingSection: function (product) {

				////console.log("showBookingSection featured part list run");
				var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
              var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;

				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}

				this.$http.get(App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selected[Object.keys(this.selected)[0]].product.skuID);
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					otherButtons.removeAttr('disabled');
					if (startMacbookRepairFunnel(this)) return;
                    document.querySelector('body').classList.add("popup-active");
					this.booking.stage = 1;
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						////console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});

	//Old New Price Part List
	Vue.component('old-new', {
		template: '#old-new',
		props: ['thefeaturedproduct', 'loadSelected', 'booking', 'stores'],
		data: function () {
			return {
				isinsurance: this.$isinsurance,
				selected: {},
				errors: null
			};
		},
		mounted: function () {
			this.selected = this.loadSelected;
		},
		methods: {
			togglePart: function (product) {
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection();
				}

			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			selectProduct: function (product) {

				if (product.variants.length < 2) {
					//console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var selectedThis = document.getElementById('option' + product.id).value;
					if(selectedThis){
						$('.optionselect').addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
					
					//console.log('multi option product ' + selectedThisValue);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById(product.skuID);
				var otherButtons = $('.part-select-btn');
				otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				this.showBookingSection(product);
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showBookingSection: function (product) {

				////console.log("showBookingSection featured part list run");
				var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
              var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;

				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}

				this.$http.get(App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selected[Object.keys(this.selected)[0]].product.skuID);
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					this.booking.stage = 1;
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						////console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});

	//New Iphone templates aug 2020
	Vue.component('iphone-new-aug-20', {
		template: '#iphone-new-aug-20',
		props: ['thefeaturedproduct', 'loadSelected', 'booking', 'stores'],
		data: function () {
			return {
				isinsurance: this.$isinsurance,
				selected: {},
				errors: null,
				products:[],
				collection:{},
				is_iphoneX:false,
				premium_service_product:{}
			};
		},
		mounted: function () {
			//the service level produt handle https://ismashuk.myshopify.com/admin/products/4703107842137
			let prod_handle = "iphonescreenrepairservicelevel";
			let comp = this;
			//get the product sevice level
			fetch(`/products/${prod_handle}.js`).then(response=>response.json()).then(data=>{

				let title = window.collection.title.replace('Screen Replacement','').replace('&','').replace('Other','').replace('Repairs','').replace('Test','').replace('- Composite Test','').trim().toLowerCase()
				comp.premium_service_product = data.variants.find(variant=>{
					let option="";
					if(variant.option1 && variant.option2 === "Premium")
						option = variant.option1.trim().toLowerCase();
					else
						option = variant.title.replace('Screen Replacement','').replace('&','').replace('Other','').replace('Repairs','').replace('Test','').replace('- Composite Test','').replace('/ premium','').replace('/ Premium','').trim().toLowerCase()
					////console.log(`${title}------ ${option} -------`)
					return title == option;
				});
				comp.$root.premium_service_product = comp.premium_service_product;
			})
			 
		

			this.products = window.loadProducts.filter(prod=>{
				//we dont want to include the composit products in the product parts loop
				return !prod.tags.includes('iPhone_Standard') && !prod.tags.includes("iPhone_Premium")
			});
			this.selected = this.loadSelected; 
			this.collection = window.collection;
			if(window.location.href.includes('x=true')){
				this.is_iphoneX = true;
			}
			let x = document.getElementById('top-header-hidden');
			let anchor = '<a class="top-header-hidden__readmore" onclick="showFull()">Read More</a>';
			if(x) x.innerHTML = x.innerHTML.slice(0,373) + '...' + anchor;

		},
		computed:{
			 
		},
		methods: {
			togglePart: function (product) {
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection();
				}

			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function( premium = false){
				if(premium){
					this.$root.booking.is_premium = true;
					this.$root.booking.premium_cost = parseInt(this.premium_service_product.price);
				}else{
					this.$root.booking.is_premium = false;
					this.$root.booking.premium_cost = 0;
				}
				window.screen_repair_modal_open = true;
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
				window.screen_repair_modal_open = false;
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			selectProduct: function (product,premium) {
				if(premium){
					this.$root.booking.is_premium = true;
					this.$root.booking.premium_cost = parseInt(this.premium_service_product.price);
				}else{
					this.$root.booking.is_premium = false;
					this.$root.booking.premium_cost = 0;
				}
				if (product.variants.length < 2) {
					//console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var prodid = `option${product.id}`;
					if(premium)
						prodid = `option-premium${product.id}`;

					var selectedThis = document.getElementById(prodid).value;
					if(!!selectedThis){
						if(premium){
							$(`.premium #${prodid}`).addClass('optionerror');
						}else
						$(`#${prodid}`).addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
					
					//console.log('multi option product ' + selectedThisValue);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById(product.skuID);
				if(premium){
					var button = document.getElementById(`${product.skuID}-premium`);
				}

				

				var otherButtons = $('.part-select-btn');
				otherButtons.attr('disabled', 'disabled');

				if(window.screen_repair_modal_open){
					var button = document.querySelector("#screenRepairModal button.part-select-btn")
				}

				if(button)
					button.innerHTML = 'Loading...';
					
				this.showBookingSection(product);
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showBookingSection: function (product) {

				////console.log("showBookingSection featured part list run");
				var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
              var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;

				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}

				this.$http.get(App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selected[Object.keys(this.selected)[0]].product.skuID);
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					this.booking.stage = 1;
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						////console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});

	Vue.component('iphone-two-products', {
		template: '#iphone-two-products',
		props: ['loadSelected', 'booking', 'stores','productonebullets','producttwobullets'],
		data: function () {
			return {
				selected: {},
				errors: null,
				products:[]
			};
		},
		mounted: function () {
			this.products = window.loadProducts.filter(prod=>{
				//we dont want to include the composit products in the product parts loop
				return !prod.tags.includes('iPhone_Standard')
			});
			this.selected = this.loadSelected; 
		},
		computed:{
			unknown_product(){
				let unknown_product =  window.loadProducts.find(prod=>{
					return prod.type==="Diagnostics"
				});
				window.unknown_product = unknown_product;
				return unknown_product;
			},
			battery_product(){
				let bt_prod =  window.loadProducts.find(prod=>{
					return prod.type=="Battery"
				});
				window.bt_prod = bt_prod;
				return bt_prod;
			}
		},
		methods: {
			togglePart: function (product) {
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection(product);
				}

			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			batteryRepairClose: function(){
				var modal = document.getElementById("batteryRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			selectProduct: function (product) {
				if (product.variants.length < 2) {
					//console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var selectedEl = document.getElementById('option' + product.id) || document.getElementById('optiontab' + product.id) || document.getElementById('optionsinglescreen' + product.id) || document.getElementById('optioninsure' + product.id);
					var selectedThis = selectedEl ? selectedEl.value : '';
					if(selectedThis){
						$('.optionselect').addClass('optionerror');
					}
					var selectedThisValue = selectedThis ? JSON.parse(selectedThis) : product.variants[0];
					
					//console.log('multi option product ' + selectedThisValue);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById(product.skuID) || document.getElementById('tab' + product.skuID) || document.getElementById('single' + product.skuID) || document.getElementById('insurebutton' + product.skuID);
				var otherButtons = $('.part-select-btn');
				otherButtons.attr('disabled', 'disabled');
				if (button) {
					button.innerHTML = 'Loading...';
				}
				this.showBookingSection(product);
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showBookingSection: function (product) {
				////console.log("showBookingSection featured part list run");
				var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
              	var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;

				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}

				this.$http.get(App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode).then(function (data) {
					////console.log("storeList "+data.body);
					var storeList = data.body;
					this.stores.list = storeList;
					var selectedProduct = this.selected[Object.keys(this.selected)[0]].product;
					var button = document.getElementById(selectedProduct.skuID) || document.getElementById('tab' + selectedProduct.skuID) || document.getElementById('single' + selectedProduct.skuID) || document.getElementById('insurebutton' + selectedProduct.skuID);
					if (button) {
						button.innerHTML = 'Select';
					}

					var otherButtons = $('.part-select-btn');
					otherButtons.removeAttr('disabled');
					if (startMacbookRepairFunnel(this)) return;
                    document.querySelector('body').classList.add("popup-active");
					this.booking.stage = 1;
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						////console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});

	Vue.component('single-product', {
		template: '#single-product-template',
		props: ['loadSelected','description','productbullets', 'booking', 'stores','product','buttonText'],
		data: function () {
			return {
				selected: {},
				errors: null,
				products:[]
			};
		},
		mounted: function () {
			this.selected = this.loadSelected; 
		},
		computed:{
			text(){
				if(this.buttonText)
				return this.buttonText
				else return "Book repair";
			}
		},
		methods: {
			togglePart: function (product) {
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					if(button) button.innerHTML = 'Loading...';
					this.showBookingSection(product);
				}

			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			selectProduct: function (product) {
				if (product.variants.length < 2) {
					//console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var selectedThis = document.getElementById('option' + product.id).value;
					if(selectedThis){
						$('.optionselect').addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
					
					//console.log('multi option product ' + selectedThisValue);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById(product.skuID);
				var otherButtons = $('.part-select-btn');
				if(otherButtons) otherButtons.attr('disabled', 'disabled');
				if(button) button.innerHTML = 'Loading...';
				this.showBookingSection(product);
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showBookingSection: function (product) {
				////console.log("showBookingSection featured part list run");
				var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
              var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;

				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}

				this.$http.get(App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selected[Object.keys(this.selected)[0]].product.skuID);
					if(button) button.innerHTML = 'Select';
					var otherButtons = $('.part-select-btn');
					if(otherButtons) otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					this.booking.stage = 1;
					//ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						////console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});
	
	//OLED-LCD Part List
	Vue.component('oled-lcd', {
		template: '#oled-lcd',
		props: ['thefeaturedproduct', 'loadSelected', 'booking', 'stores'],
		data: function () {
			return {
				isinsurance: this.$isinsurance,
				selected: {},
				errors: null
			};
		},
		mounted: function () {
			this.selected = this.loadSelected;
			//console.log(this);
			//console.log(this.thefeaturedproduct);
		},
		methods: {
			togglePart: function (product) {
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection();
				}

			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			selectProduct: function (product) {

				if (product.variants.length < 2) {
					//console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var selectedThis = document.getElementById('option' + product.id).value;
					if(selectedThis){
						$('.optionselect').addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
					
					//console.log('multi option product ' + selectedThisValue);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById(product.skuID);
				var otherButtons = $('.part-select-btn');
				otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				this.showBookingSection(product);
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showBookingSection: function (product) {

				////console.log("showBookingSection featured part list run");
				var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
              var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;

				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}

				this.$http.get(App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selected[Object.keys(this.selected)[0]].product.skuID);
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					this.booking.stage = 1;
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						////console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});

	//Powr of 3 Part Screen List
	Vue.component('iphone-power-of-three', {
		template: '#iphone-power-of-three',
		props: ['thefeaturedproduct', 'loadSelected', 'loadSelectedRear', 'booking', 'stores','theinsuranceproduct'],
		data: function () {
			return {
				isinsurance: this.$isinsurance,
				selected: {},
				selectedrear: {},
				errors: null,
				collection:{},
				premium_service_product:{}
			};
		},
		mounted: function () {
			//the service level produt handle https://ismashuk.myshopify.com/admin/products/4703107842137
			let prod_handle = "iphonescreenrepairservicelevel";
			let comp = this;
			//get the product sevice level
			fetch(`/products/${prod_handle}.js`).then(response=>response.json()).then(data=>{

				let title = window.collection.title.replace('Screen Replacement','').replace('&','').replace('Other','').replace('Repairs','').replace('Test','').replace('- Composite Test','').trim().toLowerCase()
				comp.premium_service_product = data.variants.find(variant=>{
					let option="";
					if(variant.option1 && variant.option2 === "Premium")
						option = variant.option1.trim().toLowerCase();
					else
						option = variant.title.replace('Screen Replacement','').replace('&','').replace('Other','').replace('Repairs','').replace('Test','').replace('- Composite Test','').replace('/ premium','').replace('/ Premium','').trim().toLowerCase()
					////console.log(`${title}------ ${option} -------`)
					return title == option;
				});
				comp.$root.premium_service_product = comp.premium_service_product;
			})
			 
		

			this.products = window.loadProducts.filter(prod=>{
				//we dont want to include the composit products in the product parts loop
				return !prod.tags.includes('iPhone_Standard') && !prod.tags.includes("iPhone_Premium")
			});
			this.selected = this.loadSelected; 
			this.selectedrear = this.loadSelectedRear; 
			this.collection = window.collection;
			if(window.location.href.includes('x=true')){
				this.is_iphoneX = true;
			}
			let x = document.getElementById('top-header-hidden');
			let anchor = '<a class="top-header-hidden__readmore" onclick="showFull()">Read More</a>';
			if(x) x.innerHTML = x.innerHTML.slice(0,150) + '...' + anchor;

		},
		computed:{
			featured_product(){
              	if(this.thefeaturedproduct)
					return this.thefeaturedproduct[0] ? this.thefeaturedproduct[0]  : false;
                else return false;
			},
			insurance_product(){
              	if(this.theinsuranceproduct)
					return this.theinsuranceproduct[0] ? this.theinsuranceproduct[0]  : false;
                else return false;
			},			
			lcd_product(){
				let d =  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('LCD_Product');
				})
				//return d;
				
              	if(d)
					return d ? d  : false;
                else return false;
			},
			oled_product(){
				let d=  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('OLED_Product');
				})
				//return d;
				
              	if(d)
					return d ? d  : false;
                else return false;
			},
			apple_product(){
				let d=  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('APPLE_PRODUCT');
				})
				//return d;
				
              	if(d)
					return d ? d  : false;
                else return false;
			},
			powerclass(){

				let APPLE_PRODUCT = this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('APPLE_PRODUCT');
				})
				let LCD_Product = this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('LCD_Product');
				})
				let OLED_Product = this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('OLED_Product');
				})

				if(LCD_Product && OLED_Product && APPLE_PRODUCT){
					return "power3";
				} else {
					return "power2";
				}

			},			
			back_glass(){	
				let d =  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('backglass');
				})
				//return d;
				
              	if(d)
					return d ? d  : false;
                else return false;
			},
			rear_housing(){
				let d =  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('rearhousing');
				})
				//return d;
				
              	if(d)
					return d ? d  : false;
                else return false;
			},
			apple_replacement(){
				let d =  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('appledummy');
				})
				//return d;
				
              	if(d)
					return d ? d  : false;
                else return false;
			}
		},
		methods: {
			togglePart: function (product) {
				//console.log("togglePart fires here");
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection();
				}

			}, 
			opendescriptplus: function(thisdescript){
				$('.descript'+thisdescript).toggle('smooth');
				$('.descbutton'+thisdescript).toggleClass('active');
			},
			openrepairplus: function(thisdescript){
				$('.repairtime'+thisdescript).toggle('smooth');
				$('.timebutton'+thisdescript).toggleClass('active');
			},
			openplus: function(thisdescript){
				$('.'+thisdescript+'text').toggle('smooth');
				$('.'+thisdescript).toggleClass('active');
			},
			openadditionalplus: function(thisdescript,button){
				$('.repairtime'+thisdescript).toggle('smooth');
				$('.timebutton'+thisdescript).toggleClass('active');
				$('.importantclick'+button).toggleClass('active');
			},
			cardAccordions: function(id,closeclass){
				if($( "#"+id ).is(":visible")){
					$("#"+id).hide("slow"); 	
					$("."+id).removeClass("active"); 
				}else{
					$("."+closeclass).hide("slow");
					$("#"+id).show("slow");
					$("."+id).siblings().removeClass("active"); 	
					$("."+id).addClass("active"); 
				}

			},
			cardToggle: function(show,buttonclass,card){
				$("."+show).toggle("slow");
				$("."+buttonclass).toggleClass("active");  
				$("."+card).toggleClass("active");  
			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			closePopupModal: function(thisModal){
				var otherButtons = $('.part-select-btn');
				//otherButtons.attr('disabled', 'disabled');
				otherButtons.innerHTML = 'Book Repair';
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
				$('body').removeClass('popup-active');
			},
			closeNotifyMe: function(){
				
				var modal = document.getElementById("notifymeModal");
				modal.style.display = "none";
			},
			selectProduct: function (product,premium,addrepair,id) {
				this.$root.booking.is_premium = false;
				this.$root.booking.premium_cost = 0;
				if (product.variants.length < 2) {
					////console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var prodid = `option${product.id}`;
					if(premium) {
						prodid = `option-premium${product.id}`;
					}
					// //console.log('prodid '+prodid);
					var selectedThis = document.getElementById(prodid).value;
					if(!!selectedThis){
						if(premium){
							$(`.premium #${prodid}`).addClass('optionerror');
						}else
						$(`#${prodid}`).addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
					
					////console.log('multi option product ' + selectedThisValue);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById(product.skuID);
				if(premium){
					var button = document.getElementById(`${product.skuID}-premium`);
				}
				if(id){
					if(premium){
						var button = document.getElementById(`${product.id}-premium`);
					} else {
						var button = document.getElementById(product.id);
					}
				}
				// //console.log('product.skuID '+product.skuID);
				// //console.log('button '+button);

				// var otherButtons = $('.part-select-btn');
				// otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				this.showBookingSection(product,addrepair);
			},
			showBookingSection: function (product,addrepair) {
				////console.log("showBookingSection featured part list run");
				var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
				var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;
				var reartype = 'housing';
				if(Object.keys(this.selectedrear).length === 0){
					var prodSKUTwo = ''; 
				} else {
					var prodSKUTwo = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.sku;
					var backglassTags = ["backglass"];
					var backglasscheck = this.selectedrear[Object.keys(this.selectedrear)[0]].product;
					for (var i = 0; i < backglasscheck.tags.length; i++) {
						////console.log(product.tags);
						if (backglassTags.indexOf(backglasscheck.tags[i]) > -1) {
							////console.log(product.tags[i]);
							reartype = 'backglass';
						}
					}
				}

				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}

				if(prodSKUTwo.length > 1){
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodSKUTwo + '/' + prodCode + '/' + reartype;
				} else {
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode + '/' + reartype;
				}

				this.$http.get(stockurl).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selected[Object.keys(this.selected)[0]].product.skuID);
					if( button )
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					//otherButtons.removeAttr('disabled');

					var path = window.location.pathname || '';
					var collectionMatch = path.match(/^\/collections\/([^\/\?]+)/);
					if (collectionMatch && collectionMatch[1]) {
						try {
							sessionStorage.setItem('jv_selected', JSON.stringify(this.selected || {}));
							sessionStorage.setItem('jv_selectedrear', JSON.stringify(this.selectedrear || {}));
							sessionStorage.setItem('jv_stores_list', JSON.stringify(this.stores && this.stores.list ? this.stores.list : []));
						} catch (e) {}
						sessionStorage.setItem('jv_source_collection', collectionMatch[1]);
						sessionStorage.setItem('stage', '1');
						navigateWithFunnelLoader('/pages/device-funnel-stage-1?source_collection=' + encodeURIComponent(collectionMatch[1]));
						return;
					}

					document.querySelector('body').classList.add("popup-active");
					if(addrepair == true){
						this.booking.stage = 1;
					} else {
						//rearModal();
						var modal = document.getElementById("rearModal");
						modal.style.display = "block";
					}
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			showRearBookingSection: function (product,addrepair) {

				var prodSKU = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.sku;
              	var prodCode = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.option3;
				var reartype = 'housing';
				if(Object.keys(this.selected).length === 0){
					var prodSKUOne = ''; 
				} else {
					var prodSKUOne = this.selected[Object.keys(this.selected)[0]].variant.sku;
				}

				var backglassTags = ["backglass"];
				var backglasscheck = this.selectedrear[Object.keys(this.selectedrear)[0]].product;
				////console.log("backglasscheck "+backglasscheck);
				for (var i = 0; i < backglasscheck.tags.length; i++) {
					
					if (backglassTags.indexOf(backglasscheck.tags[i]) > -1) {
						////console.log(product.tags[i]);
						reartype = 'backglass';
					}
				}
				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}
				if(prodSKUOne.length > 1){
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodSKUOne + '/' + prodCode + '/' + reartype;
				} else {
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode + '/' + reartype;
				}
				////console.log("showRearBookingSection stockurl "+stockurl);
				this.$http.get(stockurl).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selectedrear[Object.keys(this.selectedrear)[0]].product.skuID);
					if( button )
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					//otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					if(addrepair == true){
						this.booking.stage = 1;
					} else {
						//screenModal();
						var modal = document.getElementById("screenModal");
						modal.style.display = "block";
					}
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				if(this.booking.appointmentDuration){
					var existingappointmentDuration = this.booking.appointmentDuration;
				} else {
					var existingappointmentDuration = 0;
				}
				//console.log("existingappointmentDuration "+existingappointmentDuration);
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						//this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90+existingappointmentDuration;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240+existingappointmentDuration;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360+existingappointmentDuration;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120+existingappointmentDuration;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180+existingappointmentDuration;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210+existingappointmentDuration;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30+existingappointmentDuration;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						//console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});
	
	Vue.component('iphone-power-of-three-ins', {
		template: '#iphone-power-of-three-ins',
		props: ['thefeaturedproduct', 'loadSelected', 'loadSelectedRear', 'booking', 'stores','theinsuranceproduct'],
		data: function () {
			return {
				isinsurance: this.$isinsurance,
				selected: {},
				selectedrear: {},
				errors: null,
				collection:{},
				premium_service_product:{}
			};
		},
		mounted: function () {
			//the service level produt handle https://ismashuk.myshopify.com/admin/products/4703107842137
			let prod_handle = "iphonescreenrepairservicelevel";
			let comp = this;
			//get the product sevice level
			fetch(`/products/${prod_handle}.js`).then(response=>response.json()).then(data=>{

				let title = window.collection.title.replace('Screen Replacement','').replace('&','').replace('Other','').replace('Repairs','').replace('Test','').replace('- Composite Test','').trim().toLowerCase()
				comp.premium_service_product = data.variants.find(variant=>{
					let option="";
					if(variant.option1 && variant.option2 === "Premium")
						option = variant.option1.trim().toLowerCase();
					else
						option = variant.title.replace('Screen Replacement','').replace('&','').replace('Other','').replace('Repairs','').replace('Test','').replace('- Composite Test','').replace('/ premium','').replace('/ Premium','').trim().toLowerCase()
					////console.log(`${title}------ ${option} -------`)
					return title == option;
				});
				comp.$root.premium_service_product = comp.premium_service_product;
			})
			 
		

			this.products = window.loadProducts.filter(prod=>{
				//we dont want to include the composit products in the product parts loop
				return !prod.tags.includes('iPhone_Standard') && !prod.tags.includes("iPhone_Premium")
			});
			this.selected = this.loadSelected; 
			this.selectedrear = this.loadSelectedRear; 
			this.collection = window.collection;
			if(window.location.href.includes('x=true')){
				this.is_iphoneX = true;
			}
			let x = document.getElementById('top-header-hidden');
			let anchor = '<a class="top-header-hidden__readmore" onclick="showFull()">Read More</a>';
			if(x) x.innerHTML = x.innerHTML.slice(0,150) + '...' + anchor;

		},
		computed:{
			featured_product(){
              	if(this.thefeaturedproduct)
					return this.thefeaturedproduct[0] ? this.thefeaturedproduct[0]  : false;
                else return false;
			},
			insurance_product(){
              	if(this.theinsuranceproduct)
					return this.theinsuranceproduct[0] ? this.theinsuranceproduct[0]  : false;
                else return false;
			},			
			lcd_product(){
				let d =  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('LCD_Product');
				})
				//return d;
				
              	if(d)
					return d ? d  : false;
                else return false;
			},
			oled_product(){
				let d=  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('OLED_Product');
				})
				//return d;
				
              	if(d)
					return d ? d  : false;
                else return false;
			},
			apple_product(){
				let d=  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('APPLE_PRODUCT');
				})
				//return d;
				
              	if(d)
					return d ? d  : false;
                else return false;
			},
			powerclass(){

				let APPLE_PRODUCT = this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('APPLE_PRODUCT');
				})
				let LCD_Product = this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('LCD_Product');
				})
				let OLED_Product = this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('OLED_Product');
				})

				if(LCD_Product && OLED_Product && APPLE_PRODUCT){
					return "power3";
				} else {
					return "power2";
				}

			},			
			back_glass(){	
				let d =  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('backglass');
				})
				//return d;
				
              	if(d)
					return d ? d  : false;
                else return false;
			},
			rear_housing(){
				let d =  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('rearhousing');
				})
				//return d;
				
              	if(d)
					return d ? d  : false;
                else return false;
			},
			apple_replacement(){
				let d =  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('appledummy');
				})
				//return d;
				
              	if(d)
					return d ? d  : false;
                else return false;
			}
		},
		methods: {
			togglePart: function (product) {
				//console.log("togglePart fires here");
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection();
				}

			}, 
			opendescriptplus: function(thisdescript){
				$('.descript'+thisdescript).toggle('smooth');
				$('.descbutton'+thisdescript).toggleClass('active');
			},
			openrepairplus: function(thisdescript){
				$('.repairtime'+thisdescript).toggle('smooth');
				$('.timebutton'+thisdescript).toggleClass('active');
			},
			openplus: function(thisdescript){
				$('.'+thisdescript+'text').toggle('smooth');
				$('.'+thisdescript).toggleClass('active');
			},
			openadditionalplus: function(thisdescript,button){
				$('.repairtime'+thisdescript).toggle('smooth');
				$('.timebutton'+thisdescript).toggleClass('active');
				$('.importantclick'+button).toggleClass('active');
			},
			cardAccordions: function(id,closeclass){
				if($( "#"+id ).is(":visible")){
					$("#"+id).hide("slow"); 	
					$("."+id).removeClass("active"); 
				}else{
					$("."+closeclass).hide("slow");
					$("#"+id).show("slow");
					$("."+id).siblings().removeClass("active"); 	
					$("."+id).addClass("active"); 
				}

			},
			cardToggle: function(show,buttonclass,card){
				$("."+show).toggle("slow");
				$("."+buttonclass).toggleClass("active");  
				$("."+card).toggleClass("active");  
			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			closePopupModal: function(thisModal){
				var otherButtons = $('.part-select-btn');
				//otherButtons.attr('disabled', 'disabled');
				otherButtons.innerHTML = 'Book Repair';
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
				$('body').removeClass('popup-active');
			},
			closeNotifyMe: function(){
				
				var modal = document.getElementById("notifymeModal");
				modal.style.display = "none";
			},
			selectProduct: function (product,premium,addrepair,id) {
				this.$root.booking.is_premium = false;
				this.$root.booking.premium_cost = 0;
				if (product.variants.length < 2) {
					////console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var prodid = `option${product.id}`;
					if(premium) {
						prodid = `option-premium${product.id}`;
					}
					// //console.log('prodid '+prodid);
					var selectedThis = document.getElementById(prodid).value;
					if(!!selectedThis){
						if(premium){
							$(`.premium #${prodid}`).addClass('optionerror');
						}else
						$(`#${prodid}`).addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
					
					////console.log('multi option product ' + selectedThisValue);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById(product.skuID);
				if(premium){
					var button = document.getElementById(`${product.skuID}-premium`);
				}
				if(id){
					if(premium){
						var button = document.getElementById(`${product.id}-premium`);
					} else {
						var button = document.getElementById(product.id);
					}
				}
				// //console.log('product.skuID '+product.skuID);
				// //console.log('button '+button);

				// var otherButtons = $('.part-select-btn');
				// otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				this.showBookingSection(product,addrepair);
			},
			showBookingSection: function (product,addrepair) {
				////console.log("showBookingSection featured part list run");
				var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
				var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;
				var reartype = 'housing';
				if(Object.keys(this.selectedrear).length === 0){
					var prodSKUTwo = ''; 
				} else {
					var prodSKUTwo = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.sku;
					var backglassTags = ["backglass"];
					var backglasscheck = this.selectedrear[Object.keys(this.selectedrear)[0]].product;
					for (var i = 0; i < backglasscheck.tags.length; i++) {
						////console.log(product.tags);
						if (backglassTags.indexOf(backglasscheck.tags[i]) > -1) {
							////console.log(product.tags[i]);
							reartype = 'backglass';
						}
					}
				}

				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}

				if(prodSKUTwo.length > 1){
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodSKUTwo + '/' + prodCode + '/' + reartype;
				} else {
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode + '/' + reartype;
				}

				this.$http.get(stockurl).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selected[Object.keys(this.selected)[0]].product.skuID);
					if( button )
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					//otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					if(addrepair == true){
						this.booking.stage = 1;
					} else {
						//rearModal();
						var modal = document.getElementById("rearModal");
						modal.style.display = "block";
					}
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			showRearBookingSection: function (product,addrepair) {

				var prodSKU = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.sku;
              	var prodCode = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.option3;
				var reartype = 'housing';
				if(Object.keys(this.selected).length === 0){
					var prodSKUOne = ''; 
				} else {
					var prodSKUOne = this.selected[Object.keys(this.selected)[0]].variant.sku;
				}

				var backglassTags = ["backglass"];
				var backglasscheck = this.selectedrear[Object.keys(this.selectedrear)[0]].product;
				////console.log("backglasscheck "+backglasscheck);
				for (var i = 0; i < backglasscheck.tags.length; i++) {
					
					if (backglassTags.indexOf(backglasscheck.tags[i]) > -1) {
						////console.log(product.tags[i]);
						reartype = 'backglass';
					}
				}
				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}
				if(prodSKUOne.length > 1){
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodSKUOne + '/' + prodCode + '/' + reartype;
				} else {
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode + '/' + reartype;
				}
				////console.log("showRearBookingSection stockurl "+stockurl);
				this.$http.get(stockurl).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selectedrear[Object.keys(this.selectedrear)[0]].product.skuID);
					if( button )
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					//otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					if(addrepair == true){
						this.booking.stage = 1;
					} else {
						//screenModal();
						var modal = document.getElementById("screenModal");
						modal.style.display = "block";
					}
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				if(this.booking.appointmentDuration){
					var existingappointmentDuration = this.booking.appointmentDuration;
				} else {
					var existingappointmentDuration = 0;
				}
				//console.log("existingappointmentDuration "+existingappointmentDuration);
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						//this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90+existingappointmentDuration;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240+existingappointmentDuration;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360+existingappointmentDuration;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120+existingappointmentDuration;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180+existingappointmentDuration;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210+existingappointmentDuration;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30+existingappointmentDuration;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						//console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});

	//Powr of 3 No Apple Genuine Part Screen List
	Vue.component('iphone-power-of-three-no-genuine', {
		template: '#iphone-power-of-three-no-genuine',
		props: ['thefeaturedproduct', 'loadSelected', 'loadSelectedRear', 'booking', 'stores','theinsuranceproduct'],
		data: function () {
			return {
				isinsurance: this.$isinsurance,
				selected: {},
				selectedrear: {},
				errors: null,
				collection:{},
				premium_service_product:{}
			};
		},
		mounted: function () {
			//the service level produt handle https://ismashuk.myshopify.com/admin/products/4703107842137
			let prod_handle = "iphonescreenrepairservicelevel";
			loadPremiumServiceProduct(this, prod_handle);
			 
		

			this.products = safeArray(window.loadProducts).filter(prod=>{
				//we dont want to include the composit products in the product parts loop
				return !productHasTag(prod, 'iPhone_Standard') && !productHasTag(prod, 'iPhone_Premium')
			});
			this.selected = this.loadSelected; 
			this.selectedrear = this.loadSelectedRear; 
			this.collection = window.collection;
			if(window.location.href.includes('x=true')){
				this.is_iphoneX = true;
			}
			let x = document.getElementById('top-header-hidden');
			let anchor = '<a class="top-header-hidden__readmore" onclick="showFull()">Read More</a>';
			if(x) x.innerHTML = x.innerHTML.slice(0,150) + '...' + anchor;

		},
		computed:{
			featured_product(){
              	if(this.thefeaturedproduct)
					return this.thefeaturedproduct[0] ? this.thefeaturedproduct[0]  : false;
                else return false;
			},
			insurance_product(){
              	if(this.theinsuranceproduct)
					return this.theinsuranceproduct[0] ? this.theinsuranceproduct[0]  : false;
                else return false;
			},			
			lcd_product(){
				return findFeaturedByTag(this.thefeaturedproduct, 'LCD_Product');
			},
			oled_product(){
				return findFeaturedByTag(this.thefeaturedproduct, 'OLED_Product');
			},
			apple_product(){
				return findFeaturedByAppleType(this.thefeaturedproduct, 'APPLE_Product');
			},
			powerclass(){
				let ap = findFeaturedByAppleType(this.thefeaturedproduct, 'APPLE_Product');
				return ap && ap.powerclass ? ap.powerclass : '';
			},			
			back_glass(){	
				return findFeaturedByTag(this.thefeaturedproduct, 'backglass');
			},
			rear_housing(){
				return findFeaturedByTag(this.thefeaturedproduct, 'rearhousing');
			},
			apple_replacement(){
				return findFeaturedByTag(this.thefeaturedproduct, 'appledummy');
			}
		},
		methods: {
			togglePart: function (product) {
				//console.log("togglePart fires here");
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection();
				}

			},
			cardAccordions: function(id,closeclass){
				if($( "#"+id ).is(":visible")){
					$("#"+id).hide("slow"); 	
					$("."+id).removeClass("active"); 
				}else{
					$("."+closeclass).hide("slow");
					$("#"+id).show("slow");
					$("."+id).siblings().removeClass("active"); 	
					$("."+id).addClass("active"); 
				}

			},
			cardToggle: function(show,buttonclass,card){
				$("."+show).toggle("slow");
				$("."+buttonclass).toggleClass("active");  
				$("."+card).toggleClass("active");  
			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			closePopupModal: function(thisModal){
				var otherButtons = $('.part-select-btn');
				//otherButtons.attr('disabled', 'disabled');
				otherButtons.innerHTML = 'Book Repair';
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
				$('body').removeClass('popup-active');
			},
			closeNotifyMe: function(){
				
				var modal = document.getElementById("notifymeModal");
				modal.style.display = "none";
			},
			selectProduct: function (product,premium,addrepair,id) {
				// if(premium){
				// 	this.$root.booking.is_premium = true;
				// 	this.$root.booking.premium_cost = parseInt(this.premium_service_product.price);
				// }else{
				// 	this.$root.booking.is_premium = false;
				// 	this.$root.booking.premium_cost = 0;
				// }
				this.$root.booking.is_premium = false;
				this.$root.booking.premium_cost = 0;
				if (product.variants.length < 2) {
					////console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var prodid = `option${product.id}`;
					if(premium) {
						prodid = `option-premium${product.id}`;
					}
					// //console.log('prodid '+prodid);
					var selectedThis = document.getElementById(prodid).value;
					if(!!selectedThis){
						if(premium){
							$(`.premium #${prodid}`).addClass('optionerror');
						}else
						$(`#${prodid}`).addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
					
					////console.log('multi option product ' + selectedThisValue);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById(product.skuID);
				if(premium){
					var button = document.getElementById(`${product.skuID}-premium`);
				}
				if(id){
					if(premium){
						var button = document.getElementById(`${product.id}-premium`);
					} else {
						var button = document.getElementById(product.id);
					}
				}
				// //console.log('product.skuID '+product.skuID);
				// //console.log('button '+button);

				// var otherButtons = $('.part-select-btn');
				// otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				this.showBookingSection(product,addrepair);
			},
			selectInsuranceProduct: function (product,premium,addrepair,id) {
				// if(premium){
				// 	this.$root.booking.is_premium = true;
				// 	this.$root.booking.premium_cost = parseInt(this.premium_service_product.price);
				// }else{
				// 	this.$root.booking.is_premium = false;
				// 	this.$root.booking.premium_cost = 0;
				// }
				this.$root.booking.is_premium = false;
				this.$root.booking.premium_cost = 0;
				if (product.variants.length < 2) {
					////console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var prodid = `option${product.id}`;
					if(premium) {
						prodid = `option-premium${product.id}`;
					}
					// //console.log('prodid '+prodid);
					var selectedThis = document.getElementById(prodid).value;
					if(!!selectedThis){
						if(premium){
							$(`.premium #${prodid}`).addClass('optionerror');
						}else
						$(`#${prodid}`).addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
					
					////console.log('multi option product ' + selectedThisValue);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);					
				var button = document.getElementById("insurebutton"+product.skuID);
				// //console.log('product.skuID '+product.skuID);
				// //console.log('button '+button);

				// var otherButtons = $('.part-select-btn');
				// otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				this.showBookingSection(product,addrepair);
			},
			selectPopupProduct: function (product,premium,addrepair,id) {
				this.$root.booking.is_premium = false;
				this.$root.booking.premium_cost = 0;
				if (product.variants.length < 2) {
					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var prodid = `popupoption${product.id}`;
					if(premium) {
						prodid = `popupoption-premium${product.id}`;
					}
					var selectedThis = document.getElementById(prodid).value;
					if(!!selectedThis){
						if(premium){
							$(`.premium #${prodid}`).addClass('optionerror');
						}else
						$(`#${prodid}`).addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
				}
				$('.optionselect').removeClass('optionerror');
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				var button = document.getElementById(product.skuID);
				if(premium){
					var button = document.getElementById(`${product.skuID}-premiumpopup`);
				} else {
					var button = document.getElementById('popup'+product.skuID);
				}
				if(id){
					if(premium){
						var button = document.getElementById(`${product.id}-premiumpopup`);
					} else {
						var button = document.getElementById('popup'+product.id);
					}
				}

				// var otherButtons = $('.part-select-btn');
				// otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				addrepair = true;
				this.showBookingSection(product,addrepair);
			},
			selectRearProduct: function (productrear,addrepair) {
				////console.log('selectRearProduct fires');
				this.$root.booking.is_premium = false;
				this.$root.booking.premium_cost = 0;
				if (productrear.variants.length < 2) {
					var selectedThisValue = productrear.variants[0];

				} else if (productrear.variants.length > 1) {
					var prodid = `option${productrear.id}`;
					////console.log('prodid '+prodid);
					var selectedThis = document.getElementById(prodid).value;
					////console.log("selectedThis "+selectedThis);
					if(!!selectedThis){
						$(`#${prodid}`).addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selectedrear = Object.keys(this.selectedrear)[0];
				this.$delete(this.selectedrear, selectedrear);

				this.$set(this.selectedrear, productrear.id, {
					product: productrear,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selectedrear);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById(productrear.skuID);

				// var otherButtons = $('.part-select-btn');
				// otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';

				this.showRearBookingSection(productrear,addrepair);
			},
			selectPopupRearProduct: function (productrear,addrepair) {
				////console.log('selectRearProduct fires');
				this.$root.booking.is_premium = false;
				this.$root.booking.premium_cost = 0;
				if (productrear.variants.length < 2) {
					var selectedThisValue = productrear.variants[0];

				} else if (productrear.variants.length > 1) {
					var prodid = `popupoption${productrear.id}`;
					////console.log('prodid '+prodid);
					var selectedThis = document.getElementById(prodid).value;
					////console.log("selectedThis "+selectedThis);
					if(!!selectedThis){
						$(`#${prodid}`).addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selectedrear = Object.keys(this.selectedrear)[0];
				this.$delete(this.selectedrear, selectedrear);

				this.$set(this.selectedrear, productrear.id, {
					product: productrear,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selectedrear);
				////console.log($('.totals-contain2').offset().top);
				var button = 'popup'+productrear.skuID;
				button = document.getElementById(button);
				// var otherButtons = $('.part-select-btn');
				// otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';

				addrepair = true;
				this.showRearBookingSection(productrear,addrepair);
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showBookingSection: function (product,addrepair) {
				////console.log("showBookingSection featured part list run");
				var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
				var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;
				var reartype = 'housing';
				if(Object.keys(this.selectedrear).length === 0){
					var prodSKUTwo = ''; 
				} else {
					var prodSKUTwo = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.sku;
					var backglassTags = ["backglass"];
					var backglasscheck = this.selectedrear[Object.keys(this.selectedrear)[0]].product;
					for (var i = 0; i < backglasscheck.tags.length; i++) {
						////console.log(product.tags);
						if (backglassTags.indexOf(backglasscheck.tags[i]) > -1) {
							////console.log(product.tags[i]);
							reartype = 'backglass';
						}
					}
				}

				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}

				if(prodSKUTwo.length > 1){
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodSKUTwo + '/' + prodCode + '/' + reartype;
				} else {
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode + '/' + reartype;
				}

				this.$http.get(stockurl).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selected[Object.keys(this.selected)[0]].product.skuID);
					if( button )
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					//otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					if(addrepair == true){
						this.booking.stage = 1;
					} else {
						//rearModal();
						var modal = document.getElementById("rearModal");
						modal.style.display = "block";
					}
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			showRearBookingSection: function (product,addrepair) {

				var prodSKU = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.sku;
              	var prodCode = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.option3;
				var reartype = 'housing';
				if(Object.keys(this.selected).length === 0){
					var prodSKUOne = ''; 
				} else {
					var prodSKUOne = this.selected[Object.keys(this.selected)[0]].variant.sku;
				}

				var backglassTags = ["backglass"];
				var backglasscheck = this.selectedrear[Object.keys(this.selectedrear)[0]].product;
				////console.log("backglasscheck "+backglasscheck);
				for (var i = 0; i < backglasscheck.tags.length; i++) {
					
					if (backglassTags.indexOf(backglasscheck.tags[i]) > -1) {
						////console.log(product.tags[i]);
						reartype = 'backglass';
					}
				}
				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}
				if(prodSKUOne.length > 1){
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodSKUOne + '/' + prodCode + '/' + reartype;
				} else {
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode + '/' + reartype;
				}
				////console.log("showRearBookingSection stockurl "+stockurl);
				this.$http.get(stockurl).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selectedrear[Object.keys(this.selectedrear)[0]].product.skuID);
					if( button )
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					//otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					if(addrepair == true){
						this.booking.stage = 1;
					} else {
						//screenModal();
						var modal = document.getElementById("screenModal");
						modal.style.display = "block";
					}
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			continueWithout: function(type){
				////console.log("continueWithout type: "+type);
				if(type=='screen'){
					var selected = Object.keys(this.selected)[0];
					this.$delete(this.selected, selected);
				} else {
					var selectedrear = Object.keys(this.selectedrear)[0];
					this.$delete(this.selectedrear, selectedrear);
				}

				this.booking.stage = 1;
				var rearModal = document.getElementById("rearModal");
				rearModal.style.display = "none";
				var screenModal = document.getElementById("screenModal");
				screenModal.style.display = "none";
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				if(this.booking.appointmentDuration){
					var existingappointmentDuration = this.booking.appointmentDuration;
				} else {
					var existingappointmentDuration = 0;
				}
				//console.log("existingappointmentDuration "+existingappointmentDuration);
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						//this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90+existingappointmentDuration;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240+existingappointmentDuration;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360+existingappointmentDuration;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120+existingappointmentDuration;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180+existingappointmentDuration;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210+existingappointmentDuration;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30+existingappointmentDuration;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						//console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});

	//Powr of 3 Part Rear List
	Vue.component('iphone-rear-glass', {
		template: '#iphone-rear-glass',
		props: ['thefeaturedproduct', 'loadSelected', 'loadSelectedRear', 'booking', 'stores','theinsuranceproduct'],
		data: function () {
			return {
				isinsurance: this.$isinsurance,
				selected: {},
				selectedrear: {},
				errors: null,
				collection:{},
				premium_service_product:{}
			};
		},
		mounted: function () {
			//the service level produt handle https://ismashuk.myshopify.com/admin/products/4703107842137
			let prod_handle = "iphonescreenrepairservicelevel";
			loadPremiumServiceProduct(this, prod_handle);
			 
		

			this.products = safeArray(window.loadProducts).filter(prod=>{
				//we dont want to include the composit products in the product parts loop
				return !productHasTag(prod, 'iPhone_Standard') && !productHasTag(prod, 'iPhone_Premium')
			});
			this.selected = this.loadSelected; 
			this.selectedrear = this.loadSelectedRear; 
			this.collection = window.collection;
			if(window.location.href.includes('x=true')){
				this.is_iphoneX = true;
			}
			let x = document.getElementById('top-header-hidden');
			let anchor = '<a class="top-header-hidden__readmore" onclick="showFull()">Read More</a>';
			if(x) x.innerHTML = x.innerHTML.slice(0,150) + '...' + anchor;

		},
		computed:{
			featured_product(){
              	if(this.thefeaturedproduct)
					return this.thefeaturedproduct[0] ? this.thefeaturedproduct[0]  : false;
                else return false;
			},
			insurance_product(){
              	if(this.theinsuranceproduct)
					return this.theinsuranceproduct[0] ? this.theinsuranceproduct[0]  : false;
                else return false;
			},			
			lcd_product(){
				return findFeaturedByTag(this.thefeaturedproduct, 'LCD_Product');
			},
			oled_product(){
				return findFeaturedByTag(this.thefeaturedproduct, 'OLED_Product');
			},
			apple_product(){
				return findFeaturedByAppleType(this.thefeaturedproduct, 'APPLE_Product');
			},
			powerclass(){
				let ap = findFeaturedByAppleType(this.thefeaturedproduct, 'APPLE_Product');
				return ap && ap.powerclass ? ap.powerclass : '';
			},
			rear_housing(){
				return findFeaturedByTag(this.thefeaturedproduct, 'rearhousing');
			},
			apple_replacement(){
				return findFeaturedByTag(this.thefeaturedproduct, 'appledummy');
			}
		},
		methods: {
			togglePart: function (product) {
				//console.log("togglePart fires here");
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection();
				}

			},
			cardAccordions: function(id,closeclass){
				if($( "#"+id ).is(":visible")){
					$("#"+id).hide("slow"); 	
					$("."+id).removeClass("active"); 
				}else{
					$("."+closeclass).hide("slow");
					$("#"+id).show("slow");
					$("."+id).siblings().removeClass("active"); 	
					$("."+id).addClass("active"); 
				}

			},
			cardToggle: function(show,buttonclass,card){
				$("."+show).toggle("slow");
				$("."+buttonclass).toggleClass("active");  
				$("."+card).toggleClass("active");  
			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			closePopupModal: function(thisModal){
				var otherButtons = $('.part-select-btn');
				//otherButtons.attr('disabled', 'disabled');
				otherButtons.innerHTML = 'Book Repair';
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
				$('body').removeClass('popup-active');
			},
			closeNotifyMe: function(){
				
				var modal = document.getElementById("notifymeModal");
				modal.style.display = "none";
			},
			selectProduct: function (product,premium,addrepair,id) {
				// if(premium){
				// 	this.$root.booking.is_premium = true;
				// 	this.$root.booking.premium_cost = parseInt(this.premium_service_product.price);
				// }else{
				// 	this.$root.booking.is_premium = false;
				// 	this.$root.booking.premium_cost = 0;
				// }
				this.$root.booking.is_premium = false;
				this.$root.booking.premium_cost = 0;
				if (product.variants.length < 2) {
					////console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var prodid = `option${product.id}`;
					if(premium) {
						prodid = `option-premium${product.id}`;
					}
					// //console.log('prodid '+prodid);
					var selectedThis = document.getElementById(prodid).value;
					if(!!selectedThis){
						if(premium){
							$(`.premium #${prodid}`).addClass('optionerror');
						}else
						$(`#${prodid}`).addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
					
					////console.log('multi option product ' + selectedThisValue);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById(product.skuID);
				if(premium){
					var button = document.getElementById(`${product.skuID}-premium`);
				}
				if(id){
					if(premium){
						var button = document.getElementById(`${product.id}-premium`);
					} else {
						var button = document.getElementById(product.id);
					}
				}
				// //console.log('product.skuID '+product.skuID);
				// //console.log('button '+button);

				// var otherButtons = $('.part-select-btn');
				// otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				this.showBookingSection(product,addrepair);
			},
			selectPopupProduct: function (product,premium,addrepair,id) {
				this.$root.booking.is_premium = false;
				this.$root.booking.premium_cost = 0;
				if (product.variants.length < 2) {
					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var prodid = `popupoption${product.id}`;
					if(premium) {
						prodid = `popupoption-premium${product.id}`;
					}
					var selectedThis = document.getElementById(prodid).value;
					if(!!selectedThis){
						if(premium){
							$(`.premium #${prodid}`).addClass('optionerror');
						}else
						$(`#${prodid}`).addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
				}
				$('.optionselect').removeClass('optionerror');
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				var button = document.getElementById(product.skuID);
				if(premium){
					var button = document.getElementById(`${product.skuID}-premiumpopup`);
				} else {
					var button = document.getElementById('popup'+product.skuID);
				}
				if(id){
					if(premium){
						var button = document.getElementById(`${product.id}-premiumpopup`);
					} else {
						var button = document.getElementById('popup'+product.id);
					}
				}

				// var otherButtons = $('.part-select-btn');
				// otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				addrepair = true;
				this.showBookingSection(product,addrepair);
			},
			selectRearProduct: function (productrear,addrepair) {
				////console.log('selectRearProduct fires');
				this.$root.booking.is_premium = false;
				this.$root.booking.premium_cost = 0;
				if (productrear.variants.length < 2) {
					var selectedThisValue = productrear.variants[0];

				} else if (productrear.variants.length > 1) {
					var prodid = `option${productrear.id}`;
					////console.log('prodid '+prodid);
					var selectedThis = document.getElementById(prodid).value;
					////console.log("selectedThis "+selectedThis);
					if(!!selectedThis){
						$(`#${prodid}`).addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selectedrear = Object.keys(this.selectedrear)[0];
				this.$delete(this.selectedrear, selectedrear);

				this.$set(this.selectedrear, productrear.id, {
					product: productrear,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selectedrear);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById(productrear.skuID);

				// var otherButtons = $('.part-select-btn');
				// otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';

				this.showRearBookingSection(productrear,addrepair);
			},
			selectPopupRearProduct: function (productrear,addrepair) {
				////console.log('selectRearProduct fires');
				this.$root.booking.is_premium = false;
				this.$root.booking.premium_cost = 0;
				if (productrear.variants.length < 2) {
					var selectedThisValue = productrear.variants[0];

				} else if (productrear.variants.length > 1) {
					var prodid = `popupoption${productrear.id}`;
					////console.log('prodid '+prodid);
					var selectedThis = document.getElementById(prodid).value;
					////console.log("selectedThis "+selectedThis);
					if(!!selectedThis){
						$(`#${prodid}`).addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selectedrear = Object.keys(this.selectedrear)[0];
				this.$delete(this.selectedrear, selectedrear);

				this.$set(this.selectedrear, productrear.id, {
					product: productrear,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selectedrear);
				////console.log($('.totals-contain2').offset().top);
				var button = 'popup'+productrear.skuID;
				button = document.getElementById(button);
				// var otherButtons = $('.part-select-btn');
				// otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';

				addrepair = true;
				this.showRearBookingSection(productrear,addrepair);
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showBookingSection: function (product,addrepair) {
				////console.log("showBookingSection featured part list run");
				var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
				var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;
				var reartype = 'housing';
				if(Object.keys(this.selectedrear).length === 0){
					var prodSKUTwo = ''; 
				} else {
					var prodSKUTwo = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.sku;
					var backglassTags = ["backglass"];
					var backglasscheck = this.selectedrear[Object.keys(this.selectedrear)[0]].product;
					for (var i = 0; i < backglasscheck.tags.length; i++) {
						////console.log(product.tags);
						if (backglassTags.indexOf(backglasscheck.tags[i]) > -1) {
							////console.log(product.tags[i]);
							reartype = 'backglass';
						}
					}
				}

				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}
				this.booking.appointmentDurationAdjust = this.booking.appointmentDuration;
				if(prodSKUTwo.length > 1){
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodSKUTwo + '/' + prodCode + '/' + reartype;
				} else {
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode + '/' + reartype;
				}

				this.$http.get(stockurl).then(function (data) {
					this.booking.appointmentDuration = this.booking.appointmentDurationAdjust;
					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selected[Object.keys(this.selected)[0]].product.skuID);
					if( button ){
						button.innerHTML = 'Select';
					}

					var otherButtons = $('.part-select-btn');
					//otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					if(addrepair == true){						
						this.booking.stage = 1;
					} else {
						//rearModal();
						var modal = document.getElementById("rearModal");
						modal.style.display = "block";
					}
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});
				//scrollTo('.store-select');
			},
			showRearBookingSection: function (product,addrepair) {

				var prodSKU = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.sku;
              	var prodCode = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.option3;
				var reartype = 'housing';
				if(Object.keys(this.selected).length === 0){
					var prodSKUOne = ''; 
				} else {
					var prodSKUOne = this.selected[Object.keys(this.selected)[0]].variant.sku;
				}

				var backglassTags = ["backglass"];
				var backglasscheck = this.selectedrear[Object.keys(this.selectedrear)[0]].product;
				////console.log("backglasscheck "+backglasscheck);
				for (var i = 0; i < backglasscheck.tags.length; i++) {
					
					if (backglassTags.indexOf(backglasscheck.tags[i]) > -1) {
						////console.log(product.tags[i]);
						reartype = 'backglass';
					}
				}
				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}
				if(prodSKUOne.length > 1){
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodSKUOne + '/' + prodCode + '/' + reartype;
				} else {
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode + '/' + reartype;
				}
				////console.log("showRearBookingSection stockurl "+stockurl);
				this.$http.get(stockurl).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selectedrear[Object.keys(this.selectedrear)[0]].product.skuID);
					if( button )
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					//otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					if(addrepair == true){
						this.booking.stage = 1;
					} else {
						//screenModal();
						var modal = document.getElementById("screenModal");
						modal.style.display = "block";
					}
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			continueWithout: function(type){
				////console.log("continueWithout type: "+type);
				if(type=='screen'){
					var selected = Object.keys(this.selected)[0];
					this.$delete(this.selected, selected);
				} else {
					var selectedrear = Object.keys(this.selectedrear)[0];
					this.$delete(this.selectedrear, selectedrear);
				}

				this.booking.stage = 1;
				var rearModal = document.getElementById("rearModal");
				rearModal.style.display = "none";
				var screenModal = document.getElementById("screenModal");
				screenModal.style.display = "none";
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				if(this.booking.appointmentDuration){
					var existingappointmentDuration = this.booking.appointmentDuration;
				} else {
					var existingappointmentDuration = 0;
				}
				//console.log("existingappointmentDuration "+existingappointmentDuration);
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						//this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90+existingappointmentDuration;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240+existingappointmentDuration;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360+existingappointmentDuration;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120+existingappointmentDuration;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180+existingappointmentDuration;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210+existingappointmentDuration;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30+existingappointmentDuration;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						//console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});

	Vue.component('iphone-rear-glass-ins', {
		template: '#iphone-rear-glass-ins',
		props: ['thefeaturedproduct', 'loadSelected', 'loadSelectedRear', 'booking', 'stores','theinsuranceproduct'],
		data: function () {
			return {
				isinsurance: this.$isinsurance,
				selected: {},
				selectedrear: {},
				errors: null,
				collection:{},
				premium_service_product:{}
			};
		},
		mounted: function () {
			//the service level produt handle https://ismashuk.myshopify.com/admin/products/4703107842137
			let prod_handle = "iphonescreenrepairservicelevel";
			let comp = this;
			//get the product sevice level
			fetch(`/products/${prod_handle}.js`).then(response=>response.json()).then(data=>{

				let title = window.collection.title.replace('Screen Replacement','').replace('&','').replace('Other','').replace('Repairs','').replace('Test','').replace('- Composite Test','').trim().toLowerCase()
				comp.premium_service_product = data.variants.find(variant=>{
					let option="";
					if(variant.option1 && variant.option2 === "Premium")
						option = variant.option1.trim().toLowerCase();
					else
						option = variant.title.replace('Screen Replacement','').replace('&','').replace('Other','').replace('Repairs','').replace('Test','').replace('- Composite Test','').replace('/ premium','').replace('/ Premium','').trim().toLowerCase()
					////console.log(`${title}------ ${option} -------`)
					return title == option;
				});
				comp.$root.premium_service_product = comp.premium_service_product;
			})
			 
		

			this.products = window.loadProducts.filter(prod=>{
				//we dont want to include the composit products in the product parts loop
				return !prod.tags.includes('iPhone_Standard') && !prod.tags.includes("iPhone_Premium")
			});
			this.selected = this.loadSelected; 
			this.selectedrear = this.loadSelectedRear; 
			this.collection = window.collection;
			if(window.location.href.includes('x=true')){
				this.is_iphoneX = true;
			}
			let x = document.getElementById('top-header-hidden');
			let anchor = '<a class="top-header-hidden__readmore" onclick="showFull()">Read More</a>';
			if(x) x.innerHTML = x.innerHTML.slice(0,150) + '...' + anchor;

		},
		computed:{
			featured_product(){
              	if(this.thefeaturedproduct)
					return this.thefeaturedproduct[0] ? this.thefeaturedproduct[0]  : false;
                else return false;
			},
			insurance_product(){
              	if(this.theinsuranceproduct)
					return this.theinsuranceproduct[0] ? this.theinsuranceproduct[0]  : false;
                else return false;
			},			
			lcd_product(){
				let d =  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('LCD_Product');
				})
				//return d;
				
              	if(d)
					return d ? d  : false;
                else return false;
			},
			oled_product(){
				let x = this.loadSelected
				let d=  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('OLED_Product');
				})
				//return d;
				
              	if(d)
					return d ? d  : false;
                else return false;
			},
			apple_product(){
				let ap=  this.thefeaturedproduct.find(prod => prod.AppleType === 'APPLE_Product' );
				return ap;
			},
			powerclass(){
				let ap=  this.thefeaturedproduct.find(prod => prod.AppleType === 'APPLE_Product' );
				return ap.powerclass;
			},
			rear_housing(){
				let d =  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('rearhousing');
				})
				//return d;
				
              	if(d)
					return d ? d  : false;
                else return false;
			},
			apple_replacement(){
				let d =  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('appledummy');
				})
				//return d;
				
              	if(d)
					return d ? d  : false;
                else return false;
			}
		},
		methods: {
			togglePart: function (product) {
				//console.log("togglePart fires here");
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection();
				}

			},
			cardAccordions: function(id,closeclass){
				if($( "#"+id ).is(":visible")){
					$("#"+id).hide("slow"); 	
					$("."+id).removeClass("active"); 
				}else{
					$("."+closeclass).hide("slow");
					$("#"+id).show("slow");
					$("."+id).siblings().removeClass("active"); 	
					$("."+id).addClass("active"); 
				}

			},
			cardToggle: function(show,buttonclass,card){
				$("."+show).toggle("slow");
				$("."+buttonclass).toggleClass("active");  
				$("."+card).toggleClass("active");  
			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			closePopupModal: function(thisModal){
				var otherButtons = $('.part-select-btn');
				//otherButtons.attr('disabled', 'disabled');
				otherButtons.innerHTML = 'Book Repair';
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
				$('body').removeClass('popup-active');
			},
			closeNotifyMe: function(){
				
				var modal = document.getElementById("notifymeModal");
				modal.style.display = "none";
			},
			selectProduct: function (product,premium,addrepair,id) {
				// if(premium){
				// 	this.$root.booking.is_premium = true;
				// 	this.$root.booking.premium_cost = parseInt(this.premium_service_product.price);
				// }else{
				// 	this.$root.booking.is_premium = false;
				// 	this.$root.booking.premium_cost = 0;
				// }
				this.$root.booking.is_premium = false;
				this.$root.booking.premium_cost = 0;
				if (product.variants.length < 2) {
					////console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var prodid = `option${product.id}`;
					if(premium) {
						prodid = `option-premium${product.id}`;
					}
					// //console.log('prodid '+prodid);
					var selectedThis = document.getElementById(prodid).value;
					if(!!selectedThis){
						if(premium){
							$(`.premium #${prodid}`).addClass('optionerror');
						}else
						$(`#${prodid}`).addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
					
					////console.log('multi option product ' + selectedThisValue);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById(product.skuID);
				if(premium){
					var button = document.getElementById(`${product.skuID}-premium`);
				}
				if(id){
					if(premium){
						var button = document.getElementById(`${product.id}-premium`);
					} else {
						var button = document.getElementById(product.id);
					}
				}
				// //console.log('product.skuID '+product.skuID);
				// //console.log('button '+button);

				// var otherButtons = $('.part-select-btn');
				// otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				this.showBookingSection(product,addrepair);
			},
			selectPopupProduct: function (product,premium,addrepair,id) {
				this.$root.booking.is_premium = false;
				this.$root.booking.premium_cost = 0;
				if (product.variants.length < 2) {
					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var prodid = `popupoption${product.id}`;
					if(premium) {
						prodid = `popupoption-premium${product.id}`;
					}
					var selectedThis = document.getElementById(prodid).value;
					if(!!selectedThis){
						if(premium){
							$(`.premium #${prodid}`).addClass('optionerror');
						}else
						$(`#${prodid}`).addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
				}
				$('.optionselect').removeClass('optionerror');
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				var button = document.getElementById(product.skuID);
				if(premium){
					var button = document.getElementById(`${product.skuID}-premiumpopup`);
				} else {
					var button = document.getElementById('popup'+product.skuID);
				}
				if(id){
					if(premium){
						var button = document.getElementById(`${product.id}-premiumpopup`);
					} else {
						var button = document.getElementById('popup'+product.id);
					}
				}

				// var otherButtons = $('.part-select-btn');
				// otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				addrepair = true;
				this.showBookingSection(product,addrepair);
			},
			selectRearProduct: function (productrear,addrepair) {
				////console.log('selectRearProduct fires');
				this.$root.booking.is_premium = false;
				this.$root.booking.premium_cost = 0;
				if (productrear.variants.length < 2) {
					var selectedThisValue = productrear.variants[0];

				} else if (productrear.variants.length > 1) {
					var prodid = `option${productrear.id}`;
					////console.log('prodid '+prodid);
					var selectedThis = document.getElementById(prodid).value;
					////console.log("selectedThis "+selectedThis);
					if(!!selectedThis){
						$(`#${prodid}`).addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selectedrear = Object.keys(this.selectedrear)[0];
				this.$delete(this.selectedrear, selectedrear);

				this.$set(this.selectedrear, productrear.id, {
					product: productrear,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selectedrear);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById(productrear.skuID);

				// var otherButtons = $('.part-select-btn');
				// otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';

				this.showRearBookingSection(productrear,addrepair);
			},
			selectPopupRearProduct: function (productrear,addrepair) {
				////console.log('selectRearProduct fires');
				this.$root.booking.is_premium = false;
				this.$root.booking.premium_cost = 0;
				if (productrear.variants.length < 2) {
					var selectedThisValue = productrear.variants[0];

				} else if (productrear.variants.length > 1) {
					var prodid = `popupoption${productrear.id}`;
					////console.log('prodid '+prodid);
					var selectedThis = document.getElementById(prodid).value;
					////console.log("selectedThis "+selectedThis);
					if(!!selectedThis){
						$(`#${prodid}`).addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selectedrear = Object.keys(this.selectedrear)[0];
				this.$delete(this.selectedrear, selectedrear);

				this.$set(this.selectedrear, productrear.id, {
					product: productrear,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selectedrear);
				////console.log($('.totals-contain2').offset().top);
				var button = 'popup'+productrear.skuID;
				button = document.getElementById(button);
				// var otherButtons = $('.part-select-btn');
				// otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';

				addrepair = true;
				this.showRearBookingSection(productrear,addrepair);
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showBookingSection: function (product,addrepair) {
				////console.log("showBookingSection featured part list run");
				var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
				var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;
				var reartype = 'housing';
				if(Object.keys(this.selectedrear).length === 0){
					var prodSKUTwo = ''; 
				} else {
					var prodSKUTwo = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.sku;
					var backglassTags = ["backglass"];
					var backglasscheck = this.selectedrear[Object.keys(this.selectedrear)[0]].product;
					for (var i = 0; i < backglasscheck.tags.length; i++) {
						////console.log(product.tags);
						if (backglassTags.indexOf(backglasscheck.tags[i]) > -1) {
							////console.log(product.tags[i]);
							reartype = 'backglass';
						}
					}
				}

				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}
				this.booking.appointmentDurationAdjust = this.booking.appointmentDuration;
				if(prodSKUTwo.length > 1){
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodSKUTwo + '/' + prodCode + '/' + reartype;
				} else {
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode + '/' + reartype;
				}

				this.$http.get(stockurl).then(function (data) {
					this.booking.appointmentDuration = this.booking.appointmentDurationAdjust;
					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selected[Object.keys(this.selected)[0]].product.skuID);
					if( button ){
						button.innerHTML = 'Select';
					}

					var otherButtons = $('.part-select-btn');
					//otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					if(addrepair == true){						
						this.booking.stage = 1;
					} else {
						//rearModal();
						var modal = document.getElementById("rearModal");
						modal.style.display = "block";
					}
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});
				//scrollTo('.store-select');
			},
			showRearBookingSection: function (product,addrepair) {

				var prodSKU = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.sku;
              	var prodCode = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.option3;
				var reartype = 'housing';
				if(Object.keys(this.selected).length === 0){
					var prodSKUOne = ''; 
				} else {
					var prodSKUOne = this.selected[Object.keys(this.selected)[0]].variant.sku;
				}

				var backglassTags = ["backglass"];
				var backglasscheck = this.selectedrear[Object.keys(this.selectedrear)[0]].product;
				////console.log("backglasscheck "+backglasscheck);
				for (var i = 0; i < backglasscheck.tags.length; i++) {
					
					if (backglassTags.indexOf(backglasscheck.tags[i]) > -1) {
						////console.log(product.tags[i]);
						reartype = 'backglass';
					}
				}
				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}
				if(prodSKUOne.length > 1){
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodSKUOne + '/' + prodCode + '/' + reartype;
				} else {
					var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode + '/' + reartype;
				}
				////console.log("showRearBookingSection stockurl "+stockurl);
				this.$http.get(stockurl).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selectedrear[Object.keys(this.selectedrear)[0]].product.skuID);
					if( button )
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					//otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					if(addrepair == true){
						this.booking.stage = 1;
					} else {
						//screenModal();
						var modal = document.getElementById("screenModal");
						modal.style.display = "block";
					}
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			continueWithout: function(type){
				////console.log("continueWithout type: "+type);
				if(type=='screen'){
					var selected = Object.keys(this.selected)[0];
					this.$delete(this.selected, selected);
				} else {
					var selectedrear = Object.keys(this.selectedrear)[0];
					this.$delete(this.selectedrear, selectedrear);
				}

				this.booking.stage = 1;
				var rearModal = document.getElementById("rearModal");
				rearModal.style.display = "none";
				var screenModal = document.getElementById("screenModal");
				screenModal.style.display = "none";
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				if(this.booking.appointmentDuration){
					var existingappointmentDuration = this.booking.appointmentDuration;
				} else {
					var existingappointmentDuration = 0;
				}
				//console.log("existingappointmentDuration "+existingappointmentDuration);
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						//this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90+existingappointmentDuration;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240+existingappointmentDuration;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360+existingappointmentDuration;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120+existingappointmentDuration;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180+existingappointmentDuration;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210+existingappointmentDuration;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30+existingappointmentDuration;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						//console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});

	//Front and Back
	Vue.component('front-and-back', {
		template: '#front-and-back',
		props: ['thefeaturedproduct', 'loadSelected', 'loadSelectedRear', 'booking', 'stores','theinsuranceproduct'],
		data: function () {
			return {
				isinsurance: this.$isinsurance,
				selected: {},
				selectedrear: {},
				errors: null,
				collection:{},
				premium_service_product:{}
			};
		},
		mounted: function () {
			//the service level produt handle https://ismashuk.myshopify.com/admin/products/4703107842137
			let prod_handle = "iphonescreenrepairservicelevel";
			loadPremiumServiceProduct(this, prod_handle);
			 
		

			this.products = safeArray(window.loadProducts).filter(prod=>{
				//we dont want to include the composit products in the product parts loop
				return !productHasTag(prod, 'iPhone_Standard') && !productHasTag(prod, 'iPhone_Premium')
			});
			this.selected = this.loadSelected; 
			this.selectedrear = this.loadSelectedRear; 
			this.collection = window.collection;
			if(window.location.href.includes('x=true')){
				this.is_iphoneX = true;
			}
			let x = document.getElementById('top-header-hidden');
			let anchor = '<a class="top-header-hidden__readmore" onclick="showFull()">Read More</a>';
			if(x) x.innerHTML = x.innerHTML.slice(0,150) + '...' + anchor;

		},
		computed:{
			featured_product(){
              	if(this.thefeaturedproduct)
					return this.thefeaturedproduct[0] ? this.thefeaturedproduct[0]  : false;
                else return false;
			},
			insurance_product(){
              	if(this.theinsuranceproduct)
					return this.theinsuranceproduct[0] ? this.theinsuranceproduct[0]  : false;
                else return false;
			},			
			lcd_product(){
				return findFeaturedByTag(this.thefeaturedproduct, 'LCD_Product');
			},
			oled_product(){
				return findFeaturedByTag(this.thefeaturedproduct, 'OLED_Product');
			},
			apple_product(){
				return findFeaturedByAppleType(this.thefeaturedproduct, 'APPLE_Product');
			},
			powerclass(){
				let ap = findFeaturedByAppleType(this.thefeaturedproduct, 'APPLE_Product');
				return ap && ap.powerclass ? ap.powerclass : '';
			},
			rear_housing(){
				return findFeaturedByTag(this.thefeaturedproduct, 'rearhousing');
			},
			apple_replacement(){
				return findFeaturedByTag(this.thefeaturedproduct, 'appledummy');
			}
		},
		methods: {
			togglePart: function (product) {
				//console.log("togglePart fires here");
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection();
				}

			},
			cardAccordions: function(id,closeclass){
				if($( "#"+id ).is(":visible")){
					$("#"+id).hide("slow"); 	
					$("."+id).removeClass("active"); 
				}else{
					$("."+closeclass).hide("slow");
					$("#"+id).show("slow");
					$("."+id).siblings().removeClass("active"); 	
					$("."+id).addClass("active"); 
				}

			},
			cardToggle: function(show,buttonclass,card){
				$("."+show).toggle("slow");
				$("."+buttonclass).toggleClass("active");  
				$("."+card).toggleClass("active");  
			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			closePopupModal: function(thisModal){
				var otherButtons = $('.part-select-btn');
				//otherButtons.attr('disabled', 'disabled');
				otherButtons.innerHTML = 'Book Repair';
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
				$('body').removeClass('popup-active');
			},
			closeNotifyMe: function(){
				
				var modal = document.getElementById("notifymeModal");
				modal.style.display = "none";
			},
			selectRearProduct: function (productrear,addrepair,screenproduct,type,insurance) {

				this.$root.booking.is_premium = false;
				this.$root.booking.premium_cost = 0;
				
				if (screenproduct.variants.length < 2) {
					var selectedThisValueScreen = screenproduct.variants[0];

				} else if (screenproduct.variants.length > 1) {
					if(insurance=="insurance"){
						var prodidFront = `optioninsure${screenproduct.id}`;
					} else {
						var prodidFront = `optionscreen${screenproduct.id}`;
					}
					
					////console.log('prodid '+prodid);
					var selectedThisFront = document.getElementById(prodidFront).value;
					////console.log("selectedThis "+selectedThis);
					if(!!selectedThisFront){
						$(`#${prodidFront}`).addClass('optionerror');
					}
					var selectedThisValueScreen = JSON.parse(selectedThisFront);
				}

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, screenproduct.id, {
					product: screenproduct,
					variant: selectedThisValueScreen
				});

				////console.log('selectRearProduct fires');

				if (productrear.variants.length < 2) {
					var selectedThisValue = productrear.variants[0];

				} else if (productrear.variants.length > 1) {
					if(insurance=="insurance"){
						var prodid = `optioninsurerear${productrear.id}`;
					} else if(type==true){						
						var prodid = `optionoledrear${productrear.id}`;
					} else {												
						var prodid = `optionlcdrear${productrear.id}`;
					}
					////console.log('prodid '+prodid);
					var selectedThis = document.getElementById(prodid).value;
					//console.log("selectedThis "+selectedThis);
					if(selectedThis=="Select Colour"){
						$(`#${prodid}`).addClass('optionerror');
					} 
					var selectedThisValue = JSON.parse(selectedThis);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selectedrear = Object.keys(this.selectedrear)[0];
				this.$delete(this.selectedrear, selectedrear);

				this.$set(this.selectedrear, productrear.id, {
					product: productrear,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selectedrear);
				
				if(type==true){			
					if(insurance=="insurance"){						
						var button = document.getElementById("insurebutton"+productrear.skuID);
					} else {
						var button = document.getElementById("frontrear"+screenproduct.skuID);
					} 
				} else {
					if(insurance=="insurance"){
						var button = document.getElementById("insurebutton"+productrear.skuID);
					} else {
						var button = document.getElementById("frontrear"+productrear.skuID);
					}
				}
				
				
				button.innerHTML = 'Loading...';

				this.showRearBookingSection(productrear,addrepair);
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showRearBookingSection: function (product,addrepair) {

				var prodSKU = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.sku;
              	var prodCode = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.option3;
				var reartype = 'housing';
				
				var prodSKUOne = this.selected[Object.keys(this.selected)[0]].variant.sku;

				var backglassTags = ["backglass"];
				var backglasscheck = this.selectedrear[Object.keys(this.selectedrear)[0]].product;
				////console.log("backglasscheck "+backglasscheck);
				for (var i = 0; i < backglasscheck.tags.length; i++) {
					
					if (backglassTags.indexOf(backglasscheck.tags[i]) > -1) {
						////console.log(product.tags[i]);
						reartype = 'backglass';
					}
				}
				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}
				
				var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodSKUOne + '/' + prodCode + '/' + reartype;
				////console.log("showRearBookingSection stockurl "+stockurl);
				this.$http.get(stockurl).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selectedrear[Object.keys(this.selectedrear)[0]].product.skuID);
					if( button )
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					//otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					if(addrepair == true){
						this.booking.stage = 1;
					} else {
						//screenModal();
						var modal = document.getElementById("screenModal");
						modal.style.display = "block";
					}
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			continueWithout: function(type){
				////console.log("continueWithout type: "+type);
				if(type=='screen'){
					var selected = Object.keys(this.selected)[0];
					this.$delete(this.selected, selected);
				} else {
					var selectedrear = Object.keys(this.selectedrear)[0];
					this.$delete(this.selectedrear, selectedrear);
				}

				this.booking.stage = 1;
				var rearModal = document.getElementById("rearModal");
				rearModal.style.display = "none";
				var screenModal = document.getElementById("screenModal");
				screenModal.style.display = "none";
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				if(this.booking.appointmentDuration){
					var existingappointmentDuration = this.booking.appointmentDuration;
				} else {
					var existingappointmentDuration = 0;
				}
				//console.log("existingappointmentDuration "+existingappointmentDuration);
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						//this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90+existingappointmentDuration;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240+existingappointmentDuration;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360+existingappointmentDuration;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120+existingappointmentDuration;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180+existingappointmentDuration;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210+existingappointmentDuration;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30+existingappointmentDuration;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						//console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});

	Vue.component('front-and-back-ins', {
		template: '#front-and-back-ins',
		props: ['thefeaturedproduct', 'loadSelected', 'loadSelectedRear', 'booking', 'stores','theinsuranceproduct'],
		data: function () {
			return {
				isinsurance: this.$isinsurance,
				selected: {},
				selectedrear: {},
				errors: null,
				collection:{},
				premium_service_product:{}
			};
		},
		mounted: function () {
			//the service level produt handle https://ismashuk.myshopify.com/admin/products/4703107842137
			let prod_handle = "iphonescreenrepairservicelevel";
			let comp = this;
			//get the product sevice level
			fetch(`/products/${prod_handle}.js`).then(response=>response.json()).then(data=>{

				let title = window.collection.title.replace('Screen Replacement','').replace('&','').replace('Other','').replace('Repairs','').replace('Test','').replace('- Composite Test','').trim().toLowerCase()
				comp.premium_service_product = data.variants.find(variant=>{
					let option="";
					if(variant.option1 && variant.option2 === "Premium")
						option = variant.option1.trim().toLowerCase();
					else
						option = variant.title.replace('Screen Replacement','').replace('&','').replace('Other','').replace('Repairs','').replace('Test','').replace('- Composite Test','').replace('/ premium','').replace('/ Premium','').trim().toLowerCase()
					////console.log(`${title}------ ${option} -------`)
					return title == option;
				});
				comp.$root.premium_service_product = comp.premium_service_product;
			})
			 
		

			this.products = window.loadProducts.filter(prod=>{
				//we dont want to include the composit products in the product parts loop
				return !prod.tags.includes('iPhone_Standard') && !prod.tags.includes("iPhone_Premium")
			});
			this.selected = this.loadSelected; 
			this.selectedrear = this.loadSelectedRear; 
			this.collection = window.collection;
			if(window.location.href.includes('x=true')){
				this.is_iphoneX = true;
			}
			let x = document.getElementById('top-header-hidden');
			let anchor = '<a class="top-header-hidden__readmore" onclick="showFull()">Read More</a>';
			if(x) x.innerHTML = x.innerHTML.slice(0,150) + '...' + anchor;

		},
		computed:{
			featured_product(){
              	if(this.thefeaturedproduct)
					return this.thefeaturedproduct[0] ? this.thefeaturedproduct[0]  : false;
                else return false;
			},
			insurance_product(){
              	if(this.theinsuranceproduct)
					return this.theinsuranceproduct[0] ? this.theinsuranceproduct[0]  : false;
                else return false;
			},			
			lcd_product(){
				let d =  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('LCD_Product');
				})
				//return d;
				
              	if(d)
					return d ? d  : false;
                else return false;
			},
			oled_product(){
				let x = this.loadSelected
				let d=  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('OLED_Product');
				})
				//return d;
				
              	if(d)
					return d ? d  : false;
                else return false;
			},
			apple_product(){
				let ap=  this.thefeaturedproduct.find(prod => prod.AppleType === 'APPLE_Product' );
				return ap;
			},
			powerclass(){
				let ap=  this.thefeaturedproduct.find(prod => prod.AppleType === 'APPLE_Product' );
				return ap.powerclass;
			},
			rear_housing(){
				let d =  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('rearhousing');
				})
				//return d;
				
              	if(d)
					return d ? d  : false;
                else return false;
			},
			apple_replacement(){
				let d =  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('appledummy');
				})
				//return d;
				
              	if(d)
					return d ? d  : false;
                else return false;
			}
		},
		methods: {
			togglePart: function (product) {
				//console.log("togglePart fires here");
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection();
				}

			},
			cardAccordions: function(id,closeclass){
				if($( "#"+id ).is(":visible")){
					$("#"+id).hide("slow"); 	
					$("."+id).removeClass("active"); 
				}else{
					$("."+closeclass).hide("slow");
					$("#"+id).show("slow");
					$("."+id).siblings().removeClass("active"); 	
					$("."+id).addClass("active"); 
				}

			},
			cardToggle: function(show,buttonclass,card){
				$("."+show).toggle("slow");
				$("."+buttonclass).toggleClass("active");  
				$("."+card).toggleClass("active");  
			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			closePopupModal: function(thisModal){
				var otherButtons = $('.part-select-btn');
				//otherButtons.attr('disabled', 'disabled');
				otherButtons.innerHTML = 'Book Repair';
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
				$('body').removeClass('popup-active');
			},
			closeNotifyMe: function(){
				
				var modal = document.getElementById("notifymeModal");
				modal.style.display = "none";
			},
			selectRearProduct: function (productrear,addrepair,screenproduct,type,insurance) {

				this.$root.booking.is_premium = false;
				this.$root.booking.premium_cost = 0;
				
				if (screenproduct.variants.length < 2) {
					var selectedThisValueScreen = screenproduct.variants[0];

				} else if (screenproduct.variants.length > 1) {
					if(insurance=="insurance"){
						var prodidFront = `optioninsure${screenproduct.id}`;
					} else {
						var prodidFront = `optionscreen${screenproduct.id}`;
					}
					
					////console.log('prodid '+prodid);
					var selectedThisFront = document.getElementById(prodidFront).value;
					////console.log("selectedThis "+selectedThis);
					if(!!selectedThisFront){
						$(`#${prodidFront}`).addClass('optionerror');
					}
					var selectedThisValueScreen = JSON.parse(selectedThisFront);
				}

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, screenproduct.id, {
					product: screenproduct,
					variant: selectedThisValueScreen
				});

				////console.log('selectRearProduct fires');

				if (productrear.variants.length < 2) {
					var selectedThisValue = productrear.variants[0];

				} else if (productrear.variants.length > 1) {
					if(insurance=="insurance"){
						var prodid = `optioninsurerear${productrear.id}`;
					} else if(type==true){						
						var prodid = `optionoledrear${productrear.id}`;
					} else {												
						var prodid = `optionlcdrear${productrear.id}`;
					}
					////console.log('prodid '+prodid);
					var selectedThis = document.getElementById(prodid).value;
					//console.log("selectedThis "+selectedThis);
					if(selectedThis=="Select Colour"){
						$(`#${prodid}`).addClass('optionerror');
					} 
					var selectedThisValue = JSON.parse(selectedThis);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selectedrear = Object.keys(this.selectedrear)[0];
				this.$delete(this.selectedrear, selectedrear);

				this.$set(this.selectedrear, productrear.id, {
					product: productrear,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selectedrear);
				
				if(type==true){			
					if(insurance=="insurance"){						
						var button = document.getElementById("insurebutton"+productrear.skuID);
					} else {
						var button = document.getElementById("frontrear"+screenproduct.skuID);
					} 
				} else {
					if(insurance=="insurance"){
						var button = document.getElementById("insurebutton"+productrear.skuID);
					} else {
						var button = document.getElementById("frontrear"+productrear.skuID);
					}
				}
				
				
				button.innerHTML = 'Loading...';

				this.showRearBookingSection(productrear,addrepair);
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showRearBookingSection: function (product,addrepair) {

				var prodSKU = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.sku;
              	var prodCode = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.option3;
				var reartype = 'housing';
				
				var prodSKUOne = this.selected[Object.keys(this.selected)[0]].variant.sku;

				var backglassTags = ["backglass"];
				var backglasscheck = this.selectedrear[Object.keys(this.selectedrear)[0]].product;
				////console.log("backglasscheck "+backglasscheck);
				for (var i = 0; i < backglasscheck.tags.length; i++) {
					
					if (backglassTags.indexOf(backglasscheck.tags[i]) > -1) {
						////console.log(product.tags[i]);
						reartype = 'backglass';
					}
				}
				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}
				
				var stockurl = App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodSKUOne + '/' + prodCode + '/' + reartype;
				////console.log("showRearBookingSection stockurl "+stockurl);
				this.$http.get(stockurl).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selectedrear[Object.keys(this.selectedrear)[0]].product.skuID);
					if( button )
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					//otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					if(addrepair == true){
						this.booking.stage = 1;
					} else {
						//screenModal();
						var modal = document.getElementById("screenModal");
						modal.style.display = "block";
					}
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			continueWithout: function(type){
				////console.log("continueWithout type: "+type);
				if(type=='screen'){
					var selected = Object.keys(this.selected)[0];
					this.$delete(this.selected, selected);
				} else {
					var selectedrear = Object.keys(this.selectedrear)[0];
					this.$delete(this.selectedrear, selectedrear);
				}

				this.booking.stage = 1;
				var rearModal = document.getElementById("rearModal");
				rearModal.style.display = "none";
				var screenModal = document.getElementById("screenModal");
				screenModal.style.display = "none";
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				if(this.booking.appointmentDuration){
					var existingappointmentDuration = this.booking.appointmentDuration;
				} else {
					var existingappointmentDuration = 0;
				}
				//console.log("existingappointmentDuration "+existingappointmentDuration);
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						//this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60+existingappointmentDuration;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90+existingappointmentDuration;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240+existingappointmentDuration;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360+existingappointmentDuration;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120+existingappointmentDuration;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180+existingappointmentDuration;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210+existingappointmentDuration;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30+existingappointmentDuration;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						//console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});
	
	//Front and Back Tab
	Vue.component('front-and-back-tab', {
		template: '#front-and-back-tab',
		props: ['theproducts','therearproducts', 'loadSelected', 'loadSelectedRear', 'booking', 'stores'],
		data: function () {
			return {
				selected: {},
				selectedrear: {},
				errors: null,
				products:[]
			};
		},
		mounted: function () {
			
			this.selected = this.loadSelected; 
			this.selectedrear = this.loadSelectedRear; 
		},
		computed:{
				
			featured_product(){
              	if(this.theproducts)
					return this.theproducts[0] ? this.theproducts[0]  : false;
                else return false;
			},
			insurance_product(){
              	if(this.theinsuranceproduct)
					return this.theinsuranceproduct[0] ? this.theinsuranceproduct[0]  : false;
                else return false;
			},
			rear_housing(){
              	if(this.therearproducts)
					return this.therearproducts[0] ? this.therearproducts[0]  : false;
                else return false;
			},
		},
		methods: {
			togglePart: function (product) {
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection(product);
				}

			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			batteryRepairClose: function(){
				var modal = document.getElementById("batteryRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			opendescriptplus: function(thisdescript){
				$('.descript'+thisdescript).toggle('smooth');
				$('.descbutton'+thisdescript).toggleClass('active');
			},
			openrepairplus: function(thisdescript){
				$('.repairtime'+thisdescript).toggle('smooth');
				$('.timebutton'+thisdescript).toggleClass('active');
			},
			openadditionalplus: function(thisdescript,button){
				$('.repairtime'+thisdescript).toggle('smooth');
				$('.timebutton'+thisdescript).toggleClass('active');
				$('.importantclick'+button).toggleClass('active');
			},
			selectRearProduct: function (productrear,addrepair,screenproduct) {

				this.$root.booking.is_premium = false;
				this.$root.booking.premium_cost = 0;
				var error = false;
				if (screenproduct.variants.length < 2) {
					var selectedThisValueScreen = screenproduct.variants[0];

				} else if (screenproduct.variants.length > 1) {
					var prodidFront = `optionsinglescreen${screenproduct.id}`;
					console.log('prodidFront '+prodidFront);
					var selectedThisFront = document.getElementById(prodidFront).value;
					////console.log("selectedThis "+selectedThis);
					if(selectedThisFront){
						var selectedThisValueScreen = JSON.parse(selectedThisFront);
					} else {
						error = true;
						$(`#${prodidFront}`).addClass('optionerror');
					}
				}

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, screenproduct.id, {
					product: screenproduct,
					variant: selectedThisValueScreen
				});

				////console.log('selectRearProduct fires');

				if (productrear.variants.length < 2) {
					var selectedThisValue = productrear.variants[0];

				} else if (productrear.variants.length > 1) {
					var prodid = `optionsinglerear${productrear.id}`;
					console.log('prodid '+prodid);
					var selectedThis = document.getElementById(prodid).value;
					//console.log("selectedThis "+selectedThis);
					if(selectedThis){
						var selectedThisValue = JSON.parse(selectedThis);
					} else {
						error = true;
						$(`#${prodid}`).addClass('optionerror');
					}
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selectedrear = Object.keys(this.selectedrear)[0];
				this.$delete(this.selectedrear, selectedrear);

				this.$set(this.selectedrear, productrear.id, {
					product: productrear,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selectedrear);
				
				var button = document.getElementById("single"+screenproduct.skuID);
				if(error==false) {
					button.innerHTML = 'Loading...';
				}

				this.showRearBookingSection(productrear,addrepair);
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showRearBookingSection: function (product,addrepair) {

				var prodSKU = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.sku;
              	var prodCode = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.option3;
				var insurance = this.selected[Object.keys(this.selected)[0]].product.insurance_customer;
				var reartype = 'housing';
				
				var prodSKUOne = this.selected[Object.keys(this.selected)[0]].variant.sku;

				var backglassTags = ["backglass"];
				var backglasscheck = this.selectedrear[Object.keys(this.selectedrear)[0]].product;
				////console.log("backglasscheck "+backglasscheck);

				var vendor = backglasscheck.vendor;
				
				for (var i = 0; i < backglasscheck.tags.length; i++) {
					
					if (backglassTags.indexOf(backglasscheck.tags[i]) > -1) {
						////console.log(product.tags[i]);
						reartype = 'backglass';
					}
				}
				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}
				
				var stockurl = App.config.api.filemaker + '/store/withvendor/' + prodSKU + '/' + prodSKUOne + '/' + prodCode + '/' + reartype + '/' + vendor + '/' + insurance;
				////console.log("showRearBookingSection stockurl "+stockurl);
				this.$http.get(stockurl).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selectedrear[Object.keys(this.selectedrear)[0]].product.skuID);
					if( button )
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					//otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					if(addrepair == true){
						this.booking.stage = 1;
					} else {
						//screenModal();
						var modal = document.getElementById("screenModal");
						modal.style.display = "block";
					}
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						////console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});	

	Vue.component('front-and-back-tab-ins', {
		template: '#front-and-back-tab-ins',
		props: ['theproducts','therearproducts', 'loadSelected', 'loadSelectedRear', 'booking', 'stores'],
		data: function () {
			return {
				selected: {},
				selectedrear: {},
				errors: null,
				products:[]
			};
		},
		mounted: function () {
			
			this.selected = this.loadSelected; 
			this.selectedrear = this.loadSelectedRear; 
		},
		computed:{
				
			featured_product(){
              	if(this.theproducts)
					return this.theproducts[0] ? this.theproducts[0]  : false;
                else return false;
			},
			insurance_product(){
              	if(this.theinsuranceproduct)
					return this.theinsuranceproduct[0] ? this.theinsuranceproduct[0]  : false;
                else return false;
			},
			rear_housing(){
              	if(this.therearproducts)
					return this.therearproducts[0] ? this.therearproducts[0]  : false;
                else return false;
			},
		},
		methods: {
			togglePart: function (product) {
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection(product);
				}

			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			batteryRepairClose: function(){
				var modal = document.getElementById("batteryRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			opendescriptplus: function(thisdescript){
				$('.descript'+thisdescript).toggle('smooth');
				$('.descbutton'+thisdescript).toggleClass('active');
			},
			openrepairplus: function(thisdescript){
				$('.repairtime'+thisdescript).toggle('smooth');
				$('.timebutton'+thisdescript).toggleClass('active');
			},
			openadditionalplus: function(thisdescript,button){
				$('.repairtime'+thisdescript).toggle('smooth');
				$('.timebutton'+thisdescript).toggleClass('active');
				$('.importantclick'+button).toggleClass('active');
			},
			selectRearProduct: function (productrear,addrepair,screenproduct) {

				this.$root.booking.is_premium = false;
				this.$root.booking.premium_cost = 0;
				var error = false;
				if (screenproduct.variants.length < 2) {
					var selectedThisValueScreen = screenproduct.variants[0];

				} else if (screenproduct.variants.length > 1) {
					var prodidFront = `optionsinglescreen${screenproduct.id}`;
					console.log('prodidFront '+prodidFront);
					var selectedThisFront = document.getElementById(prodidFront).value;
					////console.log("selectedThis "+selectedThis);
					if(selectedThisFront){
						var selectedThisValueScreen = JSON.parse(selectedThisFront);
					} else {
						error = true;
						$(`#${prodidFront}`).addClass('optionerror');
					}
				}

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, screenproduct.id, {
					product: screenproduct,
					variant: selectedThisValueScreen
				});

				////console.log('selectRearProduct fires');

				if (productrear.variants.length < 2) {
					var selectedThisValue = productrear.variants[0];

				} else if (productrear.variants.length > 1) {
					var prodid = `optionsinglerear${productrear.id}`;
					console.log('prodid '+prodid);
					var selectedThis = document.getElementById(prodid).value;
					//console.log("selectedThis "+selectedThis);
					if(selectedThis){
						var selectedThisValue = JSON.parse(selectedThis);
					} else {
						error = true;
						$(`#${prodid}`).addClass('optionerror');
					}
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selectedrear = Object.keys(this.selectedrear)[0];
				this.$delete(this.selectedrear, selectedrear);

				this.$set(this.selectedrear, productrear.id, {
					product: productrear,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selectedrear);
				
				var button = document.getElementById("single"+screenproduct.skuID);
				if(error==false) {
					button.innerHTML = 'Loading...';
				}

				this.showRearBookingSection(productrear,addrepair);
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showRearBookingSection: function (product,addrepair) {

				var prodSKU = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.sku;
              	var prodCode = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.option3;
				var reartype = 'housing';
				
				var prodSKUOne = this.selected[Object.keys(this.selected)[0]].variant.sku;

				var backglassTags = ["backglass"];
				var backglasscheck = this.selectedrear[Object.keys(this.selectedrear)[0]].product;
				var insurance = this.selected[Object.keys(this.selected)[0]].product.insurance_customer;
				////console.log("backglasscheck "+backglasscheck);

				var vendor = backglasscheck.vendor;
				
				for (var i = 0; i < backglasscheck.tags.length; i++) {
					
					if (backglassTags.indexOf(backglasscheck.tags[i]) > -1) {
						////console.log(product.tags[i]);
						reartype = 'backglass';
					}
				}
				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}
				
				var stockurl = App.config.api.filemaker + '/store/withvendor/' + prodSKU + '/' + prodSKUOne + '/' + prodCode + '/' + reartype + '/' + vendor + '/' + insurance;
				////console.log("showRearBookingSection stockurl "+stockurl);
				this.$http.get(stockurl).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selectedrear[Object.keys(this.selectedrear)[0]].product.skuID);
					if( button )
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					//otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					if(addrepair == true){
						this.booking.stage = 1;
					} else {
						//screenModal();
						var modal = document.getElementById("screenModal");
						modal.style.display = "block";
					}
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						////console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});	

	//OLED-LCD Part List
	Vue.component('iphone-oled-lcd', {
		template: '#iphone-oled-lcd',
		props: ['thefeaturedproduct', 'loadSelected', 'booking', 'stores'],
		data: function () {
			return {
				isinsurance: this.$isinsurance,
				selected: {},
				errors: null,
				collection:{},
				premium_service_product:{}
			};
		},
		mounted: function () {

			//the service level produt handle https://ismashuk.myshopify.com/admin/products/4703107842137
			let prod_handle = "iphonescreenrepairservicelevel";
			let comp = this;
			//get the product sevice level
			fetch(`/products/${prod_handle}.js`).then(response=>response.json()).then(data=>{
				
				let title = window.collection.title.replace('Screen Replacement','').replace('&','').replace('Other','').replace('Repairs','').replace('Test','').replace('- Composite Test','').trim()

				comp.premium_service_product = data.variants.find(variant=>variant.title.includes( title ));
				comp.$root.premium_service_product = comp.premium_service_product;
			})


			this.selected = this.loadSelected;
			this.collection = window.collection;
			////console.log(this);
			////console.log(this.thefeaturedproduct);
		},
		computed:{
			featured_product(){
              	if(this.thefeaturedproduct)
					return this.thefeaturedproduct[0] ? this.thefeaturedproduct[0]  : false;
                else return false;
			},
			lcd_product(){
				let d =  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('LCD_Product');
				})
				return d;
			},
			oled_product(){
				let x = this.loadSelected
				let d=  this.thefeaturedproduct.find(prod=>{
					return prod.tags.includes('OLED_Product');
				})
				return d;
			},
		},
		methods: {
			togglePart: function (product) {
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: product.variants[0]
				});
				this.$emit('selected-changed', this.selected);
				if (this.selected[Object.keys(this.selected)[0]].product.variants.length < 2) {
					////console.log($('.totals-contain2').offset().top);
					var button = document.getElementById(product.skuID);
					button.innerHTML = 'Loading...';

					this.showBookingSection();
				}

			},
			getRepairTime: function (product) {
				////console.log(product);
				if (product.showTime) {
					return product.showTime;
				} else {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < product.tags.length; i++) {
						////console.log(product.tags);
						if (repairTags.indexOf(product.tags[i]) > -1) {
							////console.log(product.tags[i]);
							return product.tags[i];
						}
					}
				}
			},
			screenRepair: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "block";
			},
			screenRepairClose: function(){
				
				var modal = document.getElementById("screenRepairModal");
				modal.style.display = "none";
			},
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			selectProduct: function (product,premium) {
				if(premium){
					this.$root.booking.is_premium = true;
					this.$root.booking.premium_cost = parseInt(this.premium_service_product.price);
				}else{
					this.$root.booking.is_premium = false;
					this.$root.booking.premium_cost = 0;
				}
				if (product.variants.length < 2) {
					//console.log('single product');

					var selectedThisValue = product.variants[0];

				} else if (product.variants.length > 1) {
					var prodid = `option${product.id}`;
					if(premium)
						prodid = `option-premium${product.id}`;

					var selectedThis = document.getElementById(prodid).value;
					if(!!selectedThis){
						if(premium){
							$(`.premium #${prodid}`).addClass('optionerror');
						}else
						$(`#${prodid}`).addClass('optionerror');
					}
					var selectedThisValue = JSON.parse(selectedThis);
					
					//console.log('multi option product ' + selectedThisValue);
				}
				$('.optionselect').removeClass('optionerror');
				////console.log(selectedThis);

				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);

				this.$set(this.selected, product.id, {
					product: product,
					variant: selectedThisValue
				});
				this.$emit('selected-changed', this.selected);
				////console.log($('.totals-contain2').offset().top);
				var button = document.getElementById(product.skuID);
				if(premium){
					var button = document.getElementById(`${product.skuID}-premium`);
				}

				var otherButtons = $('.part-select-btn');
				otherButtons.attr('disabled', 'disabled');
				button.innerHTML = 'Loading...';
				this.showBookingSection(product);
			},
			statusSelected: function (evt) {
				//console.log(JSON.parse(evt.target.value));
			},
			showBookingSection: function (product) {

				////console.log("showBookingSection featured part list run");
				var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;
              var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;

				this.setRepairTime(product);
				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}

				this.$http.get(App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;
					var button = document.getElementById(this.selected[Object.keys(this.selected)[0]].product.skuID);
					if( button )
					button.innerHTML = 'Select';

					var otherButtons = $('.part-select-btn');
					otherButtons.removeAttr('disabled');
					document.querySelector('body').classList.add("popup-active");
					this.booking.stage = 1;
					ga('send', 'pageview', '?select-method');

					// check if there are at least 5 store with this repair in stock
					checkStock(this.stores.list);
					////console.log(StockQty);

				}, function (data) {
					console.error(data);
				});

				//scrollTo('.store-select');
			},
			setRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						////console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			}
		}
	});

	//Order Summary
	Vue.component('order-summary', {
		template: '#order-summary',
		props: ['selected', 'selectedrear', 'booking', 'stores'],
		computed: {
			total: function () {
				var total = 0;
				for (var i = 0; i < Object.keys(this.selected).length; i++) {
					total += this.selected[Object.keys(this.selected)[i]].variant.price;
				}
				return '�' + (total / 100).toFixed(2);
			},
			product: function () {
				if (!this.selected[Object.keys(this.selected)[0]]) {
					return null;
				}
				return this.selected[Object.keys(this.selected)[0]].product;
			},
			variant: function () {
				if (!this.selected[Object.keys(this.selected)[0]]) {
					return null;
				}
				return this.selected[Object.keys(this.selected)[0]].variant;
			}
		},
		methods: {
			showBookingSection: function (e) {

				//console.log("showBookingSection run");
				var button = document.getElementById('RepairContinueButton');
				button.innerHTML = 'Loading...';

				var product = Object.keys(this.selected)[0];
				//this.getRepairTime(product);
				var prodSKU = this.selected[product].variant.sku;
              var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;

				if (prodSKU == '') {
					prodSKU = 'SKUNOTFOUND';
				}

				this.$http.get(App.config.api.filemaker + '/store/stock/' + prodSKU + '/' + prodCode).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;

					document.querySelector('body').classList.add("popup-active");
					this.booking.stage = 1;
					ga('send', 'pageview', '?select-method');
					button.innerHTML = "Continue to next step";

				}, function (data) {
					console.error(data);
				});


				scrollTo('.store-select');
			},
			getRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes","180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						//this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						////console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			},
			getRepairDetails: function (product) {
				//Get Repair Type
				var typeTags = ["Smartphone", "Tablet", "Laptop", "Drone", "smartphone", "tablet", "laptop", "drone"];
				for (var i = 0; i < product.tags.length; i++) {
					if (typeTags.indexOf(product.tags[i]) > -1) {
						this.booking.repairType = product.tags[i];
					}
				}
			}
		}
	});

	Vue.component('delivery-method', {
		template: '#delivery-method',
		props: ['selected', 'selectedrear', 'booking', 'selectedStore', 'stores', 'StockQty', 'storesOpen'],
		data: function () {
			return {
				courierCollectThis: courierCollection,
				mailinThis: mailin,
				postcode: null,
				radius: 10,
				postcodeAccepted: false,
				postcodeStatusText: null,
				courierPostcodeAccepted: false,
				courierPostcodeStatusText: null,
				courier: null,
				map: null,
				delay: null,
				postcodeSearched: false,
				storesList: null,
				zoomLevel: 15,
				errors: [],
				post_in_errors: [],
				postcodeCourierAccepted: null,
				postcodeCourierCost: null,
				hideavailability: this.$hideavailability,
				availabilitymessage: this.$availabilitymessage,
				hasStock: null,
				isinsurance: this.$isinsurance,
				insurer: this.$insurer,
				mapInitRetryTimer: null,
				mapInitRetryCount: 0
			};
		},
		computed: {
			storesSorted: function () {
				//console.log(this.storesList);
				if (this.storesList) {
					////console.log('stores list here');
					return this.storesList.sort(function (a, b) {
						if (a.distance < b.distance) return -1;
						if (a.distance > b.distance) return 1;
						return 0;
					});
				} else {
					//console.log("storesSorted "+this.stores);
					return this.stores.list.sort(function (a, b) {
						if (a.name < b.name) return -1;
						if (a.name > b.name) return 1;
						return 0;
					});
				}
			},
			storesCourierSorted: function () {
					return this.storesList.sort(function (a, b) {
						if (a.distance < b.distance) return -1;
						if (a.distance > b.distance) return 1;
						return 0;
					});
			},
			storesCourierOutSorted: function () {
					return this.storesOutList.sort(function (a, b) {
						if (a.distance < b.distance) return -1;
						if (a.distance > b.distance) return 1;
						return 0;
					});
			},
			selectedRepairType: function () {
				
				if(Object.keys(this.selected).length === 0){					
					var productId = Object.keys(this.selectedrear)[0];
					var title = this.selectedrear[productId].product.title;
				} else {	
					var productId = Object.keys(this.selected)[0];
					var title = this.selected[productId].product.title;
				}
				return title.split(' - ')[0];
			},
			normalized_zip: function () {
				if (!this.booking.courier.zip) {
					return null;
				}
				return this.booking.courier.zip.replace(/\s/g, '').toUpperCase();
			},
			normalized_phone: function () {
				if (!this.booking.courier.phone) {
					return null;
				}
				return this.booking.courier.phone.replace(/\s/g, '');
			},
			normalized_bookingphone: function () {
				if (!this.booking.phone) {
					return null;
				}
				return this.booking.phone.replace(/\s/g, '');
			},
			is_variant_vend_product:function(){
				var selectedValues = Object.values(this.selected || {});
				var selectedRearValues = Object.values(this.selectedrear || {});
				var currentSelection = selectedValues.length > 0 ? selectedValues[0] : (selectedRearValues.length > 0 ? selectedRearValues[0] : null);
				if (!currentSelection || !currentSelection.variant || !currentSelection.variant.title) {
					return false;
				}
				var variantTitle = currentSelection.variant.title;
				return variantTitle.endsWith('BO-W-I') || variantTitle.endsWith('BO-D-I');
			},
			productSelected: function () {
				if (Object.keys(this.selected).length > 0) {
					let product = Object.values(this.selected)[0].product;
					return product;
				} else {
					return false;
				}
			},
			productRearSelected: function () {
				if (this.selectedrear === undefined || !this.selectedrear || Object.keys(this.selectedrear).length === 0) {
					return false;
				} else {
					let product = Object.values(this.selectedrear)[0].product;
					return product;
				}
				
			}
		},
		created: function () {
			this.mapInit();
			//console.log("Created Runs Now");
			if(this.isinsurance=="Yes" || this.isinsurance=="true"){				
				this.thisIsInsurance();
			}
		},
		methods: {		
			skycustomerold: function () {
				//this.booking.delivery_type = "store_visit";
				if(this.booking.skyemployee == true){
					this.booking.skyemployee = false;
				} else {
					this.booking.skyemployee = true;
				}
				
				$('.skyemployeeold').toggleClass('active');
			},
			submitSkyold: function () {
				this.booking.skyemployeeemailError = "";
				this.booking.skycodeError = "";
				if (!this.booking.skyemployeeemail) {
					this.booking.skyemployeeemailError = "Please enter an email address";

					return;
				}
				if (!REGEX_EMAIL.test(this.booking.skyemployeeemail)) {
					this.booking.skyemployeeemailError = "Please enter a valid email address";

					return;
				}
				this.booking.email = this.booking.skyemployeeemail;
				
				if (!this.booking.skycode) {
					this.booking.skycodeError = "Please enter a code";

					return;
				}
				if (this.booking.skycode != "Sky001") {
					this.booking.skycodeError = "Please enter a valid code";

					return;
				}

				
				this.booking.delivery_type = "store_visit";
				this.booking.skyemployeeemailError = "";
				this.booking.skycodeError = "";
				this.booking.emailSubmitted = true;
				this.changeMethod('store_visit');
				//this.booking.stage = 2;
				setTimeout(
				function() 
				{
					$("#london_stores").hide();
					$("#nationwide_stores").hide();
					$('.repair--map-postcode').hide();
					$('.storesearchbutton').hide();
					$('.storelistcon').hide();
					$('.sky-customer').hide();
					$('.enterheading').hide();
					
					
					$("#skylistviewold").show(); 

				}, 100);				
				console.log("skylistview old runs");
				
			},
			changeBookingStage: function (stage) {
				// Only go back stages, not forward
				if (this.booking.stage < stage) {
					return;
				}
				//disable step 3 for post in
				if(this.booking.stage == 3 && this.booking.delivery_type == 'post_in' && stage == 2){
					return;
				}
				if (stage === 0) {
					document.querySelector('body').classList.remove("popup-active");
					document.querySelector('body');
				}
				this.booking.stage = stage;
				$(".repair--delivery-popup").animate({ scrollTop: 0 }, { duration: 'medium', easing: 'swing' });
				
				// Get the modal
				
				if (document.getElementById("rearModal").style.display == 'block') { 
					var modal = document.getElementById("rearModal");
					modal.style.display = "none";
				}
				if (document.getElementById("screenModal").style.display == 'block') { 
					var modal = document.getElementById("screenModal");
					modal.style.display = "none";
				}
					
				const collection = document.getElementsByClassName("part-select-btn");
				for (let i = 0; i < collection.length; i++) {
				collection[i].innerHTML = "Book Repair";
				}
				
				const screenModelbutton = document.getElementsByClassName("screenModelbutton");
				for (let i = 0; i < screenModelbutton.length; i++) {
				screenModelbutton[i].innerHTML = "+ Add repair";
				}
				
				const rearModalbutton = document.getElementsByClassName("rearModalbutton");
				for (let i = 0; i < rearModalbutton.length; i++) {
				rearModalbutton[i].innerHTML = "+ Add repair";
				}	
				
				const continuebutton = document.getElementsByClassName("continuewithoutbutton");
				for (let i = 0; i < continuebutton.length; i++) {
				continuebutton[i].innerHTML = "Continue without";
				}				
				
				
				
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);
				var selectedrear = Object.keys(this.selectedrear)[0];
				this.$delete(this.selectedrear, selectedrear);
			},
			createUserMarker: function (lat, lng) {
				var marker_pin = "//www.ismash.com/cdn/shop/files/marker3.png?v=10549156088123064699";
				var self = this;
				console.log("show marker: "+lat+" " + lng);
				var marker = new google.maps.Marker({
					position: {
						lat: lat,
						lng: lng
					},
					map: this.map
				});
				marker.set("id", 1234);
				//console.log(marker.get("id"));
				return marker;

			},
			createStoreMarker: function (store) {
				var marker_pin = "//www.ismash.com/cdn/shop/files/marker2.png?v=5410585011668452327";
				


				marker_pin = App.config.api.filemaker + "/public/img/marker-pink.png";
				var lat = parseFloat(store.latitude);
				var lng = parseFloat(store.longitude);
				var marker = new google.maps.Marker({
					position: {
						lat: lat,
						lng: lng
					},
					map: this.map,
					icon: {
						url: marker_pin,
					}
				});

				var storeDetailsWrap = document.createElement('div');
				var lineBreak = document.createElement('br');

				var storeDetails = document.createElement('p');

				var storeName = document.createElement('b');
				storeName.textContent = store.name;
				storeDetails.appendChild(storeName);
				storeDetails.appendChild(lineBreak);

				var storeAddress = document.createElement('p');
				storeAddress.textContent = store.address;
				storeDetails.appendChild(storeAddress);
				storeDetails.appendChild(lineBreak);

				var storePhone = document.createElement('p');

				storePhone.textContent = store.contact_phone;
				storeDetails.appendChild(storePhone);
				storeDetails.appendChild(lineBreak);

				var stockDetails = document.createElement('p');
				var stockText = store.in_stock;
				if (store.in_stock == 'in_store') {
					stockText = 'Parts in stock | Repair immediately';
					stockDetails.classList.add('in-stock-infowindow');
				}

				if (store.in_stock == 'in_warehouse') {
					stockText = 'Part available for repair in 4 days';
					stockDetails.classList.add('in-warehouse-infowindow');
				}

				if (store.in_stock == 'out_of_stock') {
					stockText = 'Parts out of stock | Request notification when available';
					stockDetails.classList.add('out-of-stock-infowindow');
				}

				if (this.$availabilitymessage) {
					stockText = this.$availabilitymessage;
				}

				if (this.$hideavailability == 'Hide') {
					stockText = '';
				}

				stockDetails.textContent = '';
				
				storeDetails.appendChild(stockDetails);
				storeDetails.appendChild(lineBreak);

				var directionLink = document.createElement('a');
				if (this.booking.zip != null) {
					directionLink.href = 'https://www.google.com/maps/dir/' + encodeURIComponent(this.booking.zip) + '/' + encodeURIComponent(store.address);
				} else {
					directionLink.href = 'https://www.google.com/maps/dir//' + encodeURIComponent(store.address);
				}
				directionLink.setAttribute("target", "_blank");
				directionLink.textContent = "Get Directions";
				storeDetails.appendChild(directionLink);
				storeDetails.appendChild(lineBreak);

				var selectStore = document.createElement('a');
				selectStore.classList.add('btn');
				selectStore.href = 'javascript:window.repairApp.setStore(' + JSON.stringify(store) + ')';
				selectStore.textContent = "Select this store";
				if (store.in_stock != 'out_of_stock') {
					storeDetails.appendChild(selectStore);
				}

				storeDetailsWrap.appendChild(storeDetails);

				infoWindow = new google.maps.InfoWindow({
					content: storeDetailsWrap
				});
				var self = this;

				marker.addListener('click', (function (self, infoWindow, marker) {
					return function () {
						infoWindow.open(self.map, marker);
					};
				})(self, infoWindow, marker));
				return marker;
			},
			showLondon: function (){
				$('#london_stores').show();
				$('#nationwide_stores').hide();
				$('#london_button').addClass('active');
				$('#nationwide_button').removeClass('active');
				document.getElementById("listscroll").scrollIntoView({
					behavior: 'smooth'
				});
			},
			showNationwide: function (){
				$('#london_stores').hide();
				$('#nationwide_stores').show();
				$('#london_button').removeClass('active');
				$('#nationwide_button').addClass('active');
				document.getElementById("listscroll").scrollIntoView({
					behavior: 'smooth'
				});
			},
			openMarker: function (store, event) {

				//console.log("button fires");
				var storeContainer = $(event.currentTarget);
				var parentContainer = storeContainer.parent();
				var accordionHeader = storeContainer.find('.store-inner');

				$('.store-inner').removeClass('active');
				accordionHeader.addClass('active');

				if (accordionHeader.next('.hidden-store-details').is(":hidden")) {
					$(".gm-style-iw").next().click();
					if (infoWindow.length != 0) {
						infoWindow.close();
					}
					var marker = this.createStoreMarker(store);
					this.map.setZoom(this.zoomLevel);
					this.map.setCenter(marker.getPosition());
					infoWindow.close();
					infoWindow.open(this.map, marker);
					$('.hidden-store-details').slideUp();
					accordionHeader.next('.hidden-store-details').slideDown();

				} else {
					$('.store-inner').removeClass('active');
					accordionHeader.next('.hidden-store-details').slideUp();
				}

				var index = parentContainer.find('li').index(storeContainer);
				var offset = index * 57;
				if ($(window).width() > 480) {
					//parentContainer.animate({ scrollTop: offset }, 1000);
				}


			},
			mapInit: function () {
				var self = this;
				Vue.nextTick().then(function () {
					var mapEl = document.querySelector('[data-map]');
					if (!mapEl) { return; }
					self.map = new google.maps.Map(mapEl, {
						center: {
							lat: 54.576411,
							lng: -3.446423
						},
						zoom: 6
					});

					for (var i = 0; i < self.stores.list.length; i++) {
						var store = self.stores.list[i];
						store.name = store.name.trim();
						// if (!store.latitude || !store.contact_phone) {
						// 	continue;
						// }
						if (!store.latitude) {
							continue;
						}
						self.createStoreMarker(store);
					}
				});
			},
			enterPostcode: function () {
				clearTimeout(this.delay);
				this.delay = setTimeout(this.gotoNearestStore, 3000);
			},
			viewStoreList: function () {
				this.postcodeSearched = false;
				this.mapInit();
				this.storesList = this.stores.list;
			},
			gotoNearestStore: function (e) {
				if (!this.booking.zip) {
					this.mapInit();
					return;
				}

				this.postcodeSearched = true;
				$('.loading-nearby-stores').show();
				$('.nearby-stores-list').hide();

				this.$http.get('https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyBa2bxAi5-ZjZ30Pxp9PPl94Dgin8Sottw&address=' + this.booking.zip + ', GB').then(function (data) {

					var userLocation = data.body.results[0].geometry.location;
					var userMarker = this.createUserMarker(userLocation.lat, userLocation.lng);

					userLocation = new google.maps.LatLng(userLocation.lat, userLocation.lng);


					if (this.radius == 5) {
						this.zoomLevel = 12;
					} else if (this.radius == 10) {
						this.zoomLevel = 11;
					} else if (this.radius == 15) {
						this.zoomLevel = 9;
					} else if (this.radius == 20) {
						this.zoomLevel = 9;
					} else if (this.radius == 30) {
						this.zoomLevel = 9;
					} else if (this.radius == 40) {
						this.zoomLevel = 8;
					} else if (this.radius == 50) {
						this.zoomLevel = 8;
					} else if (this.radius == 75) {
						this.zoomLevel = 7;
					} else if (this.radius == 100) {
						this.zoomLevel = 7;
					} else if (this.radius == 200) {
						this.zoomLevel = 6;
					}

					var storesArray = [];

					this.map.setZoom(this.zoomLevel);
					this.map.setCenter(userMarker.getPosition());
					for (var i = 0; i < this.stores.list.length; i++) {

						var storeLocation = new google.maps.LatLng(this.stores.list[i].latitude, this.stores.list[i].longitude);
						var currentStoreDistance = google.maps.geometry.spherical.computeDistanceBetween(userLocation, storeLocation);
						var distanceInMile = currentStoreDistance / 1609.344;
						////console.log(distanceInMile);
						if (distanceInMile < this.radius) {
							nearestStore = this.stores.list[i];
							nearestStore['distance'] = distanceInMile;
							////console.log(nearestStore);
							var marker = this.createStoreMarker(nearestStore);
							storesArray.push(nearestStore);
						}
					}

					this.storesList = storesArray;
					$('.loading-nearby-stores').hide();
					$('.nearby-stores-list').show();

				}, function (data) {
					console.error(data);
				});
				if ($(window).width() < 480) {
					$(".repair--map-postcode").animate({ scrollTop: 800 }, { duration: 'medium', easing: 'swing' });
				}
			},
			selectStore: function (store) {
				this.booking.slot = {
					id: null,
					store_id: null
				};

				var useremail = this.booking.email;
				var abandon_data = {
					"email": useremail,
					"store": store.name
				}

				this.selectedStore.store = store;
				this.booking.stage = 2;
				ga('send', 'pageview', '?select-your-store/time');
				App.funnelEvent({
					'action': 'booking_funnel::selected_store',
					'email': this.booking.email,
					'properties': {
						'store_name': this.selectedStore.store.name
					}
				});
				$(".repair--delivery-popup").animate({ scrollTop: 0 }, { duration: 'medium', easing: 'swing' });

			},
			thisIsInsurance: function () {
				//it's an insurance journey so pre-select store visit
				this.booking.delivery_type = "store_visit";
			},			
			changeMethod: function (method) {
				//we need to make an extra check if the produc is a Vend for post-in method
				if (method === "post_in") {
					let is_vend_product = this.is_variant_vend_product;
					if (is_vend_product) return false;
				}

				this.selectedStore.store = null;
				this.booking.slot = {
					id: null,
					store_id: null
				};
				this.booking.delivery_type = method;
				this.booking.callout = false;
				// this.hasStock = StockQty;
				// //console.log("StockQty "+StockQty);

				if (method == "store_visit") {
					ga('send', 'pageview', '?select-your-store');
					this.mapInit();
				} else if (method == "courier_collection") {
					ga('send', 'pageview', '?send-your-device');
				} else if (method == "post_in") {
					ga('send', 'pageview', '?send-your-device');
				} else if (method == "call_out") {
					this.booking.callout = true;
					ga('send', 'pageview', '?select-your-store/time');
				}
				if ($(window).width() < 480) {
					if(method == "store_visit"){
						scrollToMobile('#stores_anchor',30,100);
					}else if(method == "courier_collection"){
						scrollToMobile('#courier_anchor',30,100);
					}else if(method == "post_in"){
						scrollToMobile('#postin_anchor',30,100);
					}
					
				} else if ($(window).width() < 1300 && $(window).width() > 480) {
					$(".repair--delivery-popup").animate({ scrollTop: 300 }, { duration: 'medium', easing: 'swing' });
				} else {
					$(".repair--delivery-popup").animate({ scrollTop: 400 }, { duration: 'medium', easing: 'swing' });
				}

			},
			selectCourierStore: function () {
				this.booking.slot = {
					id: null,
					store_id: null
				}
				this.selectedStore.store = JSON.parse('{"address": "","contact_email": "courier@ismash.com","contact_phone": "02076403111","googleID": "ChIJ8wOfrBQFdkgR2RCtjwx4PBE","id": "06bd64da-d882-11e8-f71b-7f7ec9c70955","in_london": 1,"in_stock": "courier","isStore": 1,"latitude": 51.489219800000000759609974920749664306640625,"longitude": -0.1640771000000000034990677022506133653223514556884765625,"mon_fri": "08:00-20:00","name": "Courier Pick-up","sat": "10:00-19:00","sun": "10:00-18:00","yelpID": "y7Dw4dlwzkSsVKN3E_-orw"}');
				this.booking.stage = 2;
			},
			checkCourierBooking: function (e) {

				var foundit = 0;

				var needle = this.booking.courier.zip.replace(/\s/g, '').slice(0, -3).toUpperCase();

				////console.log("file contains this now "+JSON.stringify(this.$postcodeLookup));
				//console.log("new postcode " + needle);
				// iterate over each element in the array
				for (var i = 0; i < this.$postcodeLookup.length; i++) {
					var thispostcode = this.$postcodeLookup[i].Postcode.replace(/\s/g, '').toUpperCase();
					this.booking.addressPostCode = this.booking.courier.zip.toUpperCase();
					////console.log("loop runs "+thispostcode);
					// look for the entry with a matching `postcode` value
					if (thispostcode == needle) {
						foundit = 1;
						courierCost = this.$postcodeLookup[i].Price;
						this.booking.courier.pickupcost = this.$postcodeLookup[i].Price;

						////console.log("courier price "+courierCost);
					}
				}

				if (foundit == 1) {
					this.postcodeCourierAccepted = 'yes';
					this.postcodeCourierCost = courierCost;
				} else {
					this.postcodeCourierAccepted = 'no';
				}

			},
			checkCourierTimeslots: function (e) {

				this.booking.slot = {
					id: null,
					store_id: null
				};
				this.booking.stage = 2;
				ga('send', 'pageview', '?send-your-device/time');
			},
			addSelectedToCart: function (callback) {
				this.post_in_errors = [];

				if (typeof (callback) === 'undefined') {
					callback = null;
				}
				// if (!this.booking.device_passcode || this.booking.device_passcode == null) {
				// 	this.post_in_errors.push("Device passcode is required!");
				// }
				// if (!this.booking.post_in_terms_accepted || this.booking.post_in_terms_accepted == false) {
				// 	this.post_in_errors.push("Please accept terms and conditions");
				// }

				if (this.post_in_errors.length > 0) {
					return;
				}

				var errorfree = 0;
				if(Object.keys(this.selected).length > 0){
					var itemsToAdd = {};
					for (var i = 0; i < Object.keys(this.selected).length; i++) {
						itemsToAdd[this.selected[Object.keys(this.selected)[i]].variant.id] = 1;
					}

					this.$http.post('/cart/update.js', {
						updates: itemsToAdd
					}).then(function (data) {
						//window.location.href = "/cart?dp=" + this.booking.device_passcode + "&ta=" + this.booking.post_in_terms_accepted;

						this.booking.slot = {
							id: null,
							store_id: null
						}
						this.selectedStore.store = JSON.parse('{"address":"111 Power Road, London, W45PY","contact_email":"customerservice@ismash.com","contact_phone":"020 7640 3111","googleID":"","id":"060f02b1-c882-11e6-fcd2-33e0499e0cc0","in_london":0,"in_stock":"in_warehouse","isStore":0,"latitude":51.4945573,"longitude":-0.2791007,"mon_fri":"","name":"Online","sat":"Closed","sun":"-","yelpID":""}');
						errorfree = 1;
						//console.log("selected added");
						this.booking.stage = 3;
						if (callback) {
							callback();
						}
					}, function (data) {
						console.error(data);
					});
				}
				if(Object.keys(this.selectedrear).length > 0){

					var itemsToAdd = {};
					for (var i = 0; i < Object.keys(this.selectedrear).length; i++) {
						itemsToAdd[this.selectedrear[Object.keys(this.selectedrear)[i]].variant.id] = 1;
					}
					

					this.$http.post('/cart/update.js', {
						updates: itemsToAdd
					}).then(function (data) {
						//window.location.href = "/cart?dp=" + this.booking.device_passcode + "&ta=" + this.booking.post_in_terms_accepted;
					
						this.booking.slot = {
							id: null,
							store_id: null
						}
						this.selectedStore.store = JSON.parse('{"address":"111 Power Road, London, W45PY","contact_email":"customerservice@ismash.com","contact_phone":"020 7640 3111","googleID":"","id":"060f02b1-c882-11e6-fcd2-33e0499e0cc0","in_london":0,"in_stock":"in_warehouse","isStore":0,"latitude":51.4945573,"longitude":-0.2791007,"mon_fri":"","name":"Online","sat":"Closed","sun":"-","yelpID":""}');
						errorfree = 1;
						//console.log("selectedrear added");
						this.booking.stage = 3;
					}, function (data) {
						console.error(data);
					});

				}

				if(errorfree==1){
					//console.log("errorfree "+errorfree);
					this.booking.stage = 3;
				} else {
					//console.log("not errorfree "+errorfree);
				}
			},
			goToInsurancePostIn: function () {
				this.post_in_errors = [];
				// if (!this.booking.device_passcode || this.booking.device_passcode == null) {
				// 	this.post_in_errors.push("Device passcode is required!");
				// }
				// if (!this.booking.post_in_terms_accepted || this.booking.post_in_terms_accepted == false) {
				// 	this.post_in_errors.push("Please accept terms and conditions");
				// }

				if (this.post_in_errors.length > 0) {
					return;
				}
				window.location.href = "/pages/insurance-booking-post-ins";
			},
			addItemToCart: function (variantId, callback) {
				if (typeof (callback) === 'undefined') {
					callback = null;
				}
				var itemsToAdd = {};
				itemsToAdd[variantId] = 1;
				
				//if the product selected is premium 
				if(this.$root.booking.is_premium){
					itemsToAdd[this.$root.premium_service_product.id] = 1;
				}
				
				if(Object.keys(this.selected).length > 0){
					
					for (var i = 0; i < Object.keys(this.selected).length; i++) {
						itemsToAdd[this.selected[Object.keys(this.selected)[i]].variant.id] = 1;
					}
					this.$http.post('/cart/update.js', {
						updates: itemsToAdd
					}).then(function (data) {
						if (callback) {
							callback();
						}
					}, function (data) {
						console.error(data);
					});
				}
				if(Object.keys(this.selectedrear).length > 0){

					for (var i = 0; i < Object.keys(this.selectedrear).length; i++) {
						itemsToAdd[this.selectedrear[Object.keys(this.selectedrear)[i]].variant.id] = 1;
					}
					this.$http.post('/cart/update.js', {
						updates: itemsToAdd
					}).then(function (data) {

					}, function (data) {
						console.error(data);
					});
				}
			},
			clearCart: function (callback) {
				if (typeof (callback) === 'undefined') {
					callback = null;
				}
				this.$http.post('/cart/clear.js').then(function (data) {
					if (callback) {
						callback();
					}
				}, function (data) {
					console.error(data);
				});
			},
			subscribeToDripCampaign: function () {
				if (typeof _dcq != 'object') {
					console.error('Drip JS obj not found');
					return;
				}
				if (!this.booking.email || !REGEX_EMAIL.test(this.booking.email)) {
					return;
				}
				//console.log("subscribeToDripCampaign push: "+this.booking.email)
				_dcq.push(["identify", {
					email: this.booking.email
				}]);
			},
			subscribeToActiveCampaign: function () {
				if (!this.booking.email || !REGEX_EMAIL.test(this.booking.email)) {
					return;
				}
				var activecampaigndata = {
					"email": this.booking.email
				}
				
				this.$http.post(App.config.api.filemaker + '/customer/addAC', activecampaigndata).then(function (data) {
					//console.log(data.body);
				}, function (data) {
					console.error(data);
					e.target.disabled = false;
				});
				
				//console.log("activeCampaign push: "+this.booking.email)
				// _dcq.push(["identify", {
				// 	email: this.booking.email
				// }]);
			},
			submitEmail: function () {
				fbq('track', 'Lead');

				if (!this.booking.email) {
					this.booking.emailSubmitError = "Please enter an email address";
					this.booking.emailSubmitted = false;

					return;
				}
				if (!REGEX_EMAIL.test(this.booking.email)) {
					this.booking.emailSubmitError = "Please enter a valid email address";
					this.booking.emailSubmitted = false;

					return;
				}
				var useremail = this.booking.email;
				var productitle = '';
				var repairprice = 0;
				var primarySelection = Object.values(this.selected || {})[0] || null;
				var rearSelection = Object.values(this.selectedrear || {})[0] || null;
				var chosenSelection = primarySelection && primarySelection.product ? primarySelection : rearSelection;
				if (chosenSelection && chosenSelection.product) {
					productitle = chosenSelection.product.title || '';
					repairprice = (chosenSelection.product.price || 0) / 100;
				}
				var abandon_data = {
					"email": useremail,
					"device": productitle
				}

				document.cookie = "useremail="+useremail+";";
				ga('send', 'event', 'Exits', 'Booking', 'Proceed_To_Book');
				//if(this.booking.optin){
				//this.subscribeToDripCampaign();
                this.subscribeToActiveCampaign();
				this.booking.optedin = true;
				App.funnelEvent({
					'action': 'booking_funnel::start',
					'email': this.booking.email,
					'properties': {
						'email': this.booking.email,
						'repair_name': this.selectedRepairType,
						'collection_url': window.location.href,
						'collection_name': window.collection.title.replace(' Repairs', '')
					}

				});
				////console.log('optin1');
				//}else{
				////console.log('optout1');
				//}
				// //console.log("Email "+useremail)
				// //console.log("Price "+repairprice)
				// //console.log("Title "+repairtitle)
				var _tvqsky = window._tvqsky = window._tvqsky || [];
				(function () {
					var session = { 'user': useremail };
					var actionname = 'bookings';
					var action = {
					'rev': repairprice,
					'prod': productitle,
					'id': useremail
					};

					var u = (("https:" == document.location.protocol) ?
					"https://collector-12744.tvsquared.com/"
					:
					"http://collector-12744.tvsquared.com/");
					_tvqsky.push(['setSiteId', "TV-8172275454-1"]);
					_tvqsky.push(['setTrackerUrl', u + 'tv2track.php']);
					_tvqsky.push([function () {
					this.setCustomVariable(5, 'session', JSON2.stringify(session), 'visit')
					}]);
					_tvqsky.push([function () {
					this.setCustomVariable(5, actionname, JSON2.stringify(action), 'page')
					}]);
					_tvqsky.push(['trackPageView']);
					var d = document,
					g = d.createElement('script'),
					s = d.getElementsByTagName('script')[0];
					g.type = 'text/javascript';
					g.defer = true;
					g.async = true;
					g.src = u + 'tv2tracksky.js';
					s.parentNode.insertBefore(g, s);
				})();

				this.booking.emailSubmitError = null;
				this.booking.emailSubmitted = true;
				this.booking.stage = 2;
				var currentPath = window.location.pathname || '';
				if (currentPath.indexOf('/pages/device-funnel-stage-1') === 0) {
					var params = new URLSearchParams(window.location.search || '');
					var sourceCollection = params.get('source_collection') || sessionStorage.getItem('jv_source_collection') || (window.collection && window.collection.handle ? window.collection.handle : '');
					var hasRedirected = false;
					var persistAndRedirect = function (prefetchedStores) {
						if (hasRedirected) {
							return;
						}
						hasRedirected = true;
						var storesToPersist = [];
						if (Array.isArray(prefetchedStores)) {
							storesToPersist = prefetchedStores;
						} else if (prefetchedStores && typeof prefetchedStores === 'object') {
							storesToPersist = Object.values(prefetchedStores);
						} else if (this.stores && Array.isArray(this.stores.list)) {
							storesToPersist = this.stores.list;
						}
						try {
							sessionStorage.setItem('jv_selected', JSON.stringify(this.selected || {}));
							sessionStorage.setItem('jv_selectedrear', JSON.stringify(this.selectedrear || {}));
							sessionStorage.setItem('jv_stores_list', JSON.stringify(storesToPersist || []));
							sessionStorage.setItem('jv_booking_snapshot', JSON.stringify({
								email: this.booking.email || null,
								zip: this.booking.zip || null,
								delivery_type: this.booking.delivery_type || 'store_visit'
							}));
						} catch (e) {}
						if (sourceCollection) {
							sessionStorage.setItem('jv_source_collection', sourceCollection);
						}
						var nextUrl = '/pages/device-funnel-stage-2';
						if (sourceCollection) {
							nextUrl += '?source_collection=' + encodeURIComponent(sourceCollection);
						}
						navigateWithFunnelLoader(nextUrl);
					}.bind(this);

					var existingStores = this.stores && Array.isArray(this.stores.list) ? this.stores.list : [];
					var stockUrl = buildStoreStockUrl(this.selected, this.selectedrear);

					if (!this.$http || existingStores.length > 0 || !stockUrl) {
						persistAndRedirect(existingStores);
						return;
					}
					var prefetchTimeout = setTimeout(function () {
						persistAndRedirect(this.stores && this.stores.list ? this.stores.list : []);
					}.bind(this), 2000);

					this.$http.get(stockUrl).then(function (data) {
						clearTimeout(prefetchTimeout);
						var storeList = normalizeStoreListResponse(data && data.body ? data.body : null);
						this.stores.list = Array.isArray(storeList) ? storeList : [];
						persistAndRedirect(this.stores.list);
					}.bind(this), function () {
						clearTimeout(prefetchTimeout);
						persistAndRedirect(this.stores && this.stores.list ? this.stores.list : []);
					}.bind(this));
					return;
				}

				this.mapInit();
				if ($(window).width() < 480) {
					$(".scrollpoint").animate({ scrollTop: 300 }, { duration: 'medium', easing: 'swing' });
				}



			},
			makeCourierBooking: function (e) {
				e.target.disabled = true;
				this.errors = [];
				var booking = this.booking.courier;

				if (!this.booking.courier.first_name) {
					this.errors.push("First Name is required");
				}
				if (!this.booking.courier.last_name) {
					this.errors.push("Last Name is required");
				}
				if (!this.booking.courier.email) {
					this.errors.push("An email address is required");
				}
				if (!this.normalized_phone) {
					this.errors.push("A phone number is required");
				} else if (!/^\d+$/.test(this.normalized_phone)) {
					this.errors.push("Please enter a valid phone number");
				}
				if (!this.booking.courier.zip) {
					this.errors.push("Postcode is required");
				} else if (!/^([A-Z][A-Z0-9]?[A-Z0-9]?[A-Z0-9]{1,2}[0-9][A-Z0-9]{2})$/.test(this.normalized_zip)) {
					this.errors.push("Please enter a valid UK postcode");
				}
				if (!this.booking.courier.terms_accepted) {
					this.errors.push("Please read and accept the terms and conditions");
				}

				if (this.errors.length > 0) {
					e.target.disabled = false;
					return;
				}
				if(Object.keys(this.selected).length === 0){
					booking['selected_repair'] = this.selected[Object.keys(this.selectedrear)[0]].variant.name;
				} else {
					booking['selected_repair'] = this.selected[Object.keys(this.selected)[0]].variant.name;
				}

				this.$http.post(App.config.api.filemaker + '/booking/courier', booking).then(function (data) {
					ga("send", "pageview", "?booking-confirmed/" + this.booking.delivery_type);
					window.location.href = "/pages/courier-thank-you";
				}, function (data) {
					console.error(data);
					e.target.disabled = false;
				});
			},
			makeNoStockBooking: function (e) {
				e.target.disabled = true;
				this.errors = [];
				var nostockbooking = [];

				if (!this.booking.first_name) {
					this.errors.push("First Name is required");
					this.booking.errors.first_name = "First Name is required";
				}
				if (!this.booking.last_name) {
					this.errors.push("Last Name is required");
					this.booking.errors.last_name = "Last Name is required";
				}
				if (!REGEX_EMAIL.test(this.booking.email)) {
					this.errors.push("An email address is required");
					this.booking.errors.email = "An email address is required";
				}
				if (!this.normalized_bookingphone) {
					this.errors.push("A phone number is required");
					this.booking.errors.phone = "A phone number is required";
				} else if (!REGEX_PHONE.test(this.normalized_bookingphone)) {
					this.errors.push("Please enter a valid phone number");
					this.booking.errors.phone = "Please enter a valid phone number";
				}
				if (!this.booking.insurance.is_insurance) {
					if (!this.booking.terms_accepted) {
						this.errors.push("Please read and accept the terms and conditions");
						this.booking.errors.terms_accepted = "Please read and accept the terms and conditions";
					}
				}
				
				if (!this.booking.customer_zip) {
					this.errors.errors.customer_zip = "Postcode is required";
				} else if (!/^([A-Z][A-Z0-9]?[A-Z0-9]?[A-Z0-9]{1,2}[0-9][A-Z0-9]{2})$/.test(this.normalized_zip)) {
					this.errors.errors.customer_zip = "Please enter a valid UK postcode";
				}

				if (this.errors.length > 0) {
					e.target.disabled = false;
					return;
				}
				if(Object.keys(this.selected).length === 0){
					var selected_repair = this.selected[Object.keys(this.selectedrear)[0]].variant.name;
				} else {
					var selected_repair = this.selected[Object.keys(this.selected)[0]].variant.name;
				}
				var json = {
					"first_name": this.booking.first_name,
					"last_name": this.booking.last_name,
					"email": this.booking.email,
					"postcode": this.booking.customer_zip,
					"phone": this.booking.phone,
					"notes": this.booking.notes,
					"store": 'Post In',
					"terms_accepted": this.booking.terms_accepted,
					"selected_repair": selected_repair,
					"optin": this.booking.optin
				}

				this.$http.post(App.config.api.filemaker + '/booking/out-of-stock', json).then(function (data) {
					ga("send", "pageview", "?booking-confirmed/out-of-stock");
					window.location.href = "/pages/device-enquiry-thank-you";
				}, function (data) {
					console.error(data);
					e.target.disabled = false;
				});
			},
			covidReminder: function(e) {
				e.target.disabled = true;
				this.errors = [];

				if (!REGEX_EMAIL.test(this.booking.email)) {
					this.errors.push("A valid email address is required");
					this.booking.errors.email = "A valid email address is required";
				}

				if (this.errors.length > 0) {
					e.target.disabled = false;
					return;
				}

				if(Object.keys(this.selected).length === 0){
					var producsku = this.selectedrear[Object.keys(this.selectedrear)[0]].product.sku;
				} else {
					var producsku = this.selected[Object.keys(this.selected)[0]].product.sku;
				}
				var json = {
					"email": this.booking.email,
					"repair": this.selectedRepairType,
					"sku": producsku,
				}

				this.$http.post(App.config.api.filemaker + '/booking/covid19', json).then(function (data) {
					ga("send", "pageview", "?booking-confirmed/covid19");
					//console.log(data);
					if(data.body == 1){
						//console.log("success");
						window.location.href = "/pages/thank-you-for-registering-your-interest";
					}else{
						//console.log("fail");
						//Show error message
					}
					
				}, function (data) {
					console.error(data);
					e.target.disabled = false;
				});
			},
		}
	});

	//Timetable
	Vue.component('timetable', {
		template: '#timetable',
		props: ['booking', 'store', 'callout', 'bookingDate', 'selected'],
		data: function () {
			return {
				slots: [],
				timetable: (typeof Timetable !== 'undefined') ? new Timetable() : null,
				selectedDay: null,
				isinsurance: this.$isinsurance,
				errors: []
			};
		},
		mounted: function () {
			this.renderStoreSlots();
		},
		computed: {
			normalized_phone: function () {
				if (!this.booking.phone) {
					return null;
				}
				return this.booking.phone.replace(/\s/g, '');
			},
			// dates: function () {
			// 	var dates = [];
			// 	for (var i = 0; i < this.daySlots.length; i++) {
			// 		dates.push(moment().add(i, 'days').format("ddd Do MMM"));
			// 	}
			// 	return dates;
			// },
			availibleDaySlots: function () {
				var slots = Array.isArray(this.slots) ? this.slots : [];
				var daySlots = [
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[]
				];

				for (var i = 0; i < slots.length; i++) {
					if (!daySlots[slots[i].day]) {
						daySlots[slots[i].day] = [];
					}

					daySlots[slots[i].day].push(slots[i]);
				}

				return daySlots;
			},
			daySlots: function () {
				var daySlots = JSON.parse(JSON.stringify(this.availibleDaySlots));
				////console.log(daySlots);
				for (var i = 0; i < daySlots.length; i++) {
					if (!daySlots[i]) {
						continue;
					}
					var thisDaysSlots = daySlots[i].map(function (e) {
						return {
							start_hour: e.start_hour,
							start_min: e.start_min
						};
					});

					var openHour = this.store.open_hour ? this.store.open_hour : 6;
					var openMin = this.store.open_minute ? this.store.open_minute : 0;
					var closeHour = this.store.close_hour ? this.store.close_hour : 22;
					var closeMin = this.store.close_minute ? this.store.close_minute : 0;

					var start = moment().utc().hours(openHour).minutes(openMin);
					var end = moment().utc().hours(closeHour).minutes(closeMin);

					var current = start;
					while (current < end) {

						var thisSlot = {
							start_hour: current.hours(),
							start_min: current.minutes()
						};

						if (!findObjInArray(thisDaysSlots, thisSlot)) {
							daySlots[i].push({
								id: -1,
								start_hour: current.hours(),
								start_min: current.minutes(),
								end_hour: current.hours(),
								end_min: current.minutes(),
								disabled: true
							});
						}

						current = current.add(30, 'minutes');
					}

					daySlots[i] = daySlots[i].sort(function (a, b) {
						var aInMins = (a.start_hour * 60) + a.start_min;
						var bInMins = (b.start_hour * 60) + b.start_min;
						if (aInMins > bInMins) {
							return 1;
						}
						return -1;
					});
				}
				
				return daySlots;
			},
			dates: function () {
				var dates = [];
				if(this.booking.slotweek==0){
					for (var i = 0; i < 7; i++) {
						dates.push(moment().add(i, 'days').format("dddd[|]Do[|]MMMM"));
					}
				}
				if(this.booking.slotweek==1){
					for (var i = 7; i < 14; i++) {
						dates.push(moment().add(i, 'days').format("dddd[|]Do[|]MMMM"));
					}
				}
				if(this.booking.slotweek==2){
					for (var i = 14; i < 21; i++) {
						dates.push(moment().add(i, 'days').format("dddd[|]Do[|]MMMM"));
					}
				}
				////console.log(dates);
				return dates;
			}
		},
		methods: {
			localTime: function (slot) {
				var start = moment().utc().minute(slot.start_min).hours(slot.start_hour);
				var end = moment().utc().minute(slot.end_min).hours(slot.end_hour);

				return {
					start: {
						hour: slot.start_hour,
						min: slot.start_min
					},
					end: {
						hour: slot.end_min,
						min: slot.end_hour
					}
				};
			},
			renderStoreSlots: function () {
				if (!this.store || !this.store.id) {
					return;
				}
				$('.timetable').hide();
				$('.loading-days').show();
				$('.next-week').hide();
				$('.prev-week').hide();


				var date = new Date();
				var CurrentDate = moment(date).format('YYYY-MM-DD');

				////console.log('/store/slots_new/' + CurrentDate + '/' + this.booking.slotweek + '/' + this.store.id + '/' + this.store.in_stock);
				this.$http.get(App.config.api.filemaker + '/store/slots_new/' + CurrentDate + '/' + this.booking.slotweek + '/' + this.store.id + '/' + this.store.in_stock).then(function (data) {
					this.slots = data.body;
					$('.timetable').show();
					$('.loading-days').hide();
					$('.prev-week').show();
					$('.next-week').show();
					if (this.booking.slotweek == 0){
						$('.prev-week').hide();
					}
					if (this.booking.slotweek == 1){
						$('.next-week').hide();
					}

					////console.log('Slots: '+this.slots);
				}, function (data) {
					console.error(data);
				});

			},
			getStorePrevWeek: function () {
				this.booking.slot = {
					id: null,
					store_id: null
				};
				this.selectedDay = null;
				this.booking.slotweek = this.booking.slotweek - 1;
				$('.timetable').hide();
				this.renderStoreSlots();
			},
			getStoreNextWeek: function () {
				this.booking.slot = {
					id: null,
					store_id: null
				};
				this.selectedDay = null;
				this.booking.slotweek = this.booking.slotweek + 1;
				this.renderStoreSlots();
			},
			getStoreThisWeek: function () {
				this.booking.slot = {
					id: null,
					store_id: null
				};
				this.booking.slotweek = 0;
				this.booking.week = moment().week(),
					this.booking.year = moment().year()
				this.renderStoreSlots();
			},
			selectSlot: function (slot) {
				if (slot.id < 0) {
					return;
				}
				this.booking.slot = slot;
				scrollBookingToTop();
				if (!this.booking.appointmentDuration){
					this.booking.appointmentDuration = 30;
				}
				var end = moment(this.booking.slot.start_hour + ':' + this.booking.slot.start_min, 'HH:mm').add(this.booking.appointmentDuration, 'minutes').format('HH:mm');
				// //console.log("appointmentDuration "+this.booking.appointmentDuration);
				// //console.log("start "+this.booking.slot.start_hour + ':' + this.booking.slot.start_min);
				// //console.log("end "+end);
				var endslot = end.split(":");
				this.booking.slot.end_hour = endslot[0];
				this.booking.slot.end_min = endslot[1];
			},
			selectDay: function (day) {
				if (this.availibleDaySlots[day].length < 1) {
					return;
				}
				
				this.booking.slot = {
					id: null,
					store_id: null
				};

				this.selectedDay = this.selectedDay == day ? null : day;
				

				if(this.booking.delivery_type === "courier_collection"){
					var courierSlot;
					for(var i=0; i < this.slots.length; i++){
						if(this.slots[i].day == this.selectedDay){
							courierSlot = this.slots[i];
						}
					}
					this.selectSlot(courierSlot);
				}

				if ($(window).width() < 480) {
					scrollToMobile('.mobile-slots');
				}
			},
			confirmSlot: function () {
				this.booking.stage = 3;
				ga('send', 'pageview', '?select-your-store/time/contact-details');
				$(".repair--delivery-popup").animate({ scrollTop: 0 }, { duration: 'medium', easing: 'swing' });
				App.funnelEvent({
					'action': 'booking_funnel::selected_timeslot',
					'email': this.booking.email
				});
			},
			makeNoStockBooking: function (e) {
				e.target.disabled = true;
				this.errors = [];
				var nostockbooking = [];
				
				if (!this.booking.first_name) {
					this.errors.push("First Name is required");
					this.booking.errors.first_name = "First Name is required";
				}
				if (!this.booking.last_name) {
					this.errors.push("Last Name is required");
					this.booking.errors.last_name = "Last Name is required";
				}
				if (!REGEX_EMAIL.test(this.booking.email)) {
					this.errors.push("An email address is required");
					this.booking.errors.email = "An email address is required";
				}
				if (!this.normalized_phone) {
					this.errors.push("A phone number is required");
					this.booking.errors.phone = "A phone number is required";
				} else if (!REGEX_PHONE.test(this.normalized_phone)) {
					this.errors.push("Please enter a valid phone number");
					this.booking.errors.phone = "Please enter a valid phone number";
				}
				if (!this.booking.insurance.is_insurance) {
					if (!this.booking.terms_accepted) {
						this.errors.push("Please read and accept the terms and conditions");
						this.booking.errors.terms_accepted = "Please read and accept the terms and conditions";
					}
				}

				if (this.errors.length > 0) {
					e.target.disabled = false;
					return;
				}
				if(Object.keys(this.selected).length === 0){
					var selected_repair = this.selected[Object.keys(this.selectedrear)[0]].variant.name;
				} else {
					var selected_repair = this.selected[Object.keys(this.selected)[0]].variant.name;
				}
				var json = {
					"first_name": this.booking.first_name,
					"last_name": this.booking.last_name,
					"email": this.booking.email,
					"phone": this.booking.phone,
					"notes": this.booking.notes,
					"store": this.store.name,
					"terms_accepted": this.booking.terms_accepted,
					"selected_repair": selected_repair,
					"optin": this.booking.optin
				}

				this.$http.post(App.config.api.filemaker + '/booking/out-of-stock', json).then(function (data) {
					ga("send", "pageview", "?booking-confirmed/out-of-stock");
					window.location.href = "/pages/device-enquiry-thank-you";
				}, function (data) {
					console.error(data);
					e.target.disabled = false;
				});
			}
		},
		watch: {
			store: function () {
				this.booking.slot = {
					id: null,
					store_id: null
				};
				this.selectedDay = null;
				this.renderStoreSlots();
			}
		}
	});

	//Booking Form
	Vue.component('booking-form', {
		template: '#booking-form',
		props: ['booking', 'collection', 'selected', 'selectedrear', 'store','showExtraFields'],
		data: function () {
			return {
				err: 0,
				business_err: 0,
				isinsurance: this.$isinsurance,
				insuranceref: this.$insuranceref,
				insurer: this.$insurer
			};
		},
		mounted:function(){	
			if(this.booking.insurance.is_insurance){
				this.validateInsurance();
			}			
			if (sessionStorage.getItem("samsung")) {
				$('#device_imei').show();
			}
		},
		computed: {
			selectedProduct: function () {
				if(Object.keys(this.selected).length === 0){
					var selectedProduct = this.selectedrear[Object.keys(this.selectedrear)[0]];
				} else {
					var selectedProduct = this.selected[Object.keys(this.selected)[0]];
				}
				if (!selectedProduct || !selectedProduct.product) {
					return createEmptySelectedProduct();
				}
				return selectedProduct.product;
			},
			normalized_zip: function () {
				if (!this.booking.zip) {
					return null;
				}
				return this.booking.zip.replace(/\s/g, '').toUpperCase();
			},
			normalized_phone: function () {
				if (!this.booking.phone) {
					return null;
				}
				return this.booking.phone.replace(/\s/g, '');
			}
		},
		methods: {			
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			addSelectedToCart: function (callback) {
				this.post_in_errors = [];

				if (typeof (callback) === 'undefined') {
					callback = null;
				}
				if (this.post_in_errors.length > 0) {
					return;
				}

				var itemsToAdd = {};
				for (var i = 0; i < Object.keys(this.selected).length; i++) {
					itemsToAdd[this.selected[Object.keys(this.selected)[i]].variant.id] = 1;
				}
				for (var i = 0; i < Object.keys(this.selectedrear).length; i++) {
					itemsToAdd[this.selectedrear[Object.keys(this.selectedrear)[i]].variant.id] = 1;
				}

				this.$http.post('/cart/update.js', {
					updates: itemsToAdd
				}).then(function (data) {
					//window.location.href = "/cart?dp=" + this.booking.device_passcode + "&ta=" + this.booking.post_in_terms_accepted;

					this.booking.slot = {
						id: null,
						store_id: null
					}
					this.selectedStore.store = JSON.parse('{"address": "111 Power Road, , London, , W45PY","contact_email": "centralworkshop@ismash.com","contact_phone": "02076571186","googleID": "ChIJC5wtUnUOdkgRm1QqxHMtrw8","id": "a0369f1f-9082-11e4-ee62-b82846eaf49c","in_london": 1,"in_stock": "post_in","isStore": 1,"latitude": 51.489219800000000759609974920749664306640625,"longitude": -0.1640771000000000034990677022506133653223514556884765625,"mon_fri": "08:00-20:00","name": "Central Workshop","sat": "10:00-19:00","sun": "10:00-18:00","yelpID": "DrsDVXUsMq7RjdB78Bm2vw"}');

					this.booking.stage = 3;
					if (callback) {
						callback();
					}
				}, function (data) {
					console.error(data);
				});
			},
			addItemToCart: function (variantId) {
				var itemsToAdd = {};
				itemsToAdd[variantId] = 1;
				
				//if the product selected is premium 
				if(this.$root.booking.is_premium){
					itemsToAdd[this.$root.premium_service_product.id] = 1;
				}

				this.$http.post('/cart/update.js', {
					updates: itemsToAdd
				}).then(function (data) {
					
				}, function (data) {
					console.error(data);
				});
			},
			makeBooking: function (e) {
				var businessidentifier = 0;
				var businessauth = 0;
				var button = document.getElementById('confirmbookingbutton');
				button.innerHTML = 'Processing, please wait';
				e.target.disabled = true;
				$("#sky_booking_type").hide();
				$("#sky_booking_type_old").hide();

				var booking = this.booking;
				this.err = 0;
				this.booking.errors.first_name = null;
				this.booking.errors.last_name = null;
				this.booking.errors.email = null;
				this.booking.errors.phone = null;
				this.booking.errors.zip = null;
				this.booking.errors.device_passcode = null;
				this.booking.errors.marketing = null;
				this.booking.errors.tvmarketing = null;
				this.booking.errors.terms_accepted = null;
				this.booking.errors.device_imei = null;
				this.booking.errors.sky_booking_type = null;
				

				if (this.booking.skyemployee == true && !this.booking.sky_type) {
					$("#sky_booking_type").show();
					$("#sky_booking_type_old").show();
					this.err++;
					this.booking.errors.sky_booking_type = "Ths option is required";
				} 

				if (this.selected.length < 1 && this.selectedrear.length < 1) {
					//console.log("Error - No Repair");
					this.err++;
					this.errors.push("You must have atleast one item selected");
				}
				//Only check Optin for none insurance bookings
				if (this.booking.optinFileMaker == "Please select" && !this.booking.insurance.is_insurance && !this.booking.skyjourney) {
					//console.log("Error - No Optin");
					this.err++;
					this.booking.errors.marketing = "Please select an option";
				}
				if (!this.booking.insurance.is_insurance && !this.booking.skyjourney) {
					if (this.booking.TVMarketing == "Please select") {
						//console.log("Error - No TV");
						this.err++;
						this.booking.errors.tvmarketing = "Please select an option";
					}
				}
				if (!this.booking.first_name) {
					//console.log("Error - No Firstname");
					this.err++;
					this.booking.errors.first_name = "First Name is required";
				}
				if (!this.booking.last_name) {
					//console.log("Error - No Lastname");
					this.err++;
					this.booking.errors.last_name = "Last Name is required";
				}
				if (!REGEX_EMAIL.test(this.booking.email)) {
					//console.log("Error - No Email");
					this.err++;
					this.booking.errors.email = "An email address is required";
				}
				if (!this.normalized_phone) {
					//console.log("Error - No Phone NUmber");
					this.err++;
					this.booking.errors.phone = "A phone number is required";
				} else if (!REGEX_PHONE.test(this.normalized_phone)) {
					//console.log("Error - No Valid Phone Number");
					this.err++;
					this.booking.errors.phone = "Please enter a valid phone number";
				}
				if(sessionStorage.getItem("samsung")){
					if (!this.booking.imei) {
						this.err++;
						this.booking.errors.device_imei = "An IMEI number is required";

					} else if (!REGEX_IMEI.test(this.booking.imei)){
						this.err++;
						this.booking.errors.device_imei = "Please enter a valid IMEI number";
					}
				}
				
				// if (!this.booking.zip) {
				// 	this.err++;
				// 	this.booking.errors.zip = "A postcode is required";
				// } else if (!REGEX_POSTCODE.test(this.normalized_zip)) {
				// 	this.err++;
				// 	this.booking.errors.zip = "Please enter a valid UK postcode";
				// }
				// if(this.isinsurance==false){
				// 	if (!this.booking.optinFileMaker){
				// 		this.err++;
				// 		this.booking.errors.marketing = 'Please select your marketing preference';
				// 	}
				// }
				// if (this.booking.optinFileMaker && this.booking.optoutFileMaker){
				// 	this.err++;
				// 	this.booking.errors.marketing = 'Please select your marketing preference';
				// }
				if (!this.booking.insurance.is_insurance && !this.booking.skyjourney) {
					if (!this.booking.terms_accepted) {
						//console.log("Insurnance Booking - T&C's");
						this.err++;
						this.booking.errors.terms_accepted = "Please read and accept the terms and conditions";
					}
				}

				if (this.booking.delivery_type == 'courier_collection') {
					if (!this.booking.addressLine1) {
						this.err++;
						this.booking.errors.addressLine1 = "Address Line 1 is required";
					}
					if (!this.booking.addressCity) {
						this.err++;
						this.booking.errors.addressCity = "City/Town is required";
					}
					if (!this.booking.addressCounty) {
						this.err++;
						this.booking.errors.addressCounty = "County is required";
					}
					if (!this.booking.addressPostCode) {
						this.err++;
						this.booking.errors.addressPostCode = "Postcode is required";
					}

					if (!this.booking.device_passcode) {
						this.err++;
						this.booking.errors.device_passcode = "Device passcode is required";
					}

				}


				//Business Booking Validation
				if (this.booking.pricing_type) {
					var business = {
						"identifier": this.booking.business.identifier,
						"authorisation_code": this.booking.business.authorisation_code,
					}
					if (!this.booking.business.identifier) {
						this.err++;
						this.booking.messages.business_identifier = null;
						this.booking.errors.business_identifier = "Please enter your business identifier";
					} else if (this.booking.business.identifier.length < 6) {
						this.err++;
						this.booking.messages.business_identifier = null;
						this.booking.errors.business_identifier = "Please check your business identifier";
					} else {
						this.$http.post(App.config.api.filemaker + '/business/identify', business).then(function (data) {
							if (data.body['status'] == 'success') {
								this.booking.business.id_company = data.body['id'];
								this.booking.errors.business_identifier = null;
							} else {
								this.booking.messages.business_identifier = null;
								this.booking.errors.business_identifier = "Company ID not found - please try again";
							}
						}, function (data) {
							this.booking.errors.business_identifier = "Something went wrong. Please refresh the page and try again";
							console.error(data);
						});
					}

					if (!this.booking.business.business_type) {
						this.err++;
						this.booking.errors.business_type = "Please select your payment type";
					}

					if (this.booking.business.business_type == 'On Account') {
						//console.log("test on account");
						if (!this.booking.business.authorisation_code) {
							this.err++;
							this.booking.messages.business_authorisation = null;
							this.booking.errors.business_authorisation = "Please enter your authorisation code";
						} else {
							this.$http.post(App.config.api.filemaker + '/business/authorise', business).then(function (data) {
								if (data.body['status'] == 'success') {
									this.booking.errors.business_authorisation = null;
								} else {
									this.booking.messages.business_authorisation = null;
									this.booking.errors.business_authorisation = "Authorisation failed, please try again";
								}
							}, function (data) {
								this.booking.errors.business_authorisation = "Something went wrong. Please refresh the page and try again";
								console.error(data);
							});
						}

					}
				}

				if (this.booking.insurance.is_insurance && !this.booking.pixelcare) {
					if (!this.booking.insurance.validated) {
						this.err++;
						//console.log("Insurnance Booking - Not Validated");
						//this.booking.errors.insurance_reference = 'Please check and retry or contact operations@ismash.com';
						//this.booking.errors.insurance_reference = 'Please check and retry or contact your insurer';
						if(this.booking.skyjourney){
							this.booking.errors.insurance_reference = 'This voucher number was not found, please contact customerservice@ismash.com';
						} else {
							this.booking.errors.insurance_reference = 'Please check and retry or contact your insurer';
						}
					} else {
						this.booking.errors.insurance_reference = null;
					}
				} else if (this.booking.pixelcare) {
					//this.booking.insurance.reference = this.booking.pixelcare;
				} else {
					this.booking.insurance.reference = '';
				}

				if (this.err > 0 || this.business_err > 0) {
					//console.log("Error with Insurnance Booking");
					button.innerHTML = 'Confirm Appointment';
					e.target.disabled = false;
					return;
				}


				
				var date = new Date(this.booking.slot.bookingdate);

				if(this.booking.delivery_type == 'post_in'){
					const today = new Date();
					date = new Date(today);
					date.setDate(date.getDate() + 1);
					this.booking.slot.start_hour = 7;
					this.booking.slot.start_min = '00';

					if (!this.booking.device_passcode) {
						this.err++;
						this.booking.errors.device_passcode = "Device passcode is required";
					}

				}

				var booking_datetime = moment(date).format("dddd[,] Do MMMM [at]")+" "+this.booking.slot.start_hour+":"+this.booking.slot.start_min+",";
				var fm_booking_date = moment(date).format("L");
				//console.log(fm_booking_date);

				if (!this.booking.appointmentDuration){
					this.booking.appointmentDuration = 30;
				}
				var end = moment(this.booking.slot.start_hour + ':' + this.booking.slot.start_min, 'HH:mm').add(this.booking.appointmentDuration, 'minutes').format('HH:mm');
				////console.log("appointmentDuration "+this.booking.appointmentDuration);
				//console.log("start "+this.booking.slot.start_hour + ':' + this.booking.slot.start_min);
				//console.log("end "+end);
				if(Object.keys(this.selected).length === 0){
					//var prodSKU = this.selected[Object.keys(this.selectedrear)[0]].variant.sku;	
				} else {
					var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;	
				}			
				if(Object.keys(this.selectedrear).length === 0){
					var prodSKUTwo = '';
				} else {
					var prodSKUTwo = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.sku;
				}

				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}

				if (this.booking.business_customer){
					this.booking.customer_type = 'Business';
				}
				if (this.booking.student_customer){
					this.booking.customer_type = 'Student';
				}

				var optinVal = this.booking.optinFileMaker;
				
				App.funnelEvent({
					'action': 'booking_funnel::booking_confirmed',
					'email': this.booking.email,
				});

				var self = this;

				$.get("/collections/" + collection.handle + "?view=json", function (data) {
					var metafields = JSON.parse(data);
					var manufacturer = metafields.manufacturer;
					var model = metafields.model;
					var type = metafields.type;
					if(self.selected[Object.keys(self.selected)[0]]){
						var deviceSKU = self.selected[Object.keys(self.selected)[0]].product.deviceSKU;
						var modelCode = self.selected[Object.keys(self.selected)[0]].product.modelCode;
					} else {
						var deviceSKU = self.selectedrear[Object.keys(self.selectedrear)[0]].product.deviceSKU;
						var modelCode = self.selectedrear[Object.keys(self.selectedrear)[0]].product.modelCode;
					}
					//console.log("modelCode "+modelCode);
					if(!model){
						var thismodel = self.selected[Object.keys(self.selected)[0]].variant.name.split("Battery");
						model = thismodel[0];
					}

					var thankyou_data = {
						"customer": {
							"first_name": self.booking.first_name,
							"last_name": self.booking.last_name,
							"email": self.booking.email,
							"phone": self.booking.phone,
							"postcode": self.booking.zip
						},
						"store": {
							"id": self.store.id,
							"name": self.store.name
						},
						"slot": {
							"start_hour": self.booking.slot.start_hour,
							"start_min": self.booking.slot.start_min,
							"start": self.booking.slot.start_hour + ':' + self.booking.slot.start_min,
							"end": end
						},
						"device": {
							"brand": manufacturer,
							"model": model,
							"type": type,
							"imei": "",
							"passcode":self.booking.device_passcode
						},
						"isinsurance": self.booking.isinsurance,
						"booking_datetime": booking_datetime
					}

					if(self.selected[Object.keys(self.selected)[0]]){
						var thankyou_data_one = {
								"required_repair": self.selected[Object.keys(self.selected)[0]].variant.name,
								"sku": prodSKU,
								"stock_status": self.store.in_stock,
								"cost": self.selected[Object.keys(self.selected)[0]].variant.price,
								"discountamount": self.booking.discountamount,
								"featured_image": self.booking.discountamount,
								"repair_page": window.location.href
						}
					} else {
						var thankyou_data_one = {
								"required_repair": null,
								"sku": null,
								"stock_status": null,
								"cost": null,
								"discountamount": null,
								"featured_image": null,
								"repair_page": null
						}
					}
					thankyou_data['repair'] = thankyou_data_one;

					if(self.selectedrear[Object.keys(self.selectedrear)[0]]){
						var thankyou_data_two = {
								"required_repair": self.selectedrear[Object.keys(self.selectedrear)[0]].variant.name,
								"sku": prodSKUTwo,
								"stock_status": self.store.in_stock,
								"cost": self.selectedrear[Object.keys(self.selectedrear)[0]].variant.price
						}
					} else {
						var thankyou_data_two = {
								"required_repair": null,
								"sku": null,
								"stock_status": null,
								"cost": null
						}
					}
					thankyou_data['repairtwo'] = thankyou_data_two;

					if(!self.selected[Object.keys(self.selected)[0]]){
						thankyou_data_one = {
								"required_repair": self.selectedrear[Object.keys(self.selectedrear)[0]].variant.name,
								"sku": prodSKU,
								"stock_status": self.store.in_stock,
								"cost": self.selectedrear[Object.keys(self.selectedrear)[0]].variant.price,
								"discountamount": self.booking.discountamount,
								"featured_image": self.booking.discountamount,
								"repair_page": window.location.href
						}
						thankyou_data['repair'] = thankyou_data_one;
						
						var thankyou_data_two = {
								"required_repair": null,
								"sku": null,
								"stock_status": null,
								"cost": null
						}
						thankyou_data['repairtwo'] = thankyou_data_two;
					}

					//add macbook fields if needed
					if(self.booking.model_name)
						thankyou_data['model_name'] = self.booking.model_name

					if(self.booking.serial_number)
						thankyou_data['serial_number'] = self.booking.serial_number

					if(self.booking.is_premium){
						thankyou_data.repair['is_premium'] = true;
						thankyou_data.repair['premium_cost'] = self.booking.premium_cost;
					}

					var reschedule_data = {
						"customer": {
							"first_name": self.booking.first_name,
							"last_name": self.booking.last_name,
							"email": self.booking.email,
							"phone": self.booking.phone,
							"postcode": self.booking.zip
						},
						"device": {
							"brand": manufacturer,
							"model": model,
							"type": type,
							"deviceSKU": deviceSKU || null,
							"modelCode": modelCode || null,
							"device_network": self.booking.device_network || null
						},
						"branch": {
							"name": self.store.name,
							"email":  self.store.contact_email,
							"id": self.store.id || null,
							"phone": self.store.contact_phone || null,
							"address": self.store.address || null
						},
						"insurance": {
							"reference": self.booking.insurance.reference,
							"vend_id": self.booking.insurance.vend_id
						},
						"booking_datetime": {
							"appt_date": booking_datetime
						},
						"source_collection": (collection && collection.handle) ? collection.handle : null
					}

					var buildRescheduleRepairData = function (selection, sku) {
						var selectedItem = selection || null;
						var selectedVariant = selectedItem && selectedItem.variant ? selectedItem.variant : null;
						var selectedProduct = selectedItem && selectedItem.product ? selectedItem.product : null;
						return {
							"required_repair": selectedVariant && selectedVariant.name ? selectedVariant.name : null,
							"sku": sku || null,
							"variant_id": selectedVariant && selectedVariant.id ? selectedVariant.id : null,
							"variant_title": selectedVariant && selectedVariant.title ? selectedVariant.title : null,
							"cost": selectedVariant && selectedVariant.price ? selectedVariant.price : null,
							"discountamount": self.booking.discountamount || null,
							"product_id": selectedProduct && selectedProduct.id ? selectedProduct.id : null,
							"product_title": selectedProduct && selectedProduct.title ? selectedProduct.title : null,
							"product_handle": selectedProduct && selectedProduct.handle ? selectedProduct.handle : null,
							"vendor": selectedProduct && selectedProduct.vendor ? selectedProduct.vendor : null,
							"deviceSKU": selectedProduct && selectedProduct.deviceSKU ? selectedProduct.deviceSKU : null,
							"modelCode": selectedProduct && selectedProduct.modelCode ? selectedProduct.modelCode : null
						};
					};
					
					if(self.selected[Object.keys(self.selected)[0]]){
						var reschedule_data_one = buildRescheduleRepairData(self.selected[Object.keys(self.selected)[0]], prodSKU);
					} else {
						var reschedule_data_one = buildRescheduleRepairData(null, null);
					}
					reschedule_data['repair'] = reschedule_data_one;
					if(self.selectedrear[Object.keys(self.selectedrear)[0]]){
						var reschedule_data_two = buildRescheduleRepairData(self.selectedrear[Object.keys(self.selectedrear)[0]], prodSKUTwo);
					} else {
						var reschedule_data_two = buildRescheduleRepairData(null, null);

					}
					reschedule_data['repairtwo'] = reschedule_data_two;
					
					if(!self.selected[Object.keys(self.selected)[0]]){
						reschedule_data_one = buildRescheduleRepairData(self.selectedrear[Object.keys(self.selectedrear)[0]], prodSKUTwo);
						reschedule_data['repair'] = reschedule_data_one;
						
						var reschedule_data_two = buildRescheduleRepairData(null, null);
						reschedule_data['repairtwo'] = reschedule_data_two;
					}

					var holdingref = Date.now();
					if(sessionStorage.getItem("samsung")){
						self.booking.bookingnotes = self.booking.bookingnotes+" - Samsung Reference: "+sessionStorage.getItem("samsung");
						var partnerref = sessionStorage.getItem("samsung");
						var partner = "Samsung";
					} else {
						var partner = "";
						var partnerref = "";
					}

					if(self.booking.skyemployee==true){
						if(self.booking.sky_type=='Corporate'){
							self.booking.bookingnotes = self.booking.bookingnotes+" - The customer has selected this repair as a corporate device, please transact in Vend/Lightspeed as 'On Account' ";
						} else {
							self.booking.bookingnotes = self.booking.bookingnotes+" - The customer has selected that this repair is a personal device, the customer must pay for this repair themselves instead of 'On Account' ";
						}
					}
					var tracking = window.iSmashTracking ? window.iSmashTracking.getBookingTracking() : {
						Traffic: null, Source: null, UTMMedium: null, UTMCampaign: null,
						UTMContent: null, UTMTerm: null, Brand: null,
						ConsentProvider: "unavailable", ConsentStatus: "unavailable",
						TrackingStatus: "unavailable"
					};
					var booking_data = {
						"customer": {
							"first_name": self.booking.first_name,
							"last_name": self.booking.last_name,
							"email": self.booking.email,
							"phone": self.booking.phone,
							"address1": self.booking.address1,
							"postcode": self.booking.zip,
							"addressLine1": self.booking.addressLine1,
							"addressLine2": self.booking.addressLine2,
							"addressCity": self.booking.addressCity,
							"addressCounty": self.booking.addressCounty,
							"addressPostCode": self.booking.addressPostCode,
							"pickUpCost": self.booking.courier.pickupcost,
							"pricing_type": self.booking.pricing_type,
							"business": {
								"business_type": self.booking.business.business_type,
								"authorisation_code": self.booking.business.authorisation_code,
								"id_company": self.booking.business.id_company,
								"po_number": self.booking.business.po_number,
								"name": self.booking.business.name
							},
							"optin": optinVal,
							"customer_type": self.booking.customer_type
						},
						"store": {
							"id": self.store.id,
							"name": self.store.name,
							"phone": self.store.contact_phone,
							"email": self.store.contact_email,
							"address": self.store.address
						},
						"slot": {
							"start_hour": self.booking.slot.start_hour,
							"start_min": self.booking.slot.start_min,
							"start": self.booking.slot.start_hour + ':' + self.booking.slot.start_min,
							"end": end,
							"appointmentDuration": self.booking.appointmentDuration
						},
						"device": {
							"brand": manufacturer,
							"model": model,
							"type": type,
							"imei": self.booking.imei,
							"passcode": self.booking.device_passcode,
							"deviceSKU": deviceSKU,
							"modelCode": modelCode,
							"device_network": self.booking.device_network
						},
						"insurance": {
							"reference": self.booking.insurance.reference,
							"vend_id": self.booking.insurance.vend_id
						},
						"bookingnotes": self.booking.bookingnotes,
						"terms_accepted": self.booking.terms_accepted,
						"notes": self.booking.notes,
						"source": self.booking.source,
						"booking_datetime": booking_datetime,
						"filemaker_booking_date": fm_booking_date,
						"insurance_reference_number": self.booking.insurance.reference,
						"tracking": {
							"traffic": tracking.Traffic,
							"source": tracking.Source,
							"utm_medium": tracking.UTMMedium,
							"utm_campaign": tracking.UTMCampaign,
							"utm_content": tracking.UTMContent,
							"utm_term": tracking.UTMTerm,
							"brand": tracking.Brand,
							"consent_provider": tracking.ConsentProvider,
							"consent_status": tracking.ConsentStatus,
							"tracking_status": tracking.TrackingStatus
						},
						"reschedule": encodeURIComponent(JSON.stringify(reschedule_data)),
						"rebook": self.booking.rebook,
						"fmid": self.booking.fmid,
						"job_number": self.booking.job_number,
						"booking_type":self.booking.delivery_type,
						"TVMarketing": self.booking.TVMarketing,
						"holdingref": holdingref,
						"partner": partner,
						"partnerref": partnerref,
					}

					if(self.selected[Object.keys(self.selected)[0]]){
						var booking_data_one = {
							"required_repair": self.selected[Object.keys(self.selected)[0]].variant.name,
							"sku": prodSKU,
							"stock_status": self.store.in_stock,
							"cost": self.selected[Object.keys(self.selected)[0]].variant.price,
							"discountamount": self.booking.discountamount
						}
					} else {
						var booking_data_one = {
							"required_repair": null,
							"sku": null,
							"stock_status": null,
							"cost": null,
							"discountamount": null
						}
					}
					booking_data['repair'] = booking_data_one;
					if(self.selectedrear[Object.keys(self.selectedrear)[0]]){
						var booking_data_two = {	
								"required_repair": self.selectedrear[Object.keys(self.selectedrear)[0]].variant.name,
								"sku": prodSKUTwo,
								"stock_status": self.store.in_stock,
								"cost": self.selectedrear[Object.keys(self.selectedrear)[0]].variant.price,
								"discountamount": self.booking.discountamount
						}
					} else {
						var booking_data_two = {
							"required_repair": null,
							"sku": null,
							"stock_status": null,
							"cost": null,
							"discountamount": null
						}
					}
					booking_data['repairtwo'] = booking_data_two;

					if(!self.selected[Object.keys(self.selected)[0]]){
						var booking_data_one = {
							"required_repair": self.selectedrear[Object.keys(self.selectedrear)[0]].variant.name,
							"sku": prodSKUTwo,
							"stock_status": self.store.in_stock,
							"cost": self.selectedrear[Object.keys(self.selectedrear)[0]].variant.price,
							"discountamount": self.booking.discountamount
						}
						booking_data['repair'] = booking_data_one;
						
						var booking_data_two = {
							"required_repair": null,
							"sku": null,
							"stock_status": null,
							"cost": null,
							"discountamount": null
						}
						booking_data['repairtwo'] = booking_data_two;
					}
					//add macbook fields if needed
					if(self.booking.model_name){
						booking_data['model_name'] = self.booking.model_name
					} else {
						booking_data['model_name'] = null
					}

					if(self.booking.serial_number){
						booking_data['serial_number'] = self.booking.serial_number
					} else {
						booking_data['serial_number'] = null
					}




					if(self.booking.is_premium){
						booking_data.repair['is_premium'] = true;
						booking_data.repair['premium_cost'] = self.booking.premium_cost;
					}
					
					// if(self.booking.business.account_type == 'new'){
					//     self.sendNewBusinessBooking(booking_data);
					// }

					//console.log(booking_data);
					//debugger
					var routeCheck = 0;
					if(self.store.in_stock == 'in_warehouse' && !self.booking.insurance.is_insurance && !partner){
						// Disable Deposit
						//routeCheck = 1;
						// Booking Deposit Variant ID
						//self.addItemToCart('39290562773081');
					}
					
					//routeCheck = 0;

					//if(self.booking.delivery_type == 'post_in' || self.booking.delivery_type == 'courier_collection'){
					if(self.booking.delivery_type == 'post_in' || routeCheck == 1){
						//document.cookie = "holdingref="+holdingref;
						sessionStorage.setItem("hr", holdingref);
						sessionStorage.setItem("ta", self.booking.terms_accepted);
						sessionStorage.setItem("dp", self.booking.device_passcode);
						//console.log(holdingref);
						setTimeout(
      						function () {
							self.$http.post(App.config.api.filemaker + '/holdbooking', booking_data).then(function (data) {
								//console.log(data.body);
								//goog_report_conversion('/pages/repair-confirmed');
		
								ga('send', 'event', 'Booking', 'Confirmed', '');
								//console.log("Redirect to cart - new server");
								window.location.href = "/cart?dp=" + self.booking.device_passcode + "&ta=" + self.booking.terms_accepted + "&hr=" + holdingref;
							}, function (data) {
								console.error(data);
								e.target.disabled = false;
							});
						}, 1000);

					}else{

						self.$http.post(App.config.api.filemaker + '/booking', booking_data).then(function (data) {
							if (window.iSmashTracking && window.iSmashTracking.captureBookingResponse) {
								window.iSmashTracking.captureBookingResponse(data.body);
							}
							//console.log(data.body);
							//goog_report_conversion('/pages/repair-confirmed');
	
							ga('send', 'event', 'Booking', 'Confirmed', '');
							if (this.booking.insurance.is_insurance && !this.booking.pixelcare) {
								//console.log("Redirect to repair-confirmed-insurance");
								window.location.href = "/pages/repair-confirmed-insurance#" + encodeURIComponent(JSON.stringify(thankyou_data));
							}else{
								//console.log("Redirect to repair-confirmed");
								window.location.href = "/pages/repair-confirmed#" + encodeURIComponent(JSON.stringify(thankyou_data));
							}
						}, function (data) {
							console.error(data);
							e.target.disabled = false;
						});

					}
				});
			},
			sendNewBusinessBooking: function (booking_data) {
				//Testing
				//console.log(booking_data);

				this.$http.post(App.config.api.filemaker + '/business/notify', booking_data).then(function (data) {
					//console.log(data.body);
					//window.location.href = "/pages/repair-confirmed#" + encodeURIComponent(JSON.stringify(data.body));
				}, function (data) {
					console.error(data);
					e.target.disabled = false;
				});
			},
			identifyBusiness: function () {
				//document.querySelector("#confirmbookingbutton").disabled = true;
				this.business_err = 0;
				//console.log();
				var business = {
					"identifier": this.booking.business.identifier
				}

				if (this.booking.business.identifier) {
					if (this.booking.business.identifier.length < 2) {
						/* Setup to only trigger event on first character */
						ga('send', 'event', 'Business Booking', 'Business Identifier Box', 'Business Booking Tracking');
					}
					if (this.booking.business.identifier.length > 5) {
						this.$http.post(App.config.api.filemaker + '/business/identify', business).then(function (data) {
							if (data.body['status'] == 'success') {
								this.booking.business.id_company = data.body['id'];
								this.booking.errors.business_identifier = null;
								this.booking.messages.business_identifier = "Business found";
							} else {
								this.business_err++;
								this.booking.messages.business_identifier = null;
								this.booking.errors.business_identifier = "Company ID not found - please try again";
							}
							if (this.booking.business.business_type == 'On Account') {
								this.authoriseAccount();
							}
						}, function (data) {
							this.business_err++;
							this.booking.messages.business_identifier = null;
							this.booking.errors.business_identifier = "Something went wrong. Please refresh the page and try again";
						});
					} else {
						this.business_err++;
						this.booking.messages.business_identifier = null;
					}
				} else {
					this.business_err++;
					this.booking.messages.business_identifier = null;
					this.booking.errors.business_identifier = "Please enter your business identifier";
				}
				// if (err > 0) {
				//     document.querySelector("#confirmbookingbutton").disabled = false;
				//     return;
				// }

			},
			authoriseAccount: function (e) {
				//document.querySelector("#confirmbookingbutton").disabled = true;

				this.business_err = 0;
				var business = {
					"identifier": this.booking.business.identifier,
					"authorisation_code": this.booking.business.authorisation_code,
				}

				if (this.booking.business.authorisation_code) {
					if (this.booking.business.authorisation_code.length < 2) {
						/* Setup to only trigger event on first character */
						ga('send', 'event', 'Business Booking', 'Authorisation Code Box', 'Business Booking Tracking');
					}
					if (this.booking.business.authorisation_code.length > 4) {
						this.$http.post(App.config.api.filemaker + '/business/authorise', business).then(function (data) {
							if (data.body['status'] == 'success') {
								this.booking.errors.business_authorisation = null;
								this.booking.messages.business_authorisation = "Authorised";
								// if(this.booking.business.business_type == 'On Account'){
								//     if(this.booking.business.identified){
								//         document.querySelector("#confirmbookingbutton").disabled = false;
								//     }
								// }
							} else {
								this.business_err++;
								this.booking.messages.business_authorisation = null;
								this.booking.errors.business_authorisation = "Authorisation failed, please try again";
							}
						}, function (data) {
							this.business_err++;
							this.booking.messages.business_authorisation = null;
							this.booking.errors.business_authorisation = "Something went wrong. Please refresh the page and try again";
							console.error(data);
						});
					} else {
						this.business_err++;
						this.booking.messages.business_authorisation = null;
					}
				} else {
					this.business_err++;
					this.booking.messages.business_authorisation = null;
					this.booking.errors.business_authorisation = "Please enter your authorisation code";
				}
				// if (err > 0) {
				//     document.querySelector("#confirmbookingbutton").disabled = false;
				//     return;
				// }

			},
			businessCustomer: function () {
				//console.log('Business Customer clicked');
				ga('send', 'event', 'Business Booking', 'Business Customer Selected', 'Business Booking Tracking');
			},
			accountExisting: function () {
				//console.log('account existing clicked');
				ga('send', 'event', 'Business Booking', 'Existing Business Box Ticked', 'Business Booking Tracking');
			},
			accountNew: function () {
				//console.log('account new clicked');
				ga('send', 'event', 'Business Booking', 'New Business Box Ticked', 'Business Booking Tracking');
			},
			employeeDiscount: function () {
				//console.log('Employee Discount clicked');
				ga('send', 'event', 'Business Booking', 'Employee Discount Box Ticked', 'Business Booking Tracking');
				this.booking.errors.business_type = null;
			},
			onAccount: function () {
				//console.log('On Account clicked');
				ga('send', 'event', 'Business Booking', 'On Account Box Ticked', 'Business Booking Tracking');
				this.booking.errors.business_type = null;
			},
			validateInsurance: function () {
				if (this.booking.insurance.reference.length > 4) {
					var insurance = {
						"first_name": this.booking.first_name,
						"last_name": this.booking.last_name,
						"reference": this.booking.insurance.reference
					}
					this.$http.post(App.config.api.filemaker + '/insurance/validate', insurance).then(function (data) {
						if (data.body['Error']) {							
							if(this.booking.skyjourney){
								this.booking.errors.insurance_reference = 'This voucher number was not found, please contact customerservice@ismash.com';
							} else {
								this.booking.errors.insurance_reference = data.body['Error'];
							}
							//this.booking.errors.insurance_reference = data.body['Error'];
							this.booking.messages.insurance_reference = null;
							this.booking.insurance.validated = false;
						} else {
							if(this.booking.skyjourney){
								this.booking.messages.insurance_reference = 'Voucher Code is valid';
							} else {
								this.booking.messages.insurance_reference = 'Claim ID is valid';
							}
							

							this.booking.errors.insurance_reference = null;
							this.booking.insurance.vend_id = data.body['id'];
							this.booking.insurance.validated = true;
						}
					}, function (data) {
						this.booking.errors.insurance_reference = "Something went wrong. Please refresh the page and try again";
						console.error(data);
					});
				}
			},
			validateInsuranceCheck: function () {
				if (this.booking.insurance.reference.length > 4) {
					var insurance = {
						"first_name": this.booking.first_name,
						"last_name": this.booking.last_name,
						"reference": this.booking.insurance.reference
					}
					this.$http.post(App.config.api.filemaker + '/insurance/validate', insurance).then(function (data) {
						if (data.body['Error']) {				
							if(this.booking.skyjourney){
								this.booking.errors.insurance_reference = 'This voucher number was not found, please contact customerservice@ismash.com';
							} else {
								this.booking.errors.insurance_reference = data.body['Error'];
							}
							//this.booking.errors.insurance_reference = data.body['Error'];	
							this.booking.messages.insurance_reference = null;
							this.booking.insurance.validated = false;
						} else {
							this.booking.messages.insurance_reference = 'Claim ID is valid';
							this.booking.errors.insurance_reference = null;
							this.booking.insurance.vend_id = data.body['id'];
							this.booking.insurance.validated = true;
						}
					}, function (data) {
						this.booking.errors.insurance_reference = "Something went wrong. Please refresh the page and try again";
						console.error(data);
					});
				}
			},
			insurance: function () {
				//console.log('On Account clicked');
				ga('send', 'event', 'Insurance Booking', 'Insurance Box Clicked', 'Insurance Booking Tracking');
				this.booking.errors.insurance_reference = null;
			}

		}
	});

	Vue.component('booking-confirmation', {
		template: '#booking-confirmation',
		props: ['booking'],
		computed: {
			formattedStartTime: function () {
				if (!this.booking.confirmation) {
					return null;
				}
				return moment(this.booking.confirmation.booking.start_time).format("dddd Do MMMM, h:mm");
			}
		}
	});

	Vue.component('booking-summary', {
		template: '#booking-summary',
		props: ['store', 'bookingDate', 'selected', 'selectedrear', 'booking'],
		computed: {
			selectedProduct: function () {
				var selectedEntry = this.selected[Object.keys(this.selected)[0]];
				if (!selectedEntry || !selectedEntry.product) {
					return createEmptySelectedProduct();
				}
				return selectedEntry.product;
			},
			selectedVariant: function () {
				if (!this.selected[Object.keys(this.selected)[0]]) {
					return null;
				}
				return this.selected[Object.keys(this.selected)[0]].variant;
			},
			productSelected: function () {
				if (!this.selected[Object.keys(this.selected)[0]]) {
					return false;
				}

				if (!this.selected[Object.keys(this.selected)[0]].variant) {
					return false;
				}
				return true;
			},
			selectedRearProduct: function () {
				if (!this.selectedrear[Object.keys(this.selectedrear)[0]]) {
					return null;
				}
				return this.selectedrear[Object.keys(this.selectedrear)[0]].product;
			},
			selectedRearVariant: function () {
				if (!this.selectedrear[Object.keys(this.selectedrear)[0]]) {
					return null;
				}
				return this.selectedrear[Object.keys(this.selectedrear)[0]].variant;
			},
			productRearSelected: function () {
				if (!this.selectedrear[Object.keys(this.selectedrear)[0]]) {
					return false;
				}

				if (!this.selectedrear[Object.keys(this.selectedrear)[0]].variant) {
					return false;
				}
				return true;
			},
			repairTime: function () {
				if (this.selected[Object.keys(this.selected)[0]]) {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days", "Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < this.selectedProduct.tags.length; i++) {
						if (repairTags.indexOf(this.selectedProduct.tags[i]) > -1) {
							return this.selectedProduct.tags[i];
						}
					}
					return "24 - 48 hours";
				}
			},
			repairRearTime: function () {
				if (this.selectedrear[Object.keys(this.selectedrear)[0]]) {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < this.selectedRearProduct.tags.length; i++) {
						if (repairTags.indexOf(this.selectedRearProduct.tags[i]) > -1) {
							return this.selectedRearProduct.tags[i];
						}
					}
					return "24 - 48 hours";
				}
			},
			repaircombinedTime: function () {
				if(this.selectedrear[Object.keys(this.selectedrear)[0]].product.title.indexOf("Rear Glass") > -1){
					return "3 - 4 hours";
				}
				if(this.selectedrear[Object.keys(this.selectedrear)[0]].product.title.indexOf("Rear Housing") > -1){
					return "45 - 90 minutes";
				}
			}
		}
	});

	Vue.component('repair-summary', {
		template: '#repair-summary',
		props: ['selected', 'selectedrear', 'booking'],
		computed: {
			selectedProduct: function () {
				var selectedEntry = this.selected[Object.keys(this.selected)[0]];
				if (!selectedEntry || !selectedEntry.product) {
					return createEmptySelectedProduct();
				}
				return selectedEntry.product;
			},
			selectedVariant: function () {
				if (!this.selected[Object.keys(this.selected)[0]]) {
					return null;
				}
				return this.selected[Object.keys(this.selected)[0]].variant;
			},
			productSelected: function () {

				if (!this.selected[Object.keys(this.selected)[0]]) {
					return false;
				}
				return true;
			},
			selectedRearProduct: function () {
				if (!this.selectedrear[Object.keys(this.selectedrear)[0]]) {
					return null;
				}
				return this.selectedrear[Object.keys(this.selectedrear)[0]].product;
			},
			selectedRearVariant: function () {
				if (!this.selectedrear[Object.keys(this.selectedrear)[0]]) {
					return null;
				}
				return this.selectedrear[Object.keys(this.selectedrear)[0]].variant;
			},
			productRearSelected: function () {

				if (!this.selectedrear[Object.keys(this.selectedrear)[0]]) {
					return null;
				}
				return this.selectedrear[Object.keys(this.selectedrear)[0]].product;
			},
			repairTime: function () {
				if (this.selected[Object.keys(this.selected)[0]]) {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < this.selectedProduct.tags.length; i++) {
						if (repairTags.indexOf(this.selectedProduct.tags[i]) > -1) {
							return this.selectedProduct.tags[i];
						}
					}
					return "24 - 48 hours";
				}
			},
			repairRearTime: function () {
				if (this.selectedrear[Object.keys(this.selectedrear)[0]]) {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < this.selectedRearProduct.tags.length; i++) {
						if (repairTags.indexOf(this.selectedRearProduct.tags[i]) > -1) {
							return this.selectedRearProduct.tags[i];
						}
					}
					return "24 - 48 hours";
				}
			},
			repaircombinedTime: function () {
				var rearEntry = this.selectedrear[Object.keys(this.selectedrear)[0]];
				if (!rearEntry || !rearEntry.product || !rearEntry.product.title) {
					return null;
				}
				if(rearEntry.product.title.indexOf("Rear Glass") > -1){
					return "3 - 4 hours";
				}
				if(rearEntry.product.title.indexOf("Rear Housing") > -1){
					return "45 - 90 minutes";
				}
			}
		},
		methods: {
			closeAll: function () {
				this.booking.stage = 0;
				document.querySelector('body').classList.remove("popup-active");
				scrollTo('#app-repair', 0);
			}
		}
	});

	Vue.component('booking-progress', {
		template: '#booking-progress',
		props: ['booking','product','selected','selectedrear'],
		methods: {
			changeBookingStage: function (stage) {
				// Only go back stages, not forward
				if (this.booking.stage < stage) {
					return;
				}
				//disable step 3 for post in
				if(this.booking.stage == 3 && this.booking.delivery_type == 'post_in' && stage == 2){
					return;
				}
				if (stage === 0) {
					document.querySelector('body').classList.remove("popup-active");
					document.querySelector('body');
				}
				this.booking.stage = stage;
				$(".repair--delivery-popup").animate({ scrollTop: 0 }, { duration: 'medium', easing: 'swing' });
				
				// Get the modal
				
				if (document.getElementById("myData").style.display == 'block') { 
					var myData = document.getElementById("myData");
					myData.style.display = "none";
				}
				if (document.getElementById("myLiquid").style.display == 'block') { 
					var myLiquid = document.getElementById("myLiquid");
					myLiquid.style.display = "none";
				}
				if (document.getElementById("myModal").style.display == 'block') { 
					var modal = document.getElementById("myModal");
					modal.style.display = "none";
				}
				if (document.getElementById("rearModal").style.display == 'block') { 
					var modal = document.getElementById("rearModal");
					modal.style.display = "none";
				}
				if (document.getElementById("screenModal").style.display == 'block') { 
					var modal = document.getElementById("screenModal");
					modal.style.display = "none";
				}
					
				const collection = document.getElementsByClassName("part-select-btn");
				for (let i = 0; i < collection.length; i++) {
				collection[i].innerHTML = "Book Repair";
				}
				
				const screenModelbutton = document.getElementsByClassName("screenModelbutton");
				for (let i = 0; i < screenModelbutton.length; i++) {
				screenModelbutton[i].innerHTML = "+ Add repair";
				}
				
				const rearModalbutton = document.getElementsByClassName("rearModalbutton");
				for (let i = 0; i < rearModalbutton.length; i++) {
				rearModalbutton[i].innerHTML = "+ Add repair";
				}	
				
				const continuebutton = document.getElementsByClassName("continuewithoutbutton");
				for (let i = 0; i < continuebutton.length; i++) {
				continuebutton[i].innerHTML = "Continue without";
				}				
				
				
				
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);
				var selectedrear = Object.keys(this.selectedrear)[0];
				this.$delete(this.selectedrear, selectedrear);
				this.booking.appointmentDuration = 0;
			},
			backToInsuranceStage: function () {
				//console.log("backToInsuranceStage runs");
				if (this.booking && this.booking.stage === 1) {
					var params = new URLSearchParams(window.location.search || '');
					var sourceCollection = params.get('source_collection') || sessionStorage.getItem('jv_source_collection') || (window.collection && window.collection.handle ? window.collection.handle : '');
					if (sourceCollection) {
						sessionStorage.setItem('jv_source_collection', sourceCollection);
						navigateWithFunnelLoader('/collections/' + encodeURIComponent(sourceCollection));
						return;
					}
				}
				var stage = 0; 

				if (sessionStorage.getItem("insureurl")){
					document.location.assign(sessionStorage.getItem("insureurl"));
				} else {
					if (this.booking.stage < stage) {
						return;
					}
					if (stage === 0) {
						document.querySelector('body').classList.remove("popup-active");
						document.querySelector('body');
					}
					this.booking.stage = stage;
					$(".repair--delivery-popup").animate({ scrollTop: 0 }, { duration: 'medium', easing: 'swing' });
					
					if (document.getElementById("myModal") && document.getElementById("myModal").style.display == 'block') { 
						var modal = document.getElementById("myModal");
						modal.style.display = "none";
					}
					if (document.getElementById("rearModal") && document.getElementById("rearModal").style.display == 'block') { 
						var modal = document.getElementById("rearModal");
						modal.style.display = "none";
					}
					if (document.getElementById("screenModal") && document.getElementById("screenModal").style.display == 'block') { 
						var modal = document.getElementById("screenModal");
						modal.style.display = "none";
					}
					
					const collection = document.getElementsByClassName("part-select-btn");
					for (let i = 0; i < collection.length; i++) {
					collection[i].innerHTML = "Book Repair";
					}
					
					const screenModelbutton = document.getElementsByClassName("screenModelbutton");
					for (let i = 0; i < screenModelbutton.length; i++) {
					screenModelbutton[i].innerHTML = "+ Add repair";
					}
					
					const rearModalbutton = document.getElementsByClassName("rearModalbutton");
					for (let i = 0; i < rearModalbutton.length; i++) {
					rearModalbutton[i].innerHTML = "+ Add repair";
					}	

					const continuebutton = document.getElementsByClassName("continuewithoutbutton");
					for (let i = 0; i < continuebutton.length; i++) {
					continuebutton[i].innerHTML = "Continue without";
					}			
					
					var selected = Object.keys(this.selected)[0];
					this.$delete(this.selected, selected);
					var selectedrear = Object.keys(this.selectedrear)[0];
					this.$delete(this.selectedrear, selectedrear);
					this.booking.appointmentDuration = 0;
				}
			}
		}
	});

	Vue.component('store-picker', {
		template: '#store-picker',
		props: ['stores', 'selectedStore', 'selected', 'selectedrear', 'booking'],
		data: function () {
			return {
				active: false
			};
		},
		methods: {
			showPicker: function () {
				this.booking.stage = 1;
				// this.$http.get(App.config.api.filemaker + '/api/stores').then(function(data) {
				//     this.stores = data.body;
				// }, function(data) {
				//     console.error(data);
				// });
				// this.active = true;
			},
			hidePicker: function () {
				this.active = false;
			}
		}
	});

	Vue.component('enquiry-form', {
		template: '#enquiry-form',
		props: ['enquiry'],
		data: function () {
			return {
				errors: [],
				device: window.collection.title.replace(/Repairs|Repair|Replacement|Water Damage/ig, "")
			};
		},
		methods: {
			sendEnquiry: function (e) {
				e.target.disabled = true;
				this.errors = [];
				var enquiry = this.enquiry;
				if (!this.enquiry.name) {
					this.errors.push("Please enter your name");
				}
				if (!REGEX_EMAIL.test(this.enquiry.email)) {
					this.errors.push("Please enter valid email address");
				}
				if (!REGEX_PHONE.test(this.enquiry.phone)) {
					this.errors.push("Please enter valid phone number");
				}
				if (!this.enquiry.question) {
					this.errors.push("Please enter your enquiry");
				}

				if (this.errors.length > 0) {
					e.target.disabled = false;
					return;
				}

				enquiry["device"] = this.device;

				this.$http.post(App.config.api.filemaker + '/emails/repair-contact', enquiry).then(function (data) {
					ga("send", "pageview", "?device-enquiry-sent");
					window.location.href = "/pages/device-enquiry-thank-you";
				}, function (data) {
					console.error(data);
					e.target.disabled = false;
				});
			}
		}
	});

	//New Sales Funnel
	Vue.component('new-order-summary', {
		template: '#new-order-summary',
		props: ['selected', 'selectedrear', 'booking', 'stores', 'skystores'],
		computed: {
			total: function () {
				var total = 0;
				for (var i = 0; i < Object.keys(this.selected).length; i++) {
					total += this.selected[Object.keys(this.selected)[i]].variant.price;
				}
				return '�' + (total / 100).toFixed(2);
			},
			product: function () {
				if (!this.selected[Object.keys(this.selected)[0]]) {
					return null;
				}
				return this.selected[Object.keys(this.selected)[0]].product;
			},
			variant: function () {
				if (!this.selected[Object.keys(this.selected)[0]]) {
					return null;
				}
				return this.selected[Object.keys(this.selected)[0]].variant;
			}
		},
		methods: {
			showBookingSection: function (e) {

				//console.log("showBookingSection run");
				var button = document.getElementById('RepairContinueButton');
				button.innerHTML = 'Loading...';

				var product = Object.keys(this.selected)[0];
				//this.getRepairTime(product);
				var prodSKU = this.selected[product].variant.sku;
              	var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;
				var vendor = this.selected[product].product.vendor;
				var insurance = this.selected[Object.keys(this.selected)[0]].product.insurance_customer;

				if (prodSKU == '') {
					prodSKU = 'SKUNOTFOUND';
				}

				this.$http.get(App.config.api.filemaker + '/store/withvendor/' + prodSKU + '/' + prodCode + '/' + vendor + '/' + insurance).then(function (data) {

					var storeList = data.body;
					this.stores.list = storeList;

					document.querySelector('body').classList.add("popup-active");
					this.booking.stage = 1;
					ga('send', 'pageview', '?select-method');
					button.innerHTML = "Continue to next step";

				}, function (data) {
					console.error(data);
				});


				scrollTo('.store-select');
			},
			getRepairTime: function (product) {
				var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes","180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
				////console.log("Repair Time function run");
				for (var i = 0; i <= product.tags.length; i++) {
					////console.log(product.tags[i]);
					if (repairTags.indexOf(product.tags[i]) > -1) {
						//this.booking.appointmentDuration = product.tags[i].substring(0, 2);
						if(product.tags[i] == "Up to 30 minutes" || product.tags[i] == "30 minutes") {
							this.booking.appointmentDuration = 30;
						} else if(product.tags[i] == "Up to 45 minutes" || product.tags[i] == "45 minutes") {
							this.booking.appointmentDuration = 45;
						} else if(product.tags[i] == "Up to 60 minutes" || product.tags[i] == "60 minutes") {
							this.booking.appointmentDuration = 60;
						} else if(product.tags[i] == "Up to 90 minutes" || product.tags[i] == "90 minutes") {
							this.booking.appointmentDuration = 90;
						} else if(product.tags[i] == "1 - 2 hours") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "2 - 4 hours") {
							this.booking.appointmentDuration = 240;
						} else if(product.tags[i] == "2 - 6 hours") {
							this.booking.appointmentDuration = 360;
						} else if(product.tags[i] == "120 minutes") {
							this.booking.appointmentDuration = 120;
						} else if(product.tags[i] == "180 minutes") {
							this.booking.appointmentDuration = 180;
						} else if(product.tags[i] == "210 minutes") {
							this.booking.appointmentDuration = 210;
						} else if (product.tags[i] == "Up to 24 hours" || product.tags[i] == "24 - 48 hours" || product.tags[i] == "up to 7 days") {
							this.booking.appointmentDuration = 30;
							return;
							//console.log(this.booking.appointmentDuration);
						}
						////console.log(this.booking.appointmentDuration);
						return product.tags[i];
					}
				}
				return "24 - 48 hours";
			},
			getRepairDetails: function (product) {
				//Get Repair Type
				var typeTags = ["Smartphone", "Tablet", "Laptop", "Drone", "smartphone", "tablet", "laptop", "drone"];
				for (var i = 0; i < product.tags.length; i++) {
					if (typeTags.indexOf(product.tags[i]) > -1) {
						this.booking.repairType = product.tags[i];
					}
				}
			}
		}
	});

	Vue.component('new-delivery-method', {
		template: '#new-delivery-method',
		props: ['selected', 'selectedrear', 'booking', 'selectedStore', 'stores', 'skystores'],
		data: function () {
			return {
				courierCollectThis: window.courierCollection || null,
				mailinThis: (function (v) {
					v = (v || '').toString().trim().toLowerCase();
					return v === 'no' ? 'No' : 'Yes';
				})(window.mailin),
				visitusThis: (function (v) {
					v = (v || '').toString().trim().toLowerCase();
					return v === 'no' ? 'No' : 'Yes';
				})(window.visitus),
				courierPostcodeAccepted: false,
				delay: null,
				postcodeCourierAccepted: null,
				hasStock: null,
				isinsurance: this.$isinsurance,
				insurer: this.$insurer
			};
		},
		computed: {
			productSelected: function () {
				if (Object.keys(this.selected).length > 0) {
					let product = Object.values(this.selected)[0].product;
					return product;
				} else {
					return false;
				}
			},
			productRearSelected: function () {
				if (this.selectedrear === undefined || !this.selectedrear || Object.keys(this.selectedrear).length === 0) {
					return false;
				} else {
					let product = Object.values(this.selectedrear)[0].product;
					return product;
				}
				
			},			
			is_variant_vend_product:function(){
				var selectedValues = Object.values(this.selected || {});
				var selectedRearValues = Object.values(this.selectedrear || {});
				var currentSelection = selectedValues.length > 0 ? selectedValues[0] : (selectedRearValues.length > 0 ? selectedRearValues[0] : null);
				if (!currentSelection || !currentSelection.variant || !currentSelection.variant.title) {
					return false;
				}
				var variantTitle = currentSelection.variant.title;
				return variantTitle.endsWith('BO-W-I') || variantTitle.endsWith('BO-D-I');
			}
		},
		created: function () {
			//this.mapInit();
			////console.log("Created Runs Now");
			if(this.isinsurance=="Yes" || this.isinsurance=="true"){				
				this.thisIsInsurance();
			}			

			var redirectedToStageOne = false;
			var redirectToStageOne = function () {
				if (redirectedToStageOne) {
					return;
				}

				var path = window.location.pathname || '';
				var collectionMatch = path.match(/^\/collections\/([^\/\?]+)/);
				var inNewFunnelOverlay = !!document.querySelector('.repair--confirmation-wrap-new-funnel');
				if (collectionMatch && collectionMatch[1] && inNewFunnelOverlay) {
					redirectedToStageOne = true;
					sessionStorage.setItem('jv_source_collection', collectionMatch[1]);
					sessionStorage.setItem('jv_selected', JSON.stringify(this.selected || {}));
					sessionStorage.setItem('jv_selectedrear', JSON.stringify(this.selectedrear || {}));
					sessionStorage.setItem('jv_stores_list', JSON.stringify((this.stores && this.stores.list) ? this.stores.list : []));
					sessionStorage.setItem('stage', '1');
					var insuranceMarker = sessionStorage.getItem('isinsurance');
					var isInsuranceJourney = insuranceMarker === 'true' || insuranceMarker === 'Yes' || insuranceMarker === '1';
					var insuranceQuery = isInsuranceJourney ? '&isinsurance=Yes' : '';
					navigateWithFunnelLoader('/pages/device-funnel-stage-1?source_collection=' + encodeURIComponent(collectionMatch[1]) + insuranceQuery);
				}
			}.bind(this);

			console.log("GA4 Test - new-delivery-method: New_Device_Picked");
			gtag('event', 'New_Device_Picked', {
				'app_name': 'BookingFunnel',
				'screen_name': 'Repair Selected',
				'event_callback': redirectToStageOne
			});

			setTimeout(redirectToStageOne, 250);
		},
		methods: {
			thisIsInsurance: function () {
				//it's an insurance journey so pre-select store visit
				this.booking.delivery_type = "store_visit";
				this.booking.email = sessionStorage.getItem("email");
			},			
			skycustomer: function () {		

				//this.booking.delivery_type = "store_visit";
				if(this.booking.skyemployee == true){
					this.booking.skyemployee = false;
				} else {
					this.booking.skyemployee = true;							
					var product = Object.keys(this.selected)[0];
					var prodSKU = this.selected[product].variant.sku;
					var prodCode = this.selected[Object.keys(this.selected)[0]].variant.option3;
					// Sky Store Check
					this.$http.get(App.config.api.filemaker + '/store/skystock/' + prodSKU + '/' + prodCode + '/06bd64da-d882-11e8-f71b-d1300399b585').then(function (data) {
						console.log("data.body "+data.body)
						var skystoreList = data.body;
						this.skystores.list = skystoreList;

					}, function (data) {
						console.error(data);
					});
				}
				
				$('.skyemployee').toggleClass('active');
			},
			submitSky: function () {
				this.booking.skyemployeeemailError = "";
				this.booking.skycodeError = "";
				if (!this.booking.skyemployeeemail) {
					this.booking.skyemployeeemailError = "Please enter an email address";

					return;
				}
				if (!REGEX_EMAIL.test(this.booking.skyemployeeemail)) {
					this.booking.skyemployeeemailError = "Please enter a valid email address";

					return;
				}
				this.booking.email = this.booking.skyemployeeemail;
				
				if (!this.booking.skycode) {
					this.booking.skycodeError = "Please enter a code";

					return;
				}
				if (this.booking.skycode != "Sky001") {
					this.booking.skycodeError = "Please enter a valid code";

					return;
				}

				this.selectedStore.store = this.skystores.list[Object.keys(this.skystores.list)[0]];
				
				this.booking.delivery_type = "store_visit";
				this.booking.skyemployeeemailError = "";
				this.booking.skycodeError = "";
				this.booking.stage = 3;
				setTimeout(
				function() 
				{
					$("#storelistview").hide();
					$("#searchfields").hide();
					$(".storesearchbutton").hide();
					$(".uselocation").hide();
					
					
					$("#instockonlycon").hide();
					
					$("#skylistview").show(); 

				}, 100);				
				console.log("skylistview runs");
				
			},
			changeMethod: function (method) {
				
				this.booking.isinsurance = this.isinsurance;
				//we need to make an extra check if the produc is a Vend for post-in method
				if (method === "post_in") {
					let is_vend_product = this.is_variant_vend_product;
					if (is_vend_product) return false;
					this.booking.addonone = null;
					this.booking.addontwo = null;
					
					this.booking.addon.addonone = null; 
					this.booking.addon.addononesku = null;
					this.booking.addon.addononeprice = null;
					this.booking.addon.addononename = null;
					this.booking.addon.addononevend = null;
					this.booking.addon.addononediscount = null;
					
					this.booking.addon.addontwo = null; 
					this.booking.addon.addontwosku = null;
					this.booking.addon.addontwoprice = null;
					this.booking.addon.addontwoname = null;
					this.booking.addon.addontwovend = null;
					this.booking.addon.addontwodiscount = null;

					this.booking.stage = 2;
				}
				
				this.selectedStore.store = null;
				this.booking.slot = {
					id: null,
					store_id: null
				};
				this.booking.delivery_type = method;
				this.booking.callout = false;

				if (method === "post_in") {
					var currentPath = window.location.pathname || '';
					if (currentPath.indexOf('/pages/device-funnel-stage-1') === 0) {
						var params = new URLSearchParams(window.location.search || '');
						var sourceCollection = params.get('source_collection') || sessionStorage.getItem('jv_source_collection') || (window.collection && window.collection.handle ? window.collection.handle : '');
						try {
							sessionStorage.setItem('jv_selected', JSON.stringify(this.selected || {}));
							sessionStorage.setItem('jv_selectedrear', JSON.stringify(this.selectedrear || {}));
							sessionStorage.setItem('jv_stores_list', JSON.stringify(this.stores && this.stores.list ? this.stores.list : []));
							sessionStorage.setItem('jv_booking_snapshot', JSON.stringify({
								email: this.booking.email || null,
								zip: this.booking.zip || null,
								delivery_type: 'post_in'
							}));
						} catch (e) {}
						sessionStorage.setItem('stage', '2');
						var nextUrl = '/pages/device-funnel-stage-2';
						if (sourceCollection) {
							sessionStorage.setItem('jv_source_collection', sourceCollection);
							nextUrl += '?source_collection=' + encodeURIComponent(sourceCollection);
						}
						navigateWithFunnelLoader(nextUrl);
						return;
					}
				}
				// this.hasStock = StockQty;
				// //console.log("StockQty "+StockQty);

				if (method == "store_visit") {
					ga('send', 'pageview', '?select-your-store');
					//$(".emailmarketingbox").animate({ scrollTop: 300 }, { duration: 'medium', easing: 'swing' });
					//scrollToMobile('#emailmarketingbox',0);
					//this.mapInit();
					var productitle = '';
					var repairprice = 0;
					var primarySelection = Object.values(this.selected || {})[0] || null;
					var rearSelection = Object.values(this.selectedrear || {})[0] || null;
					var chosenSelection = primarySelection && primarySelection.product ? primarySelection : rearSelection;
					if (chosenSelection && chosenSelection.product) {
						productitle = chosenSelection.product.title || '';
						repairprice = (chosenSelection.product.price || 0) / 100;
					}
					this.booking.stage = 2;
					var currentPath = window.location.pathname || '';
					if (currentPath.indexOf('/pages/device-funnel-stage-1') === 0) {
						var params = new URLSearchParams(window.location.search || '');
						var sourceCollection = params.get('source_collection') || sessionStorage.getItem('jv_source_collection') || (window.collection && window.collection.handle ? window.collection.handle : '');
						var hasRedirected = false;
						var persistAndRedirect = function (prefetchedStores) {
							if (hasRedirected) {
								return;
							}
							hasRedirected = true;
							var storesToPersist = [];
							if (Array.isArray(prefetchedStores)) {
								storesToPersist = prefetchedStores;
							} else if (prefetchedStores && typeof prefetchedStores === 'object') {
								storesToPersist = Object.values(prefetchedStores);
							} else if (this.stores && Array.isArray(this.stores.list)) {
								storesToPersist = this.stores.list;
							}
							try {
								sessionStorage.setItem('jv_selected', JSON.stringify(this.selected || {}));
								sessionStorage.setItem('jv_selectedrear', JSON.stringify(this.selectedrear || {}));
								sessionStorage.setItem('jv_stores_list', JSON.stringify(storesToPersist || []));
								sessionStorage.setItem('jv_booking_snapshot', JSON.stringify({
									email: this.booking.email || null,
									zip: this.booking.zip || null,
									delivery_type: this.booking.delivery_type || 'store_visit'
								}));
							} catch (e) {}
							if (sourceCollection) {
								sessionStorage.setItem('jv_source_collection', sourceCollection);
							}
							var nextUrl = '/pages/device-funnel-stage-2';
							if (sourceCollection) {
								nextUrl += '?source_collection=' + encodeURIComponent(sourceCollection);
							}
							navigateWithFunnelLoader(nextUrl);
						}.bind(this);

						var existingStores = this.stores && Array.isArray(this.stores.list) ? this.stores.list : [];
						var stockUrl = buildStoreStockUrl(this.selected, this.selectedrear);

						if (!this.$http || existingStores.length > 0 || !stockUrl) {
							persistAndRedirect(existingStores);
							return;
						}
						var prefetchTimeout = setTimeout(function () {
							persistAndRedirect(this.stores && this.stores.list ? this.stores.list : []);
						}.bind(this), 2000);

						this.$http.get(stockUrl).then(function (data) {
							clearTimeout(prefetchTimeout);
							var storeList = normalizeStoreListResponse(data && data.body ? data.body : null);
							this.stores.list = Array.isArray(storeList) ? storeList : [];
							persistAndRedirect(this.stores.list);
						}.bind(this), function () {
							clearTimeout(prefetchTimeout);
							persistAndRedirect(this.stores && this.stores.list ? this.stores.list : []);
						}.bind(this));
						return;
					}


				} else if (method == "courier_collection") {
					ga('send', 'pageview', '?send-your-device');
				} else if (method == "post_in") {
					ga('send', 'pageview', '?send-your-device');
				} else if (method == "call_out") {
					this.booking.callout = true;
					ga('send', 'pageview', '?select-your-store/time');
				}
				if ($(window).width() < 480) {
					if(method == "store_visit"){
						//scrollToMobile('#stores_anchor',30,100);
					}else if(method == "courier_collection"){
						scrollToMobile('#courier_anchor',30,100);
					}else if(method == "post_in"){
						scrollToMobile('#postin_anchor',30,100);
					}
					
				} else if ($(window).width() < 1300 && $(window).width() > 480) {
					//$(".repair--delivery-popup").animate({ scrollTop: 300 }, { duration: 'medium', easing: 'swing' });
				} else {
					//$(".repair--delivery-popup").animate({ scrollTop: 200 }, { duration: 'medium', easing: 'swing' });
				}

			},
			subscribeToActiveCampaign: function () {
				if (!this.booking.email || !REGEX_EMAIL.test(this.booking.email)) {
					return;
				}
				var activecampaigndata = {
					"email": this.booking.email
				}
				
				this.$http.post(App.config.api.filemaker + '/customer/addAC', activecampaigndata).then(function (data) {
					//console.log(data.body);
				}, function (data) {
					console.error(data);
					e.target.disabled = false;
				});
				
				////console.log("activeCampaign push: "+this.booking.email)
				// _dcq.push(["identify", {
				// 	email: this.booking.email
				// }]);
			},
			submitEmail: function () {
				//fbq('track', 'Lead');

				// if (!this.booking.email) {
				// 	this.booking.emailSubmitError = "Please enter an email address";
				// 	this.booking.emailSubmitted = false;

				// 	return;
				// }
				// if (!REGEX_EMAIL.test(this.booking.email)) {
				// 	this.booking.emailSubmitError = "Please enter a valid email address";
				// 	this.booking.emailSubmitted = false;

				// 	return;
				// }
				//var useremail = this.booking.email;
				var productitle = '';
				var repairprice = 0;
				var primarySelection = Object.values(this.selected || {})[0] || null;
				var rearSelection = Object.values(this.selectedrear || {})[0] || null;
				var chosenSelection = primarySelection && primarySelection.product ? primarySelection : rearSelection;
				if (chosenSelection && chosenSelection.product) {
					productitle = chosenSelection.product.title || '';
					repairprice = (chosenSelection.product.price || 0) / 100;
				}
				// var abandon_data = {
				// 	"email": useremail,
				// 	"device": productitle
				// }

				// document.cookie = "useremail="+useremail+";";
				ga('send', 'event', 'Exits', 'Booking', 'Proceed_To_Book');
				gtag('event', 'New_Submitted_Email', {
					'app_name': 'BookingFunnel',
					'screen_name': 'How do you want us to fix your device?'
				});
				console.log("GA4 Test - new-delivery-method: New_Submitted_Email");
				//this.subscribeToDripCampaign();
                //this.subscribeToActiveCampaign();
				this.booking.optedin = true;
				// App.funnelEvent({
				// 	'action': 'booking_funnel::start',
				// 	'email': this.booking.email,
				// 	'properties': {
				// 		'email': this.booking.email,
				// 		'repair_name': this.selectedRepairType,
				// 		'collection_url': window.location.href,
				// 		'collection_name': window.collection.title.replace(' Repairs', '')
				// 	}

				// });
				// var _tvqsky = window._tvqsky = window._tvqsky || [];
				// (function () {
				// 	var session = { 'user': useremail };
				// 	var actionname = 'bookings';
				// 	var action = {
				// 	'rev': repairprice,
				// 	'prod': productitle,
				// 	'id': useremail
				// 	};

				// 	var u = (("https:" == document.location.protocol) ?
				// 	"https://collector-12744.tvsquared.com/"
				// 	:
				// 	"http://collector-12744.tvsquared.com/");
				// 	_tvqsky.push(['setSiteId', "TV-8172275454-1"]);
				// 	_tvqsky.push(['setTrackerUrl', u + 'tv2track.php']);
				// 	_tvqsky.push([function () {
				// 	this.setCustomVariable(5, 'session', JSON2.stringify(session), 'visit')
				// 	}]);
				// 	_tvqsky.push([function () {
				// 	this.setCustomVariable(5, actionname, JSON2.stringify(action), 'page')
				// 	}]);
				// 	_tvqsky.push(['trackPageView']);
				// 	var d = document,
				// 	g = d.createElement('script'),
				// 	s = d.getElementsByTagName('script')[0];
				// 	g.type = 'text/javascript';
				// 	g.defer = true;
				// 	g.async = true;
				// 	g.src = u + 'tv2tracksky.js';
				// 	s.parentNode.insertBefore(g, s);
				// })();

				// this.booking.emailSubmitError = null;
				// this.booking.emailSubmitted = true;
				this.booking.stage = 2;
				var currentPath = window.location.pathname || '';
				if (currentPath.indexOf('/pages/device-funnel-stage-1') === 0) {
					var params = new URLSearchParams(window.location.search || '');
					var sourceCollection = params.get('source_collection') || sessionStorage.getItem('jv_source_collection') || (window.collection && window.collection.handle ? window.collection.handle : '');
					var hasRedirected = false;
					var persistAndRedirect = function (prefetchedStores) {
						if (hasRedirected) {
							return;
						}
						hasRedirected = true;
						var storesToPersist = [];
						if (Array.isArray(prefetchedStores)) {
							storesToPersist = prefetchedStores;
						} else if (prefetchedStores && typeof prefetchedStores === 'object') {
							storesToPersist = Object.values(prefetchedStores);
						} else if (this.stores && Array.isArray(this.stores.list)) {
							storesToPersist = this.stores.list;
						}
						try {
							sessionStorage.setItem('jv_selected', JSON.stringify(this.selected || {}));
							sessionStorage.setItem('jv_selectedrear', JSON.stringify(this.selectedrear || {}));
							sessionStorage.setItem('jv_stores_list', JSON.stringify(storesToPersist || []));
							sessionStorage.setItem('jv_booking_snapshot', JSON.stringify({
								email: this.booking.email || null,
								zip: this.booking.zip || null,
								delivery_type: this.booking.delivery_type || 'store_visit'
							}));
						} catch (e) {}
						if (sourceCollection) {
							sessionStorage.setItem('jv_source_collection', sourceCollection);
						}
						var nextUrl = '/pages/device-funnel-stage-2';
						if (sourceCollection) {
							nextUrl += '?source_collection=' + encodeURIComponent(sourceCollection);
						}
						navigateWithFunnelLoader(nextUrl);
					}.bind(this);

					var existingStores = this.stores && Array.isArray(this.stores.list) ? this.stores.list : [];
					var stockUrl = buildStoreStockUrl(this.selected, this.selectedrear);

					if (!this.$http || existingStores.length > 0 || !stockUrl) {
						persistAndRedirect(existingStores);
						return;
					}
					var prefetchTimeout = setTimeout(function () {
						persistAndRedirect(this.stores && this.stores.list ? this.stores.list : []);
					}.bind(this), 2000);

					this.$http.get(stockUrl).then(function (data) {
						clearTimeout(prefetchTimeout);
						var storeList = normalizeStoreListResponse(data && data.body ? data.body : null);
						this.stores.list = Array.isArray(storeList) ? storeList : [];
						persistAndRedirect(this.stores.list);
					}.bind(this), function () {
						clearTimeout(prefetchTimeout);
						persistAndRedirect(this.stores && this.stores.list ? this.stores.list : []);
					}.bind(this));
					return;
				}

				//this.mapInit();
				if ($(window).width() < 480) {
					$(".scrollpoint").animate({ scrollTop: 300 }, { duration: 'medium', easing: 'swing' });
				}
			},
		}
	});

	Vue.component('new-delivery-method-stage-two', {
		template: '#new-delivery-method-stage-two',
		props: ['selected', 'selectedrear', 'booking', 'selectedStore', 'stores', 'StockQty', 'storesOpen'],
		data: function () {
			return {
				courierCollectThis: window.courierCollection || null,
				mailinThis: window.mailin || null,
				visitusThis: (function (v) {
					v = (v || '').toString().trim().toLowerCase();
					return v === 'no' ? 'No' : 'Yes';
				})(window.visitus),
				postcode: null,
				radius: 10,
				postcodeAccepted: false,
				postcodeStatusText: null,
				courierPostcodeAccepted: false,
				courierPostcodeStatusText: null,
				courier: null,
				map: null,
				delay: null,
				postcodeSearched: false,
				storesList: null,
				viewmore: 1,
				instockonly: 0,
				zoomLevel: 15,
				errors: [],
				post_in_errors: [],
				postcodeCourierAccepted: null,
				postcodeCourierCost: null,
				hideavailability: this.$hideavailability,
				availabilitymessage: this.$availabilitymessage,
				hasStock: null,
				isinsurance: this.$isinsurance,
				insurer: this.$insurer
			};
		},
		computed: {
			preferredStore: function () {
				try {
					var preferred = JSON.parse(sessionStorage.getItem('jv_preferred_store') || 'null');
					if (!preferred || !preferred.set_at || (Date.now() - preferred.set_at) > (4 * 60 * 60 * 1000)) {
						sessionStorage.removeItem('jv_preferred_store');
						return null;
					}
					return preferred;
				} catch (e) {
					return null;
				}
			},
			allStoresList: function () {
				if (this.stores && Array.isArray(this.stores.list)) {
					return this.stores.list;
				}
				if (this.stores && this.stores.list && typeof this.stores.list === 'object') {
					return Object.values(this.stores.list);
				}
				return [];
			},
			showVisitUsStoreList: function () {
				return this.postcodeSearched === true || this.storesSorted.length > 0;
			},
			storesSorted: function () {
				var list = [];
				if (Array.isArray(this.storesList)) {
					list = this.storesList.slice();
				} else if (this.storesList && typeof this.storesList === 'object') {
					list = Object.values(this.storesList);
				}
				if (list.length) {
					var preferredStore = this.preferredStore;
					list.sort(function (a, b) {
						var aPreferred = this.storeMatchesPreference(a, preferredStore);
						var bPreferred = this.storeMatchesPreference(b, preferredStore);
						if (aPreferred && !bPreferred) return -1;
						if (!aPreferred && bPreferred) return 1;
						if (a.distance < b.distance) return -1;
						if (a.distance > b.distance) return 1;
						return 0;
					}.bind(this));
					if(this.viewmore == 1){
						var storesshortList = [];
						for (var i = 0; i < list.length; i++) {
							if(i < 3){
								storesshortList.push(list[i]);
							}							
						}
						return storesshortList;
					} else {
						return list;
					}
					
				} else {
					var fallback = this.allStoresList.slice();
					return fallback.sort(function (a, b) {
						if (a.name < b.name) return -1;
						if (a.name > b.name) return 1;
						return 0;
					});
				}
			},
			storesCourierSorted: function () {
					var list = [];
					if (Array.isArray(this.storesList)) {
						list = this.storesList.slice();
					} else if (this.storesList && typeof this.storesList === 'object') {
						list = Object.values(this.storesList);
					}
					return list.sort(function (a, b) {
						if (a.distance < b.distance) return -1;
						if (a.distance > b.distance) return 1;
						return 0;
					});
			},
			storesCourierOutSorted: function () {
					var outList = Array.isArray(this.storesOutList) ? this.storesOutList.slice() : [];
					return outList.sort(function (a, b) {
						if (a.distance < b.distance) return -1;
						if (a.distance > b.distance) return 1;
						return 0;
					});
			},
			selectedRepairType: function () {
				
				if(Object.keys(this.selected).length === 0){					
					var productId = Object.keys(this.selectedrear)[0];
					var title = this.selectedrear[productId].product.title;
				} else {	
					var productId = Object.keys(this.selected)[0];
					var title = this.selected[productId].product.title;
				}
				return title.split(' - ')[0];
			},
			normalized_zip: function () {
				if (!this.booking.courier.zip) {
					return null;
				}
				return this.booking.courier.zip.replace(/\s/g, '').toUpperCase();
			},
			normalized_phone: function () {
				if (!this.booking.courier.phone) {
					return null;
				}
				return this.booking.courier.phone.replace(/\s/g, '');
			},
			normalized_bookingphone: function () {
				if (!this.booking.phone) {
					return null;
				}
				return this.booking.phone.replace(/\s/g, '');
			},
			is_variant_vend_product:function(){
				var selectedValues = Object.values(this.selected || {});
				var selectedRearValues = Object.values(this.selectedrear || {});
				var currentSelection = selectedValues.length > 0 ? selectedValues[0] : (selectedRearValues.length > 0 ? selectedRearValues[0] : null);
				if (!currentSelection || !currentSelection.variant || !currentSelection.variant.title) {
					return false;
				}
				var variantTitle = currentSelection.variant.title;
				return variantTitle.endsWith('BO-W-I') || variantTitle.endsWith('BO-D-I');
			},
			productSelected: function () {
				if (Object.keys(this.selected).length > 0) {
					let product = Object.values(this.selected)[0].product;
					return product;
				} else {
					return false;
				}
			},
			productSelectedId: function () {
				return this.productSelected && this.productSelected.id ? String(this.productSelected.id) : '';
			},
			productRearSelected: function () {
				if (this.selectedrear === undefined || !this.selectedrear || Object.keys(this.selectedrear).length === 0) {
					return false;
				} else {
					let product = Object.values(this.selectedrear)[0].product;
					return product;
				}
				
			}
		},
		created: function () {
			var baseStores = this.allStoresList;
			if (baseStores.length > 0) {
				this.postcodeSearched = true;
				this.storesList = baseStores.slice();
				this.$nextTick(function () {
					this.ensureStoreListVisible();
				}.bind(this));
			} else {
				this.prefetchStoresForStageTwo();
			}
			this.mapInit(); 
			this.ensureMapInitWithRetry();
			//this.initAutocomplete();
			//console.log("Created Runs Now");
			if(this.isinsurance=="Yes" || this.isinsurance=="true"){				
				this.thisIsInsurance();
			}
			var method = this.booking.delivery_type;
				if (method == "store_visit") {
				} else if (method == "courier_collection") {
					console.log("GA4 Test - new-delivery-method-stage-two: changeMethod New_Selected_Courier");
					ga('send', 'pageview', '?send-your-device');
					
					gtag('event', 'New_Selected_Courier', {
						'app_name': 'BookingFunnel',
						'screen_name': 'Courier service'
					});
				} else if (method == "post_in") {					
					console.log("GA4 Test - new-delivery-method-stage-two: changeMethod New_Selected_Mailin");
					ga('send', 'pageview', '?send-your-device');
					
					gtag('event', 'New_Selected_Mailin', {
						'app_name': 'BookingFunnel',
						'screen_name': 'Mail-in service'
					});
				}
		},
		beforeDestroy: function () {
			if (this.mapInitRetryTimer) {
				clearInterval(this.mapInitRetryTimer);
				this.mapInitRetryTimer = null;
			}
		},
		watch: {
			'stores.list': {
				handler: function () {
					var baseStores = this.allStoresList;
					if (!baseStores.length) {
						return;
					}
					this.postcodeSearched = true;
					this.storesList = baseStores.slice();
					this.$nextTick(function () {
						this.mapInit();
						this.ensureMapInitWithRetry();
						this.ensureStoreListVisible();
					}.bind(this));
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			normalizeStoreLookupValue: function (value) {
				return (value || '').toString().toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim();
			},
			storeMatchesPreference: function (store, preferredStore) {
				if (!store || !preferredStore) return false;
				if (preferredStore.id) {
					return String(store.id || '') === String(preferredStore.id);
				}
				var storeName = this.normalizeStoreLookupValue(store.name);
				var preferredName = this.normalizeStoreLookupValue(preferredStore.name);
				var preferredKey = this.normalizeStoreLookupValue(preferredStore.key);
				return !!((preferredName && storeName === preferredName) || (preferredKey && storeName === preferredKey));
			},
			isPreferredStore: function (store) {
				return this.storeMatchesPreference(store, this.preferredStore);
			},
			ensureMapInitWithRetry: function () {
				if (this.map && this.isGoogleReady()) {
					return;
				}
				if (this.mapInitRetryTimer) {
					clearInterval(this.mapInitRetryTimer);
				}
				this.mapInitRetryCount = 0;
				this.mapInitRetryTimer = setInterval(function () {
					this.mapInitRetryCount += 1;
					if (this.isGoogleReady() && !this.map) {
						this.mapInit();
					}
					if ((this.map && this.isGoogleReady()) || this.mapInitRetryCount >= 40) {
						clearInterval(this.mapInitRetryTimer);
						this.mapInitRetryTimer = null;
					}
				}.bind(this), 200);
			},
			prefetchStoresForStageTwo: function () {
				if (!this.$http || !App || !App.config || !App.config.api || !App.config.api.filemaker) {
					return;
				}
				if (this.allStoresList.length > 0) {
					this.postcodeSearched = true;
					this.storesList = this.allStoresList.slice();
					return;
				}
				var stockUrl = buildStoreStockUrl(this.selected, this.selectedrear);
				if (!stockUrl) {
					return;
				}
				console.log('Stage2 prefetch stores with', stockUrl);
				this.$http.get(stockUrl).then(function (data) {
					var storeList = normalizeStoreListResponse(data && data.body ? data.body : null);
					console.log('Stage2 prefetch stores result count', Array.isArray(storeList) ? storeList.length : 0);
					this.stores.list = Array.isArray(storeList) ? storeList : [];
					if (this.stores.list.length > 0) {
						this.postcodeSearched = true;
						this.storesList = this.stores.list.slice();
						this.$nextTick(function () {
							this.ensureStoreListVisible();
						}.bind(this));
					}
				}.bind(this), function () {
					// Keep original behavior when fetch fails.
				}.bind(this));
			},
			ensureStoreListVisible: function () {
				var storeListView = document.getElementById('storelistview');
				var storeInStockListView = document.getElementById('storeinstocklistview');
				if (storeListView) {
					storeListView.style.display = 'block';
				}
				if (storeInStockListView) {
					storeInStockListView.style.display = 'none';
				}
				if (window.jQuery) {
					window.jQuery('.nearby-stores-list').show();
				}
			},
			isGoogleReady: function () {
				return !!(window.google && google.maps && google.maps.Map && google.maps.LatLng && google.maps.geometry && google.maps.geometry.spherical);
			},
			initAutocomplete: function () {
				if (!this.isGoogleReady()) {
					return;
				}
				////console.log("autocomplete runs");
				var address = document.getElementById('address_lookup');
				////console.log("address "+address)
				var options = {
					types: ['(regions)'],
					componentRestrictions: {country: ['uk']}
				};
				var autocomplete = new google.maps.places.Autocomplete(address, options);
				//console.log("autocomplete runs 2");
				//var autocomplete = new google.maps.places.Autocomplete(address, options);
				autocomplete.addListener('place_changed', function() {
					//console.log("autocomplete addListener runs");
					var place = autocomplete.getPlace();
					var latitude = place;
					document.getElementById('postcode_search').value = latitude;
				});
				//console.log("autocomplete runs 3");
			},
			viewmorestores: function (){
				////console.log("viewmorestores: function");
				this.viewmore = 0;
				////console.log("this.viewmore "+this.viewmore);
				document.getElementById('storelists').classList.add('viewmorestoreslist');
				document.getElementById('storeinstocklists').classList.add('viewmorestoreslist');
				////console.log("Viewmorestores clicked");		
				this.gotoNearestStore();
			},
			viewinstockstores: function (){
				////console.log("instockonly: "+this.instockonly);
				//this.viewmore = 0;
				if(this.instockonly == 1){
					this.instockonly = 0;					
					document.getElementById("instockonly").checked = false;
					$("#storelistview").show();
					$("#storeinstocklistview").hide();
				} else {
					this.instockonly = 1;
					//this.viewmore = 1;
					this.viewmorestores();
					document.getElementById("instockonly").checked = true;
					$("#storeinstocklistview").show();
					$("#storelistview").hide();
				}				
				$('.viewDetailsButton').removeClass('active');
				$('.hidden-store-details').slideUp();
				$('.hidden-store-details-instock').slideUp();
				////console.log("new instockonly: "+this.instockonly);
				//this.gotoNearestStore();
			},			
			openModal: function(thisModal){
				//console.log(thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			changeBookingStage: function (stage) {
				// Only go back stages, not forward
				if (this.booking.stage < stage) {
					return;
				}
				//disable step 3 for post in
				if(this.booking.stage == 3 && this.booking.delivery_type == 'post_in' && stage == 2){
					return;
				}
				if (stage === 0) {
					document.querySelector('body').classList.remove("popup-active");
					document.querySelector('body');
				}
				this.booking.stage = stage;
				$(".repair--delivery-popup").animate({ scrollTop: 0 }, { duration: 'medium', easing: 'swing' });
				
				// Get the modal
				
				if (document.getElementById("rearModal").style.display == 'block') { 
					var modal = document.getElementById("rearModal");
					modal.style.display = "none";
				}
				if (document.getElementById("screenModal").style.display == 'block') { 
					var modal = document.getElementById("screenModal");
					modal.style.display = "none";
				}
					
				const collection = document.getElementsByClassName("part-select-btn");
				for (let i = 0; i < collection.length; i++) {
				collection[i].innerHTML = "Book Repair";
				}
				
				const screenModelbutton = document.getElementsByClassName("screenModelbutton");
				for (let i = 0; i < screenModelbutton.length; i++) {
				screenModelbutton[i].innerHTML = "+ Add repair";
				}
				
				const rearModalbutton = document.getElementsByClassName("rearModalbutton");
				for (let i = 0; i < rearModalbutton.length; i++) {
				rearModalbutton[i].innerHTML = "+ Add repair";
				}	
				
				const continuebutton = document.getElementsByClassName("continuewithoutbutton");
				for (let i = 0; i < continuebutton.length; i++) {
				continuebutton[i].innerHTML = "Continue without";
				}				
				
				
				
				var selected = Object.keys(this.selected)[0];
				this.$delete(this.selected, selected);
				var selectedrear = Object.keys(this.selectedrear)[0];
				this.$delete(this.selectedrear, selectedrear);
			},
			createUserMarker: function (lat, lng) {
				if (!this.isGoogleReady() || !this.map) {
					return null;
				}
				var marker_pin = App.config.api.filemaker + "/public/img/marker-outstock.png";
				var self = this;
				var lat = parseFloat(lat);
				var lng = parseFloat(lng);
				var marker = new google.maps.Marker({
					position: {
						lat: lat,
						lng: lng
					},
					map: this.map,
					icon: {
						url: marker_pin,
					}
				});
				
				//return marker;

			},
			createStoreMarker: function (store) {
				if (!this.isGoogleReady() || !this.map) {
					return null;
				}
				var marker_pin = "https://cdn.shopify.com/s/files/1/1180/1832/files/new_pin.png?v=1667321973";

				var lat = parseFloat(store.latitude);
				var lng = parseFloat(store.longitude);
				var marker = new google.maps.Marker({
					position: {
						lat: lat,
						lng: lng
					},
					map: this.map,
					icon: {
						url: marker_pin,
					}
				});

				var storeDetailsWrap = document.createElement('div');
				var lineBreak = document.createElement('br');

				var storeDetails = document.createElement('p');

				var storeName = document.createElement('b');
				storeName.textContent = store.name;
				storeDetails.appendChild(storeName);
				//storeDetails.appendChild(lineBreak);

				var storeAddress = document.createElement('p');
				storeAddress.textContent = store.address;
				//storeDetails.appendChild(storeAddress);
				//storeDetails.appendChild(lineBreak);

				var storePhone = document.createElement('p');

				storePhone.textContent = store.contact_phone;
				//storeDetails.appendChild(storePhone);
				//storeDetails.appendChild(lineBreak);

				var stockDetails = document.createElement('p');
				var stockText = store.in_stock;
				if (store.in_stock == 'in_store') {
					stockText = 'Parts in stock | Repair immediately';
					stockDetails.classList.add('in-stock-infowindow');
				}

				if (store.in_stock == 'in_warehouse') {
					stockText = 'Part available for repair in 4 days';
					stockDetails.classList.add('in-warehouse-infowindow');
				}

				if (store.in_stock == 'out_of_stock') {
					stockText = 'Parts out of stock | Request notification when available';
					stockDetails.classList.add('out-of-stock-infowindow');
				}

				if (this.$availabilitymessage) {
					stockText = this.$availabilitymessage;
				}

				if (this.$hideavailability == 'Hide') {
					stockText = '';
				}

				stockDetails.textContent = '';
				
				//storeDetails.appendChild(stockDetails);
				//storeDetails.appendChild(lineBreak);

				var directionLink = document.createElement('a');
				if (this.booking.zip != null) {
					directionLink.href = 'https://www.google.com/maps/dir/' + encodeURIComponent(this.booking.zip) + '/' + encodeURIComponent(store.address);
				} else {
					directionLink.href = 'https://www.google.com/maps/dir//' + encodeURIComponent(store.address);
				}
				directionLink.setAttribute("target", "_blank");
				directionLink.textContent = "Get Directions";
				//storeDetails.appendChild(directionLink);
				//storeDetails.appendChild(lineBreak);

				var selectStore = document.createElement('a');
				selectStore.classList.add('btn');
				selectStore.href = 'javascript:window.repairApp.setStore(' + JSON.stringify(store) + ')';
				selectStore.textContent = "Select this store";
				if (store.in_stock != 'out_of_stock') {
					//storeDetails.appendChild(selectStore);
				}

				storeDetailsWrap.appendChild(storeDetails);

				infoWindow = new google.maps.InfoWindow({
					content: storeDetailsWrap
				});
				var self = this;

				marker.addListener('click', (function (self, infoWindow, marker) {
					return function () {
						infoWindow.open(self.map, marker);
					};
				})(self, infoWindow, marker));
				return marker;
			},
			showLondon: function (){
				$('#london_stores').show();
				$('#nationwide_stores').hide();
				$('#london_button').addClass('active');
				$('#nationwide_button').removeClass('active');
				document.getElementById("listscroll").scrollIntoView({
					behavior: 'smooth'
				});
			},
			showNationwide: function (){
				$('#london_stores').hide();
				$('#nationwide_stores').show();
				$('#london_button').removeClass('active');
				$('#nationwide_button').addClass('active');
				document.getElementById("listscroll").scrollIntoView({
					behavior: 'smooth'
				});
			},
			openMarker: function (store, event, viewmorebutton) {
				if (!this.isGoogleReady() || !this.map) {
					return;
				}

				//console.log("new sales button fires");
				//console.log('#viewmorebutton '+viewmorebutton);
				$('.'+viewmorebutton).toggleClass('active');
				if ($('#details'+store.id).is(":hidden")) {
					$('#detailsbutton'+store.id).addClass('active');
					
					$(".gm-style-iw").next().click();
					if (infoWindow.length != 0) {
						infoWindow.close();
					}
					var marker = this.createStoreMarker(store);
					this.map.setZoom(14);
					this.map.setCenter(marker.getPosition());
					infoWindow.close();
					infoWindow.open(this.map, marker);
					$('.hidden-store-details').slideUp();
					$('#details'+store.id).slideDown();

				} else {
					$('#detailsbutton'+store.id).removeClass('active');
					$('#details'+store.id).slideUp();
				}

				if ($('#detailsinstock'+store.id).is(":hidden")) {
					$('#detailsinstockbutton'+store.id).addClass('active');
					
					$(".gm-style-iw").next().click();
					if (infoWindow.length != 0) {
						infoWindow.close();
					}
					var marker = this.createStoreMarker(store);
					this.map.setZoom(14);
					this.map.setCenter(marker.getPosition());
					infoWindow.close();
					infoWindow.open(this.map, marker);
					$('.hidden-store-details-instock').slideUp();
					$('#detailsinstock'+store.id).slideDown();

				} else {
					$('#detailsinstockbutton'+store.id).removeClass('active');
					$('#detailsinstock'+store.id).slideUp();
				}

			},
			mapInit: function () {
				if (!this.isGoogleReady()) {
					return;
				}
				var self = this;
				Vue.nextTick().then(function () {
					var mapEl = document.querySelector('[data-map]');
					if (!mapEl) { return; }
					self.map = new google.maps.Map(mapEl, {
						center: {
							lat: 54.576411,
							lng: -3.446423
						},
						zoom: 6
					});

					var stores = self.allStoresList;
					for (var i = 0; i < stores.length; i++) {
						var store = stores[i];
						store.name = store.name.trim();
						// if (!store.latitude || !store.contact_phone) {
						// 	continue;
						// }
						if (!store.latitude) {
							continue;
						}
						self.createStoreMarker(store);
					}
				});
			},
			enterPostcode: function () {
				clearTimeout(this.delay);
				this.delay = setTimeout(this.gotoNearestStore, 3000);
			},
			viewStoreList: function () {
				this.postcodeSearched = false;
				this.mapInit();
				this.storesList = this.allStoresList;
			},
			gotoNearestStore: function (e) {
				var allStores = this.allStoresList;
				if (allStores.length === 0) {
					return;
				}
				if (!this.booking.zip) {
					this.postcodeSearched = true;
					this.storesList = allStores;
					this.mapInit();
					this.ensureStoreListVisible();
					return;
				}
				if (!this.isGoogleReady()) {
					this.postcodeSearched = true;
					this.storesList = allStores;
					this.ensureStoreListVisible();
					return;
				}
				$('#instockonlycon').show();	
				//this.viewmore = 1;
				this.postcodeSearched = true;
				$('.loading-nearby-stores').show();
				//$('.nearby-stores-list').hide();

				this.$http.get('https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyBa2bxAi5-ZjZ30Pxp9PPl94Dgin8Sottw&address=' + this.booking.zip + ', GB').then(function (data) {

					var userLocation = data.body.results[0].geometry.location;
					var userMarker = this.createUserMarker(userLocation.lat, userLocation.lng);

					userLocation = new google.maps.LatLng(userLocation.lat, userLocation.lng);


					if (this.radius == 5) {
						this.zoomLevel = 12;
					} else if (this.radius == 10) {
						this.zoomLevel = 11;
					} else if (this.radius == 15) {
						this.zoomLevel = 9;
					} else if (this.radius == 20) {
						this.zoomLevel = 9;
					} else if (this.radius == 30) {
						this.zoomLevel = 9;
					} else if (this.radius == 40) {
						this.zoomLevel = 8;
					} else if (this.radius == 50) {
						this.zoomLevel = 8;
					} else if (this.radius == 75) {
						this.zoomLevel = 7;
					} else if (this.radius == 100) {
						this.zoomLevel = 7;
					} else if (this.radius == 200) {
						this.zoomLevel = 6;
					}
					////console.log("this.radius "+this.radius+" this.zoomLevel "+this.zoomLevel);
					var storesArray = [];

					this.map.setZoom(this.zoomLevel);
					this.map.setCenter(userLocation);
					////console.log("userMarker "+userMarker.getPosition());
					for (var i = 0; i < allStores.length; i++) {

						var storeLocation = new google.maps.LatLng(allStores[i].latitude, allStores[i].longitude);
						var currentStoreDistance = google.maps.geometry.spherical.computeDistanceBetween(userLocation, storeLocation);
						var distanceInMile = currentStoreDistance / 1609.344;
						////console.log(distanceInMile);
						//if (distanceInMile < this.radius) {
							nearestStore = allStores[i];
							nearestStore['distance'] = distanceInMile;
							nearestStore['distancetotwo'] = distanceInMile.toFixed(1);
							////console.log(nearestStore);
							var marker = this.createStoreMarker(nearestStore);
							storesArray.push(nearestStore);
						//}
					}

					this.storesList = storesArray;
					$('.loading-nearby-stores').hide();
					$('.nearby-stores-list').show();

				}, function (data) {
					console.error(data);
				});
				if ($(window).width() < 480) {
					$(".repair--map-postcode").animate({ scrollTop: 800 }, { duration: 'medium', easing: 'swing' });
				}
						
				if(this.instockonly == 1){
					//console.log("goto instockonly 1: "+this.instockonly);
					$("#storeinstocklistview").show();
					$("#storelistview").hide();
				} else {
					//console.log("goto instockonly 0: "+this.instockonly);
					$("#storelistview").show();
					$("#storeinstocklistview").hide();
				}
			},
			gotomMyLocationStore: function (e) {
				$('#instockonlycon').show();	
				this.booking.zip = "";
				$("#postcode_search").val = "";
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(this.showPosition, this.showError);
				} else { 
					$('#getlocation').html("Geolocation is not supported by this browser.");
				}
			},
			showPosition: function(position) {
				if (!this.isGoogleReady()) {
					this.postcodeSearched = true;
					this.storesList = this.allStoresList;
					return;
				}
				
				this.zoomLevel = 9;
				this.radius = 30;				

				var userLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);	

				var userMarker = this.createUserMarker(position.coords.latitude, position.coords.longitude);

				this.map.setZoom(this.zoomLevel);
				this.map.setCenter(userLocation);

				//this.mapInit();
				//$('#getlocation').html("Latitude: " + position.coords.latitude + "<br>Longitude: " + position.coords.longitude);				

				this.postcodeSearched = true;
				$('.loading-nearby-stores').show();
				$('.nearby-stores-list').hide();

				//var userMarker = this.createUserMarker(position.coords.latitude, position.coords.longitude);
				
				var initialstoresArray = [];
				var storesArray = [];
				var allStores = this.allStoresList;
				for (var i = 0; i < allStores.length; i++) {

					var storeLocation = new google.maps.LatLng(allStores[i].latitude, allStores[i].longitude);
					var currentStoreDistance = google.maps.geometry.spherical.computeDistanceBetween(userLocation, storeLocation);
					var distanceInMile = currentStoreDistance / 1609.344;
					////console.log(distanceInMile);
					if (distanceInMile < this.radius) {
						nearestStore = allStores[i];
						nearestStore['distance'] = distanceInMile;
						nearestStore['distancetotwo'] = distanceInMile.toFixed(1);
						////console.log(nearestStore);
						//var marker = this.createStoreMarker(nearestStore);
						storesArray.push(nearestStore);
					}
				}

				this.storesList = storesArray;
				$('.loading-nearby-stores').hide();
				$('.nearby-stores-list').show();

				if ($(window).width() < 480) {
					$(".repair--map-postcode").animate({ scrollTop: 800 }, { duration: 'medium', easing: 'swing' });
				}
			},
			showError: function(error) {
				switch(error.code) {
					case error.PERMISSION_DENIED:
					x.innerHTML = "User denied the request for Geolocation."
					break;
					case error.POSITION_UNAVAILABLE:
					x.innerHTML = "Location information is unavailable."
					break;
					case error.TIMEOUT:
					x.innerHTML = "The request to get user location timed out."
					break;
					case error.UNKNOWN_ERROR:
					x.innerHTML = "An unknown error occurred."
					break;
				}
			},
			selectStore: function (store) {
				this.booking.slot = {
					id: null,
					store_id: null
				};

				var useremail = this.booking.email;
				var abandon_data = {
					"email": useremail,
					"store": store.name
				}
				this.selectedStore.store = store;
				this.booking.stage = 3;
				var currentPath = window.location.pathname || '';
				if (currentPath.indexOf('/pages/device-funnel-stage-2') === 0) {
					var params = new URLSearchParams(window.location.search || '');
					var sourceCollection = params.get('source_collection') || sessionStorage.getItem('jv_source_collection') || (window.collection && window.collection.handle ? window.collection.handle : '');
					var selectedStorePayload = wrapSelectedStorePayload(store);
					try {
						sessionStorage.setItem('jv_selected', JSON.stringify(this.selected || {}));
						sessionStorage.setItem('jv_selectedrear', JSON.stringify(this.selectedrear || {}));
						sessionStorage.setItem('jv_stores_list', JSON.stringify(this.stores && this.stores.list ? this.stores.list : []));
						sessionStorage.setItem('jv_selected_store', JSON.stringify(selectedStorePayload));
						sessionStorage.setItem('jv_booking_snapshot', JSON.stringify({
							email: this.booking.email || null,
							zip: this.booking.zip || null,
							delivery_type: this.booking.delivery_type || 'store_visit'
						}));
					} catch (e) {}
					sessionStorage.setItem('stage', '3');
					var nextUrl = '/pages/device-funnel-stage-3';
					if (sourceCollection) {
						sessionStorage.setItem('jv_source_collection', sourceCollection);
						nextUrl += '?source_collection=' + encodeURIComponent(sourceCollection);
					}
					navigateWithFunnelLoader(nextUrl);
					return;
				}
				ga('send', 'pageview', '?select-your-store/time');
				App.funnelEvent({
					'action': 'booking_funnel::selected_store',
					'email': this.booking.email,
					'properties': {
						'store_name': this.selectedStore.store.name
					}
				});
				//$(".repair--delivery-popup").animate({ scrollTop: 200 }, { duration: 'medium', easing: 'swing' });

			},
			thisIsInsurance: function () {
				//it's an insurance journey so pre-select store visit
				this.booking.delivery_type = "store_visit";
			},			
			changeMethod: function (method) {
				//we need to make an extra check if the produc is a Vend for post-in method
				if (method === "post_in") {
					let is_vend_product = this.is_variant_vend_product;
					if (is_vend_product) return false;
				}

				this.selectedStore.store = null;
				this.booking.slot = {
					id: null,
					store_id: null
				};
				this.booking.delivery_type = method;
				this.booking.callout = false;
				// this.hasStock = StockQty;
				// //console.log("StockQty "+StockQty);

				if (method == "store_visit") { 
					console.log("GA4 Test - new-delivery-method-stage-two: changeMethod New_Selected_Store");
					ga('send', 'pageview', '?select-your-store');
					
					gtag('event', 'New_Selected_Store', {
						'app_name': 'BookingFunnel',
						'screen_name': 'Walk-in service'
					});
					this.mapInit();
				} else if (method == "courier_collection") {
					console.log("GA4 Test - new-delivery-method-stage-two: changeMethod New_Selected_Courier");
					ga('send', 'pageview', '?send-your-device');
					
					gtag('event', 'New_Selected_Courier', {
						'app_name': 'BookingFunnel',
						'screen_name': 'Courier service'
					});
				} else if (method == "post_in") {					
					console.log("GA4 Test - new-delivery-method-stage-two: changeMethod New_Selected_Mailin");
					ga('send', 'pageview', '?send-your-device');
					
					gtag('event', 'New_Selected_Mailin', {
						'app_name': 'BookingFunnel',
						'screen_name': 'Mail-in service'
					});
				} else if (method == "call_out") {
					this.booking.callout = true;
					ga('send', 'pageview', '?select-your-store/time');
				}
				if ($(window).width() < 480) {
					if(method == "store_visit"){
						scrollToMobile('#stores_anchor',30,100);
					}else if(method == "courier_collection"){
						scrollToMobile('#courier_anchor',30,100);
					}else if(method == "post_in"){
						scrollToMobile('#postin_anchor',30,100);
					}
					
				} else if ($(window).width() < 1300 && $(window).width() > 480) {
					//$(".repair--delivery-popup").animate({ scrollTop: 300 }, { duration: 'medium', easing: 'swing' });
				} else {
					//$(".repair--delivery-popup").animate({ scrollTop: 200 }, { duration: 'medium', easing: 'swing' });
				}

			},
			selectCourierStore: function () {
				this.booking.slot = {
					id: null,
					store_id: null
				}
				this.selectedStore.store = JSON.parse('{"address": "","contact_email": "courier@ismash.com","contact_phone": "02076403111","googleID": "ChIJ8wOfrBQFdkgR2RCtjwx4PBE","id": "06bd64da-d882-11e8-f71b-7f7ec9c70955","in_london": 1,"in_stock": "courier","isStore": 1,"latitude": 51.489219800000000759609974920749664306640625,"longitude": -0.1640771000000000034990677022506133653223514556884765625,"mon_fri": "08:00-20:00","name": "Courier Pick-up","sat": "10:00-19:00","sun": "10:00-18:00","yelpID": "y7Dw4dlwzkSsVKN3E_-orw"}');
				this.booking.stage = 2;
			},
			checkCourierBooking: function (e) {

				var foundit = 0;

				var needle = this.booking.courier.zip.replace(/\s/g, '').slice(0, -3).toUpperCase();

				////console.log("file contains this now "+JSON.stringify(this.$postcodeLookup));
				//console.log("new postcode " + needle);
				// iterate over each element in the array
				for (var i = 0; i < this.$postcodeLookup.length; i++) {
					var thispostcode = this.$postcodeLookup[i].Postcode.replace(/\s/g, '').toUpperCase();
					this.booking.addressPostCode = this.booking.courier.zip.toUpperCase();
					////console.log("loop runs "+thispostcode);
					// look for the entry with a matching `postcode` value
					if (thispostcode == needle) {
						foundit = 1;
						courierCost = this.$postcodeLookup[i].Price;
						this.booking.courier.pickupcost = this.$postcodeLookup[i].Price;

						////console.log("courier price "+courierCost);
					}
				}

				if (foundit == 1) {
					this.postcodeCourierAccepted = 'yes';
					this.postcodeCourierCost = courierCost;
				} else {
					this.postcodeCourierAccepted = 'no';
				}

			},
			checkCourierTimeslots: function (e) {

				this.booking.slot = {
					id: null,
					store_id: null
				};
				this.booking.stage = 2;
				ga('send', 'pageview', '?send-your-device/time');
			},
			addSelectedToCart: function (callback) {
				this.post_in_errors = [];

				if (typeof (callback) === 'undefined') {
					callback = null;
				}
				// if (!this.booking.device_passcode || this.booking.device_passcode == null) {
				// 	this.post_in_errors.push("Device passcode is required!");
				// }
				// if (!this.booking.post_in_terms_accepted || this.booking.post_in_terms_accepted == false) {
				// 	this.post_in_errors.push("Please accept terms and conditions");
				// }

				if (this.post_in_errors.length > 0) {
					return;
				}

				var hasFinalizedPostInRoute = false;
				var finalizePostInRoute = function () {
					if (hasFinalizedPostInRoute) {
						return;
					}
					hasFinalizedPostInRoute = true;
					this.booking.stage = 5;
					var currentPath = window.location.pathname || '';
					if (currentPath.indexOf('/pages/device-funnel-stage-2') === 0) {
						var params = new URLSearchParams(window.location.search || '');
						var sourceCollection = params.get('source_collection') || sessionStorage.getItem('jv_source_collection') || (window.collection && window.collection.handle ? window.collection.handle : '');
						try {
							sessionStorage.setItem('jv_selected', JSON.stringify(this.selected || {}));
							sessionStorage.setItem('jv_selectedrear', JSON.stringify(this.selectedrear || {}));
							sessionStorage.setItem('jv_selected_store', JSON.stringify(wrapSelectedStorePayload(this.selectedStore && this.selectedStore.store ? this.selectedStore.store : null)));
							sessionStorage.setItem('jv_booking_snapshot', JSON.stringify({
								email: this.booking.email || null,
								zip: this.booking.zip || null,
								delivery_type: 'post_in',
								slot: this.booking.slot || null
							}));
						} catch (e) {}
						sessionStorage.setItem('stage', '5');
						var nextUrl = '/pages/device-funnel-stage-5';
						if (sourceCollection) {
							sessionStorage.setItem('jv_source_collection', sourceCollection);
							nextUrl += '?source_collection=' + encodeURIComponent(sourceCollection);
						}
						navigateWithFunnelLoader(nextUrl);
						return;
					}
					if (callback) {
						callback();
					}
				}.bind(this);

				if(Object.keys(this.selected).length > 0){
					var itemsToAdd = {};
					for (var i = 0; i < Object.keys(this.selected).length; i++) {
						itemsToAdd[this.selected[Object.keys(this.selected)[i]].variant.id] = 1;
					}

					this.$http.post('/cart/update.js', {
						updates: itemsToAdd
					}).then(function (data) {
						//window.location.href = "/cart?dp=" + this.booking.device_passcode + "&ta=" + this.booking.post_in_terms_accepted;

						this.booking.slot = {
							id: null,
							store_id: null
						}
						this.selectedStore.store = JSON.parse('{"address":"111 Power Road, London, W45PY","contact_email":"customerservice@ismash.com","contact_phone":"020 7640 3111","googleID":"","id":"060f02b1-c882-11e6-fcd2-33e0499e0cc0","in_london":0,"in_stock":"in_warehouse","isStore":0,"latitude":51.4945573,"longitude":-0.2791007,"mon_fri":"","name":"Online","sat":"Closed","sun":"-","yelpID":""}');
						//console.log("selected added");
						finalizePostInRoute();
					}, function (data) {
						console.error(data);
					});
				}
				if(Object.keys(this.selectedrear).length > 0){

					var itemsToAdd = {};
					for (var i = 0; i < Object.keys(this.selectedrear).length; i++) {
						itemsToAdd[this.selectedrear[Object.keys(this.selectedrear)[i]].variant.id] = 1;
					}
					

					this.$http.post('/cart/update.js', {
						updates: itemsToAdd
					}).then(function (data) {
						//window.location.href = "/cart?dp=" + this.booking.device_passcode + "&ta=" + this.booking.post_in_terms_accepted;
					
						this.booking.slot = {
							id: null,
							store_id: null
						}
						this.selectedStore.store = JSON.parse('{"address":"111 Power Road, London, W45PY","contact_email":"customerservice@ismash.com","contact_phone":"020 7640 3111","googleID":"","id":"060f02b1-c882-11e6-fcd2-33e0499e0cc0","in_london":0,"in_stock":"in_warehouse","isStore":0,"latitude":51.4945573,"longitude":-0.2791007,"mon_fri":"","name":"Online","sat":"Closed","sun":"-","yelpID":""}');
						//console.log("selectedrear added");
						finalizePostInRoute();
					}, function (data) {
						console.error(data);
					});

				}

			},
			goToInsurancePostIn: function () {
				this.post_in_errors = [];
				// if (!this.booking.device_passcode || this.booking.device_passcode == null) {
				// 	this.post_in_errors.push("Device passcode is required!");
				// }
				// if (!this.booking.post_in_terms_accepted || this.booking.post_in_terms_accepted == false) {
				// 	this.post_in_errors.push("Please accept terms and conditions");
				// }

				if (this.post_in_errors.length > 0) {
					return;
				}
				window.location.href = "/pages/insurance-booking-post-ins";
			},
			addItemToCart: function (variantId, callback) {
				if (typeof (callback) === 'undefined') {
					callback = null;
				}
				var itemsToAdd = {};
				itemsToAdd[variantId] = 1;
				
				//if the product selected is premium 
				if(this.$root.booking.is_premium){
					itemsToAdd[this.$root.premium_service_product.id] = 1;
				}

				if(Object.keys(this.selected).length > 0){
					for (var i = 0; i < Object.keys(this.selected).length; i++) {
						itemsToAdd[this.selected[Object.keys(this.selected)[i]].variant.id] = 1;
					}
				}
				if(Object.keys(this.selectedrear).length > 0){
					for (var i = 0; i < Object.keys(this.selectedrear).length; i++) {
						itemsToAdd[this.selectedrear[Object.keys(this.selectedrear)[i]].variant.id] = 1;
					}
				}

				this.$http.post('/cart/update.js', {
					updates: itemsToAdd
				}).then(function (data) {
					if (callback) {
						callback();
					}
				}, function (data) {
					console.error(data);
				});
			},
			clearCart: function (callback) {
				if (typeof (callback) === 'undefined') {
					callback = null;
				}
				this.$http.post('/cart/clear.js').then(function (data) {
					if (callback) {
						callback();
					}
				}, function (data) {
					console.error(data);
				});
			},
			subscribeToDripCampaign: function () {
				if (typeof _dcq != 'object') {
					console.error('Drip JS obj not found');
					return;
				}
				if (!this.booking.email || !REGEX_EMAIL.test(this.booking.email)) {
					return;
				}
				//console.log("subscribeToDripCampaign push: "+this.booking.email)
				_dcq.push(["identify", {
					email: this.booking.email
				}]);
			},
			subscribeToActiveCampaign: function () {
				if (!this.booking.email || !REGEX_EMAIL.test(this.booking.email)) {
					return;
				}
				var activecampaigndata = {
					"email": this.booking.email
				}
				
				this.$http.post(App.config.api.filemaker + '/customer/addAC', activecampaigndata).then(function (data) {
					//console.log(data.body);
				}, function (data) {
					console.error(data);
					e.target.disabled = false;
				});
				
				//console.log("activeCampaign push: "+this.booking.email)
				// _dcq.push(["identify", {
				// 	email: this.booking.email
				// }]);
			},
			submitEmail: function () {
				fbq('track', 'Lead');

				if (!this.booking.email) {
					this.booking.emailSubmitError = "Please enter an email address";
					this.booking.emailSubmitted = false;

					return;
				}
				if (!REGEX_EMAIL.test(this.booking.email)) {
					this.booking.emailSubmitError = "Please enter a valid email address";
					this.booking.emailSubmitted = false;

					return;
				}
				var useremail = this.booking.email;
				var productitle = '';
				var repairprice = 0;
				var primarySelection = Object.values(this.selected || {})[0] || null;
				var rearSelection = Object.values(this.selectedrear || {})[0] || null;
				var chosenSelection = primarySelection && primarySelection.product ? primarySelection : rearSelection;
				if (chosenSelection && chosenSelection.product) {
					productitle = chosenSelection.product.title || '';
					repairprice = (chosenSelection.product.price || 0) / 100;
				}
				var abandon_data = {
					"email": useremail,
					"device": productitle
				}

				document.cookie = "useremail="+useremail+";";
				console.log("GA4 Test - new-delivery-method-stage-two: New_Submitted_Email");
				ga('send', 'event', 'Exits', 'Booking', 'Proceed_To_Book');
				gtag('event', 'New_Submitted_Email', {
					'app_name': 'BookingFunnel',
					'screen_name': 'Please confirm your details'
				});
				//if(this.booking.optin){
				//this.subscribeToDripCampaign();
                this.subscribeToActiveCampaign();
				this.booking.optedin = true;
				App.funnelEvent({
					'action': 'booking_funnel::start',
					'email': this.booking.email,
					'properties': {
						'email': this.booking.email,
						'repair_name': this.selectedRepairType,
						'collection_url': window.location.href,
						'collection_name': window.collection.title.replace(' Repairs', '')
					}

				});
				////console.log('optin1');
				//}else{
				////console.log('optout1');
				//}
				// //console.log("Email "+useremail)
				// //console.log("Price "+repairprice)
				// //console.log("Title "+repairtitle)
				var _tvqsky = window._tvqsky = window._tvqsky || [];
				(function () {
					var session = { 'user': useremail };
					var actionname = 'bookings';
					var action = {
					'rev': repairprice,
					'prod': productitle,
					'id': useremail
					};

					var u = (("https:" == document.location.protocol) ?
					"https://collector-12744.tvsquared.com/"
					:
					"http://collector-12744.tvsquared.com/");
					_tvqsky.push(['setSiteId', "TV-8172275454-1"]);
					_tvqsky.push(['setTrackerUrl', u + 'tv2track.php']);
					_tvqsky.push([function () {
					this.setCustomVariable(5, 'session', JSON2.stringify(session), 'visit')
					}]);
					_tvqsky.push([function () {
					this.setCustomVariable(5, actionname, JSON2.stringify(action), 'page')
					}]);
					_tvqsky.push(['trackPageView']);
					var d = document,
					g = d.createElement('script'),
					s = d.getElementsByTagName('script')[0];
					g.type = 'text/javascript';
					g.defer = true;
					g.async = true;
					g.src = u + 'tv2tracksky.js';
					s.parentNode.insertBefore(g, s);
				})();

				this.booking.emailSubmitError = null;
				this.booking.emailSubmitted = true;
				this.booking.stage = 2;
				var currentPath = window.location.pathname || '';
				if (currentPath.indexOf('/pages/device-funnel-stage-1') === 0) {
					var params = new URLSearchParams(window.location.search || '');
					var sourceCollection = params.get('source_collection') || sessionStorage.getItem('jv_source_collection') || (window.collection && window.collection.handle ? window.collection.handle : '');
					var hasRedirected = false;
					var persistAndRedirect = function (prefetchedStores) {
						if (hasRedirected) {
							return;
						}
						hasRedirected = true;
						var storesToPersist = [];
						if (Array.isArray(prefetchedStores)) {
							storesToPersist = prefetchedStores;
						} else if (prefetchedStores && typeof prefetchedStores === 'object') {
							storesToPersist = Object.values(prefetchedStores);
						} else if (this.stores && Array.isArray(this.stores.list)) {
							storesToPersist = this.stores.list;
						}
						try {
							sessionStorage.setItem('jv_selected', JSON.stringify(this.selected || {}));
							sessionStorage.setItem('jv_selectedrear', JSON.stringify(this.selectedrear || {}));
							sessionStorage.setItem('jv_stores_list', JSON.stringify(storesToPersist || []));
							sessionStorage.setItem('jv_booking_snapshot', JSON.stringify({
								email: this.booking.email || null,
								zip: this.booking.zip || null,
								delivery_type: this.booking.delivery_type || 'store_visit'
							}));
						} catch (e) {}
						if (sourceCollection) {
							sessionStorage.setItem('jv_source_collection', sourceCollection);
						}
						var nextUrl = '/pages/device-funnel-stage-2';
						if (sourceCollection) {
							nextUrl += '?source_collection=' + encodeURIComponent(sourceCollection);
						}
						navigateWithFunnelLoader(nextUrl);
					}.bind(this);

					var existingStores = this.stores && Array.isArray(this.stores.list) ? this.stores.list : [];
					var stockUrl = buildStoreStockUrl(this.selected, this.selectedrear);

					if (!this.$http || existingStores.length > 0 || !stockUrl) {
						persistAndRedirect(existingStores);
						return;
					}
					var prefetchTimeout = setTimeout(function () {
						persistAndRedirect(this.stores && this.stores.list ? this.stores.list : []);
					}.bind(this), 2000);

					this.$http.get(stockUrl).then(function (data) {
						clearTimeout(prefetchTimeout);
						var storeList = normalizeStoreListResponse(data && data.body ? data.body : null);
						this.stores.list = Array.isArray(storeList) ? storeList : [];
						persistAndRedirect(this.stores.list);
					}.bind(this), function () {
						clearTimeout(prefetchTimeout);
						persistAndRedirect(this.stores && this.stores.list ? this.stores.list : []);
					}.bind(this));
					return;
				}

				this.mapInit();
				if ($(window).width() < 480) {
					$(".scrollpoint").animate({ scrollTop: 300 }, { duration: 'medium', easing: 'swing' });
				}



			},
			makeCourierBooking: function (e) {
				e.target.disabled = true;
				this.errors = [];
				var booking = this.booking.courier;

				if (!this.booking.courier.first_name) {
					this.errors.push("First Name is required");
				}
				if (!this.booking.courier.last_name) {
					this.errors.push("Last Name is required");
				}
				if (!this.booking.courier.email) {
					this.errors.push("An email address is required");
				}
				if (!this.normalized_phone) {
					this.errors.push("A phone number is required");
				} else if (!/^\d+$/.test(this.normalized_phone)) {
					this.errors.push("Please enter a valid phone number");
				}
				if (!this.booking.courier.zip) {
					this.errors.push("Postcode is required");
				} else if (!/^([A-Z][A-Z0-9]?[A-Z0-9]?[A-Z0-9]{1,2}[0-9][A-Z0-9]{2})$/.test(this.normalized_zip)) {
					this.errors.push("Please enter a valid UK postcode");
				}
				if (!this.booking.courier.terms_accepted) {
					this.errors.push("Please read and accept the terms and conditions");
				}

				if (this.errors.length > 0) {
					e.target.disabled = false;
					return;
				}
				if(Object.keys(this.selected).length === 0){
					booking['selected_repair'] = this.selected[Object.keys(this.selectedrear)[0]].variant.name;
				} else {
					booking['selected_repair'] = this.selected[Object.keys(this.selected)[0]].variant.name;
				}

				this.$http.post(App.config.api.filemaker + '/booking/courier', booking).then(function (data) {
					ga("send", "pageview", "?booking-confirmed/" + this.booking.delivery_type);
					window.location.href = "/pages/courier-thank-you";
				}, function (data) {
					console.error(data);
					e.target.disabled = false;
				});
			},
			makeNoStockBooking: function (e) {
				e.target.disabled = true;
				this.errors = [];
				var nostockbooking = [];

				if (!this.booking.first_name) {
					this.errors.push("First Name is required");
					this.booking.errors.first_name = "First Name is required";
				}
				if (!this.booking.last_name) {
					this.errors.push("Last Name is required");
					this.booking.errors.last_name = "Last Name is required";
				}
				if (!REGEX_EMAIL.test(this.booking.email)) {
					this.errors.push("An email address is required");
					this.booking.errors.email = "An email address is required";
				}
				if (!this.normalized_bookingphone) {
					this.errors.push("A phone number is required");
					this.booking.errors.phone = "A phone number is required";
				} else if (!REGEX_PHONE.test(this.normalized_bookingphone)) {
					this.errors.push("Please enter a valid phone number");
					this.booking.errors.phone = "Please enter a valid phone number";
				}
				if (!this.booking.insurance.is_insurance) {
					if (!this.booking.terms_accepted) {
						this.errors.push("Please read and accept the terms and conditions");
						this.booking.errors.terms_accepted = "Please read and accept the terms and conditions";
					}
				}
				
				if (!this.booking.customer_zip) {
					this.errors.errors.customer_zip = "Postcode is required";
				} else if (!/^([A-Z][A-Z0-9]?[A-Z0-9]?[A-Z0-9]{1,2}[0-9][A-Z0-9]{2})$/.test(this.normalized_zip)) {
					this.errors.errors.customer_zip = "Please enter a valid UK postcode";
				}

				if (this.errors.length > 0) {
					e.target.disabled = false;
					return;
				}
				if(Object.keys(this.selected).length === 0){
					var selected_repair = this.selected[Object.keys(this.selectedrear)[0]].variant.name;
				} else {
					var selected_repair = this.selected[Object.keys(this.selected)[0]].variant.name;
				}
				var json = {
					"first_name": this.booking.first_name,
					"last_name": this.booking.last_name,
					"email": this.booking.email,
					"postcode": this.booking.customer_zip,
					"phone": this.booking.phone,
					"notes": this.booking.notes,
					"store": 'Post In',
					"terms_accepted": this.booking.terms_accepted,
					"selected_repair": selected_repair,
					"optin": this.booking.optin
				}

				this.$http.post(App.config.api.filemaker + '/booking/out-of-stock', json).then(function (data) {
					ga("send", "pageview", "?booking-confirmed/out-of-stock");
					window.location.href = "/pages/device-enquiry-thank-you";
				}, function (data) {
					console.error(data);
					e.target.disabled = false;
				});
			},
			covidReminder: function(e) {
				e.target.disabled = true;
				this.errors = [];

				if (!REGEX_EMAIL.test(this.booking.email)) {
					this.errors.push("A valid email address is required");
					this.booking.errors.email = "A valid email address is required";
				}

				if (this.errors.length > 0) {
					e.target.disabled = false;
					return;
				}

				if(Object.keys(this.selected).length === 0){
					var producsku = this.selectedrear[Object.keys(this.selectedrear)[0]].product.sku;
				} else {
					var producsku = this.selected[Object.keys(this.selected)[0]].product.sku;
				}
				var json = {
					"email": this.booking.email,
					"repair": this.selectedRepairType,
					"sku": producsku,
				}

				this.$http.post(App.config.api.filemaker + '/booking/covid19', json).then(function (data) {
					ga("send", "pageview", "?booking-confirmed/covid19");
					//console.log(data);
					if(data.body == 1){
						//console.log("success");
						window.location.href = "/pages/thank-you-for-registering-your-interest";
					}else{
						//console.log("fail");
						//Show error message
					}
					
				}, function (data) {
					console.error(data);
					e.target.disabled = false;
				});
			},
		}
	});

	//Timetable
	Vue.component('new-timetable', {
		template: '#new-timetable',
		props: ['booking', 'store', 'callout', 'bookingDate', 'selected', 'selectedrear', 'addons', 'addonstwo'],
		data: function () {
			var date = new Date();
			return {
				slots: [],
				timetable: (typeof Timetable !== 'undefined') ? new Timetable() : null,
				selectedDay: null,
				isinsurance: this.$isinsurance,
				errors: [], 
				today: moment(date).format('DMMYYYY'),
				firstselect: 1,
				hasaddon: this.addons,
				hasaddontwo: this.addonstwo
			};
		},
		mounted: function () {
			console.log("GA4 Test - add-ons: New_Selected_Store");
			gtag('event', 'New_Selected_Store', {
				'app_name': 'BookingFunnel',
				'screen_name': 'Booking Add-on'
			});
			this.renderStoreSlots();			
			var month = new Date();
			month = moment(month).format('MMMM');			

			$('#bookingmonth').html(month);
			var date = new Date();
			$('#bookingyear').html(date.getFullYear()); 
			setTimeout(
			function() 
			{
				$('#dateselect'+moment(date).format('DMMYYYY')).click();

			}, 3000);
		},
		computed: {
			normalized_phone: function () {
				if (!this.booking.phone) {
					return null;
				}
				return this.booking.phone.replace(/\s/g, '');
			},
			availibleDaySlots: function () {
				var slots = Array.isArray(this.slots) ? this.slots : [];
				var daySlots = [
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[],
					[]
				];

				for (var i = 0; i < slots.length; i++) {
					if (!daySlots[slots[i].day]) {
						daySlots[slots[i].day] = [];
					}

					daySlots[slots[i].day].push(slots[i]);
				}

				return daySlots;
			},
			daySlots: function () {
				var daySlots = JSON.parse(JSON.stringify(this.availibleDaySlots));
				////console.log(daySlots);
				for (var i = 0; i < daySlots.length; i++) {
					if (!daySlots[i]) {
						continue;
					}
					var thisDaysSlots = daySlots[i].map(function (e) {
						return {
							start_hour: e.start_hour,
							start_min: e.start_min
						};
					});

					var openHour = this.store.open_hour ? this.store.open_hour : 6;
					var openMin = this.store.open_minute ? this.store.open_minute : 0;
					var closeHour = this.store.close_hour ? this.store.close_hour : 22;
					var closeMin = this.store.close_minute ? this.store.close_minute : 0;

					var start = moment().utc().hours(openHour).minutes(openMin);
					var end = moment().utc().hours(closeHour).minutes(closeMin);

					var current = start;
					while (current < end) {

						var thisSlot = {
							start_hour: current.hours(),
							start_min: current.minutes()
						};

						if (!findObjInArray(thisDaysSlots, thisSlot)) {
							daySlots[i].push({
								id: -1,
								start_hour: current.hours(),
								start_min: current.minutes(),
								end_hour: current.hours(),
								end_min: current.minutes(),
								disabled: true
							});
						}

						current = current.add(30, 'minutes');
					}

					daySlots[i] = daySlots[i].sort(function (a, b) {
						var aInMins = (a.start_hour * 60) + a.start_min;
						var bInMins = (b.start_hour * 60) + b.start_min;
						if (aInMins > bInMins) {
							return 1;
						}
						return -1;
					});
				}
				
				return daySlots;
			},
			startdates: function(){
				var month = new Date();
				var blankdays = [];
				var daycount = 0;
				if(this.booking.slotweek==0){
					var firstDay = new Date(month.getFullYear(), month.getMonth(), 1);
						firstDay = moment(firstDay).format('dddd');
						if(firstDay=="Tuesday"){
							daycount = 1;
						}
						if(firstDay=="Wednesday"){
							daycount = 2;
						}
						if(firstDay=="Thursday"){
							daycount = 3;
						}
						if(firstDay=="Friday"){
							daycount = 4;
						}
						if(firstDay=="Saturday"){
							daycount = 5;
						}
						if(firstDay=="Sunday"){
							daycount = 6;
						}

				}
				if(this.booking.slotweek==1){
					month.setMonth( month.getMonth() + 1 ); 
					var firstDay = new Date(month.getFullYear(), month.getMonth(), 1);


						firstDay = moment(firstDay).format('dddd');
						if(firstDay=="Tuesday"){
							daycount = 1;
						}
						if(firstDay=="Wednesday"){
							daycount = 2;
						}
						if(firstDay=="Thursday"){
							daycount = 3;
						}
						if(firstDay=="Friday"){
							daycount = 4;
						}
						if(firstDay=="Saturday"){
							daycount = 5;
						}
						if(firstDay=="Sunday"){
							daycount = 6;
						}

				}
				if(this.booking.slotweek==2){
					month.setMonth( month.getMonth() + 2 ); 
					var firstDay = new Date(month.getFullYear(), month.getMonth(), 1);
						firstDay = moment(firstDay).format('dddd');
						if(firstDay=="Tuesday"){
							daycount = 1;
						}
						if(firstDay=="Wednesday"){
							daycount = 2;
						}
						if(firstDay=="Thursday"){
							daycount = 3;
						}
						if(firstDay=="Friday"){
							daycount = 4;
						}
						if(firstDay=="Saturday"){
							daycount = 5;
						}
						if(firstDay=="Sunday"){
							daycount = 6;
						}

				}
				for (var i = 1; i <= daycount; i++) {
					var blankday = "blankday";
					////console.log("blankday count "+i);
					blankdays.push(blankday);
				}
				////console.log("daycount "+daycount);
				return blankdays;
			},
			dates: function () {
				var dates = [];
				var month = new Date();
				if(this.booking.slotweek==0){
					var thismonth = moment(month).format('MMMM');
					$('#bookingmonth').html(thismonth);
					$('#bookingyear').html(month.getFullYear());
					var s = (month.getMonth()+1) + "/" + "01/" + month.getFullYear();
					const start = new Date(s);
					var lastDayOfMonth = new Date(start.getFullYear(), start.getMonth()+1, 0);
					var firstDay = new Date(start.getFullYear(), start.getMonth(), 1);
					firstDay = moment(firstDay).format('dddd');
					//console.log(firstDay);

					//console.log("s "+s+" e "+lastDayOfMonth);
					const end = new Date(lastDayOfMonth);
					let loop = new Date(start);
					for (var i = 0; loop <= end; i++) {
						////console.log(loop);
						var datestring = loop.getDate()  + "|" + (loop.getMonth()+1) + "|" + loop.getFullYear() + "|" + loop.getDate()  + (loop.getMonth()+1) + loop.getFullYear();
						let newDate = loop.setDate(loop.getDate() + 1);
						loop = new Date(newDate);
						////console.log("datestring "+datestring+" 1 slotweek "+this.booking.slotweek);
						dates.push(datestring);
					}
				}
				if(this.booking.slotweek==1){
					month.setMonth( month.getMonth()+1 ); 

					
					var thismonth = moment(month).format('MMMM');
					$('#bookingmonth').html(thismonth);
					
					$('#bookingyear').html(month.getFullYear());

					const today = new Date();
					var start = new Date(today.getFullYear(), today.getMonth()+1);
					//const start = new Date(s);
					var lastDayOfMonth = new Date(start.getFullYear(), start.getMonth()+1, 0);
					var firstDay = new Date(start.getFullYear(), start.getMonth(), 1);
					console.log(firstDay);
					console.log(lastDayOfMonth);
					const end = new Date(lastDayOfMonth);
					let loop = new Date(firstDay);
					for (var i = 0; loop <= end; i++) {
						////console.log(loop);
						var datestring = loop.getDate()  + "|" + (loop.getMonth()) + "|" + loop.getFullYear() + "|" + loop.getDate()  + (loop.getMonth()) + loop.getFullYear();
						let newDate = loop.setDate(loop.getDate() + 1);
						loop = new Date(newDate);
						////console.log("datestring "+datestring+" 2 slotweek "+this.booking.slotweek);
						dates.push(datestring);
					}
				}
				if(this.booking.slotweek==2){
					month.setMonth( month.getMonth() + 2 ); 
					var thismonth = moment(month).format('MMMM');
					$('#bookingmonth').html(thismonth);
					$('#bookingyear').html(month.getFullYear());
					var s = (month.getMonth() + 2) + "/" + "01/" + month.getFullYear();
					const start = new Date(s);
					var lastDayOfMonth = new Date(start.getFullYear(), start.getMonth()+1, 0);
					var firstDay = new Date(start.getFullYear(), start.getMonth(), 1);
					//console.log(firstDay);
					const end = new Date(lastDayOfMonth);
					let loop = new Date(start);
					for (var i = 0; loop <= end; i++) {
						////console.log(loop);
						var datestring = loop.getDate()  + "|" + (loop.getMonth()+1) + "|" + loop.getFullYear() + "|" + loop.getDate()  + (loop.getMonth()+1) + loop.getFullYear();
						let newDate = loop.setDate(loop.getDate() + 1);
						loop = new Date(newDate);
						////console.log("datestring "+datestring+" 3 slotweek "+this.booking.slotweek);
						dates.push(datestring);
					}
				}
				return dates;
			}
		},
		methods: {
			localTime: function (slot) {
				var start = moment().utc().minute(slot.start_min).hours(slot.start_hour);
				var end = moment().utc().minute(slot.end_min).hours(slot.end_hour);

				return {
					start: {
						hour: slot.start_hour,
						min: slot.start_min
					},
					end: {
						hour: slot.end_min,
						min: slot.end_hour
					}
				};
			},
			renderStoreSlots: function () {
				if (!this.store || !this.store.id) {
					return;
				}
				$('.timetable').hide();
				$('.loading-days').show();
				$('.next-week').hide();
				$('.prev-week').hide();


				var date = new Date();
				var CurrentDate = moment(date).format('YYYY-MM-DD');				

				console.log('/store/slots_month/' + CurrentDate + '/' + this.booking.slotweek + '/' + this.store.id + '/' + this.store.in_stock);
				this.$http.get(App.config.api.filemaker + '/store/slots_month/' + CurrentDate + '/' + this.booking.slotweek + '/' + this.store.id + '/' + this.store.in_stock).then(function (data) {
					var seenSlots = Object.create(null);
					var receivedSlots = Array.isArray(data.body) ? data.body : [];
					this.slots = receivedSlots.filter(function (slot) {
						var slotKey = [
							slot.bookingdate || slot.date || '',
							slot.id_store || this.store.id || '',
							slot.start_hour,
							slot.start_min,
							slot.end_hour,
							slot.end_min
						].join('|');

						if (seenSlots[slotKey]) {
							return false;
						}

						seenSlots[slotKey] = true;
						return true;
					}.bind(this));
					$('.timetable').show();
					$('.loading-days').hide();
					$('.prev-week').show();
					$('.next-week').show();
					if (this.booking.slotweek == 0){
						if(this.store.in_stock == "in_warehouse"){
							$('.prev-week').hide();
							var selectdate = moment();
							selectdate = selectdate.add(4, "days");
							selectdate = selectdate.format("DD");
							this.selectDay(selectdate);
							console.log("selectdate: "+selectdate);
						} else {
							$('.prev-week').hide();
							var selectdate = moment();
							selectdate = selectdate.subtract(1, "days");
							selectdate = selectdate.format("DD");
							this.selectDay(selectdate);
							console.log("selectdate: "+selectdate);
						}
					}
					if (this.booking.slotweek == 1){			
						this.selectDay(0);
					}

					////console.log('Slots: '+this.slots);
				}, function (data) {
					console.error(data);
				});

			},
			getStorePrevWeek: function () {
				this.booking.slot = {
					id: null,
					store_id: null
				};
				this.selectedDay = null;
				this.booking.slotweek = this.booking.slotweek - 1;
				$('.timetable').hide();
				this.renderStoreSlots();
			},
			getStoreNextWeek: function () {
				this.booking.slot = {
					id: null,
					store_id: null
				};
				this.selectedDay = null;
				this.booking.slotweek = this.booking.slotweek + 1;
				this.renderStoreSlots();
			},
			getStoreThisWeek: function () {
				this.booking.slot = {
					id: null,
					store_id: null
				};
				this.booking.slotweek = 0;
				this.booking.week = moment().week(),
					this.booking.year = moment().year()
				this.renderStoreSlots();
			},
			selectSlot: function (slot) {
				if (slot.id < 0) {
					return;
				}
				this.booking.slot = slot;
				scrollBookingToTop();
				if (!this.booking.appointmentDuration){
					this.booking.appointmentDuration = 30;
				}
				var end = moment(this.booking.slot.start_hour + ':' + this.booking.slot.start_min, 'HH:mm').add(this.booking.appointmentDuration, 'minutes').format('HH:mm');
				// //console.log("appointmentDuration "+this.booking.appointmentDuration);
				// //console.log("start "+this.booking.slot.start_hour + ':' + this.booking.slot.start_min);
				// //console.log("end "+end);
				var endslot = end.split(":");
				this.booking.slot.end_hour = endslot[0];
				this.booking.slot.end_min = endslot[1];
			},
			selectDay: function (day) {
				this.firstselect = 0;
				if (this.availibleDaySlots[day].length < 1) {
					return;
				}
				
				this.booking.slot = {
					id: null,
					store_id: null
				};

				this.selectedDay = this.selectedDay == day ? null : day;
				

				if(this.booking.delivery_type === "courier_collection"){
					var courierSlot;
					for(var i=0; i < this.slots.length; i++){
						if(this.slots[i].day == this.selectedDay){
							courierSlot = this.slots[i];
						}
					}
					this.selectSlot(courierSlot);
				}

				if ($(window).width() < 1200 && $(window).width() > 480) {
					scrollToMobile('.slots');
				}

				if ($(window).width() < 480) {
					scrollToMobile('.mobile-slots');
				}
			},
			confirmSlot: function () {
				var hasAddonList = Array.isArray(this.hasaddon) ? this.hasaddon : [];
				var hasAddonTwoList = Array.isArray(this.hasaddontwo) ? this.hasaddontwo : [];
				var selectedKey = this.selected ? Object.keys(this.selected)[0] : null;
				var selectedItem = selectedKey ? this.selected[selectedKey] : null;
				var isInsuranceCustomer = !!(selectedItem && selectedItem.product && selectedItem.product.insurance_customer == 'Yes');
				var nextStage = 4;

				if((hasAddonList.length === 0 && hasAddonTwoList.length === 0) || this.booking.delivery_type != 'store_visit' || isInsuranceCustomer){
					nextStage = 5;
					this.booking.stage = 5; 
					// console.log("GA4 Test - new-timetable: New_Selected_Store");
					// gtag('event', 'New_Selected_Store', {
					// 	'app_name': 'BookingFunnel',
					// 	'screen_name': 'Walk-in service'
					// });
				} else {
					nextStage = 4;
					this.booking.stage = 4;
					// console.log("GA4 Test - new-timetable: New_Selected_Date_and_Time");
					// gtag('event', 'New_Selected_Date_and_Time', {
					// 	'app_name': 'BookingFunnel',
					// 	'screen_name': 'Choose the date & time of your repair'
					// });
				}

				var currentPath = window.location.pathname || '';
				if (currentPath.indexOf('/pages/device-funnel-stage-3') === 0) {
					var params = new URLSearchParams(window.location.search || '');
					var sourceCollection = params.get('source_collection') || sessionStorage.getItem('jv_source_collection') || (window.collection && window.collection.handle ? window.collection.handle : '');
					try {
						sessionStorage.setItem('jv_selected', JSON.stringify(this.selected || {}));
						sessionStorage.setItem('jv_selectedrear', JSON.stringify(this.selectedrear || {}));
						sessionStorage.setItem('jv_selected_store', JSON.stringify(wrapSelectedStorePayload(this.store || null)));
						sessionStorage.setItem('jv_booking_snapshot', JSON.stringify({
							email: this.booking.email || null,
							zip: this.booking.zip || null,
							delivery_type: this.booking.delivery_type || 'store_visit',
							slot: this.booking.slot || null
						}));
					} catch (e) {}
					sessionStorage.setItem('stage', String(nextStage));
					var nextUrl = '/pages/device-funnel-stage-' + nextStage;
					if (sourceCollection) {
						sessionStorage.setItem('jv_source_collection', sourceCollection);
						nextUrl += '?source_collection=' + encodeURIComponent(sourceCollection);
					}
					navigateWithFunnelLoader(nextUrl);
					return;
				}
				
				ga('send', 'pageview', '?select-your-store/time/contact-details');
				//$(".repair--delivery-popup").animate({ scrollTop: 0 }, { duration: 'medium', easing: 'swing' });
				App.funnelEvent({
					'action': 'booking_funnel::selected_timeslot',
					'email': this.booking.email
				});
			},
			makeNoStockBooking: function (e) {
				e.target.disabled = true;
				this.errors = [];
				var nostockbooking = [];
				
				if (!this.booking.first_name) {
					this.errors.push("First Name is required");
					this.booking.errors.first_name = "First Name is required";
				}
				if (!this.booking.last_name) {
					this.errors.push("Last Name is required");
					this.booking.errors.last_name = "Last Name is required";
				}
				if (!REGEX_EMAIL.test(this.booking.email)) {
					this.errors.push("An email address is required");
					this.booking.errors.email = "An email address is required";
				}
				if (!this.normalized_phone) {
					this.errors.push("A phone number is required");
					this.booking.errors.phone = "A phone number is required";
				} else if (!REGEX_PHONE.test(this.normalized_phone)) {
					this.errors.push("Please enter a valid phone number");
					this.booking.errors.phone = "Please enter a valid phone number";
				}
				if (!this.booking.insurance.is_insurance) {
					if (!this.booking.terms_accepted) {
						this.errors.push("Please read and accept the terms and conditions");
						this.booking.errors.terms_accepted = "Please read and accept the terms and conditions";
					}
				}

				if (this.errors.length > 0) {
					e.target.disabled = false;
					return;
				}
				if(Object.keys(this.selected).length === 0){
					var selected_repair = this.selected[Object.keys(this.selectedrear)[0]].variant.name;
				} else {
					var selected_repair = this.selected[Object.keys(this.selected)[0]].variant.name;
				}
				var json = {
					"first_name": this.booking.first_name,
					"last_name": this.booking.last_name,
					"email": this.booking.email,
					"phone": this.booking.phone,
					"notes": this.booking.notes,
					"store": this.store.name,
					"terms_accepted": this.booking.terms_accepted,
					"selected_repair": selected_repair,
					"optin": this.booking.optin
				}

				this.$http.post(App.config.api.filemaker + '/booking/out-of-stock', json).then(function (data) {
					ga("send", "pageview", "?booking-confirmed/out-of-stock");
					window.location.href = "/pages/device-enquiry-thank-you";
				}, function (data) {
					console.error(data);
					e.target.disabled = false;
				});
			}
		},
		watch: {
			store: function () {
				this.booking.slot = {
					id: null,
					store_id: null
				};
				this.selectedDay = null;
				this.renderStoreSlots();
			}
		}
	});


	// Add-ons	
	Vue.component('add-ons', {
		template: '#add-ons',
		props: ['theproducts', 'addonstwo', 'booking', 'selected'],
		computed: {
			selectedProduct: function () {
				if (!this.selected[Object.keys(this.selected)[0]]) {
					return 0;
				} else {
					let battery = this.selected[Object.keys(this.selected)[0]].product.title;
					let result = battery.includes("Battery");
					if(result){
						return 1;
					} else {
						return 0;
					}
				}
				//return this.selected[Object.keys(this.selected)[0]].product;
			}
		},
		data: function () {
			return {
				errors: null,
				products: []
			};
		},
		methods: {
			addItemToSales: function (variantId, sku, price, name, vend, discount) {
				var thisbutton = document.getElementById("addbutton"+variantId);
				if(thisbutton.classList.contains('active')){
					
					document.getElementById("addbuttoncon"+variantId).classList.remove("active");
					document.getElementById("addbutton"+variantId).innerHTML = 'Add';
					document.getElementById("addbutton"+variantId).classList.remove("active");
					if(this.booking.addon.addonone == variantId){
						this.booking.addon.addonone = null; 
						this.booking.addon.addononesku = null;
						this.booking.addon.addononeprice = null;
						this.booking.addon.addononename = null;
						this.booking.addon.addononevend = null;
						this.booking.addon.addononediscount = null;
					}
					if(this.booking.addon.addontwo == variantId){
						this.booking.addon.addontwo = null; 
						this.booking.addon.addontwosku = null;
						this.booking.addon.addontwoprice = null;
						this.booking.addon.addontwoname = null;
						this.booking.addon.addontwovend = null;
						this.booking.addon.addontwodiscount = null;
					}
				} else {
					document.getElementById("addbuttoncon"+variantId).classList.add("active");
					document.getElementById("addbutton"+variantId).innerHTML = 'Added';
					document.getElementById("addbutton"+variantId).classList.add("active");
					if(this.booking.addon.addonone == null) {
						this.booking.addon.addonone = variantId; 
						this.booking.addon.addononesku = sku;
						this.booking.addon.addononeprice = price;
						this.booking.addon.addononename = name;
						this.booking.addon.addononevend = vend;
						this.booking.addon.addononediscount = discount;
					} else {
						this.booking.addon.addontwo = variantId;
						this.booking.addon.addontwosku = sku;
						this.booking.addon.addontwoprice = price;
						this.booking.addon.addontwoname = name;
						this.booking.addon.addontwovend = vend;
						this.booking.addon.addontwodiscount = discount;
					}
				}				
				//console.log("addon "+variantId+" "+sku+" "+price+" "+name);
			},
			continueToBooking: function () {
				this.booking.stage = 5;
				var currentPath = window.location.pathname || '';
				if (currentPath.indexOf('/pages/device-funnel-stage-4') === 0) {
					var params = new URLSearchParams(window.location.search || '');
					var sourceCollection = params.get('source_collection') || sessionStorage.getItem('jv_source_collection') || (window.collection && window.collection.handle ? window.collection.handle : '');
					try {
						sessionStorage.setItem('jv_selected', JSON.stringify(this.$root.selected || {}));
						sessionStorage.setItem('jv_selectedrear', JSON.stringify(this.$root.selectedrear || {}));
						sessionStorage.setItem('jv_selected_store', JSON.stringify(wrapSelectedStorePayload(this.$root.selectedStore && this.$root.selectedStore.store ? this.$root.selectedStore.store : null)));
						sessionStorage.setItem('jv_booking_snapshot', JSON.stringify({
							email: (this.booking && this.booking.email) || null,
							zip: (this.booking && this.booking.zip) || null,
							delivery_type: (this.booking && this.booking.delivery_type) || 'store_visit',
							slot: (this.booking && this.booking.slot) || null
						}));
					} catch (e) {}
					sessionStorage.setItem('stage', '5');
					var nextUrl = '/pages/device-funnel-stage-5';
					if (sourceCollection) {
						sessionStorage.setItem('jv_source_collection', sourceCollection);
						nextUrl += '?source_collection=' + encodeURIComponent(sourceCollection);
					}
					navigateWithFunnelLoader(nextUrl);
					return;
				}

				$(".repair--delivery-popup").animate({ scrollTop: 0 }, { duration: 'medium', easing: 'swing' });
					
				console.log("GA4 Test - add-ons: New_Booking_Add_on_Page");
				gtag('event', 'New_Booking_Add_on_Page', {
					'app_name': 'BookingFunnel',
					'screen_name': 'Booking Add-on'
				});
			}
		}
	});

	//Booking Form
	Vue.component('new-booking-continue', {
		template: '#new-booking-continue',
		props: ['booking', 'collection', 'selected', 'selectedrear', 'store','showExtraFields'],
		data: function () {
			return {
				err: 0,
				business_err: 0,
				isinsurance: this.$isinsurance,
				insuranceref: this.$insuranceref,
				insurer: this.$insurer
			};
		},
		mounted:function(){	
			if(this.booking.insurance.is_insurance){
				this.validateInsurance();
			}			
			if (sessionStorage.getItem("samsung")) {
				$('#device_imei').show();
			}
		},
		computed: {
			selectedProduct: function () {
				if(Object.keys(this.selected).length === 0){
					var selectedProduct = this.selectedrear[Object.keys(this.selectedrear)[0]];
				} else {
					var selectedProduct = this.selected[Object.keys(this.selected)[0]];
				}
				if (!selectedProduct || !selectedProduct.product) {
					return createEmptySelectedProduct();
				}
				return selectedProduct.product;
			},
			normalized_zip: function () {
				if (!this.booking.zip) {
					return null;
				}
				return this.booking.zip.replace(/\s/g, '').toUpperCase();
			},
			normalized_phone: function () {
				if (!this.booking.phone) {
					return null;
				}
				return this.booking.phone.replace(/\s/g, '');
			}
		},
		methods: {			
			openModal: function(thisModal){
				//console.log("openModal clicked "+thisModal);
				var modal = document.getElementById(thisModal);
				modal.style.display = "block";
			},
			closeModal: function(thisModal){
				
				var modal = document.getElementById(thisModal);
				modal.style.display = "none";
			},
			addSelectedToCart: function (callback) {
				this.post_in_errors = [];

				if (typeof (callback) === 'undefined') {
					callback = null;
				}
				if (this.post_in_errors.length > 0) {
					return;
				}

				var itemsToAdd = {};
				for (var i = 0; i < Object.keys(this.selected).length; i++) {
					itemsToAdd[this.selected[Object.keys(this.selected)[i]].variant.id] = 1;
				}
				for (var i = 0; i < Object.keys(this.selectedrear).length; i++) {
					itemsToAdd[this.selectedrear[Object.keys(this.selectedrear)[i]].variant.id] = 1;
				}

				this.$http.post('/cart/update.js', {
					updates: itemsToAdd
				}).then(function (data) {
					//window.location.href = "/cart?dp=" + this.booking.device_passcode + "&ta=" + this.booking.post_in_terms_accepted;

					this.booking.slot = {
						id: null,
						store_id: null
					}
					this.selectedStore.store = JSON.parse('{"address": "111 Power Road, , London, , W45PY","contact_email": "centralworkshop@ismash.com","contact_phone": "02076571186","googleID": "ChIJC5wtUnUOdkgRm1QqxHMtrw8","id": "a0369f1f-9082-11e4-ee62-b82846eaf49c","in_london": 1,"in_stock": "post_in","isStore": 1,"latitude": 51.489219800000000759609974920749664306640625,"longitude": -0.1640771000000000034990677022506133653223514556884765625,"mon_fri": "08:00-20:00","name": "Central Workshop","sat": "10:00-19:00","sun": "10:00-18:00","yelpID": "DrsDVXUsMq7RjdB78Bm2vw"}');

					this.booking.stage = 3;
					if (callback) {
						callback();
					}
				}, function (data) {
					console.error(data);
				});
			},
			addItemToCart: function (variantId) {
				var itemsToAdd = {};
				itemsToAdd[variantId] = 1;
				
				//if the product selected is premium 
				if(this.$root.booking.is_premium){
					itemsToAdd[this.$root.premium_service_product.id] = 1;
				}

				this.$http.post('/cart/update.js', {
					updates: itemsToAdd
				}).then(function (data) {
					
				}, function (data) {
					console.error(data);
				});
			},
			makeBooking: function (e) {
				var businessidentifier = 0;
				var businessauth = 0;
				var button = document.getElementById('confirmbookingbutton');
				button.innerHTML = 'Processing, please wait';
				e.target.disabled = true;
				$("#sky_booking_type").hide();
				$("#sky_booking_type_old").hide();

				var booking = this.booking;
				this.err = 0;
				this.booking.errors.first_name = null;
				this.booking.errors.last_name = null;
				this.booking.errors.email = null;
				this.booking.errors.phone = null;
				this.booking.errors.zip = null;
				this.booking.errors.device_passcode = null;
				this.booking.errors.marketing = null;
				this.booking.errors.tvmarketing = null;
				this.booking.errors.terms_accepted = null;
				this.booking.errors.device_imei = null;
				this.booking.errors.sky_booking_type = null;


				if (this.booking.skyemployee == true && !this.booking.sky_type) {
					$("#sky_booking_type").show();
					$("#sky_booking_type_old").show();
					this.err++;
					this.booking.errors.sky_booking_type = "Ths option is required";
				} 

				if (this.selected.length < 1 && this.selectedrear.length < 1) {
					//console.log("Error - No Repair");
					this.err++;
					this.errors.push("You must have atleast one item selected");
				}
				if (!this.booking.first_name) {
					//console.log("Error - No Firstname");
					this.err++;
					this.booking.errors.first_name = "First Name is required";
				}
				if (!this.booking.last_name) {
					//console.log("Error - No Lastname");
					this.err++;
					this.booking.errors.last_name = "Last Name is required";
				}
				if (!REGEX_EMAIL.test(this.booking.email)) {
					//console.log("Error - No Email");
					this.err++;
					this.booking.errors.email = "An email address is required";
				}
				if (!this.normalized_phone) {
					//console.log("Error - No Phone NUmber");
					this.err++;
					this.booking.errors.phone = "A phone number is required";
				} else if (!REGEX_PHONE.test(this.normalized_phone)) {
					//console.log("Error - No Valid Phone Number");
					this.err++;
					this.booking.errors.phone = "Please enter a valid phone number";
				}
				if(sessionStorage.getItem("samsung")){
					if (!this.booking.imei) {
						this.err++;
						this.booking.errors.device_imei = "An IMEI number is required";

					} else if (!REGEX_IMEI.test(this.booking.imei)){
						this.err++;
						this.booking.errors.device_imei = "Please enter a valid IMEI number";
					}
				}
								
				if (!this.booking.insurance.is_insurance && !this.booking.skyjourney) {
					if (!this.booking.terms_accepted) {
						//console.log("Insurnance Booking - T&C's");
						this.err++;
						this.booking.errors.terms_accepted = "Please read and accept the terms and conditions";
					}
				}

				if (this.booking.delivery_type == 'courier_collection') {
					if (!this.booking.addressLine1) {
						this.err++;
						this.booking.errors.addressLine1 = "Address Line 1 is required";
					}
					if (!this.booking.addressCity) {
						this.err++;
						this.booking.errors.addressCity = "City/Town is required";
					}
					if (!this.booking.addressCounty) {
						this.err++;
						this.booking.errors.addressCounty = "County is required";
					}
					if (!this.booking.addressPostCode) {
						this.err++;
						this.booking.errors.addressPostCode = "Postcode is required";
					}

					if (!this.booking.device_passcode) {
						this.err++;
						this.booking.errors.device_passcode = "Device passcode is required";
					}

				}

				if (this.booking.delivery_type == 'post_in') {

					if (!this.booking.device_passcode) {
						this.err++;
						this.booking.errors.device_passcode = "Device passcode is required";
					}

				}


				//Business Booking Validation
				if (this.booking.pricing_type) {
					var business = {
						"identifier": this.booking.business.identifier,
						"authorisation_code": this.booking.business.authorisation_code,
					}
					if (!this.booking.business.identifier) {
						this.err++;
						this.booking.messages.business_identifier = null;
						this.booking.errors.business_identifier = "Please enter your business identifier";
					} else if (this.booking.business.identifier.length < 6) {
						this.err++;
						this.booking.messages.business_identifier = null;
						this.booking.errors.business_identifier = "Please check your business identifier";
					} else {
						this.$http.post(App.config.api.filemaker + '/business/identify', business).then(function (data) {
							if (data.body['status'] == 'success') {
								this.booking.business.id_company = data.body['id'];
								this.booking.errors.business_identifier = null;
							} else {
								this.booking.messages.business_identifier = null;
								this.booking.errors.business_identifier = "Company ID not found - please try again";
							}
						}, function (data) {
							this.booking.errors.business_identifier = "Something went wrong. Please refresh the page and try again";
							console.error(data);
						});
					}

					if (!this.booking.business.business_type) {
						this.err++;
						this.booking.errors.business_type = "Please select your payment type";
					}

					if (this.booking.business.business_type == 'On Account') {
						//console.log("test on account");
						if (!this.booking.business.authorisation_code) {
							this.err++;
							this.booking.messages.business_authorisation = null;
							this.booking.errors.business_authorisation = "Please enter your authorisation code";
						} else {
							this.$http.post(App.config.api.filemaker + '/business/authorise', business).then(function (data) {
								if (data.body['status'] == 'success') {
									this.booking.errors.business_authorisation = null;
								} else {
									this.booking.messages.business_authorisation = null;
									this.booking.errors.business_authorisation = "Authorisation failed, please try again";
								}
							}, function (data) {
								this.booking.errors.business_authorisation = "Something went wrong. Please refresh the page and try again";
								console.error(data);
							});
						}

					}
				}

				if (this.booking.insurance.is_insurance && !this.booking.pixelcare) {
					if (!this.booking.insurance.validated) {
						this.err++;
						//console.log("Insurnance Booking - Not Validated");
						//this.booking.errors.insurance_reference = 'Please check and retry or contact operations@ismash.com';
						//this.booking.errors.insurance_reference = 'Please check and retry or contact your insurer';
						if(this.booking.skyjourney){
							this.booking.errors.insurance_reference = 'This voucher number was not found, please contact customerservice@ismash.com';
						} else {
							this.booking.errors.insurance_reference = 'Please check and retry or contact your insurer';
						}
					} else {
						this.booking.errors.insurance_reference = null;
					}
				} else if (this.booking.pixelcare) {
					
				} else {
					this.booking.insurance.reference = '';
				}

				if (this.err > 0 || this.business_err > 0) {
					//console.log("Error with Insurnance Booking");
					button.innerHTML = 'Confirm Appointment';
					e.target.disabled = false;
					return;
				}


				
				var date = new Date(this.booking.slot.bookingdate);

				if(this.booking.delivery_type == 'post_in'){
					const today = new Date();
					date = new Date(today);
					date.setDate(date.getDate() + 1);
					this.booking.slot.start_hour = 7;
					this.booking.slot.start_min = '00';

					if (!this.booking.device_passcode) {
						this.err++;
						this.booking.errors.device_passcode = "Device passcode is required";
					}

				}

				var formatted_start_min = ('0' + this.booking.slot.start_min).slice(-2);

				var booking_datetime = moment(date).format("dddd[,] Do MMMM [at]")+" "+this.booking.slot.start_hour+":"+formatted_start_min+",";
				var fm_booking_date = moment(date).format("L");
				//console.log(fm_booking_date);

				if (!this.booking.appointmentDuration){
					this.booking.appointmentDuration = 30;
				}
				var end = moment(this.booking.slot.start_hour + ':' + this.booking.slot.start_min, 'HH:mm').add(this.booking.appointmentDuration, 'minutes').format('HH:mm');
				////console.log("appointmentDuration "+this.booking.appointmentDuration);
				//console.log("start "+this.booking.slot.start_hour + ':' + this.booking.slot.start_min);
				//console.log("end "+end);
				if(Object.keys(this.selected).length === 0){
					//var prodSKU = this.selected[Object.keys(this.selectedrear)[0]].variant.sku;	
				} else {
					var prodSKU = this.selected[Object.keys(this.selected)[0]].variant.sku;	
				}			
				if(Object.keys(this.selectedrear).length === 0){
					var prodSKUTwo = '';
				} else {
					var prodSKUTwo = this.selectedrear[Object.keys(this.selectedrear)[0]].variant.sku;
				}

				if (prodSKU == '' || prodSKU == null) {
					prodSKU = 'SKUNOTFOUND';
				}

				if (this.booking.business_customer){
					this.booking.customer_type = 'Business';
				}
				if (this.booking.student_customer){
					this.booking.customer_type = 'Student';
				}
				if(this.booking.optinFileMakerNewFunnel){
					var optinVal = "Yes";
				} else {
					var optinVal = "No";
				}
				
				
				App.funnelEvent({
					'action': 'booking_funnel::booking_confirmed',
					'email': this.booking.email,
				});

				var self = this;

				$.get("/collections/" + collection.handle + "?view=json", function (data) {
					var metafields = JSON.parse(data);
					var manufacturer = metafields.manufacturer;
					var model = metafields.model;
					var type = metafields.type;
					if(self.selected[Object.keys(self.selected)[0]]){
						var deviceSKU = self.selected[Object.keys(self.selected)[0]].product.deviceSKU;
						var modelCode = self.selected[Object.keys(self.selected)[0]].product.modelCode;
					} else {
						var deviceSKU = self.selectedrear[Object.keys(self.selectedrear)[0]].product.deviceSKU;
						var modelCode = self.selectedrear[Object.keys(self.selectedrear)[0]].product.modelCode;
					}
					//console.log("modelCode "+modelCode);
					if(!model){
						var thismodel = self.selected[Object.keys(self.selected)[0]].variant.name.split("Battery");
						model = thismodel[0];
					}

					var thankyou_data = {
						"customer": {
							"first_name": self.booking.first_name,
							"last_name": self.booking.last_name,
							"email": self.booking.email,
							"phone": self.booking.phone,
							"postcode": self.booking.zip
						},
						"store": {
							"id": self.store.id,
							"name": self.store.name,
							"address": self.store.address
						},
						"slot": {
							"start_hour": self.booking.slot.start_hour,
							"start_min": formatted_start_min,
							"start": self.booking.slot.start_hour + ':' + self.booking.slot.start_min,
							"end": end
						},
						"device": {
							"brand": manufacturer,
							"model": model,
							"type": type,
							"imei": "",
							"passcode":self.booking.device_passcode
						},
						"isinsurance": self.booking.isinsurance,
						"booking_datetime": booking_datetime
					}

					if(self.selected[Object.keys(self.selected)[0]]){
						var thankyou_data_one = {
								"required_repair": self.selected[Object.keys(self.selected)[0]].variant.name,
								"sku": prodSKU,
								"stock_status": self.store.in_stock,
								"cost": self.selected[Object.keys(self.selected)[0]].variant.price,
								"discountamount": self.booking.discountamount,
								"featured_image": self.booking.discountamount,
								"repair_page": window.location.href
						}
					} else {
						var thankyou_data_one = {
								"required_repair": null,
								"sku": null,
								"stock_status": null,
								"cost": null,
								"discountamount": null,
								"featured_image": null,
								"repair_page": null
						}
					}
					thankyou_data['repair'] = thankyou_data_one;

					if(self.selectedrear[Object.keys(self.selectedrear)[0]]){
						var thankyou_data_two = {
								"required_repair": self.selectedrear[Object.keys(self.selectedrear)[0]].variant.name,
								"sku": prodSKUTwo,
								"stock_status": self.store.in_stock,
								"cost": self.selectedrear[Object.keys(self.selectedrear)[0]].variant.price
						}
					} else {
						var thankyou_data_two = {
								"required_repair": null,
								"sku": null,
								"stock_status": null,
								"cost": null
						}
					}
					thankyou_data['repairtwo'] = thankyou_data_two;

					if(!self.selected[Object.keys(self.selected)[0]]){
						thankyou_data_one = {
								"required_repair": self.selectedrear[Object.keys(self.selectedrear)[0]].variant.name,
								"sku": prodSKU,
								"stock_status": self.store.in_stock,
								"cost": self.selectedrear[Object.keys(self.selectedrear)[0]].variant.price,
								"discountamount": self.booking.discountamount,
								"featured_image": self.booking.discountamount,
								"repair_page": window.location.href
						}
						thankyou_data['repair'] = thankyou_data_one;
						
						var thankyou_data_two = {
								"required_repair": null,
								"sku": null,
								"stock_status": null,
								"cost": null
						}
						thankyou_data['repairtwo'] = thankyou_data_two;
					}

					//add macbook fields if needed
					if(self.booking.model_name)
						thankyou_data['model_name'] = self.booking.model_name

					if(self.booking.serial_number)
						thankyou_data['serial_number'] = self.booking.serial_number

					if(self.booking.is_premium){
						thankyou_data.repair['is_premium'] = true;
						thankyou_data.repair['premium_cost'] = self.booking.premium_cost;
					}

					var reschedule_data = {
						"customer": {
							"first_name": self.booking.first_name,
							"last_name": self.booking.last_name,
							"email": self.booking.email,
							"phone": self.booking.phone,
							"postcode": self.booking.zip
						},
						"device": {
							"brand": manufacturer,
							"model": model,
							"type": type,
							"deviceSKU": deviceSKU || null,
							"modelCode": modelCode || null,
							"device_network": self.booking.device_network || null
						},
						"branch": {
							"name": self.store.name,
							"email":  self.store.contact_email,
							"id": self.store.id || null,
							"phone": self.store.contact_phone || null,
							"address": self.store.address || null
						},
						"insurance": {
							"reference": self.booking.insurance.reference,
							"vend_id": self.booking.insurance.vend_id
						},
						"booking_datetime": {
							"appt_date": booking_datetime
						},
						"source_collection": (collection && collection.handle) ? collection.handle : null
					}

					var buildRescheduleRepairData = function (selection, sku) {
						var selectedItem = selection || null;
						var selectedVariant = selectedItem && selectedItem.variant ? selectedItem.variant : null;
						var selectedProduct = selectedItem && selectedItem.product ? selectedItem.product : null;
						return {
							"required_repair": selectedVariant && selectedVariant.name ? selectedVariant.name : null,
							"sku": sku || null,
							"variant_id": selectedVariant && selectedVariant.id ? selectedVariant.id : null,
							"variant_title": selectedVariant && selectedVariant.title ? selectedVariant.title : null,
							"cost": selectedVariant && selectedVariant.price ? selectedVariant.price : null,
							"discountamount": self.booking.discountamount || null,
							"product_id": selectedProduct && selectedProduct.id ? selectedProduct.id : null,
							"product_title": selectedProduct && selectedProduct.title ? selectedProduct.title : null,
							"product_handle": selectedProduct && selectedProduct.handle ? selectedProduct.handle : null,
							"vendor": selectedProduct && selectedProduct.vendor ? selectedProduct.vendor : null,
							"deviceSKU": selectedProduct && selectedProduct.deviceSKU ? selectedProduct.deviceSKU : null,
							"modelCode": selectedProduct && selectedProduct.modelCode ? selectedProduct.modelCode : null
						};
					};

					if(self.selected[Object.keys(self.selected)[0]]){
						var reschedule_data_one = buildRescheduleRepairData(self.selected[Object.keys(self.selected)[0]], prodSKU);
					} else {
						var reschedule_data_one = buildRescheduleRepairData(null, null);
					}
					reschedule_data['repair'] = reschedule_data_one;
					if(self.selectedrear[Object.keys(self.selectedrear)[0]]){
						var reschedule_data_two = buildRescheduleRepairData(self.selectedrear[Object.keys(self.selectedrear)[0]], prodSKUTwo);
					} else {
						var reschedule_data_two = buildRescheduleRepairData(null, null);

					}
					reschedule_data['repairtwo'] = reschedule_data_two;
					
					if(!self.selected[Object.keys(self.selected)[0]]){
						reschedule_data_one = buildRescheduleRepairData(self.selectedrear[Object.keys(self.selectedrear)[0]], prodSKUTwo);
						reschedule_data['repair'] = reschedule_data_one;
						
						var reschedule_data_two = buildRescheduleRepairData(null, null);
						reschedule_data['repairtwo'] = reschedule_data_two;
					}

					var holdingref = Date.now();
					if(sessionStorage.getItem("samsung")){
						self.booking.bookingnotes = self.booking.bookingnotes+" - Samsung Reference: "+sessionStorage.getItem("samsung");
						var partnerref = sessionStorage.getItem("samsung");
						var partner = "Samsung";
					} else {
						var partner = "";
						var partnerref = "";
					}

					if(self.booking.skyemployee==true){
						if(self.booking.sky_type=='Corporate'){
							self.booking.bookingnotes = self.booking.bookingnotes+" - The customer has selected this repair as a corporate device, please transact in Vend/Lightspeed as 'On Account' ";
						} else {
							self.booking.bookingnotes = self.booking.bookingnotes+" - The customer has selected that this repair is a personal device, the customer must pay for this repair themselves instead of 'On Account' ";
						}
					}

					var tracking = window.iSmashTracking ? window.iSmashTracking.getBookingTracking() : {
						Traffic: null, Source: null, UTMMedium: null, UTMCampaign: null,
						UTMContent: null, UTMTerm: null, Brand: null,
						ConsentProvider: "unavailable", ConsentStatus: "unavailable",
						TrackingStatus: "unavailable"
					};

					var booking_data = {
						"customer": {
							"first_name": self.booking.first_name,
							"last_name": self.booking.last_name,
							"email": self.booking.email,
							"phone": self.booking.phone,
							"address1": self.booking.address1,
							"postcode": self.booking.zip,
							"addressLine1": self.booking.addressLine1,
							"addressLine2": self.booking.addressLine2,
							"addressCity": self.booking.addressCity,
							"addressCounty": self.booking.addressCounty,
							"addressPostCode": self.booking.addressPostCode,
							"pickUpCost": self.booking.courier.pickupcost,
							"pricing_type": self.booking.pricing_type,
							"business": {
								"business_type": self.booking.business.business_type,
								"authorisation_code": self.booking.business.authorisation_code,
								"id_company": self.booking.business.id_company,
								"po_number": self.booking.business.po_number,
								"name": self.booking.business.name
							},
							"optin": optinVal,
							"customer_type": self.booking.customer_type
						},
						"store": {
							"id": self.store.id,
							"name": self.store.name,
							"phone": self.store.contact_phone,
							"email": self.store.contact_email,
							"address": self.store.address
						},
						"slot": {
							"start_hour": self.booking.slot.start_hour,
							"start_min": self.booking.slot.start_min,
							"start": self.booking.slot.start_hour + ':' + self.booking.slot.start_min,
							"end": end,
							"appointmentDuration": self.booking.appointmentDuration
						},
						"device": {
							"brand": manufacturer,
							"model": model,
							"type": type,
							"imei": self.booking.imei,
							"passcode": self.booking.device_passcode,
							"deviceSKU": deviceSKU,
							"modelCode": modelCode,
							"device_network": self.booking.device_network
						},
						"addon": {
							"addonone": self.booking.addon.addononevend,
							"addontwo": self.booking.addon.addontwovend
						},
						"insurance": {
							"reference": self.booking.insurance.reference,
							"vend_id": self.booking.insurance.vend_id
						},
						"bookingnotes": self.booking.bookingnotes,
						"terms_accepted": self.booking.terms_accepted,
						"notes": self.booking.notes,
						"source": self.booking.source,
						"booking_datetime": booking_datetime,
						"filemaker_booking_date": fm_booking_date,
						"insurance_reference_number": self.booking.insurance.reference,
						"tracking": {
							"traffic": tracking.Traffic,
							"source": tracking.Source,
							"utm_medium": tracking.UTMMedium,
							"utm_campaign": tracking.UTMCampaign,
							"utm_content": tracking.UTMContent,
							"utm_term": tracking.UTMTerm,
							"brand": tracking.Brand,
							"consent_provider": tracking.ConsentProvider,
							"consent_status": tracking.ConsentStatus,
							"tracking_status": tracking.TrackingStatus
						},
						"reschedule": encodeURIComponent(JSON.stringify(reschedule_data)),
						"rebook": self.booking.rebook,
						"fmid": self.booking.fmid,
						"job_number": self.booking.job_number,
						"booking_type":self.booking.delivery_type,
						"TVMarketing": self.booking.TVMarketing,
						"holdingref": holdingref,
						"partner": partner,
						"partnerref": partnerref,
					}

					if(self.selected[Object.keys(self.selected)[0]]){
						var booking_data_one = {
							"required_repair": self.selected[Object.keys(self.selected)[0]].variant.name,
							"sku": prodSKU,
							"stock_status": self.store.in_stock,
							"cost": self.selected[Object.keys(self.selected)[0]].variant.price,
							"discountamount": self.booking.discountamount
						}
					} else {
						var booking_data_one = {
							"required_repair": null,
							"sku": null,
							"stock_status": null,
							"cost": null,
							"discountamount": null
						}
					}
					booking_data['repair'] = booking_data_one;
					if(self.selectedrear[Object.keys(self.selectedrear)[0]]){
						var booking_data_two = {	
								"required_repair": self.selectedrear[Object.keys(self.selectedrear)[0]].variant.name,
								"sku": prodSKUTwo,
								"stock_status": self.store.in_stock,
								"cost": self.selectedrear[Object.keys(self.selectedrear)[0]].variant.price,
								"discountamount": self.booking.discountamount
						}
					} else {
						var booking_data_two = {
							"required_repair": null,
							"sku": null,
							"stock_status": null,
							"cost": null,
							"discountamount": null
						}
					}
					booking_data['repairtwo'] = booking_data_two;

					if(!self.selected[Object.keys(self.selected)[0]]){
						var booking_data_one = {
							"required_repair": self.selectedrear[Object.keys(self.selectedrear)[0]].variant.name,
							"sku": prodSKUTwo,
							"stock_status": self.store.in_stock,
							"cost": self.selectedrear[Object.keys(self.selectedrear)[0]].variant.price,
							"discountamount": self.booking.discountamount
						}
						booking_data['repair'] = booking_data_one;
						
						var booking_data_two = {
							"required_repair": null,
							"sku": null,
							"stock_status": null,
							"cost": null,
							"discountamount": null
						}
						booking_data['repairtwo'] = booking_data_two;
					}
					//add macbook fields if needed
					if(self.booking.model_name){
						booking_data['model_name'] = self.booking.model_name
					} else {
						booking_data['model_name'] = null
					}

					if(self.booking.serial_number){
						booking_data['serial_number'] = self.booking.serial_number
					} else {
						booking_data['serial_number'] = null
					}


					if(self.booking.is_premium){
						booking_data.repair['is_premium'] = true;
						booking_data.repair['premium_cost'] = self.booking.premium_cost;
					}

					console.log(booking_data);
					//debugger
					var routeCheck = 0;
					if(self.store.in_stock == 'in_warehouse' && !self.booking.insurance.is_insurance && !partner && self.booking.delivery_type != 'post_in' && self.selected[Object.keys(self.selected)[0]].product.id != '4730745323609' && self.selected[Object.keys(self.selected)[0]].product.id != '7126477701209'){
						// Disable Deposit
						//routeCheck = 1;
						// Booking Deposit Variant ID
						//self.addItemToCart('39290562773081');
					}
					
					//routeCheck = 0;

					//if(self.booking.delivery_type == 'post_in' || self.booking.delivery_type == 'courier_collection'){
					if(self.booking.delivery_type == 'post_in' || routeCheck == 1){
						console.log("GA4 Test - new-booking-continue: New_Mailin_Confirmed_Details ");
						gtag('event', 'New_Mailin_Confirmed_Details', {
							'app_name': 'BookingFunnel',
							'screen_name': 'User sent to cart page'
						});
						//document.cookie = "holdingref="+holdingref;
						if(self.booking.delivery_type == 'post_in'){
							sessionStorage.setItem("prevurl", window.location.href);
						}
						sessionStorage.setItem("hr", holdingref);
						sessionStorage.setItem("ta", self.booking.terms_accepted);
						sessionStorage.setItem("dp", self.booking.device_passcode);
						//console.log(holdingref);
						setTimeout(
      						function () {
							self.$http.post(App.config.api.filemaker + '/holdbooking', booking_data).then(function (data) {
								//console.log(data.body);
		
								ga('send', 'event', 'Booking', 'Confirmed', '');
								//console.log("Redirect to cart - new server");
								window.location.href = "/cart?dp=" + self.booking.device_passcode + "&ta=" + self.booking.terms_accepted + "&hr=" + holdingref;
							}, function (data) {
								console.error(data);
								e.target.disabled = false;
							});
						}, 1000);

					}else{
						console.log("GA4 Test - new-booking-continue: New_Walkin_Confirmed_Details");
						
						gtag('event', 'New_Walkin_Confirmed_Details', {
							'app_name': 'BookingFunnel',
							'screen_name': 'Last step: please confirm your details!'
						});
						self.$http.post(App.config.api.filemaker + '/booking', booking_data).then(function (data) {
							if (window.iSmashTracking && window.iSmashTracking.captureBookingResponse) {
								window.iSmashTracking.captureBookingResponse(data.body);
							}
							//find this
							if(data.body.booking.job_number){
								thankyou_data['job_number'] = data.body.booking.job_number;
							} 
	
							ga('send', 'event', 'Booking', 'Confirmed', '');
							if (this.booking.insurance.is_insurance) {
								//console.log("Redirect to repair-confirmed-insurance");
								window.location.href = "/pages/repair-confirmed-insurance#" + encodeURIComponent(JSON.stringify(thankyou_data));
							}else{
								//console.log("Redirect to repair-confirmed");
								window.location.href = "/pages/repair-confirmed-booking#" + encodeURIComponent(JSON.stringify(thankyou_data));
							}
						}, function (data) {
							console.error(data);
							e.target.disabled = false;
						});

					}
				});
			},
			sendNewBusinessBooking: function (booking_data) {
				//Testing
				//console.log(booking_data);

				this.$http.post(App.config.api.filemaker + '/business/notify', booking_data).then(function (data) {
					//console.log(data.body);
					//window.location.href = "/pages/repair-confirmed#" + encodeURIComponent(JSON.stringify(data.body));
				}, function (data) {
					console.error(data);
					e.target.disabled = false;
				});
			},
			identifyBusiness: function () {
				this.business_err = 0;
				//console.log();
				var business = {
					"identifier": this.booking.business.identifier
				}

				if (this.booking.business.identifier) {
					if (this.booking.business.identifier.length < 2) {
						/* Setup to only trigger event on first character */
						ga('send', 'event', 'Business Booking', 'Business Identifier Box', 'Business Booking Tracking');
					}
					if (this.booking.business.identifier.length > 5) {
						this.$http.post(App.config.api.filemaker + '/business/identify', business).then(function (data) {
							if (data.body['status'] == 'success') {
								this.booking.business.id_company = data.body['id'];
								this.booking.errors.business_identifier = null;
								this.booking.messages.business_identifier = "Business found";
							} else {
								this.business_err++;
								this.booking.messages.business_identifier = null;
								this.booking.errors.business_identifier = "Company ID not found - please try again";
							}
							if (this.booking.business.business_type == 'On Account') {
								this.authoriseAccount();
							}
						}, function (data) {
							this.business_err++;
							this.booking.messages.business_identifier = null;
							this.booking.errors.business_identifier = "Something went wrong. Please refresh the page and try again";
						});
					} else {
						this.business_err++;
						this.booking.messages.business_identifier = null;
					}
				} else {
					this.business_err++;
					this.booking.messages.business_identifier = null;
					this.booking.errors.business_identifier = "Please enter your business identifier";
				}

			},
			authoriseAccount: function (e) {
				//document.querySelector("#confirmbookingbutton").disabled = true;

				this.business_err = 0;
				var business = {
					"identifier": this.booking.business.identifier,
					"authorisation_code": this.booking.business.authorisation_code,
				}

				if (this.booking.business.authorisation_code) {
					if (this.booking.business.authorisation_code.length < 2) {
						/* Setup to only trigger event on first character */
						ga('send', 'event', 'Business Booking', 'Authorisation Code Box', 'Business Booking Tracking');
					}
					if (this.booking.business.authorisation_code.length > 4) {
						this.$http.post(App.config.api.filemaker + '/business/authorise', business).then(function (data) {
							if (data.body['status'] == 'success') {
								this.booking.errors.business_authorisation = null;
								this.booking.messages.business_authorisation = "Authorised";
							} else {
								this.business_err++;
								this.booking.messages.business_authorisation = null;
								this.booking.errors.business_authorisation = "Authorisation failed, please try again";
							}
						}, function (data) {
							this.business_err++;
							this.booking.messages.business_authorisation = null;
							this.booking.errors.business_authorisation = "Something went wrong. Please refresh the page and try again";
							console.error(data);
						});
					} else {
						this.business_err++;
						this.booking.messages.business_authorisation = null;
					}
				} else {
					this.business_err++;
					this.booking.messages.business_authorisation = null;
					this.booking.errors.business_authorisation = "Please enter your authorisation code";
				}

			},
			businessCustomer: function () {
				//console.log('Business Customer clicked');
				ga('send', 'event', 'Business Booking', 'Business Customer Selected', 'Business Booking Tracking');
				if(this.booking.pricing_type == true){
					this.booking.pricing_type = false;
				} else {
					this.booking.pricing_type = true;
				}
			},
			accountExisting: function () {
				//console.log('account existing clicked');
				ga('send', 'event', 'Business Booking', 'Existing Business Box Ticked', 'Business Booking Tracking');
			},
			accountNew: function () {
				//console.log('account new clicked');
				ga('send', 'event', 'Business Booking', 'New Business Box Ticked', 'Business Booking Tracking');
			},
			employeeDiscount: function () {
				//console.log('Employee Discount clicked');
				ga('send', 'event', 'Business Booking', 'Employee Discount Box Ticked', 'Business Booking Tracking');
				this.booking.errors.business_type = null;
			},
			onAccount: function () {
				//console.log('On Account clicked');
				ga('send', 'event', 'Business Booking', 'On Account Box Ticked', 'Business Booking Tracking');
				this.booking.errors.business_type = null;
			},
			validateInsurance: function () {
				if (this.booking.insurance.reference.length > 4) {
					var insurance = {
						"first_name": this.booking.first_name,
						"last_name": this.booking.last_name,
						"reference": this.booking.insurance.reference
					}
					this.$http.post(App.config.api.filemaker + '/insurance/validate', insurance).then(function (data) {
						if (data.body['Error']) {							
							if(this.booking.skyjourney){
								this.booking.errors.insurance_reference = 'This voucher number was not found, please contact customerservice@ismash.com';
							} else {
								this.booking.errors.insurance_reference = data.body['Error'];
							}
							//this.booking.errors.insurance_reference = data.body['Error'];
							this.booking.messages.insurance_reference = null;
							this.booking.insurance.validated = false;
						} else {
							if(this.booking.skyjourney){
								this.booking.messages.insurance_reference = 'Voucher Code is valid';
							} else {
								this.booking.messages.insurance_reference = 'Claim ID is valid';
							}
							

							this.booking.errors.insurance_reference = null;
							this.booking.insurance.vend_id = data.body['id'];
							this.booking.insurance.validated = true;
						}
					}, function (data) {
						this.booking.errors.insurance_reference = "Something went wrong. Please refresh the page and try again";
						console.error(data);
					});
				}
			},
			validateInsuranceCheck: function () {
				if (this.booking.insurance.reference.length > 4) {
					var insurance = {
						"first_name": this.booking.first_name,
						"last_name": this.booking.last_name,
						"reference": this.booking.insurance.reference
					}
					this.$http.post(App.config.api.filemaker + '/insurance/validate', insurance).then(function (data) {
						if (data.body['Error']) {				
							if(this.booking.skyjourney){
								this.booking.errors.insurance_reference = 'This voucher number was not found, please contact customerservice@ismash.com';
							} else {
								this.booking.errors.insurance_reference = data.body['Error'];
							}
							//this.booking.errors.insurance_reference = data.body['Error'];	
							this.booking.messages.insurance_reference = null;
							this.booking.insurance.validated = false;
						} else {
							this.booking.messages.insurance_reference = 'Claim ID is valid';
							this.booking.errors.insurance_reference = null;
							this.booking.insurance.vend_id = data.body['id'];
							this.booking.insurance.validated = true;
						}
					}, function (data) {
						this.booking.errors.insurance_reference = "Something went wrong. Please refresh the page and try again";
						console.error(data);
					});
				}
			},
			insurance: function () {
				//console.log('On Account clicked');
				ga('send', 'event', 'Insurance Booking', 'Insurance Box Clicked', 'Insurance Booking Tracking');
				this.booking.errors.insurance_reference = null;
			}

		}
	});

	Vue.component('new-booking-summary', {
		template: '#new-booking-summary',
		props: ['store', 'bookingDate', 'selected', 'selectedrear', 'booking'],
		computed: {
			selectedProduct: function () {
				var selectedEntry = this.selected[Object.keys(this.selected)[0]];
				if (!selectedEntry || !selectedEntry.product) {
					return createEmptySelectedProduct();
				}
				return selectedEntry.product;
			},
			selectedVariant: function () {
				if (!this.selected[Object.keys(this.selected)[0]]) {
					return null;
				}
				return this.selected[Object.keys(this.selected)[0]].variant;
			},
			productSelected: function () {
				if (!this.selected[Object.keys(this.selected)[0]]) {
					return false;
				}

				if (!this.selected[Object.keys(this.selected)[0]].variant) {
					return false;
				}
				return true;
			},
			selectedRearProduct: function () {
				if (!this.selectedrear[Object.keys(this.selectedrear)[0]]) {
					return null;
				}
				return this.selectedrear[Object.keys(this.selectedrear)[0]].product;
			},
			selectedRearVariant: function () {
				if (!this.selectedrear[Object.keys(this.selectedrear)[0]]) {
					return null;
				}
				return this.selectedrear[Object.keys(this.selectedrear)[0]].variant;
			},
			productRearSelected: function () {
				if (!this.selectedrear[Object.keys(this.selectedrear)[0]]) {
					return false;
				}

				if (!this.selectedrear[Object.keys(this.selectedrear)[0]].variant) {
					return false;
				}
				return true;
			},
			repairTime: function () {
				if (this.selected[Object.keys(this.selected)[0]]) {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days", "Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < this.selectedProduct.tags.length; i++) {
						if (repairTags.indexOf(this.selectedProduct.tags[i]) > -1) {
							return this.selectedProduct.tags[i];
						}
					}
					return "24 - 48 hours";
				}
			},
			repairRearTime: function () {
				if (this.selectedrear[Object.keys(this.selectedrear)[0]]) {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < this.selectedRearProduct.tags.length; i++) {
						if (repairTags.indexOf(this.selectedRearProduct.tags[i]) > -1) {
							return this.selectedRearProduct.tags[i];
						}
					}
					return "24 - 48 hours";
				}
			},
			repaircombinedTime: function () {
				var rearEntry = this.selectedrear[Object.keys(this.selectedrear)[0]];
				if (!rearEntry || !rearEntry.product || !rearEntry.product.title) {
					return null;
				}
				if(rearEntry.product.title.indexOf("Rear Glass") > -1){
					return "3 - 4 hours";
				}
				if(rearEntry.product.title.indexOf("Rear Housing") > -1){
					return "45 - 90 minutes";
				}
			},
		},
		methods: {
			removeaddon: function (variantId) {
					if(this.booking.addon.addonone == variantId){
						this.booking.addon.addonone = null; 
						this.booking.addon.addononesku = null;
						this.booking.addon.addononeprice = null;
						this.booking.addon.addononename = null;
						this.booking.addon.addononevend = null;
						this.booking.addon.addononediscount = null;
					}
					if(this.booking.addon.addontwo == variantId){
						this.booking.addon.addontwo = null; 
						this.booking.addon.addontwosku = null;
						this.booking.addon.addontwoprice = null;
						this.booking.addon.addontwoname = null;
						this.booking.addon.addontwovend = null;
						this.booking.addon.addontwodiscount = null;
					}
			}
		}
	});

	Vue.component('new-booking-form', {
		template: '#new-booking-form',
		props: ['store', 'bookingDate', 'selected', 'selectedrear', 'booking','showExtraFields'],
		mounted:function(){	
			if(this.booking.insurance.is_insurance){
				this.booking.zip = sessionStorage.getItem('postcode');
			}
			if(this.booking.pixelcare){
				this.booking.insurance.reference = 'Google Pixel Care+';
			}		
			if(this.booking.delivery_type == 'post_in'){
				console.log("GA4 Test - new-timetable: New_Mailin_Continued");
				gtag('event', 'New_Mailin_Continued', {
					'app_name': 'BookingFunnel',
					'screen_name': 'Choose the date & time of your repair'
				});
			} else {
				console.log("GA4 Test - new-timetable: New_Selected_Date_and_Time");
				gtag('event', 'New_Selected_Date_and_Time', {
					'app_name': 'BookingFunnel',
					'screen_name': 'Choose the date & time of your repair'
				});
			}
		},
		computed: {
			selectedProduct: function () {
				var selectedEntry = this.selected[Object.keys(this.selected)[0]];
				if (!selectedEntry || !selectedEntry.product) {
					return createEmptySelectedProduct();
				}
				return selectedEntry.product;
			},
			selectedVariant: function () {
				if (!this.selected[Object.keys(this.selected)[0]]) {
					return null;
				}
				return this.selected[Object.keys(this.selected)[0]].variant;
			},
			productSelected: function () {
				if (!this.selected[Object.keys(this.selected)[0]]) {
					return false;
				}

				if (!this.selected[Object.keys(this.selected)[0]].variant) {
					return false;
				}
				return true;
			},
			selectedRearProduct: function () {
				if (!this.selectedrear[Object.keys(this.selectedrear)[0]]) {
					return null;
				}
				return this.selectedrear[Object.keys(this.selectedrear)[0]].product;
			},
			selectedRearVariant: function () {
				if (!this.selectedrear[Object.keys(this.selectedrear)[0]]) {
					return null;
				}
				return this.selectedrear[Object.keys(this.selectedrear)[0]].variant;
			},
			productRearSelected: function () {
				if (!this.selectedrear[Object.keys(this.selectedrear)[0]]) {
					return false;
				}

				if (!this.selectedrear[Object.keys(this.selectedrear)[0]].variant) {
					return false;
				}
				return true;
			},
			repairTime: function () {
				if (this.selected[Object.keys(this.selected)[0]]) {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days", "Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < this.selectedProduct.tags.length; i++) {
						if (repairTags.indexOf(this.selectedProduct.tags[i]) > -1) {
							return this.selectedProduct.tags[i];
						}
					}
					return "24 - 48 hours";
				}
			},
			repairRearTime: function () {
				if (this.selectedrear[Object.keys(this.selectedrear)[0]]) {
					var repairTags = ["30 minutes", "45 minutes", "60 minutes", "90 minutes", "120 minutes", "180 minutes", "210 minutes", "Up to 24 hours", "24 - 48 hours", "up to 7 days","Up to 30 minutes","Up to 45 minutes","Up to 60 minutes","Up to 90 minutes","1 - 2 hours","2 - 4 hours","2 - 6 hours"];
					for (var i = 0; i < this.selectedRearProduct.tags.length; i++) {
						if (repairTags.indexOf(this.selectedRearProduct.tags[i]) > -1) {
							return this.selectedRearProduct.tags[i];
						}
					}
					return "24 - 48 hours";
				}
			},
			repaircombinedTime: function () {
				if(this.selectedrear[Object.keys(this.selectedrear)[0]].product.title.indexOf("Rear Glass") > -1){
					return "3 - 4 hours";
				}
				if(this.selectedrear[Object.keys(this.selectedrear)[0]].product.title.indexOf("Rear Housing") > -1){
					return "45 - 90 minutes";
				}
			}
		},
		methods: {
			
			sendNewBusinessBooking: function (booking_data) {
				//Testing
				//console.log(booking_data);

				this.$http.post(App.config.api.filemaker + '/business/notify', booking_data).then(function (data) {
					//console.log(data.body);
					//window.location.href = "/pages/repair-confirmed#" + encodeURIComponent(JSON.stringify(data.body));
				}, function (data) {
					console.error(data);
					e.target.disabled = false;
				});
			},
			identifyBusiness: function () {
				//document.querySelector("#confirmbookingbutton").disabled = true;
				this.business_err = 0;
				//console.log();
				var business = {
					"identifier": this.booking.business.identifier
				}

				if (this.booking.business.identifier) {
					if (this.booking.business.identifier.length < 2) {
						/* Setup to only trigger event on first character */
						ga('send', 'event', 'Business Booking', 'Business Identifier Box', 'Business Booking Tracking');
					}
					if (this.booking.business.identifier.length > 5) {
						this.$http.post(App.config.api.filemaker + '/business/identify', business).then(function (data) {
							if (data.body['status'] == 'success') {
								this.booking.business.id_company = data.body['id'];
								this.booking.errors.business_identifier = null;
								this.booking.messages.business_identifier = "Business found";
							} else {
								this.business_err++;
								this.booking.messages.business_identifier = null;
								this.booking.errors.business_identifier = "Company ID not found - please try again";
							}
							if (this.booking.business.business_type == 'On Account') {
								this.authoriseAccount();
							}
						}, function (data) {
							this.business_err++;
							this.booking.messages.business_identifier = null;
							this.booking.errors.business_identifier = "Something went wrong. Please refresh the page and try again";
						});
					} else {
						this.business_err++;
						this.booking.messages.business_identifier = null;
					}
				} else {
					this.business_err++;
					this.booking.messages.business_identifier = null;
					this.booking.errors.business_identifier = "Please enter your business identifier";
				}
				// if (err > 0) {
				//     document.querySelector("#confirmbookingbutton").disabled = false;
				//     return;
				// }

			},
			authoriseAccount: function (e) {
				//document.querySelector("#confirmbookingbutton").disabled = true;

				this.business_err = 0;
				var business = {
					"identifier": this.booking.business.identifier,
					"authorisation_code": this.booking.business.authorisation_code,
				}

				if (this.booking.business.authorisation_code) {
					if (this.booking.business.authorisation_code.length < 2) {
						/* Setup to only trigger event on first character */
						ga('send', 'event', 'Business Booking', 'Authorisation Code Box', 'Business Booking Tracking');
					}
					if (this.booking.business.authorisation_code.length > 4) {
						this.$http.post(App.config.api.filemaker + '/business/authorise', business).then(function (data) {
							if (data.body['status'] == 'success') {
								this.booking.errors.business_authorisation = null;
								this.booking.messages.business_authorisation = "Authorised";
								// if(this.booking.business.business_type == 'On Account'){
								//     if(this.booking.business.identified){
								//         document.querySelector("#confirmbookingbutton").disabled = false;
								//     }
								// }
							} else {
								this.business_err++;
								this.booking.messages.business_authorisation = null;
								this.booking.errors.business_authorisation = "Authorisation failed, please try again";
							}
						}, function (data) {
							this.business_err++;
							this.booking.messages.business_authorisation = null;
							this.booking.errors.business_authorisation = "Something went wrong. Please refresh the page and try again";
							console.error(data);
						});
					} else {
						this.business_err++;
						this.booking.messages.business_authorisation = null;
					}
				} else {
					this.business_err++;
					this.booking.messages.business_authorisation = null;
					this.booking.errors.business_authorisation = "Please enter your authorisation code";
				}
				// if (err > 0) {
				//     document.querySelector("#confirmbookingbutton").disabled = false;
				//     return;
				// }

			},
			businessCustomer: function () {
				//console.log('Business Customer clicked');
				ga('send', 'event', 'Business Booking', 'Business Customer Selected', 'Business Booking Tracking');
				if(this.booking.pricing_type == true){
					this.booking.pricing_type = false;
				} else {
					this.booking.pricing_type = true;
				}
			},
			accountExisting: function () {
				//console.log('account existing clicked');
				ga('send', 'event', 'Business Booking', 'Existing Business Box Ticked', 'Business Booking Tracking');
			},
			accountNew: function () {
				//console.log('account new clicked');
				ga('send', 'event', 'Business Booking', 'New Business Box Ticked', 'Business Booking Tracking');
			},
			employeeDiscount: function () {
				//console.log('Employee Discount clicked');
				ga('send', 'event', 'Business Booking', 'Employee Discount Box Ticked', 'Business Booking Tracking');
				this.booking.errors.business_type = null;
			},
			onAccount: function () {
				//console.log('On Account clicked');
				ga('send', 'event', 'Business Booking', 'On Account Box Ticked', 'Business Booking Tracking');
				this.booking.errors.business_type = null;
			},
			validateInsurance: function () {
				if (this.booking.insurance.reference.length > 4) {
					var insurance = {
						"first_name": this.booking.first_name,
						"last_name": this.booking.last_name,
						"reference": this.booking.insurance.reference
					}
					this.$http.post(App.config.api.filemaker + '/insurance/validate', insurance).then(function (data) {
						if (data.body['Error']) {							
							if(this.booking.skyjourney){
								this.booking.errors.insurance_reference = 'This voucher number was not found, please contact customerservice@ismash.com';
							} else {
								this.booking.errors.insurance_reference = data.body['Error'];
							}
							//this.booking.errors.insurance_reference = data.body['Error'];
							this.booking.messages.insurance_reference = null;
							this.booking.insurance.validated = false;
						} else {
							if(this.booking.skyjourney){
								this.booking.messages.insurance_reference = 'Voucher Code is valid';
							} else {
								this.booking.messages.insurance_reference = 'Claim ID is valid';
							}
							

							this.booking.errors.insurance_reference = null;
							this.booking.insurance.vend_id = data.body['id'];
							this.booking.insurance.validated = true;
						}
					}, function (data) {
						this.booking.errors.insurance_reference = "Something went wrong. Please refresh the page and try again";
						console.error(data);
					});
				}
			},
			validateInsuranceCheck: function () { 
				if (this.booking.insurance.reference.length > 4) {
					var insurance = {
						"first_name": this.booking.first_name,
						"last_name": this.booking.last_name,
						"reference": this.booking.insurance.reference
					}
					this.$http.post(App.config.api.filemaker + '/insurance/validate', insurance).then(function (data) {
						if (data.body['Error']) {				
							if(this.booking.skyjourney){
								this.booking.errors.insurance_reference = 'This voucher number was not found, please contact customerservice@ismash.com';
							} else {
								this.booking.errors.insurance_reference = data.body['Error'];
							}
							//this.booking.errors.insurance_reference = data.body['Error'];	
							this.booking.messages.insurance_reference = null;
							this.booking.insurance.validated = false;
						} else {
							this.booking.messages.insurance_reference = 'Claim ID is valid';
							this.booking.errors.insurance_reference = null;
							this.booking.insurance.vend_id = data.body['id'];
							this.booking.insurance.validated = true;
						}
					}, function (data) {
						this.booking.errors.insurance_reference = "Something went wrong. Please refresh the page and try again";
						console.error(data);
					});
				}
			},
			insurance: function () {
				//console.log('On Account clicked');
				ga('send', 'event', 'Insurance Booking', 'Insurance Box Clicked', 'Insurance Booking Tracking');
				this.booking.errors.insurance_reference = null;
			}
		}
	});

	Vue.component('new-store-picker', {
		template: '#new-store-picker',
		props: ['stores', 'selectedStore', 'selected', 'selectedrear', 'booking'],
		data: function () {
			return {
				active: false
			};
		},
		methods: {
			showPicker: function () {
				this.booking.stage = 1;
				// this.$http.get(App.config.api.filemaker + '/api/stores').then(function(data) {
				//     this.stores = data.body;
				// }, function(data) {
				//     console.error(data);
				// });
				// this.active = true;
			},
			hidePicker: function () {
				this.active = false;
			}
		}
	});
	
	Vue.component('new-booking-progress', {
		template: '#new-booking-progress',
		props: ['booking','selected','selectedrear'],
		methods: {			
			changeBookingStage: function (stage) { 
				//console.log("this.booking.stage "+this.booking.stage);
				console.log("stage "+stage);
				var currentPath = window.location.pathname || '';
				var stagePageMatch = currentPath.match(/^\/pages\/device-funnel-stage-(\d+)$/);
				var params = new URLSearchParams(window.location.search || '');
				var sourceCollection = params.get('source_collection') || sessionStorage.getItem('jv_source_collection') || (window.collection && window.collection.handle ? window.collection.handle : '');
				if (sourceCollection) {
					sessionStorage.setItem('jv_source_collection', sourceCollection);
				}
				if (stagePageMatch) {
					var currentStagePage = parseInt(stagePageMatch[1], 10);
					if (!isNaN(currentStagePage) && stage >= 1 && stage < currentStagePage) {
						sessionStorage.setItem('stage', String(stage));
						var previousStageUrl = '/pages/device-funnel-stage-' + stage;
						if (sourceCollection) {
							previousStageUrl += '?source_collection=' + encodeURIComponent(sourceCollection);
						}
						navigateWithFunnelLoader(previousStageUrl);
						return;
					}
					if (!isNaN(currentStagePage) && stage === 1 && currentStagePage === 1 && sourceCollection) {
						navigateWithFunnelLoader('/collections/' + encodeURIComponent(sourceCollection));
						return;
					}
				}
				// Only go back stages, not forward
				if (this.booking.stage < stage) {
					return;
				}
				//disable step 3 for post in
				if(this.booking.stage == 3 && this.booking.delivery_type == 'post_in' && stage == 2){
					return;
				}
				this.booking.stage = stage;
				//console.log("this.booking.stage "+this.booking.stage);
				if (stage === 0) {
					document.querySelector('body').classList.remove("popup-active");
					//document.querySelector('body');
				}
				if (stage === 1) {
					this.booking.delivery_type = null;
				}
				$(".repair--delivery-popup").animate({ scrollTop: 0 }, { duration: 'medium', easing: 'swing' });
				
				// Get the modal
				
				if (document.getElementById("myData") && document.getElementById("myData").style.display == 'block') { 
					var modal = document.getElementById("myData");
					modal.style.display = "none";
				}
				if (document.getElementById("myLiquid") && document.getElementById("myLiquid").style.display == 'block') { 
					var modal = document.getElementById("myLiquid");
					modal.style.display = "none";
				}
				if (document.getElementById("myModal") && document.getElementById("myModal").style.display == 'block') { 
					var modal = document.getElementById("myModal");
					modal.style.display = "none";
				}
				if (document.getElementById("rearModal") && document.getElementById("rearModal").style.display == 'block') { 
					var modal = document.getElementById("rearModal");
					modal.style.display = "none";
				}
				if (document.getElementById("screenModal") && document.getElementById("screenModal").style.display == 'block') { 
					var modal = document.getElementById("screenModal");
					modal.style.display = "none";
				}
					
				const collection = document.getElementsByClassName("part-select-btn");
				for (let i = 0; i < collection.length; i++) {
				collection[i].innerHTML = "Book Repair";
				}
				
				const screenModelbutton = document.getElementsByClassName("screenModelbutton");
				for (let i = 0; i < screenModelbutton.length; i++) {
				screenModelbutton[i].innerHTML = "+ Add repair";
				}
				
				const rearModalbutton = document.getElementsByClassName("rearModalbutton");
				for (let i = 0; i < rearModalbutton.length; i++) {
				rearModalbutton[i].innerHTML = "+ Add repair";
				}	
				
				const continuebutton = document.getElementsByClassName("continuewithoutbutton");
				for (let i = 0; i < continuebutton.length; i++) {
				continuebutton[i].innerHTML = "Continue without";
				}				
				if (stage === 0) {
					var selected = Object.keys(this.selected)[0];
					this.$delete(this.selected, selected);
					var selectedrear = Object.keys(this.selectedrear)[0];
					this.$delete(this.selectedrear, selectedrear);
					this.booking.appointmentDuration = 0;
				}

				if(this.booking.stage === 0) {
					// gtag('event', 'screen_view', {
					// 	'app_name': 'BookingFunnel',
					// 	'screen_name': 'How do you want us to fix your device?'
					// });
				} else if(this.booking.stage === 1) {
					// console.log("GA4 Test - new-booking-progress: New_Submitted_Email ");
					// gtag('event', 'New_Submitted_Email', {
					// 	'app_name': 'BookingFunnel',
					// 	'screen_name': 'How do you want us to fix your device?'
					// });

				} else if(this.booking.stage === 2 && this.booking.delivery_type === 'store_visit') {
					// console.log("GA4 Test - new-booking-progress: New_Selected_Store ");
					// gtag('event', 'New_Selected_Store', {
					// 	'app_name': 'BookingFunnel',
					// 	'screen_name': 'Choose a Service Centre'
					// });

				} else if(this.booking.stage === 2 && this.booking.delivery_type === 'post_in') {
					// console.log("GA4 Test - new-booking-progress: New_Selected_Mailin ");
					// gtag('event', 'New_Selected_Mailin', {
					// 	'app_name': 'BookingFunnel',
					// 	'screen_name': 'Mail-in service'
					// });

				} else if(this.booking.stage === 3) {
					// console.log("GA4 Test - new-booking-progress: New_Selected_Date_and_Time ");
					// gtag('event', 'New_Selected_Date_and_Time', {
					// 	'app_name': 'BookingFunnel',
					// 	'screen_name': 'Choose the date & time of your repair'
					// });

				} else if(this.booking.stage === 4) {
					// console.log("GA4 Test - new-booking-progress: New_Booking_Add_on_Page ");
					// gtag('event', 'New_Booking_Add_on_Page', {
					// 	'app_name': 'BookingFunnel',
					// 	'screen_name': 'Booking Add-on Page'
					// });

				} else if(this.booking.stage === 5) {
					// console.log("GA4 Test - new-booking-progress: New_Walkin_Confirmed_Details ");
					// gtag('event', 'New_Walkin_Confirmed_Details', {
					// 	'app_name': 'BookingFunnel',
					// 	'screen_name': 'Last step: please confirm your details!'
					// });

				}
			},
			backToInsuranceStage: function () {
				//console.log("backToInsuranceStage runs");
				var currentPath = window.location.pathname || '';
				var stagePageMatch = currentPath.match(/^\/pages\/device-funnel-stage-(\d+)$/);
				var params = new URLSearchParams(window.location.search || '');
				var sourceCollection = params.get('source_collection') || sessionStorage.getItem('jv_source_collection') || (window.collection && window.collection.handle ? window.collection.handle : '');
				if (sourceCollection) {
					sessionStorage.setItem('jv_source_collection', sourceCollection);
				}
				if (stagePageMatch) {
					var currentStagePage = parseInt(stagePageMatch[1], 10);
					if (!isNaN(currentStagePage) && currentStagePage > 1) {
						var previousStage = currentStagePage - 1;
						sessionStorage.setItem('stage', String(previousStage));
						var previousStageUrl = '/pages/device-funnel-stage-' + previousStage;
						if (sourceCollection) {
							previousStageUrl += '?source_collection=' + encodeURIComponent(sourceCollection);
						}
						navigateWithFunnelLoader(previousStageUrl);
						return;
					}
				}
				if (this.booking && this.booking.stage === 1) {
					if (sourceCollection) {
						sessionStorage.setItem('jv_source_collection', sourceCollection);
						navigateWithFunnelLoader('/collections/' + encodeURIComponent(sourceCollection));
						return;
					}
				}
				var stage = 0; 

				if (sessionStorage.getItem("insureurl")){
					document.location.assign(sessionStorage.getItem("insureurl"));
				} else {
					if (this.booking.stage < stage) {
						return;
					}
					if (stage === 0) {
						document.querySelector('body').classList.remove("popup-active");
						document.querySelector('body');
					}
					this.booking.stage = stage;
					$(".repair--delivery-popup").animate({ scrollTop: 0 }, { duration: 'medium', easing: 'swing' });
					
					if (document.getElementById("myModal") && document.getElementById("myModal").style.display == 'block') { 
						var modal = document.getElementById("myModal");
						modal.style.display = "none";
					}
					if (document.getElementById("rearModal") && document.getElementById("rearModal").style.display == 'block') { 
						var modal = document.getElementById("rearModal");
						modal.style.display = "none";
					}
					if (document.getElementById("screenModal") && document.getElementById("screenModal").style.display == 'block') { 
						var modal = document.getElementById("screenModal");
						modal.style.display = "none";
					}
					
					const collection = document.getElementsByClassName("part-select-btn");
					for (let i = 0; i < collection.length; i++) {
					collection[i].innerHTML = "Book Repair";
					}
					
					const screenModelbutton = document.getElementsByClassName("screenModelbutton");
					for (let i = 0; i < screenModelbutton.length; i++) {
					screenModelbutton[i].innerHTML = "+ Add repair";
					}
					
					const rearModalbutton = document.getElementsByClassName("rearModalbutton");
					for (let i = 0; i < rearModalbutton.length; i++) {
					rearModalbutton[i].innerHTML = "+ Add repair";
					}	

					const continuebutton = document.getElementsByClassName("continuewithoutbutton");
					for (let i = 0; i < continuebutton.length; i++) {
					continuebutton[i].innerHTML = "Continue without";
					}			
					
					var selected = Object.keys(this.selected)[0];
					this.$delete(this.selected, selected);
					var selectedrear = Object.keys(this.selectedrear)[0];
					this.$delete(this.selectedrear, selectedrear);
					this.booking.appointmentDuration = 0;
				}
			}
		},
		computed: {
			selectedProduct: function () {
				if(Object.keys(this.selected).length === 0){
					var selectedProduct = this.selectedrear[Object.keys(this.selectedrear)[0]];
				} else {
					var selectedProduct = this.selected[Object.keys(this.selected)[0]];
				}
				if (!selectedProduct) {
					return {
						featured_image: '',
						title: ''
					};
				}
				return selectedProduct.product;
			}
		}
	});

	window.repairApp = new Vue({
		el: '#app-repair',
		mounted: function () {
			var currentPath = window.location.pathname || '';
			var isCollectionPage = currentPath.indexOf('/collections/') === 0;
			if (isCollectionPage) {
				this.resetFunnelStateForCollection();
			}

			this.theAddonProduct = window.AddonProduct;
			this.theAddonProductTwo = window.AddonProductTwo;
			this.thefeaturedproduct = window.featuredProducts;
			this.therearglassproducts = window.rearGlassProducts;
			this.theRearProducts = window.theRearProducts;
			this.theOuterProducts = window.OuterProduct;
			this.theapplereplacement = window.rearAppleProducts;
			this.thetableinfo = window.tableinfo
			this.products = window.loadProducts;
			this.collection = window.collection;
			this.courierCollection = window.courierCollection;
			this.theinsuranceproduct = window.featuredInsurance;
			this.theLiquidProduct = window.LiquidProduct;
			this.theCameraProduct = window.CameraProduct;
			this.theChargingProduct = window.ChargingProduct;
			this.theDiagnosticsProduct = window.DiagnosticsProduct;
			this.theOtherProduct = window.OtherProducts;
			this.theBackProduct = window.BackProduct;
			this.theLCDProduct = window.theLCDProduct;
			this.theOLEDProduct = window.theOLEDProduct;
			this.theFrontScreen = window.theFrontScreen;
			this.thePopUpProduct = window.PopUpProduct;
			this.mailin = window.mailin;
			this.visitus = window.visitus;

			var selectedRaw = isCollectionPage ? null : sessionStorage.getItem('jv_selected');
			var selectedRearRaw = isCollectionPage ? null : sessionStorage.getItem('jv_selectedrear');
			var storesListRaw = isCollectionPage ? null : sessionStorage.getItem('jv_stores_list');
			var selectedStoreRaw = isCollectionPage ? null : sessionStorage.getItem('jv_selected_store');
			var bookingSnapshotRaw = isCollectionPage ? null : sessionStorage.getItem('jv_booking_snapshot');

			if (selectedRaw) {
				try {
					this.selected = JSON.parse(selectedRaw) || {};
				} catch (e) {
					this.selected = {};
				}
			}

			if (selectedRearRaw) {
				try {
					this.selectedrear = JSON.parse(selectedRearRaw) || {};
				} catch (e) {
					this.selectedrear = {};
				}
			}

			if (storesListRaw) {
				try {
					var parsedStores = JSON.parse(storesListRaw);
					if (Array.isArray(parsedStores)) {
						this.stores.list = parsedStores;
					} else if (parsedStores && typeof parsedStores === 'object') {
						this.stores.list = Object.values(parsedStores);
					} else {
						this.stores.list = [];
					}
				} catch (e) {
					this.stores.list = [];
				}
			}

			if (selectedStoreRaw) {
				try {
					var parsedSelectedStore = JSON.parse(selectedStoreRaw) || null;
					if (parsedSelectedStore && parsedSelectedStore.store) {
						this.selectedStore = parsedSelectedStore;
					} else {
						this.selectedStore.store = parsedSelectedStore;
					}
				} catch (e) {
					this.selectedStore.store = null;
				}
			}

			if (bookingSnapshotRaw) {
				try {
					var bookingSnapshot = JSON.parse(bookingSnapshotRaw) || {};
					if (!this.booking.delivery_type && bookingSnapshot.delivery_type) {
						this.booking.delivery_type = bookingSnapshot.delivery_type;
					}
					if (!this.booking.email && bookingSnapshot.email) {
						this.booking.email = bookingSnapshot.email;
					}
					if (!this.booking.zip && bookingSnapshot.zip) {
						this.booking.zip = bookingSnapshot.zip;
					}
					if (bookingSnapshot.slot && typeof bookingSnapshot.slot === 'object') {
						if (!this.booking.slot || !this.booking.slot.id) {
							this.booking.slot = Object.assign({}, this.booking.slot || {}, bookingSnapshot.slot);
						}
					}
				} catch (e) {}
			}


      // Keep the chosen MacBook repair duration on subsequent funnel pages.
      if (!isCollectionPage) {
        try {
          var macbookDuration = JSON.parse(sessionStorage.getItem('jv_macbook_repair_duration') || 'null');
          var currentRepair = this.selected[Object.keys(this.selected)[0]];
          if (macbookDuration && this.collection && currentRepair &&
              macbookDuration.collectionHandle === this.collection.handle &&
              macbookDuration.productId === currentRepair.product.id &&
              Number(macbookDuration.duration) > 0) {
            this.booking.appointmentDuration = Number(macbookDuration.duration);
          }
        } catch (error) {}
      }
			if (!isCollectionPage) {
				this.persistFunnelState();
			}
		},
		data: {
			addons: {},
			selected: {},
			selectedrear: {},
			booking: {
				skyemployee: false,
				skyemployeeemailError: false,
				skycodeError: false,
				sky_type: false,
				is_premium:false,
				premium_cost:0,
				first_name: sessionStorage.getItem("first_name"),
				last_name: sessionStorage.getItem("last_name"),
				email: getCookie('useremail'),
				phone: sessionStorage.getItem("tel"),
				notes: null,
				address1: null,
				address2: null,
				city: null,
				province: null,
				country: null,
				zip: sessionStorage.getItem("postcode"),
				addressLine1: null,
				addressLine2: null,
				addressCity: null,
				addressCounty: null,
				addressPostCode: null,
				bookingnotes: sessionStorage.getItem("damage"),
				terms_accepted: false,
				coupon_code: null,
				device_passcode: null,
				device_network: "Not Selected",
				model_name: null,
				serial_number: null,
				imei: null,
				delivery_type: "",
				source: null,
				slot: {
					id: null,
					store_id: null
				},
				confirmed: false,
				confirmation: null,
				callout: null,
				currentDate: moment().format('YYYY-MM-DD'),
				week: moment().week(),
				slotweek: 0,
				max_week: moment().week() + 3,
				year: moment().year(),
				stage: sessionStorage.getItem("stage"),
				topbarstage: 0,
				emailSubmitted: false,
				emailSubmitError: null,
				optin: false,
				optinFileMakerNewFunnel: false,
				optinFileMaker: "Please select",
				optoutFileMaker: false,
				optedin: false,
				discountamount: null,
				insurer: sessionStorage.getItem("insurer"),
				isinsurance: this.$isinsurance,
				skyjourney: sessionStorage.getItem("skyjourney"), 
				TVMarketing: "Please select",
				courier: {
					first_name: null,
					last_name: null,
					email: null,
					phone: null,
					zip: null,
					source: null,
					notes: null,
					terms_accepted: false,
					selected_repair: null,
					pickupcost: null,
					passcode: null
				},
				device: {
					manufacturer: null,
					model: null,
					type: null
				},
				addon: {
					addonone: null,
					addononesku: null,
					addononeprice: null,
					addononename: null,
					addononevend: null,
					addononediscount: null,
					addontwo: null,
					addontwosku: null,
					addontwoprice: null,
					addontwoname: null,
					addontwovend: null,
					addontwodiscount: null
				},
				errors: {
					first_name: null,
					last_name: null,
					email: null,
					phone: null,
					zip: null,
					terms_accepted: null,
					business_type: null,
					business_identifier: null,
					payment_type: null,
					business_authorisation: null,
					business_name: null,
					slot_status: null,
					insurance_reference: null,
					marketing: null,
					tvmarketing: null,
					device_imei: null
				},
				messages: {
					business_identifier: null,
					business_authorisation: null,
				},
				post_in_terms_accepted: false,
				pricing_type: false,
				business: {
					account_type: null,
					identifier: null,
					business_type: null,
					authorisation_code: null,
					identified: false,
					authorised: false,
					id_company: null,
					name: null,
					po_number: null
				},
				insurance: {
					is_insurance: sessionStorage.getItem("isinsurance"),
					reference: sessionStorage.getItem("insuranceref"),
					vend_id: null,
					validated: false,
				},
				rebook: sessionStorage.getItem("rebook"),
				fmid: sessionStorage.getItem("fmid"),
				pixelcare: sessionStorage.getItem("pixelcare"),
				customer_type: null,
				job_number: sessionStorage.getItem("job_number")
			},
			enquiry: {
				name: null,
				phone: null,
				email: null,
				device: null,
				question: null
			},
			stores: {
				list: []
			},
			skystores: {
				list: []
			},
			selectedStore: {
				store: null
			},
			products: null,
			thefeaturedproduct: null,
			therearproducts: null,
			therearglassproducts: null,
			theapplereplacement: null,
			thetableinfo: null,
			theinsuranceproduct: null,
			thePopUpProduct: [],
			theBackProduct: [],
			theOuterProducts: [],
			theFrontScreen: [],
			theRearProducts: [],
			theChargingProduct: [],
			theCameraProduct: [],
			theLiquidProduct: [],
			theOtherProduct: [],
			theDiagnosticsProduct: [],
			theLCDProduct: null,
			theOLEDProduct: null,
			collection: null,
			courierCollection: null,
			mailin: null,
			visitus: null,
			StockQty: null,
			storesOpen: true,
			premium_service_product:{}
		},
		computed: {
			showMacbookStoreNotice: function () {
                // The URL is authoritative on shared funnel pages, even without collection data.
                var sourceHandle = new URLSearchParams(window.location.search || '').get('source_collection');
                var handle = sourceHandle || (this.collection && this.collection.handle) || '';
                return handle.toLowerCase().indexOf('macbook') !== -1;
            },
            bookingDate: function () {
				if (!this.booking || !this.booking.slot || !this.booking.slot.bookingdate) {
					return '';
				}
				var startHour = this.booking.slot.start_hour;
				var startMin = this.booking.slot.start_min;
				if (startMin == '0') {
					startMin = '00';
				}
				if (startHour === null || typeof startHour === 'undefined' || startMin === null || typeof startMin === 'undefined') {
					return '';
				}
				var date = new Date(this.booking.slot.bookingdate);
				if (isNaN(date.getTime())) {
					return '';
				}
				var bookingdate = moment(date).format("dddd Do MMMM [at] ") + startHour + ":" + startMin;
				if(this.booking.delivery_type === "courier_collection"){
					var bookingdate = moment(date).format("dddd Do MMMM");
				}
				return bookingdate;
			}
		},
		watch: {
			selected: {
				handler: function () {
					this.persistFunnelState();
				},
				deep: true
			},
			selectedrear: {
				handler: function () {
					this.persistFunnelState();
				},
				deep: true
			},
			selectedStore: {
				handler: function () {
					this.persistFunnelState();
				},
				deep: true
			},
			stores: {
				handler: function () {
					this.persistFunnelState();
				},
				deep: true
			},
			booking: {
				handler: function () {
					this.persistFunnelState();
				},
				deep: true
			}
		},
		methods: {
			resetFunnelStateForCollection: function () {
				// Clear in-place to preserve the shared object reference used by child components
				// (replacing with a new {} would break the reference in tabs.selected etc.)
				var selectedKeys = Object.keys(this.selected);
				for (var i = 0; i < selectedKeys.length; i++) {
					this.$delete(this.selected, selectedKeys[i]);
				}
				var selectedrearKeys = Object.keys(this.selectedrear);
				for (var i = 0; i < selectedrearKeys.length; i++) {
					this.$delete(this.selectedrear, selectedrearKeys[i]);
				}
				if (this.stores && this.stores.list) {
					this.stores.list = [];
				}
				if (this.selectedStore) {
					this.selectedStore.store = null;
				}
				if (this.booking) {
					this.booking.stage = 0;
					this.booking.delivery_type = '';
					this.booking.slotweek = 0;
					this.booking.slot = {
						id: null,
						store_id: null
					};
				}
				try {
					sessionStorage.removeItem('jv_selected');
					sessionStorage.removeItem('jv_selectedrear');
					sessionStorage.removeItem('jv_stores_list');
					sessionStorage.removeItem('jv_selected_store');
					sessionStorage.removeItem('jv_booking_snapshot');
					sessionStorage.removeItem('stage');
				} catch (e) {}
			},
			persistFunnelState: function () {
				try {
					sessionStorage.setItem('jv_selected', JSON.stringify(this.selected || {}));
					sessionStorage.setItem('jv_selectedrear', JSON.stringify(this.selectedrear || {}));
					sessionStorage.setItem('jv_stores_list', JSON.stringify((this.stores && this.stores.list) ? this.stores.list : []));
					sessionStorage.setItem('jv_selected_store', JSON.stringify(wrapSelectedStorePayload(this.selectedStore || null)));
					sessionStorage.setItem('jv_booking_snapshot', JSON.stringify({
						email: this.booking && this.booking.email ? this.booking.email : null,
						zip: this.booking && this.booking.zip ? this.booking.zip : null,
						delivery_type: this.booking && this.booking.delivery_type ? this.booking.delivery_type : 'store_visit',
						slot: this.booking && this.booking.slot ? this.booking.slot : null
					}));
					if (this.booking && this.booking.stage !== null && typeof this.booking.stage !== 'undefined') {
						sessionStorage.setItem('stage', String(this.booking.stage));
					}
					if (window.collection && window.collection.handle) {
						sessionStorage.setItem('jv_source_collection', window.collection.handle);
					}
				} catch (e) {}
			},
			selectSlot: function (slot) {
				this.booking.slot = slot;
				scrollBookingToTop();
				this.persistFunnelState();
				if (slot.store_id) {
					ga("send", "pageview", "?select-your-store/time/contact-details");
				} else if (slot.technician_id) {
					ga("send", "pageview", "?call-out-technician/time/contact-details");
				}
			},
			setStore: function (store) {
				this.booking.slot = {
					id: null,
					store_id: null
				};

				//console.log(store);
				//console.log(store.name);

				var useremail = this.booking.email;
				var abandon_data = {
					"email": useremail,
					"store": store.name
				}

				this.selectedStore.store = store;
				this.booking.stage = 2;
				this.persistFunnelState();

				ga("send", "pageview", '?select-your-store/time');
			}
		}
	});
	Vue.config.devtools = true;
})(window.ESC_ISMASH_REPAIR_APP || {});

var modal = document.getElementById("myModal");
// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
	if (event.target == modal) {
	  modal.style.display = "none";
	}
  }
$("#storeinstocklistview").hide();
